// BrowserLeaks Chrome extension database captured from https://browserleaks.com/js/chrome-db.js on 2026-08-03.

import type {
  RawData,
  TestDefinition,
  TestResult,
  ValidationResult,
} from '../types.ts';
import {
  errorText,
  formatError,
  isRecord,
  result,
  validation,
  validationError,
} from './shared.ts';

export interface ExtensionTarget {
  readonly id: string;
  readonly name: string;
  readonly resource: string;
}

export const extensionTargets: readonly ExtensionTarget[] = [
  {
    id: 'ghbmnnjooekpmoecnnnilnnbdlolhkhi',
    name: 'Google Docs Offline',
    resource: 'page_embed_script.js',
  },
  {
    id: 'gbkeegbaiigmenfmjfclcdgdpimamgkj',
    name: 'Office Editing for Docs, Sheets & Slides',
    resource: 'views/app.html',
  },
  {
    id: 'efaidnbmnnnibpcajpcglclefindmkaj',
    name: 'Adobe Acrobat',
    resource: 'viewer.html',
  },
  {
    id: 'ncennffkjdiamlpmcbajkmaiiiddgioo',
    name: '迅雷下载支持',
    resource: 'assets/tick.png',
  },
  {
    id: 'aapbdbdomjkkjkaonfhkkikfgjllcleb',
    name: 'Google Translate',
    resource: 'popup_css_compiled.css',
  },
  {
    id: 'jlhmfgmfgeifomenelglieieghnjghma',
    name: 'Cisco Webex',
    resource:
      'cwcsf-nativemsg-iframe-43c85c0d-d633-af5e-c056-32dc7efc570b.html',
  },
  {
    id: 'glcimepnljoholdmjchkloafkggfoijh',
    name: '360 Internet Protection',
    resource: 'images/360ts.png',
  },
  {
    id: 'majdfhpaihoncoakbjgbdhglocklcgno',
    name: 'VPN Proxy VeePN',
    resource: 'fonts/FigtreeVF.woff2',
  },
  {
    id: 'bmnlcjabgnpnenekpadlanbbkooimhnj',
    name: 'PayPal Honey',
    resource: 'paypal/meta.js',
  },
  {
    id: 'inoeonmfapjbbkmdafoankkfajkcphgd',
    name: 'Read&Write',
    resource: 'ocr/pages/ocr.js',
  },
  {
    id: 'ecnphlgnajanjnkcmbpancdjoidceilk',
    name: 'Kami',
    resource: 'images/tick.svg',
  },
  {
    id: 'fjoaledfpmneenckfbpdfhkmimnjocfa',
    name: 'NordVPN',
    resource: 'app.bundle.css',
  },
  {
    id: 'llbcnfanfmjhpedaedhbcnpgeepdnnok',
    name: 'Online Security',
    resource: 'content.styles.css',
  },
  {
    id: 'oocalimimngaihdkbihfgmpkcpnmlaoa',
    name: 'Teleparty',
    resource: 'img/x.svg',
  },
  {
    id: 'dncepekefegjiljlfbihljgogephdhph',
    name: 'TouchEn',
    resource: 'contentscript.js',
  },
  {
    id: 'ekhagklcjbdpajgpjgmbionohlpdbjgc',
    name: 'Zotero Connector',
    resource: 'itemSaver.js',
  },
  {
    id: 'fcoeoabgfenejglbffodgkkbkcdhcgfn',
    name: 'Claude',
    resource: 'assets/accessibility-tree.js-CCweLwU2.js',
  },
  {
    id: 'hdokiejnpimakedhajhdlcegeplioahd',
    name: 'LastPass',
    resource: 'extension-pendo.html',
  },
  {
    id: 'kgjfgplpablkjnlkjmjdecgdpfankdle',
    name: 'Zoom',
    resource: 'images/icon.svg',
  },
  {
    id: 'liecbddmkiiihnedobmlmillhodjkdmb',
    name: 'Loom',
    resource: 'html/bubble.html',
  },
  {
    id: 'mmeijimgabbpbgpdklnllpncmdofkcpn',
    name: 'Screencastify',
    resource: 'webcam.html',
  },
  {
    id: 'pfhgbfnnjiafkhfdkmpiflachepdcjod',
    name: 'CAdES',
    resource: 'trusted_sites.html',
  },
  {
    id: 'eiaeiblijfjekdanodkjadfinkhbfgcd',
    name: 'NordPass',
    resource: 'biometrics.html',
  },
  {
    id: 'lpcaedmchfhocbbapmcbpinfpgnhiddi',
    name: 'Google Keep',
    resource: 'index.html',
  },
  {
    id: 'aeblfdkhhhdcdjpifhhbdiojplfjncoa',
    name: '1Password',
    resource: 'inline/injected.js',
  },
  {
    id: 'aopddeflghjljihihabdclejbojaomaf',
    name: 'AnyDoc Translator',
    resource: 'public/images/hot.svg',
  },
  {
    id: 'pejdijmoenmkgeppbflobdenhhabjlaj',
    name: 'iCloud Passwords',
    resource: 'completion_list.html',
  },
  {
    id: 'bfnaelmomeimhlpmgjnjophhpkkoljpa',
    name: 'Phantom',
    resource: 'sui.js',
  },
  {
    id: 'difoiogjjojoaoomphldepapgpbgkhkb',
    name: 'Sider',
    resource: 'i18n/am.json',
  },
  {
    id: 'enfolipbjmnmleonhhebhalojdpcpdoo',
    name: 'Screenshot reader',
    resource: 'pages/ocr.html',
  },
  {
    id: 'feepmdlmhplaojabeoecaobfmibooaid',
    name: 'OrbitNote',
    resource: 'filePicker/index.html',
  },
  {
    id: 'fjgncogppolhfdpijihbpfmeohpaadpc',
    name: 'EndNote',
    resource: 'settings.json',
  },
  {
    id: 'fmkadmapgofadopljbjfkapdkoienihi',
    name: 'React Developer Tools',
    resource: 'main.html',
  },
  {
    id: 'iidnbdjijdkbmajdffnidomddglmieko',
    name: 'Quillbot',
    resource: 'executor.js',
  },
  {
    id: 'jjkchpdmjjdmalgembblgafllbpcjlei',
    name: 'Trellix Endpoint Security Web Control',
    resource: 'images/128.png',
  },
  {
    id: 'ogdlpmhglpejoiomcodnpjnfgcpmgale',
    name: 'Custom Cursor',
    resource: 'content.js',
  },
  {
    id: 'bhlhnicpbhignbdhedgjhgdocnmhomnp',
    name: 'ColorZilla',
    resource: 'images/icon-16.png',
  },
  {
    id: 'bkdgflcldnnnapblkhphbgpggdiikppg',
    name: 'DuckDuckGo Search & Tracker Protection',
    resource: 'img/logo-small.svg',
  },
  {
    id: 'gkojfkhlekighikafcpjkiklfbnlmeio',
    name: 'Hola VPN',
    resource: 'js/popup.html',
  },
  {
    id: 'hehijbfgiekmjfkfjpbkbammjbdenadd',
    name: 'IE Tab',
    resource: 'redir.htm',
  },
  {
    id: 'mclkkofklkfljcocdinagocijmpgbhab',
    name: 'Google Input Tools',
    resource: 'inner_bin.js',
  },
  {
    id: 'njdniclgegijdcdliklgieicanpmcngj',
    name: 'Insight',
    resource: 'env/qa.json',
  },
  {
    id: 'bpoadfkcbjbfhfodiogcnhhhpibjhbnh',
    name: 'Immersive Translate',
    resource: 'locales.json',
  },
  {
    id: 'dagcmkpagjlhakfdhnbomgmjdpkdklff',
    name: 'Mendeley Web Importer',
    resource: 'index.html',
  },
  {
    id: 'dpadflhmiohjfhhaehelneimpllfbpcg',
    name: 'TeraBox Download Assistant',
    resource: 'logo.4abccce0.png',
  },
  {
    id: 'fdgfkebogiimcoedlicjlajpkdmockpc',
    name: 'Meta Pixel Helper',
    resource: 'logo.png',
  },
  {
    id: 'ghdbmcfiemkndpbhfeifkneiolehkcli',
    name: 'FUJIFILM Synapse',
    resource: 'canary.png',
  },
  {
    id: 'glghokcicpikglmflbbelbgeafpijkkf',
    name: 'Signer.Digital',
    resource: 'icon32.png',
  },
  {
    id: 'golbdgciocipijcnkhfjbljaepchclbc',
    name: '夸克网盘',
    resource: 'update-iframe.html',
  },
  {
    id: 'gppongmhjkpfnbhagpmjfkannfbllamg',
    name: 'Wappalyzer',
    resource: 'js/js.js',
  },
  {
    id: 'hjngolefdpdnooamgdldlkjgmdcmcjnc',
    name: 'Equatio',
    resource: 'desmos/graph.html',
  },
  {
    id: 'jabjbhgjaidecageckilhonbggakppme',
    name: 'Госплагин',
    resource: 'includes/system.js',
  },
  {
    id: 'kejbdjndbnbjgmefkgdddjlbokphdefk',
    name: 'Tag Assistant',
    resource: 'cs/ta/tag_assistant_api_bin.js',
  },
  {
    id: 'lgblnfidahcdcjddiepkckcfdhpknnjh',
    name: 'Ad Blocker',
    resource: 'content/popups-script.js',
  },
  {
    id: 'mfidniedemcgceagapgdekdbmanojomk',
    name: 'Coupert',
    resource: 'css/font.css',
  },
  {
    id: 'mgijmajocgfcbeboacabfgobmjgjcoja',
    name: 'Google Dictionary (by Google)',
    resource: 'content.min.css',
  },
  {
    id: 'nlipoenfbbikpbjkfpfillcgkoblgpmj',
    name: 'Awesome Screen Recorder & Screenshot',
    resource: 'camera.html',
  },
  {
    id: 'ohfgljdgelakfkefopgklcohadegdpjf',
    name: 'Smallpdf',
    resource: 'iframe.html',
  },
  {
    id: 'oldceeleldhonbafppcapldpdifcinji',
    name: 'LanguageTool',
    resource: 'content.js',
  },
  {
    id: 'pachckjkecffpdphbpmfolblodfkgbhl',
    name: 'vidIQ Vision',
    resource: 'options.js',
  },
  {
    id: 'bfgdeiadkckfbkeigkoncpdieiiefpig',
    name: 'Bitmoji',
    resource: 'popup.html',
  },
  {
    id: 'bfogiafebfohielmmehodmfbbebbbpei',
    name: 'Keeper',
    resource: 'images/web.svg',
  },
  {
    id: 'bkkbcggnhapdmkeljlodobbkopceiche',
    name: 'Poper Blocker',
    resource: 'message.html',
  },
  {
    id: 'dahenjhkoodjbpjheillcadbppiidmhp',
    name: 'Google Scholar PDF Reader',
    resource: 'reader.html',
  },
  {
    id: 'dmghijelimhndkbmpgbldicpogfkceaj',
    name: 'Dark Mode',
    resource: 'data/content_script/custom/bing.css',
  },
  {
    id: 'fjnbnpbmkenffdnngjfgmeleoegfcffe',
    name: 'Stylish',
    resource: 'index.html',
  },
  {
    id: 'ggjhpefgjjfobnfoldnjipclpcfbgbhl',
    name: 'My Apps Secure Sign-in',
    resource: 'images/notLoggedInIcon.png',
  },
  {
    id: 'hoombieeljmmljlkjmnheibnpciblicm',
    name: 'Lang Reactor',
    resource: 'images/tt.png',
  },
  {
    id: 'imdndkajeppdomiimjkcbhkafeeooghd',
    name: 'WithSecure',
    resource: 'ols.css',
  },
  {
    id: 'jddgbeighonaipjikdnfdpiefhoomlae',
    name: 'YouBoost',
    resource: 'assets/cross.svg',
  },
  {
    id: 'jpkfgepcmmchgfbjblnodjhldacghenp',
    name: 'Pie Adblock',
    resource: 'assets/page/suppressAlert.js',
  },
  {
    id: 'laookkfknpbbblfpciffpaejjkokdgca',
    name: 'Momentum',
    resource: 'site-blocker.html',
  },
  {
    id: 'mnjggcdmjocbbbhaepdhchncahnbgone',
    name: 'SponsorBlock',
    resource: 'popup.css',
  },
  {
    id: 'nmigaijibiabddkkmjhlehchpmgbokfj',
    name: 'Sound Booster',
    resource: 'css/window.css',
  },
  {
    id: 'nmmicjeknamkfloonkhhcjmomieiodli',
    name: 'YouTube Summary with ChatGPT & Claude',
    resource: 'assets/index-cd77e154.js',
  },
  {
    id: 'ohedcglhbbfdgaogjhcclacoccbagkjg',
    name: 'Адаптер Рутокен Плагин',
    resource: 'webpage.js',
  },
  {
    id: 'pchfckkccldkbclgdepkaonamkignanh',
    name: 'Visual Bookmarks',
    resource: 'brandings.js',
  },
  {
    id: 'pioclpoplcdbaefihamjohnefbikjilc',
    name: 'Evernote Web Clipper',
    resource: 'content.css',
  },
  {
    id: 'acbchkahfmndkenefkcklofjmipghjjp',
    name: 'Rutoken',
    resource: 'error.html',
  },
  {
    id: 'ajphlblkfpppdpkgokiejbjfohfohhmk',
    name: 'Mote',
    resource: 'popup.html',
  },
  {
    id: 'alhgpfoeiimagjlnfekdhkjlkiomcapa',
    name: 'Apollo.io',
    resource: 'js/css/panel.css',
  },
  {
    id: 'becfinhbfclcgokjlobojlnldbfillpf',
    name: 'AITOPIA',
    resource: 'aitopia.png',
  },
  {
    id: 'bfbmjmiodbnnpllbbbfblcplfjjepjdn',
    name: 'Turn Off the Lights',
    resource: 'scripts/video-player-status.js',
  },
  {
    id: 'bigefpfhnfcobdlfbedofhhaibnlghod',
    name: 'MEGA',
    resource: 'mega/secure.html',
  },
  {
    id: 'ckejmhbmlajgoklhgbapkiccekfoccmk',
    name: 'Mobile simulator',
    resource: 'fonts/avenir.otf',
  },
  {
    id: 'clngdbkpkpeebahjckkjfobafhncgmne',
    name: 'Stylus',
    resource: 'install-usercss.html',
  },
  {
    id: 'cmeakgjggjdlcpncigglobpjbkabhmjl',
    name: 'Steam Inventory Helper',
    resource: 'js/faq.js',
  },
  {
    id: 'cndibmoanboadcifjkjbdpjgfedanolh',
    name: 'BetterCanvas',
    resource: 'BCPuzzle.gif',
  },
  {
    id: 'cnlhokffphohmfcddnibpohmkdfafdli',
    name: 'MultiPassword',
    resource: 'save.html',
  },
  {
    id: 'cnpniohnfphhjihaiiggeabnkjhpaldj',
    name: 'Image Downloader',
    resource: 'images/me.jpg',
  },
  {
    id: 'dhcpobccjkdnmibckgpejmbpmpembgco',
    name: 'Topaz SigPlusExtLite',
    resource: 'SigPlusExtLiteWrapper.js',
  },
  {
    id: 'dmkamcknogkgcdfhhbddcghachkejeap',
    name: 'Keplr',
    resource: 'assets/icon-128.png',
  },
  {
    id: 'donbcfbmhbcapadipfkeojnmajbakjdc',
    name: 'Ruffle',
    resource: 'popup.html',
  },
  {
    id: 'edlifbnjlicfpckhgjhflgkeeibhhcii',
    name: 'ScreenShot Tool',
    resource: 'editor.html',
  },
  {
    id: 'egjidjbpglichdcondbcbdnbeeppgdph',
    name: 'Trust Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'eiimnmioipafcokbfikbljfdeojpcgbh',
    name: 'Block Site',
    resource: 'public/popup.html',
  },
  {
    id: 'epnhoepnmfjdbjjfanpjklemanhkjgil',
    name: 'Pendo Launcher',
    resource: 'idp.js',
  },
  {
    id: 'fdjamakpfbbddfjaooikfcpapjohcfmg',
    name: 'Dashlane',
    resource: 'index.html',
  },
  {
    id: 'feolagkacappiaieohahjkeaikhjjcfa',
    name: 'Dragon',
    resource: 'content.js',
  },
  {
    id: 'fggkaccpbmombhnjkjokndojfgagejfb',
    name: 'Tactiq',
    resource: 'logo.svg',
  },
  {
    id: 'fllaojicojecljbmefodhfapmkghcbnh',
    name: 'Google Analytics Opt-out Add-on (by Google)',
    resource: 'gaoptout_signal.js',
  },
  {
    id: 'fnjhmkhhmkbjkkabndcnnogagogbneec',
    name: 'Ronin Wallet',
    resource: 'in-page.js',
  },
  {
    id: 'ghmbeldphafepmbegfdlkpapadhbakde',
    name: 'Proton Pass',
    resource: 'elements.js',
  },
  {
    id: 'gkmiciealelfckimnoopefeplibjciih',
    name: 'Fortinet Privileged Access Agent',
    resource: 'css/style.css',
  },
  {
    id: 'gohjpllcolmccldfdggmamodembldgpc',
    name: 'Shimeji',
    resource:
      'fonts/balsamiq-sans-v12-cyrillic_cyrillic-ext_latin_latin-ext-700.woff2',
  },
  {
    id: 'hbapdpeemoojbophdfndmlgdhppljgmp',
    name: 'Keywords Everywhere',
    resource: 'img/on.png',
  },
  {
    id: 'hdppkjifljbdpckfajcmlblbchhledln',
    name: 'Browser Redirection',
    resource: 'bcr.html',
  },
  {
    id: 'hgeljhfekpckiiplhkigfehkdpldcggm',
    name: 'Auto Refresh Plus',
    resource: 'assets/images/web.png',
  },
  {
    id: 'hipncndjamdcmphkgngojegjblibadbe',
    name: 'Planet VPN',
    resource: 'icons/icon-48.png',
  },
  {
    id: 'hmdcmlfkchdmnmnmheododdhjedfccka',
    name: 'Eye Dropper',
    resource: 'edropper.js',
  },
  {
    id: 'hnfanknocfeofbddgcijnmhnfnkdnaad',
    name: 'Coinbase Wallet',
    resource: 'forceUpdate.js',
  },
  {
    id: 'hodiladlefdpcbemnbbcpclbmknkiaem',
    name: 'Google Meet Enhanced Experience',
    resource: 'main.css',
  },
  {
    id: 'hoklmmgfnpapgjgcpechhaamimifchmp',
    name: 'Similarweb',
    resource: 'images/close.svg',
  },
  {
    id: 'honjcnefekfnompampcpmcdadibmjhlk',
    name: 'LanSchool Web Helper',
    resource: 'style.css',
  },
  {
    id: 'ifajfiofeifbbhbionejdliodenmecna',
    name: 'Co:Writer',
    resource: 'status',
  },
  {
    id: 'ijejnggjjphlenbhmjhhgcdpehhacaal',
    name: 'scrnli',
    resource: 'index.html',
  },
  {
    id: 'inehghpkjjjdgpnagcbogckbonilnidc',
    name: 'Degreed',
    resource: 'trusted/trusted-pdf.js',
  },
  {
    id: 'ioimlbgefgadofblnajllknopjboejda',
    name: 'Transpose',
    resource: 'rb.wasm',
  },
  {
    id: 'jhhclmfgfllimlhabjkgkeebkbiadflb',
    name: 'EPUBReader',
    resource: 'reader.html',
  },
  {
    id: 'kiilhncajadbgbmdbdcopdpnmdhlbdle',
    name: 'CRXLauncher',
    resource: 'sb.html',
  },
  {
    id: 'klekeajafkkpokaofllcadenjdckhinm',
    name: 'McAfee Web Boost',
    resource: 'images/logo.png',
  },
  {
    id: 'lanhpcaapacdmofkjpkahckmlkljcdhh',
    name: 'Jinshan Web Clipper',
    resource: 'kdocs/path/index.html',
  },
  {
    id: 'ljflmlehinmoeknoonhibbjpldiijjmm',
    name: 'Speechify',
    resource: 'houdini.js',
  },
  {
    id: 'lkhjgdkpibcepflmlgahofcmeagjmecc',
    name: 'Scener',
    resource: 'ScenerIcon.png',
  },
  {
    id: 'lkoeejijapdihgbegpljiehpnlkadljb',
    name: 'LibKey Nomad',
    resource: 'static/main.js',
  },
  {
    id: 'lmbopdiikkamfphhgcckcjhojnokgfeo',
    name: 'Antidote Connector',
    resource: 'antidote-grav.js',
  },
  {
    id: 'lneaocagcijjdpkcabeanfpdbmapcjjg',
    name: 'VPNLY',
    resource: 'offscreen.html',
  },
  {
    id: 'lpfemeioodjbpieminkklglpmhlngfcn',
    name: 'WebChatGPT',
    resource: 'chunks/373ULJ4M.js',
  },
  {
    id: 'mcohilncbfahbmgdjkbpemcciiolgcge',
    name: 'OKX Wallet',
    resource: 'secure-iframe.html',
  },
  {
    id: 'mhkgegcmcapcgmnnloigolapjkajgfmd',
    name: 'Browser Security Plus',
    resource: 'bsplogo.png',
  },
  {
    id: 'mkhjobnjhllkhekbbedlkmgcglgaeidc',
    name: 'iboss Cloud Connector',
    resource: 'index.html',
  },
  {
    id: 'mloajfnmjckfjbeeofcdaecbelnblden',
    name: 'Snap&Read',
    resource: 'status',
  },
  {
    id: 'nhdogjmejiglipccpnnnanhbledajbpd',
    name: 'Vue.js devtools',
    resource: 'dist/proxy.js',
  },
  {
    id: 'njgehaondchbmjmajphnhlojfnbfokng',
    name: 'Video Downloader PLUS',
    resource: 'main.js',
  },
  {
    id: 'oemmndcbldboiebfnladdacbdfmadadm',
    name: 'PDF Viewer',
    resource: 'content/web/viewer.html',
  },
  {
    id: 'ofaokhiedipichpaobibbnahnkdoiiah',
    name: 'Instant Data Scraper',
    resource: 'pokeball64.png',
  },
  {
    id: 'ohcpnigalekghcmgcdcenkpelffpdolg',
    name: 'ColorPick Eyedropper',
    resource: 'img/close.png',
  },
  {
    id: 'ohlencieiipommannpdfcmfdpjjmeolj',
    name: 'PrintFriend',
    resource: 'sandbox.html',
  },
  {
    id: 'oiiaigjnkhngdbnoookogelabohpglmd',
    name: 'HubSpot Sales',
    resource: 'css/popup.css',
  },
  {
    id: 'okfkdaglfjjjfefdcppliegebpoegaii',
    name: 'Scribe',
    resource: 'assets/style.css',
  },
  {
    id: 'ondlbgninleaekgfkbbaloinfojpcmdn',
    name: 'Adding Furigana Function',
    resource: 'dict/cc.dat.gz',
  },
  {
    id: 'oofgbpoabipfcfjapgnbbjjaenockbdp',
    name: 'SetupVPN',
    resource: 'libs/vendors.dll.js',
  },
  {
    id: 'pbhelknnhilelbnhfpcjlcabhmfangik',
    name: '1C:Enterprise',
    resource: 'manifest.json',
  },
  {
    id: 'phgddhgfnjjaobkeekohieahfingldac',
    name: 'M*Modal',
    resource: 'fd-web-connector.js',
  },
  {
    id: 'phidhnmbkbkbkbknhldmpmnacgicphkf',
    name: 'MyBib',
    resource: 'static/css/fonts.css',
  },
  {
    id: 'pllcidbcfbamjfbfpemnnjohnfcliakf',
    name: 'ArkSigner',
    resource: 'content.js',
  },
  {
    id: 'pohmgobdeajemcifpoldnnhffjnnkhgf',
    name: 'WeVideo Screen & Webcam Recorder',
    resource: 'webcam.html',
  },
  {
    id: 'anflghppebdhjipndogapfagemgnlblh',
    name: 'Cute Cursors',
    resource: 'assets/static/svg/1.1.svg',
  },
  {
    id: 'camppjleccjaphfdbohjdohecfnoikec',
    name: 'Merlin AI',
    resource: 'logo-64x64.png',
  },
  {
    id: 'cimpffimgeipdhnhjohpbehjkcdpjolg',
    name: 'Watch2Gether',
    resource: 'controls.html',
  },
  {
    id: 'eakacpaijcpapndcfffdgphdiccmpknp',
    name: 'MozBar',
    resource: 'icon/16.png',
  },
  {
    id: 'eljapbgkmlngdpckoiiibecpemleclhh',
    name: 'Fonts Ninja',
    resource: 'frame.html',
  },
  {
    id: 'gekdekpbfehejjiecgonmgmepbdnaggp',
    name: 'Total Adblock',
    resource: 'assets/img/logo/edge.svg',
  },
  {
    id: 'idgpnmonknjnojddfkpgkljpfnnfcklj',
    name: 'ModHeader',
    resource: 'images/icon.png',
  },
  {
    id: 'iodihamcpbpeioajjeobimgagajmlibd',
    name: 'Secure Shell',
    resource: 'html/nassh.html',
  },
  {
    id: 'iplffkdpngmdjhlpjmppncnlhomiipha',
    name: 'Unpaywall',
    resource: 'unpaywall.html',
  },
  {
    id: 'kabafodfnabokkkddjbnkgbcbmipdlmb',
    name: 'Tasks for Canvas',
    resource: 'logo.png',
  },
  {
    id: 'kjacjjdnoddnpbbcjilcajfhhbdhkpgk',
    name: 'Forest',
    resource: 'images/plants/9/4.png',
  },
  {
    id: 'lppkeogbkjlmmbjenbogdndlgmpiddda',
    name: 'Ntko office document control',
    resource: 'icons/ntko.png',
  },
  {
    id: 'ojplmecpdpgccookcobabopnaifgidhf',
    name: 'BuyHatke',
    resource: 'src/ui/css/app.css',
  },
  {
    id: 'paijmjmfnjcbjlimjeminlepannmimbi',
    name: 'Pear Deck Power-Up',
    resource: 'static/css/styles.css',
  },
  {
    id: 'ppcdkdcafnbklehdngbhmhpidandcjke',
    name: 'think-cell',
    resource: 'inject.js',
  },
  {
    id: 'acmacodkjbdgmoleebolmdjonilkdbch',
    name: 'Rabby Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'cldmemdnllncchfahbcnjijheaolemfk',
    name: 'Foxified',
    resource: 'ff-options.html',
  },
  {
    id: 'cnjifjpddelmedmihgijeibhnjfabmlf',
    name: 'Obsidian Web Clipper',
    resource: 'style.css',
  },
  {
    id: 'edjkecefjhobekadlkdkopkggdefpgfp',
    name: 'Smarty',
    resource: 'css/popup.css',
  },
  {
    id: 'ekhbcipncbkfpkaianbjbcbmfehjflpf',
    name: 'CocoCut',
    resource: 'mpd.js',
  },
  {
    id: 'ffbkglfijbcbgblgflchnbphjdllaogb',
    name: 'CyberGhost',
    resource: 'images/flags/MA.svg',
  },
  {
    id: 'jfiihjeimjpkpoaekpdpllpaeichkiod',
    name: 'Page Marker',
    resource: 'main.css',
  },
  {
    id: 'kkelicaakdanhinjdeammmilcgefonfh',
    name: 'Window Resizer',
    resource: 'assets/fonts/lato-bold.ttf',
  },
  {
    id: 'kohfgcgbkjodfcfkcackpagifgbcmimk',
    name: 'NaturalReader',
    resource: 'injected/ok.js',
  },
  {
    id: 'mciiogijehkdemklbdcbfkefimifhecn',
    name: 'Chrono Download Manager',
    resource: 'icons/newd.png',
  },
  {
    id: 'opcgpfmipidbgpenhmajoajpbobppdil',
    name: 'Slush',
    resource: 'canvaskit.wasm',
  },
  {
    id: 'pomekhchngaooffdadfjnghfkaeipoba',
    name: 'Blitz Smart Card Plugin',
    resource: 'assets/index-C4FojMUk.css',
  },
  {
    id: 'achogidmbhmofkmpgamphmlebdhgkdhc',
    name: 'Soda PDF Viewer',
    resource: 'favicon.ico',
  },
  {
    id: 'ajhbdcgfhlhhmocddefknjjkejcfpbnj',
    name: 'Allow Copy +',
    resource: 'images/16.png',
  },
  {
    id: 'amfojhdiedpdnlijjbhjnhokbnohfdfb',
    name: 'eJOY AI Dictionary',
    resource: 'img/on.png',
  },
  {
    id: 'bhhhlbepdkbapadjdnnojkbgioiodbic',
    name: 'Solflare Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'bhmmomiinigofkjcapegjjndpbikblnp',
    name: 'Web of Trust',
    resource: 'popupV2.html',
  },
  {
    id: 'cbhilkcodigmigfbnphipnnmamjfkipp',
    name: 'Calendly',
    resource: '842.js',
  },
  {
    id: 'clldacgmdnnanihiibdgemajcfkmfhia',
    name: 'Color Picker',
    resource: 'cp.png',
  },
  {
    id: 'eenjdnjldapjajjofmldgmkjaienebbj',
    name: 'Copyfish',
    resource: 'dialog.html',
  },
  {
    id: 'gbdjcgalliefpinpmggefbloehmmknca',
    name: 'No Ads',
    resource: 'js/b.js',
  },
  {
    id: 'gidejehfgombmkfflghejpncblgfkagj',
    name: 'Cuponomia',
    resource: 'app.js',
  },
  {
    id: 'hgmhmanijnjhaffoampdlllchpolkdnj',
    name: 'Hunter',
    resource: 'img/location_icon.png',
  },
  {
    id: 'idgadaccgipmpannjkmfddolnnhmeklj',
    name: 'Text Blaze',
    resource: 'css/picker.css',
  },
  {
    id: 'jbbplnpkjmmeebjpijfedlgcdilocofh',
    name: 'WAVE',
    resource: 'inject.js',
  },
  {
    id: 'jlgkpaicikihijadgifklkbpdajbkhjo',
    name: 'CrxMouse',
    resource: 'icon.png',
  },
  {
    id: 'laankejkbhbdhmipfmgcngdelahlfoji',
    name: 'StayFocusd',
    resource: 'icon-16.png',
  },
  {
    id: 'mafcicncghogpdpaieifglifaagndbni',
    name: 'RoGold',
    resource: 'init.js',
  },
  {
    id: 'mbpaklahifpfndjiefdfjhmkefppocfm',
    name: 'Assinatura Digital',
    resource: 'ok.png',
  },
  {
    id: 'mhnlakgilnojmhinhkckjpncpbhabphi',
    name: 'MaxAI',
    resource: 'worker.js',
  },
  {
    id: 'nbcojefnccbanplpoffopkoepjmhgdgh',
    name: 'Hoxx VPN',
    resource: 'resources/flags/ad.png',
  },
  {
    id: 'nfmmmhanepmpifddlkkmihkalkoekpfd',
    name: 'FetchV',
    resource: 'js/hook.js',
  },
  {
    id: 'nkkighcdodpjcdenompholalclpaobff',
    name: 'MasteryConnect LockDown Browser',
    resource: 'viewer.js',
  },
  {
    id: 'oboonakemofpalcgghocfoadofidjkkk',
    name: 'KeePassXC-Browser',
    resource: 'css/totp.css',
  },
  {
    id: 'pnnfemgpilpdaojpnkjdgfgbnnjojfik',
    name: 'Streak CRM for Gmail',
    resource: 'blank.png',
  },
  {
    id: 'aejoelaoggembcahagimdiliamlcdmfm',
    name: 'Talend API Tester',
    resource: 'images/icon/favicon.ico',
  },
  {
    id: 'bafijghppfhdpldihckdcadbcobikaca',
    name: 'Keyword Surfer',
    resource: 'lib/index.js',
  },
  {
    id: 'cpaibbcbodhimfnjnakiidgbpiehfgci',
    name: 'True Key',
    resource: 'css/main.css',
  },
  {
    id: 'cpcifbdmkopohnnofedkjghjiclmhdah',
    name: 'NeatDownloadManager',
    resource: 'img/icon16.png',
  },
  {
    id: 'cpgaheeihidjmolbakklolchdplenjai',
    name: 'Turbo Downloader for Instagram',
    resource: 'icons/igdl2.png',
  },
  {
    id: 'dbjbempljhcmhlfpfacalomonjpalpko',
    name: 'ImageAssistant',
    resource: 'images/icon.png',
  },
  {
    id: 'gikbaopejleepnfocphkejjbgaifnico',
    name: 'Ripple Tools',
    resource: 'js/utils.js',
  },
  {
    id: 'gjfpmkejnolcfklaaddjnckanhhgegla',
    name: 'Guardio',
    resource: 'frame.html',
  },
  {
    id: 'hmffdimoneaieldiddcmajhbjijmnggi',
    name: 'EasyBib Toolbar',
    resource: 'popup.html',
  },
  {
    id: 'ibnejdfjmmkpcnlpebklmnkoeoihofec',
    name: 'TronLink',
    resource: 'injected/injected.js',
  },
  {
    id: 'innkphffipcmiflfibbeghfnkifiokgo',
    name: 'Amazon Quick',
    resource: 'quick-logo.svg',
  },
  {
    id: 'jifcoadedkediabkmjbflemiblmnbjfk',
    name: 'CyberArk Identity',
    resource: 'content/style-idle.css',
  },
  {
    id: 'jmekfmbnaedfebfnmakmokmlfpblbfdm',
    name: 'Tag Assistant Companion',
    resource: 'cs/ta/tag_assistant_api_bin.js',
  },
  {
    id: 'jpbjcnkcffbooppibceonlgknpkniiff',
    name: 'Global Speed',
    resource: 'circles/16.svg',
  },
  {
    id: 'nmpgaoofmjlimabncmnmnopjabbflegf',
    name: 'Ubersuggest',
    resource: 'img/pc.svg',
  },
  {
    id: 'pjnefijmagpdjfhhkpljicbbpicelgko',
    name: 'Voice In',
    resource: 'setup.html',
  },
  {
    id: 'abikfbojmghmfjdjlbagiamkinbmbaic',
    name: 'Equalizer',
    resource: 'content.js',
  },
  {
    id: 'adlpodnneegcnbophopdmhedicjbcgco',
    name: 'Troywell VPN',
    resource: 'popup.html',
  },
  {
    id: 'bekkpoinfafbjglppgdobfdeckghdhlo',
    name: 'CRX Emulator',
    resource: 'sb.html',
  },
  {
    id: 'blillmbchncajnhkjfdnincfndboieik',
    name: 'Glasp Web Highlighter',
    resource: 'images/16.png',
  },
  {
    id: 'cbapcdnkcgiajboppakkhjmdolbkinge',
    name: 'ChatbotsPlace',
    resource: 'logo/logo_128.png',
  },
  {
    id: 'cgdjpilhipecahhcilnafpblkieebhea',
    name: 'Send to Kindle',
    resource: 'images/s2k-sprite.png',
  },
  {
    id: 'cimiefiiaegbelhefglklhhakcgmhkai',
    name: 'Plasma',
    resource: 'page-script.js',
  },
  {
    id: 'dbepggeogbaibhgnhhndojpepiihcmeb',
    name: 'Vimium',
    resource: 'resources/tlds.txt',
  },
  {
    id: 'dehajjkfchegiinhcmoclkfbnmpgcahj',
    name: 'InsertLearning',
    resource: 'lib/img/icon.png',
  },
  {
    id: 'ecimfebadcfiablhgjpheinknpdkdjhh',
    name: 'Britannica School Insights',
    resource: 'img/b2.svg',
  },
  {
    id: 'elpmkbbdldhoiggkjfpgibmjioncklbn',
    name: 'Translate',
    resource: 'helpers/icons/280.svg',
  },
  {
    id: 'emalgedpdlghbkikiaeocoblajamonoh',
    name: 'Karma',
    resource: 'js/hermesSDK.js',
  },
  {
    id: 'emnoomldgleagdjapdeckpmebokijail',
    name: 'wanteeed',
    resource: 'img/W.png',
  },
  {
    id: 'fedoeoceggohfajbhbadkfhgckjkieop',
    name: 'Sound Equalizer',
    resource: 'helpers/tuna.js',
  },
  {
    id: 'fpkbnjejghdcncegfglnapabnljcimdc',
    name: 'Ad Block Wonder',
    resource: 'popup/js/dom.js',
  },
  {
    id: 'gcoekeoenehjmndhkdnoomdjeaclkhbe',
    name: 'Nearpod',
    resource: 'assets/close.svg',
  },
  {
    id: 'gnblbpbepfbfmoobegdogkglpbhcjofh',
    name: 'Beyond 20',
    resource: 'popup.html',
  },
  {
    id: 'jkncabbipkgbconhaajbapbhokpbgkdc',
    name: 'Cegid Peoplenet ClickOnce launcher',
    resource: 'nativeinstall.html',
  },
  {
    id: 'kdfieneakcjfaiglcfcgkidlkmlijjnh',
    name: 'AI Grammar and Spell Checker',
    resource: 'assets/logo.png',
  },
  {
    id: 'kmhkepipobnjllejbafajoemahjejdcm',
    name: 'iGraal',
    resource: 'public/chunks/caa.js',
  },
  {
    id: 'kpiecbcckbofpmkkkdibbllpinceiihk',
    name: 'DotVPN',
    resource: 'popup.html',
  },
  {
    id: 'llaficoajjainaijghjlofdfmbjpebpa',
    name: 'New Tab Page',
    resource: 'newtab.html',
  },
  {
    id: 'lnbmbgocenenhhhdojdielgnmeflbnfb',
    name: 'SellerSprite',
    resource: 'assets/index.js',
  },
  {
    id: 'mbnbehikldjhnfehhnaidhjhoofhpehk',
    name: 'CSS Peeper',
    resource: 'colors.3a754b95.png',
  },
  {
    id: 'mpiodijhokgodhhofbcjdecpffjipkle',
    name: 'SingleFile',
    resource: 'lib/single-file-infobar.js',
  },
  {
    id: 'nlmmgnhgdeffjkdckmikfpnddkbbfkkk',
    name: 'Lightning Autofill',
    resource: 'css/wizard.css',
  },
  {
    id: 'nnnmhgkokpalnmbeighfomegjfkklkle',
    name: 'Cite This For Me',
    resource: 'popup.htm',
  },
  {
    id: 'npdkkcjlmhcnnaoobfdjndibfkkhhdfn',
    name: 'Read Aloud',
    resource: 'background.js',
  },
  {
    id: 'oalnnpgcgikdnenhjigoaencbppcmgel',
    name: 'LexiFlow',
    resource: 'views/alert-window.html',
  },
  {
    id: 'ofgdcdohlhjfdhbnfkikfeakhpojhpgm',
    name: 'Enable Right Click',
    resource: 'js/welcome.js',
  },
  {
    id: 'pdnenlnelpdomajfejgapbdpmjkfpjkp',
    name: 'Jetwriter AI',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'pfjdepjjfjjahkjfpkcgfmfhmnakjfba',
    name: 'Detailed SEO',
    resource: 'popup.js',
  },
  {
    id: 'pnjaodmkngahhkoihejjehlcdlnohgmp',
    name: 'feeder',
    resource: 'extension-icons/icon48x48.png',
  },
  {
    id: 'ppbibelpcjmhbdihakflkdcoccbgbkpo',
    name: 'UniSat Wallet',
    resource: 'index.html',
  },
  {
    id: 'aefalnopbcachhkjnihfjgglnjdegicg',
    name: 'uPerform',
    resource: 'inject.inappui5.js',
  },
  {
    id: 'aflkmfhebedbjioipglgcbcmnbpgliof',
    name: 'Backpack',
    resource: 'injected.js',
  },
  {
    id: 'agjnjboanicjcpenljmaaigopkgdnihi',
    name: 'PreMiD',
    resource: 'icons/PreMiD.png',
  },
  {
    id: 'ahmapmilbkfamljbpgphfndeemhnajme',
    name: 'Helperbird',
    resource: 'pdf.html',
  },
  {
    id: 'aiamjjeggglngiggkmmbnpnpeejjejaf',
    name: 'Read AI',
    resource: 'index.css',
  },
  {
    id: 'baecjmoceaobpnffgnlkloccenkoibbb',
    name: 'NoteGPT',
    resource: 'src/assets/base.css',
  },
  {
    id: 'bfhkfdnddlhfippjbflipboognpdpoeh',
    name: 'Read on reMarkable',
    resource: 'options.html',
  },
  {
    id: 'bhiichidigehdgphoambhjbekalahgha',
    name: 'Font Finder',
    resource: 'data/window/index.html',
  },
  {
    id: 'bogabmgabnjabjbiggmfkdocbjgackfo',
    name: 'Cursor Helper',
    resource: 'content.js',
  },
  {
    id: 'cdnapgfjopgaggbmfgbiinmmbdcglnam',
    name: 'OpenDyslexic',
    resource: 'assets/fonts/opendyslexic/bold.otf',
  },
  {
    id: 'ckkdlimhmcjmikdlpkmbgfkaikojcbjk',
    name: 'Markdown Viewer',
    resource: 'themes/new.css',
  },
  {
    id: 'cmkdbmfndkfgebldhnkbfhlneefdaaip',
    name: 'WhatRuns',
    resource: 'popup.html',
  },
  {
    id: 'ddaloccgjfibfpkalenodgehlhkgoahe',
    name: 'Dragon Ext',
    resource: 'nuanria.Chrome.js',
  },
  {
    id: 'dfablgdffinpaeiilgjpebchbacimpoa',
    name: 'eParaksts signing',
    resource: 'eparaksts-page.js',
  },
  {
    id: 'didegimhafipceonhjepacocaffmoppf',
    name: 'passbolt',
    resource: 'webAccessibleResources/js/dist/app.js',
  },
  {
    id: 'eanggfilgoajaocelnaflolkadkeghjp',
    name: 'HARPA AI',
    resource: 'oi.js',
  },
  {
    id: 'eenflijjbchafephdplkdmeenekabdfb',
    name: 'Alitools',
    resource: 'assets/fonts/OpenSans-Regular-latin-400.woff2',
  },
  {
    id: 'eollffkcakegifhacjnlnegohfdlidhn',
    name: 'Voice Control for ChatGPT',
    resource: 'icon-34.png',
  },
  {
    id: 'fnmihdojmnkclgjpcoonokmkhjpjechg',
    name: 'Smart Sidebar',
    resource: 'logo.svg',
  },
  {
    id: 'fofjcndophjadilglgimelemjkjblgpf',
    name: 'ZoomInfo',
    resource: 'index.html',
  },
  {
    id: 'gfbepnlhpkbgbkcebjnfhgjckibfdfkc',
    name: 'FantasyPros',
    resource: 'content/svg/dock.svg',
  },
  {
    id: 'glcipcfhmopcgidicgdociohdoicpdfc',
    name: 'Muzli',
    resource: 'js/app.js',
  },
  {
    id: 'haebnnbpedcbhciplfhjjkbafijpncjl',
    name: 'TinEye Reverse Image Search',
    resource: 'assets/tineye48.png',
  },
  {
    id: 'hdgegmlancchhhlkkddoiedlklgocffm',
    name: 'Read The Web',
    resource: 'css/pin.css',
  },
  {
    id: 'hljakogpibfgelmoegmajaeefcnefngd',
    name: 'MyLOFT',
    resource: 'icon.png',
  },
  {
    id: 'ienfalfjdbdpebioblfackkekamfmbnh',
    name: 'Angular DevTools',
    resource: 'app/backend_bundle.js',
  },
  {
    id: 'ihmgiclibbndffejedjimfjmfoabpcke',
    name: 'Mate Translate',
    resource: 'images/ui/help.png',
  },
  {
    id: 'imgpenhngnbnmhdkpdfnfhdpmfgmihdn',
    name: 'IObit Surfing Protection',
    resource: 'Plugin/Test.js',
  },
  {
    id: 'inlikjemeeknofckkjolnjbpehgadgge',
    name: 'Distill Web Monitor',
    resource: 'lib/xml.js',
  },
  {
    id: 'jlmpjdjjbgclbocgajdjefcidcncaied',
    name: 'daily.dev',
    resource: 'index.html',
  },
  {
    id: 'kaibcgikagnkfgjnibflebpldakfhfih',
    name: 'CS2 Trader',
    resource: 'js/injectToPage/ShowTradeOffer.js',
  },
  {
    id: 'kgobeoibakoahbfnlficpmibdbkdchap',
    name: 'GPTZero',
    resource: 'assets/icon.png',
  },
  {
    id: 'kobncfkmjelbefaoohoblamnbackjggk',
    name: 'YouTube to NotebookLM',
    resource: 'icon/4.png',
  },
  {
    id: 'ldmmifpegigmeammaeckplhnjbbpccmm',
    name: 'Save to Notion',
    resource: 'popup/index.html',
  },
  {
    id: 'lfidjngibpklhhijphdmbmedchiiolgk',
    name: 'Omnissa Horizon URL Content Redirection Helper',
    resource: 'ConfigLoader.html',
  },
  {
    id: 'lggdbpblkekjjbobadliahffoaobaknh',
    name: 'Tango',
    resource: 'assets/DWCQOQXC.js',
  },
  {
    id: 'lgomjifbpjfhpodjhihemafahhmegbek',
    name: 'NCapture',
    resource: 'icons/ncapture-48.png',
  },
  {
    id: 'lhannfkhjdhmibllojbbdjdbpegidojj',
    name: 'Screenshot & Screen Video Recorder',
    resource: 'mf',
  },
  {
    id: 'lhdoppojpmngadmnindnejefpokejbdd',
    name: 'axe DevTools',
    resource: 'highlighter.js',
  },
  {
    id: 'lhgiigkiddoalobhmmcpdhddlccindjj',
    name: 'Seesaw',
    resource: 'images/cropped_image.png',
  },
  {
    id: 'lieogkinebikhdchceieedcigeafdkid',
    name: 'Eagle',
    resource: 'locales/ja.json',
  },
  {
    id: 'lknmjhcajhfbbglglccadlfdjbaiifig',
    name: 'tl;dv',
    resource: 'content-scripts/multi-tabs.css',
  },
  {
    id: 'lokadhdaghfjbmailhhenifjejpokche',
    name: 'AppWriter Cloud',
    resource: 'menu.html',
  },
  {
    id: 'maekfnoeejhpjfkfmdlckioggdcdofpg',
    name: 'Adblocker for Youtube',
    resource: 'js/rate.js',
  },
  {
    id: 'mcebeofpilippmndlpcghpmghcljajna',
    name: 'Lusha',
    resource: 'frame.html',
  },
  {
    id: 'mcgbeeipkmelnpldkobichboakdfaeon',
    name: 'BLACKBOX.AI',
    resource: 'logo.png',
  },
  {
    id: 'mfpiaehgjbbfednooihadalhehabhcjo',
    name: 'Scrolling screenshot tool & screen capture',
    resource: 'images/clear.png',
  },
  {
    id: 'mhmphnocemakkjdampibehejoaleebpo',
    name: 'SuperNova',
    resource: 'enabler.html',
  },
  {
    id: 'migomhggnppjdijnfkiimcpjgnhmnale',
    name: 'CrossPilot',
    resource: 'html/options.html',
  },
  {
    id: 'mmanaflgaempokjfbeeabkadnkoidjam',
    name: 'DSers-Dropship Helper+AliExpress Importer',
    resource: 'options.js',
  },
  {
    id: 'naciaagbkifhpnoodlkhbejjldaiffcm',
    name: 'Get Token Cookie',
    resource: 'css/media.css',
  },
  {
    id: 'nbllaikcjebbpdemmekhnciekkjodlla',
    name: 'SkrivaText',
    resource: 'views/login.html',
  },
  {
    id: 'nfmlkliedggdodlbgghmmchhgckjoaml',
    name: 'Spotify Ad Blocker',
    resource: 'css.js',
  },
  {
    id: 'nkkhljadiejecbgelalchmjncoilpnlk',
    name: 'Video Speed Controller',
    resource: 'styles/cnt.css',
  },
  {
    id: 'oejgccbfbmkkpaidnkphaiaecficdnfn',
    name: 'Toggl Track',
    resource: 'settings.html',
  },
  {
    id: 'aaengkeeajpfabihmmmnkjpogmfkahjo',
    name: 'TxtAnalyser',
    resource: 'css/layout.css',
  },
  {
    id: 'aefkmifgmaafnojlojpnekbpbmjiiogg',
    name: 'Popup Blocker',
    resource: 'data/ui/index.html',
  },
  {
    id: 'aeidadjdhppdffggfgjpanbafaedankd',
    name: 'SignalHire',
    resource: 'linked-in-ui-injected.js',
  },
  {
    id: 'aiifbnbfobpmeekipheeijimdpnlpgpp',
    name: 'Station Wallet',
    resource: 'keplr.js',
  },
  {
    id: 'aikflfpejipbpjdlfabpgclhblkpaafo',
    name: 'WeTab',
    resource: 'fish.mp3',
  },
  {
    id: 'alncdjedloppbablonallfbkeiknmkdi',
    name: 'Night Eye',
    resource: 'css/home.css',
  },
  {
    id: 'bckjlihkmgolmgkchbpiponapgjenaoa',
    name: 'Jungle Scout',
    resource: 'manifest.json',
  },
  {
    id: 'bfidboloedlamgdmenmlbipfnccokknp',
    name: 'PureVPN',
    resource: 'assets/js/script.js',
  },
  {
    id: 'blkboeaihdlecgdjjgkcabbacndbjibc',
    name: 'DocuSign',
    resource: 'shell.html',
  },
  {
    id: 'bmhcbmnbenmcecpmpepghooflbehcack',
    name: 'Liner',
    resource: 'fonts/ABCArizonaFlare-Regular.woff2',
  },
  {
    id: 'bnmojkbbkkonlmlfgejehefjldooiedp',
    name: 'Otter.ai',
    resource: 'offscreen.html',
  },
  {
    id: 'bnompdfnhdbgdaoanapncknhmckenfog',
    name: 'Email Tracker',
    resource: 'lib/gmail.js',
  },
  {
    id: 'cipccbpjpemcnijhjcdjmkjhmhniiick',
    name: 'SciSpace',
    resource: 'asset-manifest.json',
  },
  {
    id: 'cpofhfeclnhnhodbcabgcihloffdpgpd',
    name: 'Custom Cursor Trails',
    resource: 'images/sun.svg',
  },
  {
    id: 'ddlbpiadoechcolndfeaonajmngmhblj',
    name: 'Compose AI',
    resource: 'gdocsInject.js',
  },
  {
    id: 'dfnhijmficoiilogkjlnkionfjlgecdi',
    name: 'PDF2Go',
    resource: 'iframe.html',
  },
  {
    id: 'dicgkflojhbopmagcacdklcpdfdcnhko',
    name: 'Converter',
    resource: 'iframe.html',
  },
  {
    id: 'dkaagdgjmgdmbnecmcefdhjekcoceebi',
    name: 'PerfectPixel',
    resource: 'settings.html',
  },
  {
    id: 'dlcobpjiigpikoobohmabehhmhfoodbb',
    name: 'Ready Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'ecabifbgmdmgdllomnfinbmaellmclnh',
    name: 'Reader View',
    resource: 'data/reader/template.html',
  },
  {
    id: 'ecmeogcbcoalojmkfkmancobmiahaigg',
    name: '아이템스카우트',
    resource: 'popup/popup.html',
  },
  {
    id: 'eifflpmocdbdmepbjaopkkhbfmdgijcc',
    name: 'JSON Viewer',
    resource: 'js/main.js',
  },
  {
    id: 'ejjladinnckdgjemekebdpeokbikhfci',
    name: 'Petra',
    resource: 'static/js/inpage.js',
  },
  {
    id: 'fefnkplkicihcoenmljhbihhaaagjhpp',
    name: 'Mino',
    resource: 'scripts/dialog.js',
  },
  {
    id: 'felcpnemckonbbmnoakbjgjkgokkbaeo',
    name: 'Trusted Shops',
    resource: 'logo_eu_b2b.3b670708.png',
  },
  {
    id: 'ffnbelfdoeiohenkjibnmadjiehjhajb',
    name: 'Yoroi',
    resource: 'js/initialInject.js',
  },
  {
    id: 'fkbfgpllpbhbofnhkefnfeignnanciie',
    name: 'NetDocuments',
    resource: 'images/nd.png',
  },
  {
    id: 'flkenbnefhfhjeflinndcnlepkapgigl',
    name: 'Paper',
    resource: 'assets/favicon.staging.png',
  },
  {
    id: 'fmiojochalhealflohaicjncoofdjjfb',
    name: 'Nuance PowerMic',
    resource: 'NucaPowerMicChromeAdapter.js',
  },
  {
    id: 'fpjppnhnpnknbenelmbnidjbolhandnf',
    name: 'E.C.P',
    resource: 'content_script_web_accessible/ecp_regular.js',
  },
  {
    id: 'fpnmgdkabkmnadcjpehmlllkndpkmiak',
    name: 'Wayback Machine',
    resource: 'css/archive.css',
  },
  {
    id: 'ggaabchcecdbomdcnbahdfddfikjmphe',
    name: 'Chrome Capture',
    resource: 'images/ic_16.png',
  },
  {
    id: 'gkeojjjcdcopjkbelgbcpckplegclfeg',
    name: 'AdGuard Extra',
    resource: 'userscript.js',
  },
  {
    id: 'goabeeekdabpokgoieonknlecpaoejon',
    name: 'Great Start',
    resource: 'icons/icon128.png',
  },
  {
    id: 'idnnbdplmphpflfnlkomgpfbpcgelopg',
    name: 'Xverse',
    resource: 'inpage.js',
  },
  {
    id: 'ihpiinojhnfhpdmmacgmpoonphhimkaj',
    name: 'Open in VLC media player',
    resource: 'data/inject/index.js',
  },
  {
    id: 'iibninhmiggehlcdolcilmhacighjamp',
    name: 'Magical',
    resource: 'assets/hands.svg',
  },
  {
    id: 'iihkglbebihpaflfihhkfmpabjgdpnol',
    name: '楽天ウェブ検索',
    resource: 'img/rtt.png',
  },
  {
    id: 'ikhdkkncnoglghljlkmcimlnlhkeamad',
    name: '划词翻译',
    resource: '8.js',
  },
  {
    id: 'inmopeiepgfljkpkidclfgbgbmfcennb',
    name: 'Responsive Viewer',
    resource: 'main.css',
  },
  {
    id: 'jcmljanephecacpljcpiogonhhadfpda',
    name: 'Add to Babylist Button',
    resource: 'clientSide.js',
  },
  {
    id: 'jdbnofccmhefkmjbkkdkfiicjkgofkdh',
    name: 'Bookmarks',
    resource: 'css/sidebar.css',
  },
  {
    id: 'jdianbbpnakhcmfkcckaboohfgnngfcc',
    name: 'Email Extractor',
    resource: 'css/main.css',
  },
  {
    id: 'jiihcciniecimeajcniapbngjjbonjan',
    name: 'Vidyard',
    resource: '560.min.js',
  },
  {
    id: 'jpefmbpcbebpjpmelobfakahfdcgcmkl',
    name: 'Adblock for YouTube',
    resource: 'assets/options.css',
  },
  {
    id: 'kiodaajmphnkcajieajajinghpejdjai',
    name: 'Popup Blocker Pro',
    resource: 'js/inject-new.js',
  },
  {
    id: 'kkkbiiikppgjdiebcabomlbidfodipjg',
    name: 'Substital',
    resource: 'css/vex/vex.css',
  },
  {
    id: 'ldjkgaaoikpmhmkelcgkgacicjfbofhh',
    name: 'Instapaper',
    resource: 'img/tag.svg',
  },
  {
    id: 'lfdconleibeikjpklmlahaihpnkpmlch',
    name: 'Video Downloader by Qooly',
    resource: 'bg.js',
  },
  {
    id: 'mdnleldcmiljblolnjhpnblkcekpdkpa',
    name: 'Requestly',
    resource: 'resources/images/128x128.png',
  },
  {
    id: 'mhloojimgilafopcmlcikiidgbbnelip',
    name: 'iTab New Tab',
    resource: 'CNAME',
  },
  {
    id: 'mjdbhokoopacimoekfgkcoogikbfgngb',
    name: 'Trancy',
    resource: 'assets/hbo.svg',
  },
  {
    id: 'mjgcgnfikekladnkhnimljcalfibijha',
    name: 'DocHub',
    resource: 'blank.html',
  },
  {
    id: 'mmnbenehknklpbendgmgngeaignppnbe',
    name: 'Netflix Party',
    resource: 'videoScript.js',
  },
  {
    id: 'necpbmbhhdiplmfhmjicabdeighkndkn',
    name: 'Similar Sites',
    resource: 'images/close.svg',
  },
  {
    id: 'nfadicbbecgbdbgbibgflooojfbolpgk',
    name: 'Pie Shopping',
    resource: 'assets/page/suppressAlert.js',
  },
  {
    id: 'objafjdlhkpglojmhplfeijpojcepoah',
    name: 'Assessment Lock',
    resource: 'popup/index.html',
  },
  {
    id: 'ocfjjghignicohbjammlhhoeimpfnlhc',
    name: 'Flash Player Enable',
    resource: 'libs/ruffle/ruffle.js',
  },
  {
    id: 'oiecklaabeielolbliiddlbokpfnmhba',
    name: 'RocketReach',
    resource: 'chunks/index-24a73f8e.js',
  },
  {
    id: 'omaabbefbmiijedngplfjmnooppbclkk',
    name: 'Tonkeeper',
    resource: 'provider.js',
  },
  {
    id: 'opmeopcambhfimffbomjgemehjkbbmji',
    name: 'VideoPlayer MPD/M3U8/IPTV/EPG',
    resource: 'play-on.png',
  },
  {
    id: 'pccckmaobkjjboncdfnnofkonhgpceea',
    name: 'HoverZoom',
    resource: 'js/gumby.js',
  },
  {
    id: 'pmjeegjhjdlccodhacdgbgfagbpmccpe',
    name: 'Clockify',
    resource: 'assets/images/$.png',
  },
  {
    id: 'abjopieldicnknjgiplcjgepeijbealm',
    name: 'Single Sign-on Assistant',
    resource: 'ux/main.js',
  },
  {
    id: 'afkoofjocpbclhnldmmaphappihehpma',
    name: 'zkPass TransGate',
    resource: 'manifest.json',
  },
  {
    id: 'akimgimeeoiognljlfchpbkpfbmeapkh',
    name: 'Google Arts & Culture',
    resource: 'fonts/mat_icons.woff2',
  },
  {
    id: 'akmglodbcihkcgojpdmbocmlpkfjhfof',
    name: 'Mirror Mode for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'alcgpfgkdjbabelklflpfkooadcfgoao',
    name: 'Fabasoft Client',
    resource: 'register.js',
  },
  {
    id: 'almalgbpmcfpdaopimbdchdliminoign',
    name: 'Urban Browser Guard',
    resource: 'sdk/resource.js',
  },
  {
    id: 'apnedodbofogffiagpekmbeflilkcbgf',
    name: 'YouTube To Text',
    resource: 'html/popup_options/index.html',
  },
  {
    id: 'bbobopahenonfdgjgaleledndnnfhooj',
    name: 'AB Download Manager',
    resource: 'assets/Config-a7c0502b.js',
  },
  {
    id: 'bcellnicpceplkigjnldelfglfmomhon',
    name: 'FEPWeb CMS Digital Signature',
    resource: 'manifest.json',
  },
  {
    id: 'bhbhjjkcoghibhibegcmbomkbakkpdbo',
    name: 'OCR',
    resource: 'data/engine/index.html',
  },
  {
    id: 'bjfhmglciegochdpefhhlphglcehbmek',
    name: 'Hypothesis',
    resource: 'help/index.js',
  },
  {
    id: 'bkhaagjahfmjljalopjnoealnfndnagc',
    name: 'Octotree',
    resource: 'icons/logo.svg',
  },
  {
    id: 'bmjmipppabdlpjccanalncobmbacckjn',
    name: 'Cursor Style',
    resource: 'css/effects.css',
  },
  {
    id: 'boffdonfioidojlcpmfnkngipappmcoh',
    name: 'FC26 Enhancer',
    resource: 'js/main.js',
  },
  {
    id: 'caeeihoelgmdmafbmlgoebfjnmgpfend',
    name: 'Stop Ads Now',
    resource: 'popup/js/dom.js',
  },
  {
    id: 'cbnaodkpfinfiipjblikofhlhlcickei',
    name: 'Weava Highlighter',
    resource: 'main.js',
  },
  {
    id: 'cdockenadnadldjbbgcallicgledbeoc',
    name: 'VisBug',
    resource: 'tuts/font.gif',
  },
  {
    id: 'cdonnmffkdaoajfknoeeecmchibpmkmg',
    name: 'Saladict',
    resource: 'quick-search.html',
  },
  {
    id: 'coplmfnphahpcknbchcehdikbdieognn',
    name: 'TripChipper',
    resource: 'popup.html',
  },
  {
    id: 'cpeaihkccbeemkfefcapijechkbfjlhb',
    name: 'AMZ Suggestion Expander',
    resource: 'images/volume.png',
  },
  {
    id: 'demgbalbngngkkgjcofhdiiipjblblob',
    name: 'Horizon Browser Redirection',
    resource: 'injectEnhBrowserRedir.js',
  },
  {
    id: 'dfbnddndcmilnhdfmmaolepiaefacnpo',
    name: 'DeepSider',
    resource: 'popup.html',
  },
  {
    id: 'dgmanlpmmkibanfdgjocnabmcaclkmod',
    name: 'Just Read',
    resource: 'page.css',
  },
  {
    id: 'dhhclfjehmpacimcdknijodpjpmppkii',
    name: 'Slido',
    resource: 'oauth-callback.html',
  },
  {
    id: 'diankknpkndanachmlckaikddgcehkod',
    name: 'TickTick',
    resource: 'scripts/options.js',
  },
  {
    id: 'dkagmnnkfinalebballociekdnlaniem',
    name: 'Ad Block Genius',
    resource: 'blocked.html',
  },
  {
    id: 'dkfhfaphfkopdgpbfkebjfcblcafcmpi',
    name: 'MightyText SMS',
    resource: 'help.html',
  },
  {
    id: 'dlbjdnlebeomgpeihkkmlblibabobbnn',
    name: 'HRS Plug-in',
    resource: 'popup.html',
  },
  {
    id: 'dlepebghjlnddgihakmnpoiifjjpmomh',
    name: 'Revision History',
    resource: 'js/191.js',
  },
  {
    id: 'doojmbjmlfjjnbmnoijecmcbfeoakpjm',
    name: 'NoScript',
    resource: 'nscl/common/SyncMessage/request.json',
  },
  {
    id: 'ecbnojockcgfohpopbphhgefkfbigcej',
    name: 'Flash Player Emulator 2026',
    resource: 'external/error.html',
  },
  {
    id: 'efbglgofoippbgcjepnhiblaibcnclgk',
    name: 'Martian Aptos & Sui Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'efhlocglafmcfhkpojjbckpbonbfbgdb',
    name: 'Operata Collector',
    resource: 'operata.js',
  },
  {
    id: 'elbikiflgfhjdjmficnigpeegjbhdidh',
    name: 'Cat Gatekeeper',
    resource: 'content.css',
  },
  {
    id: 'elfaihghhjjoknimpccccmkioofjjfkf',
    name: 'StayFree',
    resource: 'icon-16.png',
  },
  {
    id: 'fbfppoaockpecjpbdmldojdehdpepfef',
    name: 'Schoology Plus',
    resource: 'imgs/logo.ai',
  },
  {
    id: 'fddhonoimfhgiopglkiokmofecgdiedb',
    name: 'RingCentral',
    resource: 'content.js',
  },
  {
    id: 'fjkmabmdepjfammlpliljpnbhleegehm',
    name: 'WebRTC Control',
    resource: 'data/content_script/page_context/media_devices.js',
  },
  {
    id: 'fkiljfkkceaopbpfgfmjdnkiejaifkgd',
    name: 'Jobalytics',
    resource: 'js/util.js',
  },
  {
    id: 'gbefmodhlophhakmoecijeppjblibmie',
    name: 'Linguist',
    resource: 'contentscript.css',
  },
  {
    id: 'gcbalfbdmfieckjlnblleoemohcganoc',
    name: 'Ui.Vision',
    resource: 'logo.png',
  },
  {
    id: 'gdfeccaioepgmgjcecjpiabelmbbpijf',
    name: 'Cool Ad Popup Blocker',
    resource: 'protection_enabled.png',
  },
  {
    id: 'gdojjgflncpbcfmenbkndfhoamlhajmf',
    name: 'Annotate',
    resource: 'icon.png',
  },
  {
    id: 'gejiddohjgogedgjnonbofjigllpkmbf',
    name: '1Password',
    resource: 'inline/injected.js',
  },
  {
    id: 'giihipjfimkajhlcilipnjeohabimjhi',
    name: 'SEO Minion',
    resource: 'img/on.png',
  },
  {
    id: 'gkkdmjjodidppndkbkhhknakbeflbomf',
    name: 'Selectext',
    resource: 'login.css',
  },
  {
    id: 'gmegofmjomhknnokphhckolhcffdaihd',
    name: 'JSONView',
    resource: 'viewer.css',
  },
  {
    id: 'gnldpbnocfnlkkicnaplmkaphfdnlplb',
    name: 'Test & Feedback - Private',
    resource: 'Fonts/segoe.ttf',
  },
  {
    id: 'goficmpcgcnombioohjcgdhbaloknabb',
    name: 'Note Board',
    resource: 'NoteBoard.png',
  },
  {
    id: 'gphandlahdpffmccakmbngmbjnjiiahp',
    name: 'PDF Editor',
    resource: 'img/logo.svg',
  },
  {
    id: 'gplcmncpklkdjiccbknjjkoidpgkcakd',
    name: 'Copyleaks',
    resource: 'styles.css',
  },
  {
    id: 'hbdkkfheckcdppiaiabobmennhijkknn',
    name: 'Open SEO Stats',
    resource: 'profile.html',
  },
  {
    id: 'hghakoefmnkhamdhenpbogkeopjlkpoa',
    name: 'Lean Library',
    resource: 'popup.css',
  },
  {
    id: 'hhinaapppaileiechjoiifaancjggfjm',
    name: 'Web Scrobbler',
    resource: 'connectors/vk.js',
  },
  {
    id: 'hhlhjgianpocpoppaiihmlpgcoehlhio',
    name: 'Super Simple Highlighter',
    resource: 'js/chunks/CmtCJnHC.js',
  },
  {
    id: 'hjbfbllnfhppnhjdhhbmjabikmkfekgf',
    name: 'Koala Inspector',
    resource: 'kins_stabilizer.js',
  },
  {
    id: 'hldjnlbobkdkghfidgoecgmklcemanhm',
    name: 'Web Highlights',
    resource: 'content.js',
  },
  {
    id: 'hmigninkgibhdckiaphhmbgcghochdjc',
    name: 'Mouse Tooltip Translator',
    resource: 'ocr.html',
  },
  {
    id: 'iadokddofjgcgjpjlfhngclhpmaelnli',
    name: 'Careerflow AI',
    resource: 'content.style.css',
  },
  {
    id: 'iapifmceeokikomajpccajhjpacjmibe',
    name: 'Auto Clicker',
    resource: 'css/_doc.css',
  },
  {
    id: 'ibdfeimkglcmdejppabkaidpippniiob',
    name: 'AIX Downloader',
    resource: 'd3Cn3k30Ps.css',
  },
  {
    id: 'ibefaeehajgcpooopoegkifhgecigeeg',
    name: '壹伴',
    resource: 'mpa-editor.js',
  },
  {
    id: 'ibplnjkanclpjokhdolnendpplpjiace',
    name: 'Simple Translate',
    resource: 'icons/512.png',
  },
  {
    id: 'iddnbalhmdkipfcopclcnchagfbmcgjb',
    name: 'Textio',
    resource: 'setCKEData.js',
  },
  {
    id: 'iebpjdmgckacbodjpijphcplhebcmeop',
    name: 'Table Capture',
    resource: 'clips.html',
  },
  {
    id: 'igkpcodhieompeloncfnbekccinhapdb',
    name: 'Zoho Vault',
    resource: 'html/tab/Alert.html',
  },
  {
    id: 'ihhkmalpkhkoedlmcnilbbhhbhnicjga',
    name: 'Bardeen',
    resource: '81.js',
  },
  {
    id: 'iidnankcocecmgpcafggbgbmkbcldmno',
    name: 'Prompt Security',
    resource: 'style/blockModal.css',
  },
  {
    id: 'ijdefdijdmghafocfmmdojfghnpelnfn',
    name: 'NotebookLM Web Importer',
    resource: 'app.html',
  },
  {
    id: 'ilfoopambfaclfjmpiaijnccgcmbeigi',
    name: 'FormApps',
    resource: 'logoS_chrome.png',
  },
  {
    id: 'infppggnoaenmfagbfknfkancpbljcca',
    name: 'Automa',
    resource: 'icon-128.png',
  },
  {
    id: 'inhcgfpbfdjbjogdfjbclgolkmhnooop',
    name: 'AI Sidebar',
    resource: 'logo.svg',
  },
  { id: 'iohjgamcilhbgmhbnllfolmkmmekfmci', name: 'Jam', resource: 'iui.html' },
  {
    id: 'ioiepomamdncfjkigofklhciigbonnlk',
    name: 'TG Downloader',
    resource: 'popup.html',
  },
  {
    id: 'ipikiaejjblmdopojhpejjmbedhlibno',
    name: 'SwiftRead',
    resource: 'x.png',
  },
  {
    id: 'jchomknmfdaeojlimglgebnjlijedgnk',
    name: 'Qantas Shopping Points-Prompter',
    resource: 'assets/Ciutadella-Regular.woff',
  },
  {
    id: 'jdelodjlpgkjenhcongcfdcocmjgjbci',
    name: 'MY AD FINDER',
    resource: 'assets/sad.png',
  },
  {
    id: 'jdkknkkbebbapilgoeccciglkfbmbnfm',
    name: 'Apollo Client Devtools',
    resource: 'hook.js',
  },
  {
    id: 'jdlkkmamiaikhfampledjnhhkbeifokk',
    name: 'PDF Viewer',
    resource: 'bg/helper/web/viewer.html',
  },
  {
    id: 'jdoahkhfkeipblhbhppmcbdgapeoaopa',
    name: 'JumpCloud Go',
    resource: 'icons/logo_32.png',
  },
  {
    id: 'jeehnidbmlhpkncbplipfalpjkhlokaa',
    name: 'Poll Everywhere for Google Slides',
    resource: 'fonts/pollev_assets/glyphs_kx77ruz8wzhgvwz4iuvtq.woff',
  },
  {
    id: 'jelniggicmclhfgnlapbkgfibmgelfnp',
    name: 'AutoGLM',
    resource: 'bot.png',
  },
  {
    id: 'jgocjgkdladclacgmkkiklmdcmngjcba',
    name: 'GPT Workspace',
    resource: 'style.css',
  },
  {
    id: 'jigflhhckdjdefdjmodlkomnmdonfbbn',
    name: 'Joko',
    resource: 'assets/eye.svg',
  },
  {
    id: 'jipdnfibhldikgcjhfnomkfpcebammhp',
    name: 'rikaikun',
    resource: 'css/popup.css',
  },
  {
    id: 'jlleokkdhkflpmghiioglgmnminbekdi',
    name: 'GIPHY',
    resource: 'img/up.png',
  },
  {
    id: 'jpjlphemcdmgimfmlmjlnfebflgaaoic',
    name: 'AutoSBC',
    resource: 'autosbc.js',
  },
  {
    id: 'jplnlifepflhkbkgonidnobkakhmpnmh',
    name: 'Private Internet Access',
    resource: 'images/flags/YE.svg',
  },
  {
    id: 'kajibbejlbohfaggdiogboambcijhkke',
    name: 'Mailvelope',
    resource: 'main.css',
  },
  {
    id: 'kbbdabhdfibnancpjfhlkhafgdilcnji',
    name: 'Screenity',
    resource: 'setup.html',
  },
  {
    id: 'kcljbbiddpoeaknnjaminoceoojdbikp',
    name: 'Padlet Mini',
    resource: 'icons/16.png',
  },
  {
    id: 'kicgclkbiilobmccmmidfghnijgfamdb',
    name: 'IG Tools',
    resource: 'options.html',
  },
  {
    id: 'kphobmidlmfbdljcjhljfbjodkjfnldd',
    name: 'HiPC',
    resource: 'assets/bg-1125d8ef.svg',
  },
  {
    id: 'lbnoedlobifdhbpjkcfhcbdcjhampmne',
    name: 'Instant Gaming',
    resource: 'fonts/barlow-medium.woff2',
  },
  {
    id: 'lenipkahddombkldhfmcnnjakmcepdlk',
    name: 'AiPrice(AliPrice) Sourcing Tool',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'lgbjhdkjmpgjgcbcdlhkokkckpjmedgc',
    name: 'DualSafe Password Manager',
    resource: 'css/fail.css',
  },
  {
    id: 'likadllkkidlligfcdhfnnbkjigdkmci',
    name: 'QR Code Reader',
    resource: 'css/app.css',
  },
  {
    id: 'ljmaegmnepbgjekghdfkgegbckolmcok',
    name: 'Horizon HTML5 Redirection',
    resource: 'html5mmrPlayer.js',
  },
  {
    id: 'lokjgaehpcnlmkebpmjiofccpklbmoci',
    name: 'Toucan',
    resource: 'images/star.svg',
  },
  {
    id: 'mbcghjiodcjankhkllfohcgnckhdbkmi',
    name: 'WABULK',
    resource: 'assets/du.js',
  },
  {
    id: 'mbflpfaamifmmmkdjkcmpofpccfmlmap',
    name: 'MPMux',
    resource: 'js/proxy.js',
  },
  {
    id: 'mkpegjkblkkefacfnmkajcjmabijhclg',
    name: 'Magic Eden',
    resource: 'inapp.js',
  },
  {
    id: 'moffahdcgnjnglbepimcggkjacdmpojc',
    name: 'IEability',
    resource: 'ieability.html',
  },
  {
    id: 'mojcdcedhidldcgaokbelcmffoaengkj',
    name: 'Fatkun Batch Download Image',
    resource: 'icon.png',
  },
  {
    id: 'nalkmonnmldhpfcpdlbdpljlaajlaphh',
    name: 'PiP',
    resource: 'icons/icon19.png',
  },
  {
    id: 'nbhcbdghjpllgmfilhnhkllmkecfmpld',
    name: 'User JS CSS',
    resource: 'js-shared/jquery.min.js',
  },
  {
    id: 'nbkomboflhdlliegkaiepilnfmophgfg',
    name: 'Custom Progress Bar for YouTube',
    resource: 'style.js',
  },
  {
    id: 'ncldcbhpeplkfijdhnoepdgdnmjkckij',
    name: 'iGuge',
    resource: 'img/128ico.png',
  },
  {
    id: 'nnffbdeachhbpfapjklmpnmjcgamcdmm',
    name: 'Download All Images',
    resource: 'data/ui/index.html',
  },
  {
    id: 'noojglkidnpfjbincgijbaiedldjfbhh',
    name: 'Buffer',
    resource: 'icon16.png',
  },
  {
    id: 'nopjifljihndhkfeogabcclpgpceapln',
    name: 'IntoWords Cloud',
    resource: 'stt.html',
  },
  {
    id: 'npnbdojkgkbcdfdjlfdmplppdphlhhcf',
    name: 'ProWritingAid',
    resource: 'images/vbr.gif',
  },
  {
    id: 'odcnpipkhjegpefkfplmedhmkmmhmoko',
    name: 'Jobright Autofill',
    resource: 'dom.ed166d80.js',
  },
  {
    id: 'odfonlkabodgbolnmmkdijkaeggofoop',
    name: 'Clearly Reader',
    resource: 'content.css',
  },
  {
    id: 'oehooocookcnclgniepdgaiankfifmmn',
    name: 'Pancake v2',
    resource: 'pancext.html',
  },
  {
    id: 'oeicpkgdngoghobnbjngekclpcmpgpij',
    name: 'EverBee',
    resource: 'svg/bell.svg',
  },
  {
    id: 'oglffgiaiekgeicdgkdlnlkhliajdlja',
    name: 'YouTube Dubbing',
    resource: 'injectScript.js',
  },
  {
    id: 'ohgndokldibnndfnjnagojmheejlengn',
    name: 'Citavi Picker',
    resource: 'shared.js',
  },
  {
    id: 'oiaejidbmkiecgbjeifoejpgmdaleoha',
    name: 'Stylebot',
    resource: 'editor/index.css',
  },
  {
    id: 'oibcaeeplepnjfjhokfcabnaafodppik',
    name: 'GMB Everywhere',
    resource: 'imgs/gmb.png',
  },
  {
    id: 'ojggmchlghnjlapmfbnjholfjkiidbch',
    name: 'Venom Wallet',
    resource: 'js/popup.js',
  },
  {
    id: 'onhiacboedfinnofagfgoaanfedhmfab',
    name: 'Reverso Context',
    resource: 'dist/index.html',
  },
  {
    id: 'onhogfjeacnfoofkfgppdlbmlmnplgbn',
    name: 'SubWallet',
    resource: 'page.js',
  },
  {
    id: 'pdliaogehgdbhbnmkklieghmmjkpigpa',
    name: 'Bybit Wallet',
    resource: 'allChain.578a133f.png',
  },
  {
    id: 'pfjibkklgpfcfdlhijfglamdnkjnpdeg',
    name: 'AliRadar',
    resource: 'settings.html',
  },
  {
    id: 'pidkjcapccmhpdokcjnkngcflobhopdl',
    name: 'Flappy Bird Offline',
    resource: 'img/48.png',
  },
  {
    id: 'pjbgfifennfhnbkhoidkdchbflppjncb',
    name: 'Dark Mode',
    resource: 'css/style.css',
  },
  {
    id: 'pkgccpejnmalmdinmhkkfafefagiiiad',
    name: 'FeHelper',
    resource: 'postman/sw.js',
  },
  {
    id: 'pliibjocnfmkagafnbkfcimonlnlpghj',
    name: 'ClickUp',
    resource: 'popup.js',
  },
  {
    id: 'pncfbmialoiaghdehhbnbhkkgmjanfhe',
    name: 'uBlacklist',
    resource: 'pages/options.html',
  },
  {
    id: 'pnhplgjpclknigjpccbcnmicgcieojbh',
    name: 'Diigo Web Collector',
    resource: 'icon16.png',
  },
  {
    id: 'aadbahhifnekkkcbapdfandpimaoacmj',
    name: 'AiPrice(AliPrice) Search by Image for China Import',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'aadiiicebnjmjmibjengdohedcfeekeg',
    name: 'Sorftime Save',
    resource: 'wmFetch.js',
  },
  {
    id: 'aaekanoannlhnajolbijaoflfhikcgng',
    name: 'Charcoal',
    resource: 'charcoal_settings.html',
  },
  {
    id: 'aajjgdpofhhcjmjoombjdfepplndhgcp',
    name: 'Prompt Optimizer',
    resource: 'images/32.png',
  },
  {
    id: 'accllpimnoffllpeblphooameaofhnah',
    name: '楽天リーベイツ ポイントアシスト',
    resource: 'css/popup.css',
  },
  {
    id: 'acglggcafiilnibeknihgglelgfafifo',
    name: 'Volume Control',
    resource: 'index.js',
  },
  {
    id: 'acjecbgflnhmeldadcbblhfdimhifpki',
    name: 'Custom Calendar Background',
    resource: 'options.html',
  },
  {
    id: 'aeachknmefphepccionboohckonoeemg',
    name: 'Coin98 Wallet',
    resource: 'cosmos.eaa93292.js',
  },
  {
    id: 'aedglnfjjccpifohekdeoogffomjcikm',
    name: 'SolvelyAI',
    resource: 'sandbox.html',
  },
  {
    id: 'aggiiclaiamajehmlfpkjmlbadmkledi',
    name: 'TransOver',
    resource: 'popup.js',
  },
  {
    id: 'aimiinbnnkboelefkjlenlgimcabobli',
    name: 'JSONViewer',
    resource: 'assets/source.html',
  },
  {
    id: 'ajiejmhbejpdgkkigpddefnjmgcbkenk',
    name: 'Clipboard',
    resource: 'ckeditor-inject.js',
  },
  {
    id: 'ajlcnbbeidbackfknkgknjefhmbngdnj',
    name: 'Pixiv Toolkit Next',
    resource: 'lib/ffmpeg/ffmpeg-core.wasm',
  },
  {
    id: 'akfldeakecjegioiiajhpjpekomdjnmh',
    name: 'Web Signer for Barclays',
    resource: 'assets/css/main.css',
  },
  {
    id: 'akjpkhfbhcikhabnieacjihhhhdlnfpa',
    name: 'AdBlocker Expert',
    resource: 'timing.js',
  },
  {
    id: 'amembkpfochonfalpaelodhiaangjpih',
    name: 'AliAssist',
    resource: 'images/local.png',
  },
  {
    id: 'amknoiejhlmhancpahfcfcfhllgkpbld',
    name: 'Hoppscotch',
    resource: 'index.js.map',
  },
  {
    id: 'andgibkjiikabclfdkecpmdkfanpdapf',
    name: 'GIPHY for Gmail',
    resource: 'img/up.png',
  },
  {
    id: 'appojfilknpkghkebigcdkmopdfcjhim',
    name: 'Passwordstate',
    resource: 'getpasskey.html',
  },
  {
    id: 'bbmolahhldcbngedljfadjlognfaaein',
    name: 'CheerpJ Applet Runner',
    resource: 'cheerpj/c.js',
  },
  {
    id: 'bboccnojhhoegfffpcllbeigipedjedf',
    name: 'Automation 360',
    resource: 'HTMLSAPWrapper.js',
  },
  {
    id: 'bchkdkhfodkkpohjhabdgfhpgjkkgfhg',
    name: 'AnswerAI',
    resource: 'assets/add.png',
  },
  {
    id: 'bclkldcgifcioppjcncibkjdfaghldoe',
    name: 'Flickcall',
    resource: 'img/remote.svg',
  },
  {
    id: 'bcnccmamhmcabokipgjechdeealcmdbe',
    name: 'e-Dnevnik Plus',
    resource: 'app/index.html',
  },
  {
    id: 'bebmphofpgkhclocdbgomhnjcpelbenh',
    name: 'Translator',
    resource: 'images/48.png',
  },
  {
    id: 'bekopgepchoeepdmokgkpkfhegkeohbl',
    name: 'App for Language',
    resource: 'manifest.json',
  },
  {
    id: 'bfelalhndlhoohbhiddkmkjhcaipclcn',
    name: 'Ad Blocker Elite',
    resource: 'icon.png',
  },
  {
    id: 'bffkjdkbmldjgfibfhggllfpldoepcld',
    name: 'Direct Search Online',
    resource: 'icons/128.png',
  },
  {
    id: 'bjfgambnhccakkhmkepdoekmckoijdlc',
    name: 'Browser MCP',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'bjnkkhimoaclnddigpphpgkfgeggokam',
    name: 'Level up for Dynamics 365/Power Apps',
    resource: 'scripts/Sdk.Soap.min.js',
  },
  {
    id: 'bkagcmloachflbbkfmfiggipaelfamdf',
    name: 'FoE',
    resource: 'js/popup.js',
  },
  {
    id: 'bkkjeefjfjcfdfifddmkdmcpmaakmelp',
    name: 'Truffle',
    resource: 'devtools/index.html',
  },
  {
    id: 'bobjajapamhdnbnimmaddcceeckkoiff',
    name: 'Total WebShield',
    resource: 'app/lander/index.html',
  },
  {
    id: 'bohahkiiknkelflnjjlipnaeapefmjbh',
    name: 'Note Anywhere',
    resource: 'assets/css/sticky.css',
  },
  {
    id: 'bpnedgjmphmmdgecmklcopblfcbhpefm',
    name: 'DjVu.js Viewer',
    resource: 'viewer.html',
  },
  {
    id: 'caejcfciegnnnepdhaopdogngbmojodl',
    name: 'Kimi Explorer',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'ccjlpblmgkncnnimcmbanbnhbggdpkie',
    name: 'Sound Booster',
    resource: 'styles/popup.css',
  },
  {
    id: 'ccnpdidcjgcdgaopacccfghmgdlipnoc',
    name: 'Laser Cat',
    resource: 'js/eye.js',
  },
  {
    id: 'cdoblkdcnbcdlcfklmbmkapbekgfbijp',
    name: 'Happy dog',
    resource: 'images/ball.png',
  },
  {
    id: 'cfmnkhhioonhiehehedmnjibmampjiab',
    name: 'start.me',
    resource: 'popup.html',
  },
  {
    id: 'cgigopjakkeclhggchgnhmpmhghcbnaf',
    name: 'IMTLazarusv3',
    resource: 'sandbox.js',
  },
  {
    id: 'chcbikmmlhbbdkfiaaaljabpefdfajnb',
    name: 'Process Feedback - Writing Process Reports for Google Docs',
    resource: 'public/popup_logo.png',
  },
  {
    id: 'chmpifjjfpeodjljjadlobceoiflhdid',
    name: 'Outreach Everywhere',
    resource: 'gmail-globals.js',
  },
  {
    id: 'cjbmfmeflcomeifhpeglfmpgmmhcopdo',
    name: 'Cash Catch',
    resource: 'icons/icon_32.png',
  },
  {
    id: 'cjdnfmjmdligcpfcekfmenlhiopehjkd',
    name: 'TwoSeven',
    resource: 'web_resources/dummy.js',
  },
  {
    id: 'cljbfnedccphacfneigoegkiieckjndh',
    name: 'Easy Scraper',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'cmncbfaaiogmfeelmicmaafbibedljpk',
    name: 'Mangoboard ColorPicker',
    resource: 'edropper2.js',
  },
  {
    id: 'cmnlolelipjlhfkhpohphpedmkfbobjc',
    name: 'Glarity ChatGPT',
    resource: 'subtitle/inject.js',
  },
  {
    id: 'cpgamigjcbffkaiciiepndmonbfdimbb',
    name: 'Axiom Browser Automation & Web Scraping',
    resource: 'jquery.js',
  },
  {
    id: 'dakjaeligofcdjlcoifkiappabgladep',
    name: 'JumpCloud',
    resource: 'images/ring.svg',
  },
  {
    id: 'dbbbhmnphepimpameepigkpjjnlpmjeg',
    name: 'Spending Calculator for Swiggy and Zomato',
    resource: 'Icons/copy.png',
  },
  {
    id: 'dbepenphjfofmnjmlacfcdehikakmaap',
    name: 'Seamless.AI',
    resource: 'flyout.html',
  },
  {
    id: 'dbfipcjecamggjfabeaclacjoohfjhhn',
    name: 'Up to 40% Cashback',
    resource: 'icons/popup/alert.svg',
  },
  {
    id: 'dbkidnlfklnjanneifjjojofckpcogcl',
    name: 'Lumin',
    resource: 'icons/i-32.png',
  },
  {
    id: 'debflmkfmkejgppfabgfcbemelmnpnho',
    name: 'ViiTor Translate',
    resource: 'images/vip.png',
  },
  {
    id: 'dejobinhdiimklegodgbmbifijpppopn',
    name: 'Tab Reloader',
    resource: 'data/counter/index.html',
  },
  {
    id: 'deojfdehldjjfmcjcfaojgaibalafifc',
    name: 'NeoExamShield',
    resource: 'rules.json',
  },
  {
    id: 'dffaiikpbncahnghlfnkhagffaemhgfo',
    name: 'Multi Find',
    resource: 'popup.html',
  },
  {
    id: 'dhccaifficimfjcpbapjockkipmmlkab',
    name: 'LostFilm.TV',
    resource: 'pages/popup.css',
  },
  {
    id: 'dhhpefjklgkmgeafimnjhojgjamoafof',
    name: 'Save Page WE',
    resource: 'download-iframe-GC.html',
  },
  {
    id: 'dhiaggccakkgdfcadnklkbljcgicpckn',
    name: 'Elevate',
    resource: 'app/index.html',
  },
  {
    id: 'dhoahbnajojjkjblhmfkdjiabiemldmh',
    name: 'AdBlocker Ultra Plus',
    resource: 'data/rules.json',
  },
  {
    id: 'digfbfaphojjndkpccljibejjbppifbc',
    name: 'Moesif Origin/CORS Changer & API Logger',
    resource: 'icon-34.png',
  },
  {
    id: 'djnhkfljnimcpelfndpcjcgngmefaobl',
    name: 'Talk & Comment',
    resource: 'FBPlayer.css',
  },
  {
    id: 'dkgjopcolgcafhnicdahjemapkniikeh',
    name: 'FBA Calculator',
    resource: 'bundle.css',
  },
  {
    id: 'dldjpboieedgcmpkchcjcbijingjcgok',
    name: 'Fuel Wallet',
    resource: 'assets/index-BHWrL7iL.js',
  },
  {
    id: 'dljdacfojgikogldjffnkdcielnklkce',
    name: 'Download Master',
    resource: 'ui/assets/img/download.png',
  },
  {
    id: 'dllpkaoladhieehkbjbifonfblhgkoki',
    name: 'Best AdBlocker',
    resource: 'pp-ui/index.html',
  },
  {
    id: 'dnclbikcihnpjohihfcmmldgkjnebgnj',
    name: 'Mouse Dictionary',
    resource: 'data/rule.json',
  },
  {
    id: 'dpkefahlefbmfgfgfoppbpkacgdmadpp',
    name: 'ProxyPlugin2 CMJ Plugin Adapter',
    resource: 'FirePromise.js',
  },
  {
    id: 'eakdijdofmnclopcffkkgmndadhbjgka',
    name: 'HLS Player',
    resource: 'hls.js',
  },
  {
    id: 'ebeglcfoffnnadgncmppkkohfcigngkj',
    name: 'VideoPlus',
    resource: 'js/core.js',
  },
  {
    id: 'ebgmlfdcgihhfheckfdmhnmedjigogmm',
    name: 'Open incognito tab',
    resource: 'images/48x48.png',
  },
  {
    id: 'ebilacdhmebcihmbjgibcbeaihbecapj',
    name: 'Dastyar Personal Assistant',
    resource: 'assets/img/lib/tl.svg',
  },
  {
    id: 'eefedolmcildfckjamddopaplfiiankl',
    name: 'ScreenPal',
    resource: 'app/pip.html',
  },
  {
    id: 'efbjojhplkelaegfbieplglfidafgoka',
    name: 'VT4Browsers + Google TI',
    resource: 'icons/gti-vt-icon2.png',
  },
  {
    id: 'egehpkpgpgooebopjihjmnpejnjafefi',
    name: 'Better History',
    resource: 'assets/icons/icon16.png',
  },
  {
    id: 'einpaelgookohagofgnnkcfjbkkgepnp',
    name: 'Random User-Agent',
    resource: 'mbEGGjir.js',
  },
  {
    id: 'ejgmneenioanldgngdomlfnbcbffmchf',
    name: 'Salesloft',
    resource: 'manifest.json',
  },
  {
    id: 'ejgnolahdlcimijhloboakpjogbfdkkp',
    name: 'Meow, The Cat Pet',
    resource: 'images/fish.png',
  },
  {
    id: 'enamippconapkdmgfgjchkhakpfinmaj',
    name: 'DeArrow',
    resource: 'help.css',
  },
  {
    id: 'enboaomnljigfhfjfoalacienlhjlfil',
    name: 'UnTrap for YouTube',
    resource: 'extension/screens/privacyPolicy/privacyPolicyForTab.js',
  },
  {
    id: 'enokdcnimpdlohalipcbkknffnhhdnac',
    name: 'Music Identifier',
    resource: 'static/images',
  },
  {
    id: 'enpannaocdooaplolobjfclkjefbeocn',
    name: 'Ad Blocker',
    resource: 'static/icon_active.png',
  },
  {
    id: 'epejdmjgfibjaffbmojllapapjejipkh',
    name: 'Samsung Browser',
    resource: 'popup-vue.html',
  },
  {
    id: 'epemkdedgaoeeobdjmkmhhhbjemckmgb',
    name: 'Auto Admit for Google Meet',
    resource: 'icons/icon-512.png',
  },
  {
    id: 'faalglbfgpcdpnngnnbhlcahgfnhoieb',
    name: 'Скачать ВК Видео',
    resource: 'pages/popup.html',
  },
  {
    id: 'fahhlhbhnmkjegdfoiadmnhcclidoflh',
    name: 'AliPrice Search by image',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'fdcnegogpncmfejlfnffnofpngdiejii',
    name: 'Razor Wallet',
    resource: 'injectScript.js',
  },
  {
    id: 'fdfcjfoifbjplmificlkdfneafllkgmn',
    name: 'Highlighter',
    resource: 'images/16.png',
  },
  {
    id: 'ffdaeeijbbijklfcpahbghahojgfgebo',
    name: 'Gyazo',
    resource: 'menu.css',
  },
  {
    id: 'ffljdddodmkedhkcjhpmdajhjdbkogke',
    name: 'Datalayer Checker',
    resource: 'js/datalayer-checker.js',
  },
  {
    id: 'fiabciakcmgepblmdkmemdbbkilneeeh',
    name: 'Tab Suspender',
    resource: 'buy.js',
  },
  {
    id: 'fiikommddbeccaoicoejoniammnalkfa',
    name: 'Nightly',
    resource: 'inject.js',
  },
  {
    id: 'fijngjgcjhjmmpcmkeiomlglpeiijkld',
    name: 'Talisman Wallet',
    resource: 'page.js',
  },
  {
    id: 'fjbgpaheigpmkbdkdfghmkbnkpeofmhh',
    name: 'Aura',
    resource: 'images/logo-16.svg',
  },
  {
    id: 'fjjlkgnbokonfaiffccmofmfopdlfmmf',
    name: 'Indian Railways',
    resource: 'scripts/page-script.js',
  },
  {
    id: 'fkagelmloambgokoeokbpihmgpkbgbfm',
    name: 'Indie Wiki Buddy',
    resource: 'data/sitesCA.json',
  },
  {
    id: 'fkjngjgmgbfelejhbjblhjkehchifpcj',
    name: 'Smart Auto Refresh',
    resource: 'content.js',
  },
  {
    id: 'fkmjepmhjempmabllonmpnlfanoknlkd',
    name: 'Kyruus Health Admin Toolkit',
    resource: 'sidepanel.html',
  },
  {
    id: 'flbjommegcjonpdmenkdiocclhjacmbi',
    name: 'HeadingsMap',
    resource: 'css/dialog.css',
  },
  {
    id: 'fldgacclkckcmflokaialbihppmndpbd',
    name: 'Mapify',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'gcjpefhffmcgplgklffgbebganmhffje',
    name: 'NetSupport School Student',
    resource: 'oem.json',
  },
  {
    id: 'gelkmljpoacdjkjkcfekkmgkpnmeomlk',
    name: 'Blocklive',
    resource: 'sounds/ping.mp3',
  },
  {
    id: 'giabbpobpebjfegnpcclkocepcgockkc',
    name: 'Screenshot Capture',
    resource: 'vendor/Jcrop.gif',
  },
  {
    id: 'gjagmgiddbbciopjhllkdnddhcglnemk',
    name: 'Hashpack',
    resource: 'warning/index.html',
  },
  {
    id: 'gjdimoodoalmblikhoicpcfnhlkkghgf',
    name: 'vLex',
    resource: 'resources/img/alert.png',
  },
  {
    id: 'gjollpknhcpffpophlagemekjakfgfdk',
    name: 'Temushuju',
    resource: 'popup.css',
  },
  {
    id: 'gmpljdlgcdkljlppaekciacdmdlhfeon',
    name: 'Docs Online Viewer',
    resource: 'images/beside-link-icon.svg',
  },
  {
    id: 'gojogohjgpelafgaeejgelmplndppifh',
    name: 'Email Tracker',
    resource: 'img/ef.png',
  },
  {
    id: 'hajphibbdloomfdkeoejchiikjggnaif',
    name: 'QuestionAI',
    resource: 'assets/icon.png',
  },
  {
    id: 'hbkblmodhbmcakopmmfbaopfckopccgp',
    name: 'Thunderbit',
    resource: 'index.html',
  },
  {
    id: 'hcjhpkgbmechpabifbggldplacolbkoh',
    name: 'StarKey Wallet',
    resource: 'images/logo.svg',
  },
  {
    id: 'hcjohblbkdgcoikaedjndgbcgcfoojmj',
    name: 'Share-A-Cart',
    resource: 'images/sac-16.png',
  },
  {
    id: 'hdapplggdhndkblofffknpmnnnnbncbn',
    name: 'Kortex',
    resource: 'src/rating/rating.js',
  },
  {
    id: 'hdlehfdjcalidklijenibmpcdgjfmafn',
    name: 'Revolut Shopper',
    resource: 'dropdown.html',
  },
  {
    id: 'hebjaboacandjnlnhocfikmaghgbfjlp',
    name: 'Video Downloader Pro',
    resource: 'popup.html',
  },
  {
    id: 'heeikiohkfkolhmdodhcjdklofmhmmhn',
    name: 'Translator',
    resource: 'icons/button.png',
  },
  {
    id: 'hhnjkanigjoiglnlopahbbjdbfhkndjk',
    name: 'Power Thesaurus',
    resource: 'fonts/roboto-latin-500.woff2',
  },
  {
    id: 'hiiekpdmbjbfhdneebgpnbbmcnlelacp',
    name: 'Ad Blocker Unlimited',
    resource: 'filters/1.json',
  },
  {
    id: 'hjhgdemcnjlhekapcjegdlckfhbmfokc',
    name: 'ReadSpeaker TextAid',
    resource: 'css/style.css',
  },
  {
    id: 'hjppjkabmcjcmfoanoclkkjlcelepaeo',
    name: 'IDL Helper',
    resource: 'ffmpeg-core.wasm',
  },
  {
    id: 'hkflippjghmgogabcfmijhamoimhapkh',
    name: 'McAfee Anti-tracker',
    resource: 'css/welcome.css',
  },
  {
    id: 'hkojjajclkgeijhcmfjcjkddfjpaimek',
    name: 'QR Code',
    resource: 'scripts/common.js',
  },
  {
    id: 'hlepfoohegkhhmjieoechaddaejaokhf',
    name: 'Refined GitHub',
    resource: 'assets/icon.png',
  },
  {
    id: 'hmdmhilocobgohohpdpolmibjklfgkbi',
    name: 'Odoo Debug',
    resource: 'pageScript.js',
  },
  {
    id: 'hnpjoenijmmlacknhmbolaofgoeckbmi',
    name: 'Youtube Unblocked',
    resource: 'yt2.js',
  },
  {
    id: 'hohedjmdoemgcpgdapepfhnilbedldnm',
    name: 'PerfecTab Search',
    resource: 'icon128.png',
  },
  {
    id: 'homifejhmckachdikhkgomachelakohh',
    name: 'Scite',
    resource: 'fonts/scite-icons/scite-icons.svg',
  },
  {
    id: 'hpcgabhdlnapolkkjpejieegfpehfdok',
    name: 'MediaHarvest',
    resource: 'static/TEST.data',
  },
  {
    id: 'iaajmlceplecbljialhhkmedjlpdblhp',
    name: 'Vue.js devtools',
    resource: 'devtools.html',
  },
  {
    id: 'iaaokenmfgahhlcfbdipjonlkeinadaa',
    name: 'Website Downloader',
    resource: 'icon/16.png',
  },
  {
    id: 'iahnhfdhidomcpggpaimmmahffihkfnj',
    name: 'JSON-handle',
    resource: 'options.html',
  },
  {
    id: 'icallnadddjmdinamnolclfjanhfoafe',
    name: 'FastForward',
    resource: 'icon/48.png',
  },
  {
    id: 'ifdepgnnjpnbkcgempionjablajancjc',
    name: 'FocusGuard',
    resource: 'block.html',
  },
  {
    id: 'ifgehbglgmidafhhdcopacejknmcmhcd',
    name: 'ClaroRead',
    resource: 'jq.js',
  },
  {
    id: 'ihljmnfgkkmoikgkdkjejbkpdpbmcgeh',
    name: 'Listly',
    resource: 'html/loading/iframe.html',
  },
  {
    id: 'iifacdnjakkhjjiengaffnegbndgingi',
    name: 'Voyager',
    resource: 'icon-32.png',
  },
  {
    id: 'iledlaeogohbilgbfhmbgkgmpplbfboh',
    name: 'Jupiter',
    resource: 'injected.js',
  },
  {
    id: 'ilglobbeckliiacnbnohbbefhkoloblo',
    name: 'Lingdys',
    resource: 'pdf.js',
  },
  {
    id: 'ilngnjopnchkedjkdjlalnlbfpkhmbie',
    name: 'Cursor Trails',
    resource: 'images/sun.svg',
  },
  {
    id: 'immpagioobbjjlckfakmgpnbhheamcbi',
    name: 'InstaText',
    resource: 'images/flags/hy.svg',
  },
  {
    id: 'imoajpmchijilhegjalddomgffnfhfgj',
    name: 'Rabatta',
    resource: 'fonts/LICENSE.txt',
  },
  {
    id: 'injlinpljbkaecdfcipjihconmpndkjj',
    name: 'TrustLogin',
    resource: 'img/loading_service_page.gif',
  },
  {
    id: 'jadmfofmocfeekmkpohbnmanfgalpbla',
    name: 'UXM',
    resource: 'js/uxm_web_agent.debug.js',
  },
  {
    id: 'jblndlipeogpafnldhgmapagcccfchpi',
    name: 'Kaia Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'jcgpghgjhhahcefnfpbncdmhhddedhnk',
    name: 'Click to Remove Element',
    resource: 'content.css',
  },
  {
    id: 'jdaeekgkccdeljekhchpnkanocghccch',
    name: 'NiCE Browser Connector',
    resource: 'cs/csInjectorHook.js',
  },
  {
    id: 'jedjajddobfbhgoaidfigmlkijbeaene',
    name: 'CT Access',
    resource: 'icon-32px.png',
  },
  {
    id: 'jfpmbokkdeapjommajdfmmheiiakdlgo',
    name: 'Download with JDownloader',
    resource: 'data/grab/index.html',
  },
  {
    id: 'jgphnjokjhjlcnnajmfjlacjnjkhleah',
    name: '购物党自动比价工具',
    resource: 'js/main.js',
  },
  {
    id: 'jhgpmfdfgihdclapmppfeddggkidnoid',
    name: 'AdSparo',
    resource: 'jquery.js',
  },
  {
    id: 'jhnleheckmknfcgijgkadoemagpecfol',
    name: 'Auto Tab Discard',
    resource: 'data/page.png',
  },
  {
    id: 'jiaopkfkampgnnkckajcbdgannoipcne',
    name: 'Adblock Unlimited',
    resource: 'block.html',
  },
  {
    id: 'jiofmdifioeejeilfkpegipdjiopiekl',
    name: 'YesCaptcha assistant',
    resource: 'content/injected.js',
  },
  {
    id: 'jjpbbahenfdgofabbgcnnfejgcigadpd',
    name: 'Alibaba Lens',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'jkkfeklkdokfnlfodkdafododleokdoa',
    name: 'BlockerX',
    resource: 'assets/web.png',
  },
  {
    id: 'jlpcnoohcpfgpbalhlggdhjocgnlgafn',
    name: '有道灵动翻译',
    resource: 'logo.svg',
  },
  {
    id: 'jmpepeebcbihafjjadogphmbgiffiajh',
    name: 'Lingocloud',
    resource: 'dist/video-subtitle.js',
  },
  {
    id: 'jnefaihbaohechagcjhebbjofkiolgan',
    name: 'Passei Direto',
    resource: 'crop.88d1e2ef.svg',
  },
  {
    id: 'jnegnfbcjklhkmoihoakeijbealomipg',
    name: 'Wayground AI',
    resource: 'popup.js',
  },
  {
    id: 'jnlgamecbpmbajjfhmmmlhejkemejdma',
    name: 'Braavos',
    resource: 'static/js/inpage.js',
  },
  {
    id: 'jnpfnacconjipomhfkphknjfmcnhagpb',
    name: 'Pricy',
    resource: 'icon16.png',
  },
  {
    id: 'jodfjmaiakpnmeddgpeflpafebmlhppn',
    name: 'Speech Translator',
    resource: 'popup.html',
  },
  {
    id: 'johejpedmdkeiffkdaodgoipdjodhlld',
    name: 'Chessvision',
    resource: 'bK.svg',
  },
  {
    id: 'kagjkiiecagemklhmhkabbalfpbianbe',
    name: 'AI Exporter',
    resource: 'preview.html',
  },
  {
    id: 'kblbdlhoeakihpcaimpdjnfkjffnhhej',
    name: 'Points Path for Google Flights',
    resource: 'popup.js',
  },
  { id: 'kdadialhpiikehpdeejjeiikopddkjem', name: 'Any.do', resource: 'ar.js' },
  {
    id: 'kdelkaogljjcbjffjmahedaobfjineig',
    name: 'Notta',
    resource: 'permissions.html',
  },
  {
    id: 'kdfkejelgkdjgfoolngegkhkiecmlflj',
    name: 'Bionic Reading',
    resource: 'icons/active.png',
  },
  {
    id: 'keaaclcjhehbbapnphnmpiklalfhelgf',
    name: 'RevEye Reverse Image Search',
    resource: 'whatsnew.html',
  },
  {
    id: 'kegphgaihkjoophpabchkmpaknehfamb',
    name: 'Cently',
    resource: 'siteScript.js',
  },
  {
    id: 'keibmolmaeiahiahfgenlaidmokmfcfm',
    name: 'Astro',
    resource: 'assets/svg/drop.svg',
  },
  {
    id: 'kgjpihadkppeljjapkmainmohomeppok',
    name: 'Universal Ad Blocker',
    resource: 'icon.png',
  },
  {
    id: 'kgknjmfebhekokplfpmodjopebmfdjac',
    name: 'AdBlocker Professional',
    resource: 'icon.png',
  },
  {
    id: 'kgmohllpiohdkkhhkfneojbadinddkpm',
    name: 'Opus Advisor',
    resource: 'index.html',
  },
  {
    id: 'khnpeclbnipcdacdkhejifenadikeghk',
    name: 'Asana',
    resource: 'index.html',
  },
  {
    id: 'kidmffepbniamfbibhfgdakkggchipjl',
    name: 'SellerAmp SAS',
    resource: 'proxy.html',
  },
  {
    id: 'kiijhgpgjnhkhpagmcgihhigiolpogec',
    name: 'XML Signer',
    resource: 'crocxmlsigner.js',
  },
  {
    id: 'kkfgenjfpmoegefcckjklfjieepogfhg',
    name: 'Kaspr',
    resource: 'assets/images/i.svg',
  },
  {
    id: 'kkfocohhekldeddhkllgofalggnlhhae',
    name: 'BigSeller',
    resource: 'static/img/16x16.png',
  },
  {
    id: 'klghhnkeealcohjjanjjdaeeggmfmlpl',
    name: 'Zerion Wallet',
    resource: 'content-script/in-page.js',
  },
  {
    id: 'klknhfgkblobpfimidmhkclikdalnoke',
    name: 'Transcript',
    resource: 'step1.7de768f7.png',
  },
  {
    id: 'kmcfomidfpdkfieipokbalgegidffkal',
    name: 'Enpass',
    resource: 'icons/cross.svg',
  },
  {
    id: 'knkpjhkhlfebmefnommmehegjgglnkdm',
    name: 'Video Downloader professional',
    resource: 'img/32.png',
  },
  {
    id: 'kpjldaeddnfokhmgdlmpdlecmobaonnj',
    name: 'Protractor',
    resource: 'images/sprite-buttons.svg',
  },
  {
    id: 'lajfdngpocmchpihjecojjllfjeehgnl',
    name: 'SEO Pro',
    resource: 'popup.html',
  },
  {
    id: 'ldbooahljamnocpaahaidnmlgfklbben',
    name: 'Recall',
    resource: 'fonts/FuturaNowHeadline.ttf',
  },
  {
    id: 'lecdifefmmfjnjjinhaennhdlmcaeeeb',
    name: '稀土掘金',
    resource: 'main.html',
  },
  {
    id: 'ledkggjjapdgojgihnaploncccgiadhg',
    name: 'Video Downloader Ultimate',
    resource: 'popup.html',
  },
  {
    id: 'lgmpcpglpngdoalbgeoldeajfclnhafa',
    name: 'SafePal',
    resource: 'inpage.js',
  },
  {
    id: 'lhciigpkocgkbnbjimbbiejpfijdbcag',
    name: 'Action Model',
    resource: 'es.178c197f.js',
  },
  {
    id: 'lijhjhlnfifgoabbihoobnfapogkcjgk',
    name: 'Scrible',
    resource: 'images/Favicon32.png',
  },
  {
    id: 'likgccmbimhjbgkjambclfkhldnlhbnn',
    name: 'Yomitan Popup Dictionary',
    resource: 'popup.html',
  },
  {
    id: 'ljdobmomdgdljniojadhoplhkpialdid',
    name: 'Katalon Recorder',
    resource: 'page/prompt.js',
  },
  {
    id: 'ljjemllljcmogpfapbkkighbhhppjdbg',
    name: 'Vue.js devtools (beta)',
    resource: 'dist/proxy.js',
  },
  {
    id: 'lkacpincnpeaopanmojlgibodfibghjc',
    name: '小满助手',
    resource: 'assets/img/mk.png',
  },
  {
    id: 'lkeokcighogdliiajgbbdjibidaaeang',
    name: 'Screen Recorder',
    resource: 'options.js',
  },
  {
    id: 'lkhobecnbfaanleincejmdaiobilholm',
    name: 'Galaxy Ad Blocker',
    resource: 'filters/data.json',
  },
  {
    id: 'lkmpdpkkkeeoiodlnmlichcmfmdjbjic',
    name: 'TopCashback',
    resource: 'icon-32.png',
  },
  {
    id: 'lknpbgnookklokdjomiildnlalffjmma',
    name: 'Save Story for Instagram',
    resource: 'img/done.svg',
  },
  {
    id: 'llimhhconnjiflfimocjggfjdlmlhblm',
    name: 'Reader Mode',
    resource: 'main.html',
  },
  {
    id: 'lmaokgcdiccpfgacillojaojkfpdfeej',
    name: 'Skinport Plus',
    resource: 'fonts.css',
  },
  {
    id: 'lnidijeaekolpfeckelhkomndglcglhh',
    name: 'Whom?',
    resource: 'index.html',
  },
  {
    id: 'logldmlncddmdfcjaaljjjkajcnacigc',
    name: 'BeFrugal',
    resource: 'icon48.png',
  },
  {
    id: 'lpfcbjknijpeeillifnkikgncikgfhdo',
    name: 'Nami',
    resource: 'icon-34.png',
  },
  {
    id: 'lpindahibbkakkdjifonckbhopdoaooe',
    name: '3DOS Network',
    resource: 'assets/css/ui.chunk.css',
  },
  {
    id: 'lplhnhhlblehjmmkcpjbojiaanbpgnpd',
    name: 'BetterBLOX',
    resource: 'changelog.json',
  },
  {
    id: 'lppbajkahdbbadheilijoeegnfndhlab',
    name: 'PPSPY-#1',
    resource: 'img/bg.png',
  },
  {
    id: 'mbiehbednoakmhlmjcpgpciocekdjabp',
    name: 'RUMIWIFI translator for Xiaomi router',
    resource: 'img/logo.svg',
  },
  {
    id: 'mbopgmdnpcbohhpnfglgohlbhfongabi',
    name: 'BlazeMeter',
    resource: 'sideex/prompt.js',
  },
  {
    id: 'medapdbncneneejhbgcjceippjlfkmkg',
    name: 'Markdown Reader',
    resource: 'assets/logo.png',
  },
  {
    id: 'meffljleomgifbbcffejnmhjagncfpbd',
    name: 'Infinite Dashboard',
    resource: 'img/32.png',
  },
  {
    id: 'meimoidfecamngeoanhnpdjjdcefoldn',
    name: 'Fireflies',
    resource: 'assets/images/rec.svg',
  },
  {
    id: 'mffifeinkgjdnhnamgabdknfkdnmkgmj',
    name: 'HelloID',
    resource: 'Framework/css/SSO.css',
  },
  {
    id: 'mgbmfbimbcffegjaagiolbjpfbepjogk',
    name: 'Grid View for Google Meet',
    resource: 'icons/grid.png',
  },
  {
    id: 'mgjneceglphcpbbfbhjplkpgfapebmdg',
    name: 'Cosmos',
    resource: 'assets/img/icon-16.png',
  },
  {
    id: 'mglpocjcjbekdckiahfhagndealpkpbj',
    name: 'AdGuard Extra',
    resource: 'userscript.js',
  },
  {
    id: 'mgpdnhlllbpncjpgokgfogidhoegebod',
    name: 'PhotoShow',
    resource: 'content/common.css',
  },
  {
    id: 'mhccpoafgdgbhnjfhkcmgknndkeenfhe',
    name: 'Verification Plugin',
    resource: 'content-scripts/inject.js',
  },
  {
    id: 'mhlppgemmcdfjonomcbgfddlgcjnghga',
    name: 'Adblocker Fortify',
    resource: 'block.js',
  },
  {
    id: 'mifjkjljbbnepicdbbemkaafcjmplkaj',
    name: 'Save image as PDF',
    resource: 'images/48x48.png',
  },
  {
    id: 'miijkofiplfeonkfmdlolnojlobmpman',
    name: 'SmartLens AI',
    resource: 'icons/icon16.png',
  },
  {
    id: 'mipimgcmndeggldjcbjfeogcpoafomhl',
    name: 'Milanote Web Clipper',
    resource: 'css/drawer.css',
  },
  { id: 'mklbhckkgddhlcdagmobdmnadpjokkkn', name: 'Guru', resource: '749.js' },
  {
    id: 'mmfhhfjhpadoefoaahomoakamjcfcoil',
    name: 'TextExpander',
    resource: 'main_window.html',
  },
  {
    id: 'mmiioagbgnbojdbcjoddlefhmcocfpmn',
    name: 'Amazon DCV WebAuthn Redirection',
    resource: '16.png',
  },
  {
    id: 'mnlohknjofogcljbcknkakphddjpijak',
    name: 'Translate',
    resource: 'frame/popup.html',
  },
  {
    id: 'mnpdbmgpebfihcndnpgdaihnkmloclkd',
    name: 'ChatGLM',
    resource: 'insert.js',
  },
  {
    id: 'molncoemjfmpgdkbdlbjmhlcgniigdnf',
    name: 'Naptha',
    resource: 'swt-worker.js',
  },
  {
    id: 'mpajidobdpdigheplhpfggmeldjcpgfh',
    name: 'AliHunter',
    resource: 'assets/js/vendors.js',
  },
  {
    id: 'mpeengabcnhhjjgleiodimegnkpcenbk',
    name: 'HOT Wallet',
    resource: 'index.html',
  },
  {
    id: 'mpkdoimpgkhjcicmhmlmgboelebflpla',
    name: 'classroom.cloud Student',
    resource: 'oem.json',
  },
  {
    id: 'naijndjklgmffmpembnkfbcjbognokbf',
    name: 'UET Tag Helper',
    resource: 'images/icon_100x100.png',
  },
  {
    id: 'namibaeakmnknolcnomfdhklhkabkchl',
    name: 'Conch AI',
    resource: 'assets/content.js-CT05Gyqb.js',
  },
  {
    id: 'nbhfcmbdimdbbclfngkjfmgmjhnkjocl',
    name: 'AliSave',
    resource: 'public/icon-bg.png',
  },
  {
    id: 'nbokbjkabcmbfdlbddjidfmibcpneigj',
    name: 'SmoothScroll',
    resource: 'img/cursor.svg',
  },
  {
    id: 'ndcooeababalnlpkfedmmbbbgkljhpjf',
    name: 'ScriptCat',
    resource: 'src/install.html',
  },
  {
    id: 'nebnhfamliijlghikdgcigoebonmoibm',
    name: 'Leo Wallet',
    resource: 'addToWindow.js',
  },
  {
    id: 'nglbhlefjhcjockellmeclkcijildjhi',
    name: 'Lingualeo Language Translator',
    resource: 'img/128.png',
  },
  {
    id: 'ngmfehckdahhmlbabjemcepfhgnoddlo',
    name: 'Draw on Page',
    resource: 'data/interface/index.html',
  },
  {
    id: 'njnakjakcnkmnogiopbiomdleekeogkp',
    name: 'vsHotel',
    resource: 'logo.25027d6c.svg',
  },
  {
    id: 'njopapoodmifmcogpingplfphojnfeea',
    name: 'AMZScout PRO',
    resource: 'bundle.css',
  },
  {
    id: 'nljcdkjpjnhlilgepggmmagnmebhadnk',
    name: 'Website SEO Checker',
    resource: 'js/page_scripts.js',
  },
  {
    id: 'nmgcefdhjpjefhgcpocffdlibknajbmj',
    name: 'mymind',
    resource: 'icons/logo.svg',
  },
  {
    id: 'nmgpnfccjfjhdenioncabecepjcmdnjg',
    name: 'FasterWeb',
    resource: 'assets/content.js',
  },
  {
    id: 'nnpljppamoaalgkieeciijbcccohlpoh',
    name: 'Redirect Trace',
    resource: 'img/star.png',
  },
  {
    id: 'nogempgplicnckhcmgjjjgflmipmbgaf',
    name: 'Influencer Analytics',
    resource: 'assets/iframe.js',
  },
  {
    id: 'nohenbjhjbaleokplonjkbmackfkpcne',
    name: 'Flash Player',
    resource: 'popup.css',
  },
  {
    id: 'noogafoofpebimajpfpamcfhoaifemoa',
    name: 'The Marvellous Suspender',
    resource: 'suspended.html',
  },
  {
    id: 'npbjhobkibekbklkghlhfhieggcggpdb',
    name: 'Rovo',
    resource: 'compiled-css.css',
  },
  {
    id: 'oacmmmjedhheaijfjidilonpngccnhdl',
    name: 'Guidde',
    resource: 'g_icon.png',
  },
  {
    id: 'obpcenkclppghkfpielmefegceegofeh',
    name: 'Browse AI',
    resource: 'popup.js',
  },
  {
    id: 'ocggccaacacpienfcgmgcihoombokbbj',
    name: 'New tab page',
    resource: 'pages/common.js',
  },
  {
    id: 'ocmojhiloccgbpjnkeiooioedaklapap',
    name: 'Glimpse',
    resource: 'inject.css',
  },
  {
    id: 'ogjibjphoadhljaoicdnjnmgokohngcc',
    name: 'NextAI Translator',
    resource: 'assets/i18n-0b7e0a68.js',
  },
  {
    id: 'okembgocccnjoiaafmdedmhodcoalbgg',
    name: 'Rewardsweb',
    resource: 'fraudSandbox.html',
  },
  {
    id: 'okmgbbamdmcnbbnamaegggpglkepfpja',
    name: 'Smart popup blocker',
    resource: 'ui/index.js',
  },
  {
    id: 'omimccinlhlkpjaeaocglgmkbelejlhj',
    name: 'Flash Player for the Web',
    resource: 'data/content_script/page_context/vendor/ruffle.js',
  },
  {
    id: 'omlipfboclalclnoekphiecadjlklphh',
    name: 'PDF Candy',
    resource: 'capture-html.js',
  },
  {
    id: 'ookdjilphngeeeghgngjabigmpepanpl',
    name: 'Cookie Editor',
    resource: 'gifs/loading.gif',
  },
  {
    id: 'ookjlbkiijinhpmnjffcofjonbfbgaoc',
    name: 'Temple Wallet',
    resource: 'fullpage.html',
  },
  {
    id: 'opfgelmcmbiajamepnmloijbpoleiama',
    name: 'Rainbow',
    resource: '703.css',
  },
  {
    id: 'paijfdbeoenhembfhkhllainmocckace',
    name: 'SAML Chrome Panel',
    resource: 'panel/assets/javascripts/sameTab.js',
  },
  {
    id: 'papdhfmmdhepoeeimnkdhnadpmemeamk',
    name: 'Cheap Flight Finder',
    resource: 'favicon.ico',
  },
  {
    id: 'pbajmiiebklfjhkeahpgjdlgclelihjh',
    name: 'Transkriptor',
    resource: 'tabs/permission.html',
  },
  {
    id: 'pbichgopagjidnkeaablhiediibgbmec',
    name: 'Comparador EscolhaSegura',
    resource: 'index.css',
  },
  {
    id: 'pbjjkligggfmakdaogkfomddhfmpjeni',
    name: 'Accessibility Insights',
    resource: 'NOTICE.html',
  },
  {
    id: 'pcfbfimijgibligmbglggnbiobgjgmbk',
    name: 'Synology Web Clipper',
    resource: 'login.html',
  },
  {
    id: 'pdmhehfogekmpmdoemhabjpaiadagpgp',
    name: 'Student Beans',
    resource: 'index.html',
  },
  {
    id: 'pembniiibielncgmegepmgcbkieljieh',
    name: 'ZYing',
    resource: 'assets/flag/AE.svg',
  },
  {
    id: 'pemhgklkefakciniebenbfclihhmmfcd',
    name: 'Visualping',
    resource: 'img/bolt.png',
  },
  {
    id: 'penndbmahnpapepljikkjmakcobdahne',
    name: 'Video Downloader Pro',
    resource: 'pay.html',
  },
  {
    id: 'penohjgblobinadflplocjekaclnoemh',
    name: 'TikTok Watermark',
    resource: 'src/assets/icon/iconfont.js',
  },
  {
    id: 'pgakpjflombjmehnebnbpnalhegaanag',
    name: 'rhwp',
    resource: 'wasm/rhwp.js',
  },
  {
    id: 'pgbdljpkijehgoacbjpolaomhkoffhnl',
    name: 'MailTracker',
    resource: 'icon16.png',
  },
  {
    id: 'pgccoaecgcgnhffkjjcaonjoockggmng',
    name: 'Dropship',
    resource: 'logo16.png',
  },
  {
    id: 'phkbamefinggmakgklpkljjmgibohnba',
    name: 'Pontem Crypto Wallet',
    resource: 'assets/inpage.js',
  },
  {
    id: 'pjbnfpohnepfohjeklbpeekacpellded',
    name: 'Safety for Gmail',
    resource: 'images/space.png',
  },
  {
    id: 'plmlopfeeobajiecodiggabcihohcnge',
    name: 'Sound Booster',
    resource: 'popup.css',
  },
  {
    id: 'plnahcmalebffmaghcpcmpaciebdhgdf',
    name: 'WCAG Color contrast checker',
    resource: 'css/style.css',
  },
  {
    id: 'pmlcjncilaaaemknfefmegedhcgelmee',
    name: 'Tetris Classic',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'pnlphjjfielecalmmjjdhjjninkbjdod',
    name: 'FastSave',
    resource: 'js/main.js',
  },
  {
    id: 'pooaemmkohlphkekccfajnbcokjlbehk',
    name: 'Cleaner',
    resource: 'popup.html',
  },
  {
    id: 'ppfoibjbcchcfifclhebkhnigneiceje',
    name: 'AliSave Plus',
    resource: 'icons/icon16.png',
  },
  {
    id: 'aajoalonednamcpodaeocebfgldhcpbe',
    name: 'Check My Links',
    resource: 'pages/linkreport.html',
  },
  {
    id: 'abdkkegmcbiomijcbdaodaflgehfffed',
    name: 'SMD',
    resource: 'ui/pixel.png',
  },
  {
    id: 'adikhbfjdbjkhelbdnffogkobkekkkej',
    name: 'Flipshope',
    resource: 'icon-34.png',
  },
  {
    id: 'aeldeepjdhhldhbgfodleiodmeegnacm',
    name: 'PhotoSolve',
    resource: 'icons/x.png',
  },
  {
    id: 'bbbiejemhfihiooipfcjmjmbfdmobobp',
    name: 'BewlyBewly',
    resource: 'assets/empty.png',
  },
  {
    id: 'bcfkiidkpkfdmdnmafkkhffacoeapeed',
    name: 'Qui-Quo',
    resource: 'data/quote.js',
  },
  {
    id: 'bchhcfjoloinebjpbfklckgohpjehdmf',
    name: 'Auto Meta',
    resource: 'images/logo.png',
  },
  {
    id: 'bhmibpbadaengbikmoglphhlhioajdjn',
    name: 'Sphere Lite',
    resource: 'js/detect.js',
  },
  {
    id: 'bkfagmnjmfjalbbaiphoiiafghlknpog',
    name: 'Softdreams',
    resource: 'page.js',
  },
  {
    id: 'bnfdmghkeppfadphbnkjcicejfepnbfe',
    name: 'Sticky Password',
    resource: 'spWebAuthnPageScript.js',
  },
  {
    id: 'cebmnlammjhancocbbnfcglifgdpfejc',
    name: 'AI Blaze',
    resource: 'css/picker.css',
  },
  {
    id: 'cjfdbemmaeeohgibnhdhlakiahifjjcf',
    name: 'Microsoft Clarity Live',
    resource: 'panel.js',
  },
  {
    id: 'dahnmmlhchpmmlgebpkpaofbefjdlpin',
    name: 'GamersClub Booster',
    resource: 'images/discord.svg',
  },
  {
    id: 'dakkielolpafjbgnjnakddabmbbkcioe',
    name: 'AegisWeb3',
    resource: 'img/risk.png',
  },
  {
    id: 'dkbccihpiccbcheieabdbjikohfdfaje',
    name: 'Video Downloader for U',
    resource: 'popup.js',
  },
  {
    id: 'dnebklifojaaecmheejjopgjdljebpeo',
    name: 'Everhour',
    resource: 'fonts/Lato-Regular.woff2',
  },
  {
    id: 'ehfcoplbhoohillcmlophcfghpeilfjc',
    name: 'Luna Adblock for Youtube & Websites',
    resource: 'shims/noop.js',
  },
  {
    id: 'ejmmioggcokagpjlajeilkakgphhmmbj',
    name: 'Mochi Dictionary',
    resource: 'images/icon.png',
  },
  {
    id: 'epapihdplajcdnnkdeiahlgigofloibg',
    name: 'Sender Wallet',
    resource: 'icon-38.png',
  },
  {
    id: 'febilkbfcbhebfnokafefeacimjdckgl',
    name: 'Markdown Preview Plus',
    resource: 'bootstrap.css',
  },
  {
    id: 'fhlkodelflcjkfkelgpinhdbnejpmnck',
    name: 'WebScannerPro',
    resource: 'logo.svg',
  },
  {
    id: 'floniaahmccleoclneebhhmnjgdfijgg',
    name: 'Colorblindly',
    resource: 'filters/normal.js',
  },
  {
    id: 'gnidjfdekbljleajoeamecfijnhbgndl',
    name: 'Sound Booster that Works!',
    resource: 'assets/icon.png',
  },
  {
    id: 'hifafgmccdpekplomjjkcfgodnhcellj',
    name: 'Crypto.com',
    resource: 'assets/zh-DPCIlXyc.js',
  },
  {
    id: 'hppdgjpcbnbfapnailmeiibngpolplao',
    name: 'GRABLEY',
    resource: 'img/ebay.png',
  },
  {
    id: 'iojgmnipokofkeihgnlhmmmchpfchonk',
    name: 'Architect',
    resource: 'images/logo.png',
  },
  {
    id: 'jckigdhmponckmebbhbfenjmofkklnif',
    name: 'Phedra X',
    resource: 'index.html',
  },
  {
    id: 'jiiigigdinhhgjflhljdkcelcjfmplnd',
    name: 'Mango Wallet',
    resource: 'dapp-interface.js',
  },
  {
    id: 'kkgaechmpjgbojahkofamdjkaklgbdkc',
    name: 'Planyway for Trello',
    resource: 'icons/browser-icon-16.png',
  },
  {
    id: 'kmcbdogdandhihllalknlcjfpdjcleom',
    name: 'Adswerve',
    resource: 'js/a.js',
  },
  {
    id: 'kmhcihpebfmpgmihbkipmjlmmioameka',
    name: 'Eternl',
    resource: 'app/dom.js',
  },
  {
    id: 'ldinpeekobnhjjdofggfgjlcehhmanlj',
    name: 'Leather',
    resource: 'inpage.js',
  },
  {
    id: 'lebiggkccaodkkmjeimmbogdedcpnmfb',
    name: 'Block Site',
    resource: 'data/close/index.html',
  },
  {
    id: 'lhipdkibljepmfojllcfflfflhflcbgi',
    name: 'Moonlight',
    resource: 'web/pdf.html',
  },
  {
    id: 'ljjmnbjaapnggdiibfleeiaookhcodnl',
    name: 'Dark Mode',
    resource: 'manifest.json',
  },
  {
    id: 'mfgccjchihfkkindfppnaooecgfneiii',
    name: 'TokenPocket',
    resource: 'inpage.js',
  },
  {
    id: 'mihdfbecejheednfigjpdacgeilhlmnf',
    name: 'Huntr',
    resource: 'assets/animate.css',
  },
  {
    id: 'mmjbimgpcbaegjiieojddickpjbdkeej',
    name: 'Font Picker',
    resource: 'logo.png',
  },
  {
    id: 'mpcaainmfjjigeicjnlkdfajbioopjko',
    name: 'VPN Unlimited',
    resource: 'icons/premium.svg',
  },
  {
    id: 'nafpfdcmppffipmhcpkbplhkoiekndck',
    name: 'EXIF Viewer Classic',
    resource: 'scripts/index.js',
  },
  {
    id: 'nkpdpmomjhifdobiopmgfjjffacldfje',
    name: 'EasyPubMedicine',
    resource: 'css/style.css',
  },
  {
    id: 'nmaonghoefpmlfgaknnboiekjhfpmajh',
    name: 'Crystal',
    resource: 'sidebar.html',
  },
  {
    id: 'pdeldjlcnhallaapdggcmhpailpnnkmg',
    name: 'Ultimate Web Scraper',
    resource: 'table.html',
  },
  {
    id: 'pnanegnllonoiklmmlegcaajoicfifcm',
    name: 'Floating Video with Playback Controls',
    resource: 'content.js',
  },
  {
    id: 'aeeninnnlhgaojlolnbpljadhbionlal',
    name: 'Bluedot',
    resource: 'camera.html',
  },
  {
    id: 'ajjpfpfbgjcgghkgbcgmifkonjdldgkh',
    name: 'Popup Blocker Max',
    resource: 'ui/popup.html',
  },
  {
    id: 'behjakjklighlhiefaoogbalmenhbjid',
    name: 'YuJa Verity',
    resource: 'style.css',
  },
  {
    id: 'bfnnokhpnncpkdmbokanobigaccjkpob',
    name: 'Adobe Experience Platform Debugger',
    resource: 'src/app/index.html',
  },
  {
    id: 'bmoobmdacjibmplkdhofkmbhpdfbpdka',
    name: '瞬悉',
    resource: 'js/content.bundle.js',
  },
  {
    id: 'cbcfbhjolgdaepkoaoepejclfggmdand',
    name: 'Word Bank',
    resource: 'status',
  },
  {
    id: 'cijidiollmnkegoghpfobabpecdkeiah',
    name: 'Hippo Video',
    resource: 'pages/onboard.html',
  },
  {
    id: 'cjfbmleiaobegagekpmlhmaadepdeedn',
    name: 'Native MPEG-Dash + HLS Playback',
    resource: 'index.html',
  },
  {
    id: 'cmcgkhihcjkdlgiackjkpcjpbgbpdmgb',
    name: 'Dokobit',
    resource: 'isign-page.js',
  },
  {
    id: 'coobjpohmllnkflglnolcoemhmdihbjd',
    name: 'Bass Booster',
    resource: 'assets/popup.css',
  },
  {
    id: 'dbfoemgnkgieejfkaddieamagdfepnff',
    name: '2FAS Auth',
    resource: 'fonts/montserrat-v25-latin-700.woff2',
  },
  {
    id: 'djekgpcemgcnfkjldcclcpcjhemofcib',
    name: 'Screenshot & Screen Video Record',
    resource: 'index.html',
  },
  {
    id: 'dnjfcfcbcakfikppoeepnjjpoplhngjj',
    name: 'MobileMind',
    resource: 'index.css',
  },
  {
    id: 'eamkimleiebmdpifljjfilhbaehclahg',
    name: 'Hex Color Picker',
    resource: 'js/edropper2.js',
  },
  {
    id: 'eoinpcbakedlpilhibkbejdgkifenhfb',
    name: 'PDF24 Tools',
    resource: 'widget_defs.json',
  },
  {
    id: 'facmlmeaedhohfdlbkmdjpghdggnnkgl',
    name: 'Neptune',
    resource: 'styles.css',
  },
  {
    id: 'felflkndljbjehhgadcfmijcoamhhngl',
    name: 'Cursor Man Game',
    resource: 'images/gift.png',
  },
  {
    id: 'fjjddemkcndmbbeeibicagaobbijjgmm',
    name: 'Alerte Bons Plans eBuyClub',
    resource: '48x48.png',
  },
  {
    id: 'fkemeeodmcbkppgcnpcmoihepcgdenmi',
    name: 'SprintPlus WebSprinter',
    resource: 'assets/models-jvYa_9h0.js',
  },
  {
    id: 'fmoglfedagdapnidjcbnchkiihllemip',
    name: 'KeyController Plugin',
    resource: 'icon48.png',
  },
  {
    id: 'gccahjgcckaemgpliioopngfgdaceffo',
    name: 'MerciApp',
    resource: 'content.js',
  },
  {
    id: 'ggopndlojiiidkhpagipcjgdinefpoeb',
    name: 'ClassroomGo AI',
    resource: 'jquery.js',
  },
  {
    id: 'gibipneadnbflmkebnmcbgjdkngkbklb',
    name: 'Windowed',
    resource: 'Vendor/Browser.js',
  },
  {
    id: 'ginpbkfigcoaokgflihfhhmglmbchinc',
    name: 'HackBar',
    resource: 'payloads/paths.txt',
  },
  {
    id: 'hcddckfgihadahfdiefinmneegaoehdh',
    name: 'WA-Sender',
    resource: 'inject.js',
  },
  {
    id: 'hfjbmagddngcpeloejdejnfgbamkjaeg',
    name: 'Vimium C',
    resource: 'lib/viewer.js',
  },
  {
    id: 'ieldiilncjhfkalnemgjbffmpomcaigi',
    name: 'Portal',
    resource: '889.css',
  },
  {
    id: 'imlalpfjijneacdcjgjmphcpmlhkhkho',
    name: 'Ad Skip Master for Youtube',
    resource: 'css/content.css',
  },
  {
    id: 'iojpcjjdfhlcbgjnpngcmaojmlokmeii',
    name: 'Smart Adblocker',
    resource: 'css-block.json',
  },
  {
    id: 'jeiahlnhacbbdkaniaednfjpaemaghol',
    name: 'Sweezy Custom Doodle',
    resource: 'assets/images/925579c7690c95c151a9.svg',
  },
  {
    id: 'jlodlegnpjplclncjkgolcmdhjmlokna',
    name: 'FDM',
    resource: 'data/grab/index.html',
  },
  {
    id: 'kafnfkonkgfgkppomkfckmkgpkfkggcp',
    name: 'PJeR',
    resource: 'content/style.css',
  },
  {
    id: 'kapnjjcfcncngkadhpmijlkblpibdcgm',
    name: 'Viewport Resizer',
    resource: 'lib/responsive-toolbar.esm.js',
  },
  {
    id: 'kcgedkeajhbfkackhppmenimpfpnopje',
    name: '600% Sound Volume Booster',
    resource: 'assets/chunk-4191e1c6.js',
  },
  {
    id: 'knemcdpkggnbhpoaaagmjiigenifejfo',
    name: 'Claude Usage Tracker',
    resource: 'debug.html',
  },
  {
    id: 'lapmgejioldofnecdomcdgblbiffefhb',
    name: 'M-Files',
    resource: 'script.js',
  },
  {
    id: 'lbnnfjfjdijcnaakaebgcoemmlicjbnl',
    name: 'Tile Tabs WE',
    resource: 'quickmenu.html',
  },
  {
    id: 'lcalofoidkpopkkadcjjgcnnkcoalpba',
    name: 'VisualEffectsForMeet',
    resource: 'dist/NNC.json',
  },
  {
    id: 'ljanpepaipafblfikgiokdoccjbckfbf',
    name: 'OnApp',
    resource: 'main.js',
  },
  {
    id: 'lobiadjfmkomemokdfhiaaaidgdhcded',
    name: 'Ultimate Color Picker',
    resource: 'src/content/inject.css',
  },
  {
    id: 'mfembjnmeainjncdflaoclcjadfhpoim',
    name: 'Dictionary Bubble',
    resource: 'pages/options.html',
  },
  {
    id: 'mgmiemnjjchgkmgbeljfocdjjnpjnmcg',
    name: 'Awesome New Tab Page',
    resource: 'ntp.html',
  },
  {
    id: 'mhkejggchhilmabpicojddgaahkkgoln',
    name: 'FranceVerif',
    resource: 'images/money.png',
  },
  {
    id: 'mikcekmbahpbehdpakenaknkkedeonhf',
    name: 'Summary Webpage',
    resource: 'css/popup.css',
  },
  {
    id: 'mlfelkmlpmhleeclefagnddgocdngibo',
    name: 'Pomodoro',
    resource: 'icon_128.png',
  },
  {
    id: 'mmhlniccooihdimnnjhamobppdhaolme',
    name: 'Kee',
    resource: 'dist/panels/panels.html',
  },
  {
    id: 'momjbjbjpbcbnepbgkkiaofkgimihbii',
    name: 'Jira Assist',
    resource: 'api-pollyfill.js',
  },
  {
    id: 'mpkodccbngfoacfalldjimigbofkhgjn',
    name: 'Aria2 Explorer',
    resource: 'magnet.html',
  },
  {
    id: 'nnpeignlpkmbhjegcbfacbgcnhhjlghp',
    name: 'Lansweeper',
    resource: 'js/version.js',
  },
  {
    id: 'ocjpgibbldacmpedgjgmcdcikjeopnpb',
    name: 'Add to Buyee',
    resource: 'data/fonts/icons.ttf',
  },
  {
    id: 'ojnikmlgjpfiogeijjkpeakbedjhjcch',
    name: 'Zight',
    resource: 'intro.html',
  },
  {
    id: 'okdioccnnkeanlegkfgnnboncggagfjh',
    name: 'Philips Device Connector',
    resource: 'pdcsdk.js',
  },
  {
    id: 'pbcoegikffnadpahojjhgdladmmddeji',
    name: 'HaramBlur',
    resource: 'src/assets/premium.svg',
  },
  {
    id: 'pjdbebkgllbkjfbbbbceeeenhkngnddp',
    name: 'Video Downloader',
    resource: 'content.js',
  },
  {
    id: 'pkiokiaeahklmefmfpnnofmgfafajpdl',
    name: 'Font Finder',
    resource: 'data/window/index.html',
  },
  {
    id: 'plafaneablgcojpbaeefkmnheilloopl',
    name: 'Wordmark',
    resource: 'styles/overlay.css',
  },
  {
    id: 'popigpemobhbfkhnnkllkjgkaabedgpb',
    name: 'BugHerd',
    resource: 'sidebar_build/app.js',
  },
  {
    id: 'aeehekhncjhhmchjolinnihgdpapmljk',
    name: 'Cursor Cat',
    resource: 'assets/bg.png',
  },
  {
    id: 'aeindiojndlokkemcgakgpgbcmgonifn',
    name: 'Secure Browser',
    resource: 'ui/index.html',
  },
  {
    id: 'afdgaoaclhkhemfkkkonemoapeinchel',
    name: 'BetterSEQTA+',
    resource: 'assets/db-Cnr5uk7A.js',
  },
  {
    id: 'ahbepdkgicljkjjjnogljplljdocjjmo',
    name: 'TwiHD',
    resource: 'fonts/CyGrotesk/kobuzan-cy-grotesk-grand-dark.otf',
  },
  {
    id: 'andhndehpcjpmneneealacgnmealilal',
    name: 'HaHa Wallet',
    resource: 'home.html',
  },
  {
    id: 'apacadmkljmohmjgefhficgiijnnmelk',
    name: 'Turbo Ad Finder 2.0',
    resource: 'libs.js',
  },
  {
    id: 'bhbekkddpbpbibiknkcjamlkhoghieie',
    name: 'darknightmode',
    resource: 'css/noty.css',
  },
  {
    id: 'bjibimlhliikdlklncdgkpdmgkpieplj',
    name: 'Vmaker',
    resource: 'pinnedTab.html',
  },
  {
    id: 'bpiohchncadidhohcajcnoelomephkdd',
    name: 'Jasper Everywhere',
    resource: 'pas.d2052332.svg',
  },
  {
    id: 'cgococegfcmmfcjggpgelfbjkkncclkf',
    name: '셀러라이프',
    resource: 'analysis/kDA.html',
  },
  {
    id: 'cmjihoeplpkmlmbbiiognkceoechmand',
    name: 'Online Seller Addon',
    resource: 'img/sort.png',
  },
  {
    id: 'cneaciknhhaahhdediboeafhdlbdoodg',
    name: 'Notebook Web Clipper',
    resource: 'css/icon.css',
  },
  {
    id: 'cpenganlfihkadidlboklhhiinncalpf',
    name: 'Xiao Mei Smart Assistant',
    resource: 'icon.png',
  },
  {
    id: 'cpmkedoipcpimgecpmgpldfpohjplkpp',
    name: 'Gate Wallet',
    resource: 'gt-metamask-shim.js',
  },
  {
    id: 'dcaikidbolchfhcieemjijhdefmomnnh',
    name: 'Games Blocker',
    resource: 'images/icon.png',
  },
  {
    id: 'dflhdcckcmcajgofmipokpgknmfikhej',
    name: 'Perceptron',
    resource: 'js/wasm/blockmesh_ext.js',
  },
  {
    id: 'dgenbagabmmjpfjlbcnnlmpopipdapjo',
    name: 'NotebookLM AI Sidebar',
    resource: 'assets/icon-16.png',
  },
  {
    id: 'djlkbfdlljbachafjmfomhaciglnmkgj',
    name: 'Motrix',
    resource: 'images/48.png',
  },
  {
    id: 'dmgaboifbpokjbdcbnmkcohiondlampj',
    name: 'Clownfish Voice Changer',
    resource: 'CF.js',
  },
  {
    id: 'dngmlblcodfobpdpecaadgfbcggfjfnm',
    name: 'MultiversX Wallet',
    resource: 'src/extension/inpage/index.js',
  },
  {
    id: 'eaidebojanpehpceonghnmgdofblnlae',
    name: 'Rebrandly',
    resource: 'css/emoji.css',
  },
  {
    id: 'ebpckmjdefimgaenaebngljijofojncm',
    name: 'Volume Booster',
    resource: 'assets/css/popup.css',
  },
  {
    id: 'eggdlmopfankeonchoflhfoglaakobma',
    name: 'Apifox',
    resource: 'adapter.js',
  },
  {
    id: 'egokmjmmjaeeipngkeljjaoibjafeacp',
    name: 'focuspang ai',
    resource: 'wasm/README.md',
  },
  {
    id: 'fchbhcjlkcdchcaklpkdofllfoimelgb',
    name: 'ChatGPT for Amazon with GPT4 Shulex Copilot',
    resource: 'logo.png',
  },
  {
    id: 'fdjglnlhapkoahdmanogpccpmmpnakje',
    name: 'Watch Netflix Together',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'febgikmgbjnbmpodlhljpnnoeappdeck',
    name: 'Sense',
    resource: 'page.js',
  },
  {
    id: 'fgobbidklammfajebkefikkdhblbaaam',
    name: '花瓣采集插件',
    resource: 'tabs/pin.html',
  },
  {
    id: 'gblgfbgdhlkjnkfdbpmdhdkhhbbhfkca',
    name: 'ZTSmartInv',
    resource: 'lib/jquery-3.7.1.min.map',
  },
  {
    id: 'gfkpklgmocbcbdabfellcnikamdaeajd',
    name: 'SimplyCodes',
    resource: 'domain-seed-1.json',
  },
  {
    id: 'gkbhgdhhefdphpikedbinecandoigdel',
    name: 'Tailwind',
    resource: 'window-fire-event.js',
  },
  {
    id: 'gkkkcomfmldkigajkmljnbpiajbpbgdg',
    name: 'TWP',
    resource: 'icons/icon-32.png',
  },
  {
    id: 'gpkildejogofhhobidokcjpolaikgldj',
    name: 'Webpage to PDF Converter',
    resource: 'redo.png',
  },
  {
    id: 'hbklahkfbghjgbclbfcnhpfmajkagnci',
    name: 'Video Notebook',
    resource: 'sandbox.html',
  },
  {
    id: 'hiajdlfgbgnnjakkbnpdhmhfhklkbiol',
    name: 'JustBlock Security - Ad Blocker, Malware & Phishing Protection',
    resource: 'blocked.html',
  },
  {
    id: 'hkledmpjpaehamkiehglnbelcpdflcab',
    name: 'asbplayer',
    resource: 'anki-ui.js',
  },
  {
    id: 'hllekbchnfikjpbdielihahenjmbpach',
    name: 'Correcto',
    resource: 'assets/index.css',
  },
  {
    id: 'hngnkmianenpifegfoggnkamjnffiobn',
    name: 'Writer',
    resource: 'css/options.css',
  },
  {
    id: 'hnlbfcoodjpconffdbddfglilhkhpdnf',
    name: 'Snap Pixel Helper',
    resource: 'src/popup.html',
  },
  {
    id: 'hpmbiinljekjjcjgijnlbmgcmoonclah',
    name: 'Previews',
    resource: 'main/cd.js',
  },
  {
    id: 'ibbpaphbbbabnmmllpdlmcfihhkahgai',
    name: 'CocoShot',
    resource: 'camera.html',
  },
  {
    id: 'ieepebpjnkhaiioojkepfniodjmjjihl',
    name: 'PDF Reader and Editor',
    resource: 'data/pdf.js/web/viewer.html',
  },
  {
    id: 'ifibfemgeogfhoebkmokieepdoobkbpo',
    name: 'Captcha solver',
    resource: 'content/style.css',
  },
  {
    id: 'igbgpehnbmhgdgjbhkkpedommgmfbeao',
    name: 'FortiClient Chromebook Webfilter',
    resource: 'block_iframe.html',
  },
  {
    id: 'ihbbifgcppfejeobcljahinddoplnohi',
    name: 'Rocket Sender',
    resource: 'images/stop_icon.svg',
  },
  {
    id: 'ihjphbgdciilclbpcmagkacpohgokpep',
    name: 'Text to Speech',
    resource: 'data/resources/selection.css',
  },
  {
    id: 'ikbablmmjldhamhcldjjigniffkkjgpo',
    name: 'dataslayer',
    resource: 'inject.js',
  },
  {
    id: 'jcgpgjhaendighananonflfmjjefjjlp',
    name: 'Streak Email Tracking for Gmail',
    resource: 'blank.png',
  },
  {
    id: 'jcmbmadioaobdgfbmbpenhlcppfcahhi',
    name: 'Troywell Cashback',
    resource: 'icon/icon-32.png',
  },
  {
    id: 'jfakgfcdgpghbbefmdfjkbdlibjgnbli',
    name: 'WebNowPlaying',
    resource: 'injected.js',
  },
  {
    id: 'jiabgmelnfhgjkfdaoiccfcbaedjfcnm',
    name: 'Prospecting',
    resource: 'images/pixel.gif',
  },
  {
    id: 'jmjbgcjbgmcfgbgikmbdioggjlhjegpp',
    name: 'ScreenClip',
    resource: 'insides/content/content.js',
  },
  {
    id: 'jncabfnemmiofhiimdgelgeobggelpci',
    name: 'Open Adblocker',
    resource: 'content/rate-us/index.html',
  },
  {
    id: 'kchaponcodemjigejilffhfchecpgdpf',
    name: 'Writesonic',
    resource: 'manifest.json',
  },
  {
    id: 'keafkoopbkbjlbbedmonhnfgfciaphdb',
    name: 'LockSelf',
    resource: 'icon-logo-name.svg',
  },
  {
    id: 'kekjfbackdeiabghhcdklcdoekaanoel',
    name: 'MAL-Sync',
    resource: 'window.html',
  },
  {
    id: 'khgocmkkpikpnmmkgmdnfckapcdkgfaf',
    name: '1Password',
    resource: 'inline/injected.js',
  },
  {
    id: 'kmmcnncdadfmbjkoloakclhfllocaeap',
    name: 'Saladict',
    resource: 'assets/trs.js',
  },
  {
    id: 'lejhbacckkdpjnllmefhlinigbngpibl',
    name: 'Copy Text from Picture',
    resource: 'engine/index.html',
  },
  {
    id: 'lgfokdfepidpjodalhpbjindjackhidg',
    name: 'ChatGenie for Chatgpt',
    resource: 'images/16.png',
  },
  {
    id: 'lkgcfobnmghhbhgekffaadadhmeoindg',
    name: 'Purple Ads Blocker',
    resource: 'app/bundle.js',
  },
  {
    id: 'lliifkldpflpgmjkpdoolkfpafbdbkoh',
    name: 'ordbogen.com',
    resource: 'content-scripts/contentscript.js',
  },
  {
    id: 'lpcbiamenoghegpghidohnfegcepamdm',
    name: 'Video downloader that works! Save online videos',
    resource: 'js/instagramStory.js',
  },
  {
    id: 'mkhblbiehikmgikojlgijbjadcpiadom',
    name: 'Ad Blocker Pro Shield',
    resource: 'static/data.json',
  },
  {
    id: 'mmbhfeiddhndihdjeganjggkmjapkffm',
    name: 'EXIF Viewer Pro',
    resource: 'img/no.png',
  },
  {
    id: 'ndmelloaocjpkhmajmkdbbhimohlclkd',
    name: "Colorful Rubik's Cube",
    resource: 'game/js/game.js',
  },
  {
    id: 'njlfcjdojmopagogfpjgcbnpmiknapnd',
    name: 'OptimAI Lite Node',
    resource: 'content.css',
  },
  {
    id: 'nphplpgoakhhjchkkhmiggakijnkhfnd',
    name: 'TON Wallet',
    resource: 'extensionPageScript.js',
  },
  {
    id: 'oeiomhmbaapihbilkfkhmlajkeegnjhe',
    name: 'Primus',
    resource: 'iconPado.svg',
  },
  {
    id: 'omlcllhgbjdlnkcamjgihppdjighddei',
    name: 'City Backgrounds',
    resource: 'images/dubai.png',
  },
  {
    id: 'oojndninaelbpllebamcojkdecjjhcle',
    name: 'Chat to Notion',
    resource: 'assets/icon.png',
  },
  {
    id: 'oooikipggipaohjibkmoiacmmlilgokn',
    name: 'Manga Translator',
    resource: 'images/star.png',
  },
  {
    id: 'pbkloffickinnlnmefmjmjbacohecpbd',
    name: 'Web Cache Viewer',
    resource: 'pages/changelog/changelog.html',
  },
  {
    id: 'pdgbckgdncnhihllonhnjbdoighgpimk',
    name: 'Wallet Guard',
    resource: 'js/vendor.js',
  },
  {
    id: 'pjpgohokimaldkikgejifibjdpbopfdc',
    name: 'Sapling',
    resource: 'assets/power.svg',
  },
  {
    id: 'pmabjgjpcbofkbbeiphkiaanogobokgg',
    name: 'Full Page Screen Capture',
    resource: 'images/crop.svg',
  },
  {
    id: 'abbpaepbpakcpipajigmlpnhlnbennna',
    name: 'Music Mode',
    resource: 'img/photo.jpg',
  },
  {
    id: 'abfimpkhacgimamjbiegeoponlepcbob',
    name: 'Seedr',
    resource: 'images/check.png',
  },
  {
    id: 'adelhekhakakocomdfejiipdnaadiiib',
    name: 'Text Mode',
    resource: 'imgs/bg/bg_blank_1px.png',
  },
  {
    id: 'adjifobelhoemalljgnjdlockheiacmc',
    name: 'Browser History Plus',
    resource: 'assets/static/64.png',
  },
  {
    id: 'afgbckekjlfkfhklldgdndiagddhbohm',
    name: 'WAMessager',
    resource: 'js/load.js',
  },
  {
    id: 'akkncdpkjlfanomlnpmmolafofpnpjgn',
    name: 'm3u8 Sniffer TV',
    resource: 'player/player.html',
  },
  {
    id: 'akpkoodohacdmlddblgnaahbbfjplcig',
    name: 'Dark Reader',
    resource: 'assets/static/32.png',
  },
  {
    id: 'amolhiihcpdbkjimhlffamgieibhfapi',
    name: 'Adminer',
    resource: 'libs.js',
  },
  {
    id: 'aoabjfoanlljmgnohepbkimcekolejjn',
    name: 'Web Site blocker',
    resource: '128.png',
  },
  {
    id: 'bafhgiajedliopeidkhgidpbjejkfnlm',
    name: 'Itzuli+',
    resource: 'toolbar.js',
  },
  {
    id: 'bbaogjaeflnjolejjcpceoapngapnbaj',
    name: 'Kudosi',
    resource: 'assets/customScript.js',
  },
  {
    id: 'bbfbeaopdnagijhehlhajpjnfghdhohm',
    name: 'MEOWSING',
    resource: 'resources/popup/loading.gif',
  },
  {
    id: 'benimdeioplgkhanklclahllklceahbe',
    name: 'Check by CyberDrain',
    resource: 'blocked.html',
  },
  {
    id: 'bfbnagnphiehemkdgmmficmjfddgfhpl',
    name: 'UltraWideo',
    resource: 'content-scripts/inject.css',
  },
  {
    id: 'blcdfhbibkkjpfdddnmnmhfgjlicebba',
    name: 'Limit',
    resource: 'html/menu.html',
  },
  {
    id: 'blenoallcdijagcfhdbidjiimoandabh',
    name: 'nCage+',
    resource: 'images/anime/duo.jpg',
  },
  {
    id: 'boapjdphamdkfjfdibbdpcemcdncfhjf',
    name: 'GradeTransferer',
    resource: 'sci.js',
  },
  {
    id: 'canbadmphamemnmdfngmcabnjmjgaiki',
    name: 'Ban Checker for Steam',
    resource: 'options.html',
  },
  {
    id: 'cbhljnnfpomfkmhefapcjmjignigcfpn',
    name: 'SuperCopy Pro',
    resource: 'ZJO623f69i.js',
  },
  {
    id: 'chmaghefgehniobggcaloeoibjmbhfae',
    name: 'GetEmail.io',
    resource: 'libs/sp.min.js',
  },
  {
    id: 'ckfgjlakjcboggkbojkdoookoeogpifc',
    name: 'Lexmark Cloud Print Management',
    resource: 'callback.html',
  },
  {
    id: 'dajhhgiioackgdldomhppobgjbinhimh',
    name: 'HttpWatch',
    resource: 'recording_started.htm',
  },
  {
    id: 'dbjldigbjceebginhcnmjnigbocicokh',
    name: 'AiPrice(AliPrice) Sourcing Tool Beta',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'dbmaeobgdodeimjdjnkipbfhgeldnmeb',
    name: 'YouTube MrBeastify',
    resource: 'images/1.png',
  },
  {
    id: 'dcidojkknfgophlmohhpdlmoiegfbkdd',
    name: 'WA Contacts Extractor',
    resource: 'assets/w.js',
  },
  {
    id: 'dehlblnjjkkbapjemjbeafjhjpjoifii',
    name: 'Amazon KW Index and Rank Tracker',
    resource: 'viewer.js',
  },
  {
    id: 'dhjiababgkcfbglanikgepmmdelngfon',
    name: 'AI YouTube Summarizer',
    resource: 'icon-32.png',
  },
  {
    id: 'dimkjjladgaekdlfebknbaooicmfalke',
    name: 'Trustpilot',
    resource: 'index.css',
  },
  {
    id: 'djbfechcnkppbknmlhfcaoifgnicolin',
    name: 'LuLu Translate',
    resource: 'content/assets/i18n/en.json',
  },
  {
    id: 'dnacggjlcbpfcfchkkogedlkenpnlfbi',
    name: 'Session Share',
    resource: 'scott48.png',
  },
  {
    id: 'dndehlekllfkaijdlokmmicgnlanfjbi',
    name: 'Ultrawidify',
    resource: 'ext/uw.js',
  },
  {
    id: 'ebgofhigpedaepplnmglnedbfjemmpnh',
    name: 'Lumaly',
    resource: 'inject.js',
  },
  {
    id: 'ecbedadooalalcgolmfgpnmphhccegei',
    name: 'Jambofy',
    resource: 'assets/images/1.png',
  },
  {
    id: 'eelolnalmpdjemddgmpnmobdhnglfpje',
    name: 'YouTube Transcript & Summary Generator with ChatGPT & Gemini',
    resource: 'src/assets/base.css',
  },
  {
    id: 'eemjhliengnnmjmbdjagekdddmkhanna',
    name: 'ima知识库',
    resource: 'img/ima.png',
  },
  {
    id: 'egmennebgadmncfjafcemlecimkepcle',
    name: 'VidHelper',
    resource: 'js/core.js',
  },
  {
    id: 'ehmneimbopigfgchjglgngamiccjkijh',
    name: 'Tabrr Dashboard',
    resource: 'assets/static/32.png',
  },
  {
    id: 'eiionlappbmidcpaabhepkipldnopcch',
    name: 'Dark Mode',
    resource: 'assets/static/logo-turn-on.png',
  },
  {
    id: 'ejhkmnhjkbekmfohoipicmpmjdbofdhm',
    name: 'Pague Menos Be!Tech',
    resource: 'index.css',
  },
  {
    id: 'epanfjkfahimkgomnigadpkobaefekcd',
    name: 'IronVest',
    resource: 'popup.html',
  },
  {
    id: 'facoldpeadablbngjnohbmgaehknhcaj',
    name: 'Bulk Image Downloader',
    resource: 'popup.js',
  },
  {
    id: 'fcfdgjihkdffhnfaefnbdbekafdeelio',
    name: 'betterdeals',
    resource: 'app.js',
  },
  {
    id: 'feahianecghpnipmhphmfgmpdodhcapi',
    name: 'tweak',
    resource: 'intercept.bundle.js',
  },
  {
    id: 'fedchalbmgfhdobblebblldiblbmpgdj',
    name: 'Video Downloader',
    resource: 'assets/logo-AnCm6Hpf.png',
  },
  {
    id: 'ffkgggpfimdabhlfomcfhpgbmjfdbhfh',
    name: 'Annotate pdf',
    resource: 'icons/16x16.png',
  },
  {
    id: 'ffoidoiaecmiamaljkhfhjacemefalec',
    name: 'Эй, Бро!',
    resource: 'icon.png',
  },
  {
    id: 'fgdaagbdeodomdnkkolfghckcjceakgb',
    name: 'CRM para Vendas por WhatsApp',
    resource: 'index.html',
  },
  {
    id: 'fhbpmacbgklobobcieiaoibpjhdnmcfn',
    name: 'Video CC translator',
    resource: 'options.html',
  },
  {
    id: 'flblmacldekcjcoockeoggionmhflecp',
    name: 'Save to Collect',
    resource: 'content.js.map',
  },
  {
    id: 'fldfpgipfncgndfolcbkdeeknbbbnhcc',
    name: 'MyTonWallet',
    resource: 'extensionPageScript.js',
  },
  {
    id: 'fnfdomooadjpfohbepiaonnbdmkdjiog',
    name: 'Meomni Pro',
    resource: 'icon_128.png',
  },
  {
    id: 'gbiahfedloaennjklbmekkhoojlaffcc',
    name: 'VU Quiz Firewall',
    resource: 'VULogo.png',
  },
  {
    id: 'gbnfheoijkjfgeobhbkpgdkfabihjonj',
    name: 'UpSeller',
    resource: 'requestHooks.js',
  },
  {
    id: 'gdfhmpjihkjpkcgfoclondnjlignnaap',
    name: 'Private video downloader',
    resource: 'popup.html',
  },
  {
    id: 'gefiaaeadjbmhjndnhedfccdjjlgjhho',
    name: 'Enhanced Image Viewer',
    resource: 'show-review-modal.css',
  },
  {
    id: 'ggacghlcchiiejclfdajbpkbjfgjhfol',
    name: 'Screenshot Master',
    resource: 'layouts/main.html',
  },
  {
    id: 'gjdmanggfaalgnpinolamlefhcjimmam',
    name: 'Minesweeper Original',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'gkkmiofalnjagdcjheckamobghglpdpm',
    name: 'YouTube FullScreen',
    resource: 'index.html',
  },
  {
    id: 'hcobdfnjjaceclfdjpmmpiknimccjpmf',
    name: 'Taskade',
    resource: 'popup.js',
  },
  {
    id: 'hdlajobndamjlloioebnannnlbopndee',
    name: 'AliScraper',
    resource: 'popup.html',
  },
  {
    id: 'henhldbgljkagjabmpjnlphncpnfggcd',
    name: 'WA',
    resource: 'js/fill.js',
  },
  {
    id: 'hfhimnmjhalnlncfajdlbpjjoediacbf',
    name: 'Tomato Destroyer',
    resource: 'img/egg.png',
  },
  {
    id: 'hgipopnedpcknmapfakdedlnjjkmpnao',
    name: 'Checkmate',
    resource: 'build/popup.js',
  },
  {
    id: 'hgphbmgpkindhnldhjafhfflhjodpfmn',
    name: 'Powtoon Capture',
    resource: 'camera.html',
  },
  {
    id: 'hhimhiimpaicidimabokfbdokhpcnmoh',
    name: 'Translate Anywhere',
    resource: 'jq.js',
  },
  {
    id: 'hnadleianomnjcoeplifgbkiejchjmah',
    name: 'Search Everywhere with Google Bard/Gemini',
    resource: 'static/images/info.png',
  },
  {
    id: 'hnmpfafamacclmemoogfmpjfcpemoeao',
    name: 'PagePatrol',
    resource: 'img/icon.png',
  },
  {
    id: 'honjoefhlidgdidlcdbipobjnoliiaid',
    name: 'Troywell VPN Lite',
    resource: 'caa/styles.css',
  },
  {
    id: 'ibiipnmmlnehmeonnhbdajcfagcgihkl',
    name: 'Passwork Self-Hosted',
    resource: 'img/triangle.svg',
  },
  {
    id: 'iffdacemhfpnchinokehhnppllonacfj',
    name: 'MightyText',
    resource: 'help.html',
  },
  {
    id: 'iigobcdpmngdgiacebgenbccmdacnjhp',
    name: 'Google Apps Script Tools',
    resource: 'js/library.js',
  },
  {
    id: 'iiojpgfndaegfkmcdleandpjnkhmbmfj',
    name: 'Virtual Backgrounds for Google Meet',
    resource: 'img/icon-512.png',
  },
  {
    id: 'ijbhcaojmmmlpkghcejkoadlfhghkkoj',
    name: 'VaSaham',
    resource: 'script/ft.js',
  },
  {
    id: 'iodbnclobmalekpemjhncgfphojcgocd',
    name: 'Mangools SEO',
    resource: 'assets/kw-icon.svg',
  },
  {
    id: 'jbojhemhnilgooplglkfoheddemkodld',
    name: 'Otto',
    resource: 'tiny-otto.png',
  },
  {
    id: 'jcacnejopjdphbnjgfaaobbfafkihpep',
    name: 'Hive Keychain',
    resource: 'hive_keychain.js',
  },
  {
    id: 'jcbjknkcpodniflhegplcmjonnfhnhmi',
    name: 'Molly',
    resource: 'background.js',
  },
  {
    id: 'jdbcdblgjdpmfninkoogcfpnkjmndgje',
    name: 'Scrum for Trello',
    resource: 'images/points-done.png',
  },
  {
    id: 'jdkmmjkcmjjhfegmbmaijcnlgkfnfcpm',
    name: 'Block Websites',
    resource: 'blocked.js',
  },
  {
    id: 'jfpjkgdpgdbddknpgplfkjjfncenlmkf',
    name: 'StoryXpress',
    resource: 'tour.html',
  },
  {
    id: 'jjmnbidkmmabkalampbilajnheeokpoj',
    name: 'TLDR This',
    resource: 'img/icon16.png',
  },
  {
    id: 'jlcaefilcommembbekhjjkibeieffchd',
    name: 'Widilo',
    resource: 'assets/fonts/Inter.woff2',
  },
  {
    id: 'jledohjahnkncbmnfmbnaophlakhoanl',
    name: 'Disable AI Overview',
    resource: 'listener.js',
  },
  {
    id: 'jlnhdnbbikjkdejminhdpmejldiapdgn',
    name: 'AliDropship 2.0',
    resource: 'js/popup.js',
  },
  {
    id: 'kfimphpokifbjgmjflanmfeppcjimgah',
    name: 'Inoreader',
    resource: 'toast.html',
  },
  {
    id: 'kkeakohpadmbldjaiggikmnldlfkdfog',
    name: 'FastStream Video Player',
    resource: 'player/index.html',
  },
  {
    id: 'lnddbhdmiciimpkbilgpklcglkdegdkg',
    name: 'Simplescraper',
    resource: 'src/finder.js',
  },
  {
    id: 'lpgajkhkagnpdjklmpgjeplmgffnhhjj',
    name: 'Trim',
    resource: 'images/fresh.png',
  },
  {
    id: 'migiikaijhclkmlpnnfficpopgmcpgia',
    name: 'Free Vimeo Downloader',
    resource: 'icons/logo.png',
  },
  {
    id: 'mkccemimdjbojildcllapppfhphcfmkn',
    name: 'PiggyBank Money Clicker',
    resource: 'assets/style.css',
  },
  {
    id: 'mobhfbcgjoleoljhpkkdhopdiemlocka',
    name: 'RPass',
    resource: 'oauth.html',
  },
  {
    id: 'naipgebhooiiccifflecbffmnjbabdbh',
    name: 'HyperChat',
    resource: 'options.js',
  },
  {
    id: 'nbphjjmibhopfgkkbpoggemjnihnchhk',
    name: 'Spekit',
    resource: 'styles/all.css',
  },
  {
    id: 'niepmhdjjdggogblnljbdflekfohknmc',
    name: 'AdLibNote',
    resource: 'images/tg.png',
  },
  {
    id: 'njincahdjloohmjeonojgjeihkgbjfko',
    name: 'USPS Tracking',
    resource: 'manifest.json',
  },
  {
    id: 'nnooggpliipegmffiolegeppbgkclbpi',
    name: 'Adaware Web Protection',
    resource: 'img/logo.png',
  },
  {
    id: 'nodnmpgjlnclahkmgjiinfjklgbbgecg',
    name: 'FlashPlayer',
    resource: 'data/player/ruffle/ruffle.js',
  },
  {
    id: 'noofnfniimcnghnkonpdlhlaeaocidbi',
    name: 'DeepTranslate',
    resource: 'icons/1.png',
  },
  {
    id: 'oaienfpdbimabhlgjlbdpocbogaijnam',
    name: 'Userlane',
    resource: 'page-script/index.js',
  },
  {
    id: 'obcbigljfpgappaaofailjjoabiikckk',
    name: 'FoxClocks',
    resource: 'css/statusbar.css',
  },
  {
    id: 'ocginjipilabheemhfbedijlhajbcabh',
    name: 'Night Shift',
    resource: 'assets/content.css',
  },
  {
    id: 'odamfmfcmgcaghpmeppfiaaafahcnfbc',
    name: 'Synology Office',
    resource: 'js/synofficeExt.js',
  },
  {
    id: 'oedkbkpngfmjfbmmmijkogojlcddmcgf',
    name: 'Bro-Mon',
    resource: 'battle_app.css',
  },
  {
    id: 'ofbhiclojhjkggpnapcnjjjdjlgcikdf',
    name: 'Maps Scraper & Map data extractor',
    resource: 'cframe.html',
  },
  {
    id: 'oiekdmlabennjdpgimlcpmphdjphlcha',
    name: 'Tripadvisor',
    resource: 'options.html',
  },
  {
    id: 'oihbmmeelledioenpfcfehdjhdnlfibj',
    name: 'Emily',
    resource: 'embed_script.js',
  },
  {
    id: 'ojaiblngghaojpllefbappfeblffgiah',
    name: 'Control de URLs para nebulaCERTagent',
    resource: 'index.htm',
  },
  {
    id: 'okcnidefkngmnodelljeodakdlfemelg',
    name: 'Dark Mode',
    resource: 'popup.css',
  },
  {
    id: 'okkffdhbfplmbjblhgapnchjinanmnij',
    name: 'Screenshot',
    resource: 'mf',
  },
  {
    id: 'omlgpaciclcjgbligehccipcikleeiea',
    name: 'Tongyi',
    resource: 'logo.svg',
  },
  {
    id: 'pjbkppdckhokepdfnlfmljjgnbnjfabg',
    name: 'View Maps & Directions',
    resource: 'manifest.json',
  },
  {
    id: 'pnpdnibdembnnlaiibkeandepjajegoi',
    name: 'Translator',
    resource: 'js/popup.js',
  },
  {
    id: 'aaeebnpadcfccmajghdpojkjobbpjmfj',
    name: 'Giant ad blocker',
    resource: 'filters/goR_1180.txt',
  },
  {
    id: 'aahnibhpidkdaeaplfdogejgoajkjgob',
    name: 'Bittorrent',
    resource: 'res/icon96.png',
  },
  {
    id: 'ablmompanofnodfdkgchkpmphailefpb',
    name: 'Miden Wallet',
    resource: 'addToWindow.js',
  },
  {
    id: 'acehfjhnmhbmgkedjmjlobpgdicnhkbp',
    name: 'Amplitude Event Explorer',
    resource: 'inject.html',
  },
  {
    id: 'acmbnbijebmjfmihfinfipebhcmgbghi',
    name: 'Video Downloader Web',
    resource: 'images/play.svg',
  },
  {
    id: 'aeojmgngnebhbjpncamiplkimkbnmpmk',
    name: 'Web Page Downloader',
    resource: 'locales/ar.json',
  },
  {
    id: 'afbcbjpbpfadlkmhmclhkeeodmamcflc',
    name: 'MathWallet',
    resource: 'assets/index.js-CSO-CXFo.js',
  },
  {
    id: 'aikkeehnlfpamidigaffhfmgbkdeheil',
    name: 'AI Code Finder',
    resource: 'assets/icons/link.png',
  },
  {
    id: 'bdiifdefkgmcblbcghdlonllpjhhjgof',
    name: 'KISS Translator',
    resource: 'injector-shadowroot.js',
  },
  {
    id: 'bebecogbafbighhaildooiibipcnbngo',
    name: 'UI5 Inspector',
    resource: 'vendor/ace.js',
  },
  {
    id: 'bepmaejckfhbdbikphclmnmclpiheche',
    name: 'Record Google Meet',
    resource: 'setup.html',
  },
  {
    id: 'bfcdaalpeodhimbiipneeaoeogkkminc',
    name: 'Smart SOP Generator',
    resource: 'css/edit.css',
  },
  {
    id: 'bgkhpibkldkmjjpikipeklkbdamlknnc',
    name: 'Economize!',
    resource: 'index.css',
  },
  {
    id: 'bhagcmmjnakekaccjmpkmcidopfmedlm',
    name: 'iatricSystems FlexButton',
    resource: 'web_page.js',
  },
  {
    id: 'bikeebdigkompjnpcljicocidefgbhgl',
    name: 'TFT Trade',
    resource: 'icons/16.png',
  },
  {
    id: 'bonfdkhbkkdoipfojcnimjagphdnfedb',
    name: 'DataHive',
    resource: 'assets/init-Cpj_yYth.js',
  },
  {
    id: 'bpjfchmapbmjeklgmlkabfepflgfckip',
    name: 'PSR',
    resource: 'img/notification.svg',
  },
  {
    id: 'canpneabbfipaelecfibpmmjbdkiaolf',
    name: 'TagHound',
    resource: 'toastContent.html',
  },
  {
    id: 'ccdgonnidaghcdicoebncgncfmpagpdk',
    name: 'NSSignXML',
    resource: 'extensionApi/xmlExtensionApi.js',
  },
  {
    id: 'cclhgechkjghfaoebihpklmllnnlnbdb',
    name: 'Paint Online',
    resource: 'assets/fonts/arial/ARIAL.TTF',
  },
  {
    id: 'ceipnlhmjohemhfpbjdgeigkababhmjc',
    name: "I'm not robot captcha clicker",
    resource: 'options.html',
  },
  {
    id: 'cfbfdhimifdmdehjmkdobpcjfefblkjm',
    name: 'Plug',
    resource: 'inpage-dist/inpage.js',
  },
  {
    id: 'chngjgginikejcpaejphfoglpppmjfne',
    name: 'ChiliCal',
    resource: 'pageWorld.js',
  },
  {
    id: 'cibffnhhlfippmhdmdkcfecncoaegdkh',
    name: 'Visual CSS Editor',
    resource: 'editor/js/addons.js',
  },
  {
    id: 'cjadmgobonfhilogbdgkkhnoojpgenfg',
    name: 'Audio Equalizer',
    resource: 'data/content_script/page_context/inject.js',
  },
  {
    id: 'cmeikcgfecnhojcbfapbmpbjgllklcbi',
    name: 'Hive AI Detector',
    resource: 'icons/info.htm',
  },
  {
    id: 'dbnfnbehhjknomdbfhcobpgpphnlnikp',
    name: 'Tipli',
    resource: 'serp.js',
  },
  {
    id: 'dcembjiicioienepbaldihjhmkedagee',
    name: 'DataTool-Video Downloader',
    resource: 'assets/js/ext.js',
  },
  {
    id: 'ddkogamcapjjcjpeapeagfklmaodgagk',
    name: 'TVDownloader',
    resource: 'content.css',
  },
  {
    id: 'dlkjdkiladlnclocjpcikagojeddmkeh',
    name: 'Convert Picture to Text',
    resource: 'engine/index.html',
  },
  {
    id: 'eadklkgmejdhldgchbmegmljdkchcdbd',
    name: 'monosearch',
    resource: 'js/popup.js',
  },
  {
    id: 'eedfldkdghfkhdcanjnfiklpeehbfoag',
    name: 'CSS Viewer',
    resource: 'img/body.png',
  },
  {
    id: 'eeeningnfkaonkonalpcicgemnnijjhn',
    name: 'eyeCare',
    resource: 'icon_48.png',
  },
  {
    id: 'efifccmcdofkcjcleapkaeedlhcejcmd',
    name: 'Web Paint',
    resource: 'ui/index.html',
  },
  {
    id: 'ehgmhinnhggigkogkbhnbodhbfjgncjf',
    name: 'Salesforce DevTools',
    resource: 'popup.html',
  },
  {
    id: 'ehoknmhmadiboejdbinglmbnlghnbldc',
    name: 'Phia',
    resource: 'rive.wasm',
  },
  {
    id: 'eimimdbkklcfefabegnlclkfakkfdcpc',
    name: 'KDP Spy',
    resource: 'images/icon.png',
  },
  {
    id: 'ejllkedmklophclpgonojjkaliafeilj',
    name: 'Web paint',
    resource: 'images/eraser.svg',
  },
  {
    id: 'ejpgchjcnlcgngfcomaoappdaemngghl',
    name: 'View Package Tracking',
    resource: 'manifest.json',
  },
  {
    id: 'fcfdegencfkkpphgkogonmpckeofhgko',
    name: 'RoSearcher',
    resource: 'load.js',
  },
  {
    id: 'fdojfgffiecmmppcjnahfgiignlnehap',
    name: 'Bitlight Wallet',
    resource: 'assets/chunk-4a411388.js',
  },
  {
    id: 'ffppmilmeaekegkpckebkeahjgmhggpj',
    name: 'Complexity',
    resource: 'public/img/logo-16.png',
  },
  {
    id: 'fhjnbgadgmmffddcilnbmcieekimilcn',
    name: 'Internet Download Accelerator',
    resource: 'ui/assets/img/download.png',
  },
  {
    id: 'flaeifplnkmoagonpbjmedjcadegiigl',
    name: 'X-VPN',
    resource: 'assets/isolated.js-3ddfd1e1.js',
  },
  {
    id: 'flkdejchjaibellgdhchhjpacegdgmin',
    name: 'n8n Chat',
    resource: 'esm-browser.76535c48.js',
  },
  {
    id: 'flnheeellpciglgpaodhkhmapeljopja',
    name: 'Altair',
    resource: 'altair-app/styles.css',
  },
  {
    id: 'gagidkjllbdgggpboolfmmdpeagghjlm',
    name: 'Arcade',
    resource: 'frame-wrapper.html',
  },
  {
    id: 'gchcfdihakkhjgfmokemfeembfokkajj',
    name: 'Fake Data',
    resource: 'sandbox/sandbox.html',
  },
  {
    id: 'gfecjpfhkebjjmanebmejoflhajdgbpa',
    name: 'Brainly Homework Help',
    resource: 'content-script-all.css',
  },
  {
    id: 'gfgpkepllngchpmcippidfhmbhlljhoo',
    name: 'XTranslate',
    resource: 'app.js',
  },
  {
    id: 'hahkojdegblcccihngmgndhdfheheofe',
    name: 'TextCortex',
    resource: 'fonts/Inter-Bold.woff',
  },
  {
    id: 'hegneaniplmfjcmohoclabblbahcbjoe',
    name: 'Video Ad Blocker Plus',
    resource: 'img/x.svg',
  },
  {
    id: 'hhfnghjdeddcfegfekjeihfmbjenlomm',
    name: 'Web Tracker',
    resource: 'assets/pomodoro-sounds/7.mp3',
  },
  {
    id: 'hlambnnbnnjkabpgemeompijpdliimkm',
    name: 'CardPointers X',
    resource: 'tweaks.css',
  },
  {
    id: 'hmbnbbbknglecphfogchkhpdjiodfclh',
    name: 'QuickForm - Autofill & Form Filler',
    resource: 'wl-AG7HGFEJ.47dae559.js',
  },
  {
    id: 'hmdkfngkncmbgiehonfebecighedjiak',
    name: 'Genspark',
    resource: 'index.html',
  },
  {
    id: 'hmlmncgagbkggdfpklpmhjcmbjadpkdo',
    name: 'Universal Copy-Enable Copy',
    resource: 'js/normal.js',
  },
  {
    id: 'hnebcbhjpeejiclgbohcijljcnjdofek',
    name: 'Namada Keychain',
    resource: 'assets/app.css',
  },
  {
    id: 'hnfdneofpohlkoeljnmkdocokcdkjiaa',
    name: 'Earth',
    resource: 'manifest.json',
  },
  {
    id: 'hobjkcpmjhlegmobgonaagepfckjkceh',
    name: 'Windsurf Plugin',
    resource: 'script.js',
  },
  {
    id: 'iccjkhpkdhdhjiaocipcegfeoclioejn',
    name: 'Pomodoro',
    resource: 'mp3/gta.mp3',
  },
  {
    id: 'ifnkdbpmgkdbfklnbfidaackdenlmhgh',
    name: 'PopUpOFF',
    resource: 'images/stop_ads.png',
  },
  {
    id: 'ikcgnmhndofpnljaijlpjjbbpiamehan',
    name: 'INLoad',
    resource: 'data/rate.js',
  },
  {
    id: 'imbddededgmcgfhfpcjmijokokekbkal',
    name: 'Nanobrowser',
    resource: 'refresh.js',
  },
  {
    id: 'imopknpgdihifjkjpmjaagcagkefddnb',
    name: 'Screen Capture and Screen Recorder',
    resource: 'popup.html',
  },
  {
    id: 'jbfeongihppeenfnaofmdeikahaefljd',
    name: 'Manganum',
    resource: 'assets/ntp.js',
  },
  {
    id: 'jblbcpkejogbghfdglhfjlplchcnmohm',
    name: 'Supademo',
    resource: 'fonts/Inter-Bold.woff2',
  },
  {
    id: 'jbmmmambjlkjkinkpifefiaehflllopg',
    name: 'Mystique Search',
    resource: '128.png',
  },
  {
    id: 'jcnfkjjanbdfabigknbedgkfjkljhbdn',
    name: 'FatRank',
    resource: 'js/google-countries.json',
  },
  {
    id: 'jepfhfjlkgobooomdgpcjikalfpcldmm',
    name: 'NflxMultiSubs',
    resource: 'nflxmultisubs.min.js',
  },
  {
    id: 'jfbbgijjljfbolelfkopkhbfjajjampm',
    name: 'Screen Ruler',
    resource: 'sidepanel/logos/d3.svg',
  },
  {
    id: 'jfoanacamkbfibjbidbmeobmnndfgpca',
    name: 'Shopilo',
    resource: 'assets/logo/48x48.png',
  },
  {
    id: 'jgdddeonphekfhicmnpffkfpboalmcjd',
    name: 'Easy PDF Viewer',
    resource: 'manifest.json',
  },
  {
    id: 'jgmgecncmjklkabkejnjfgfkglapfgek',
    name: 'Nightfall DLP',
    resource: 'assets/google_logo.png',
  },
  {
    id: 'jjcjblcbnjhgjlnclhficglfjedhpjhl',
    name: 'A & M viewer',
    resource: 'images/close.svg',
  },
  {
    id: 'jmodgcjbfcmningbahdmedofbabejbba',
    name: 'Voice Out',
    resource: 'setup.html',
  },
  {
    id: 'kdglfacllamekkphagegcaabjaicekin',
    name: '来搜',
    resource: 'js/http.js',
  },
  {
    id: 'kdoofkpcjhkbhedgkdbagobockcmeoeb',
    name: 'Laban Dict',
    resource: 'img/icon16.png',
  },
  {
    id: 'kecadfolelkekbfmmfoifpfalfedeljo',
    name: 'Email Finder',
    resource: 'script1.js',
  },
  {
    id: 'kfkdboecolemdjodhmhmcibjocfopejo',
    name: 'CSDN',
    resource: 'js/20.js',
  },
  {
    id: 'khhapgacijodhjokkcjmleaempmchlem',
    name: 'ESET PWM',
    resource: 'src/images/icons/blank.png',
  },
  {
    id: 'kijmncepdjeabghcjppndcgbogkfhbje',
    name: 'TG Content Downloader',
    resource: 'index.html',
  },
  {
    id: 'kiokdhlcmjagacmcgoikapbjmmhfchbi',
    name: 'Web Clipper',
    resource: 'js/content_scripts/inject.js',
  },
  {
    id: 'kjfmedbganalpkohkeghhpppicoigdal',
    name: 'iorad',
    resource: 'panel/app.js',
  },
  {
    id: 'kkpllkodjeloidieedojogacfhpaihoh',
    name: 'Enkrypt',
    resource: 'scripts/inject.js',
  },
  {
    id: 'kngfjpghaokedippaapkfihdlmmlafcc',
    name: 'Locale Switcher',
    resource: 'override-language.js',
  },
  {
    id: 'kodipildlgjdkoeokgibdlighekmebcg',
    name: 'Komodo',
    resource: 'static/images/ui-old/play.svg',
  },
  {
    id: 'kpecfgjcmboghimfnkpcfijmoknhipdi',
    name: 'Img2Go',
    resource: 'iframe.html',
  },
  {
    id: 'lanchoggmnkmkehofmdonkbcdolfonmf',
    name: 'Calculator',
    resource: 'js/popup.js',
  },
  {
    id: 'ledkjiplmbjfmnblpkpckbahgphoajfb',
    name: 'Pitch Changer',
    resource: 'smartProcessor.bundle.js',
  },
  {
    id: 'lfjnnkckddkopjfgmbcpdiolnmfobflj',
    name: 'Custom New Tab',
    resource: 'options.html',
  },
  {
    id: 'lghkkfjealjkonheilkflengobdkiaeo',
    name: 'max PayBack',
    resource: 'dev.js',
  },
  {
    id: 'lgjinjcobiflbbnhenlfkcjpeeacklfl',
    name: 'Copy Me That',
    resource: 'exists.gif',
  },
  {
    id: 'lklimgabcbcgnpdmhcgeomcpigimjdfe',
    name: 'Bunny VPN',
    resource: 'landing.css',
  },
  {
    id: 'lmecinlocgbbcdgbhkidmeijhdhlngjp',
    name: 'Dialpad Chrome CTI',
    resource: 'images/info.svg',
  },
  {
    id: 'lmeddoobegbaiopohmpmmobpnpjifpii',
    name: 'Open in Firefox Browser',
    resource: 'data/redirect/index.html',
  },
  {
    id: 'lnadekhdikcpjfnlhnbingbkhkfkddkl',
    name: 'Robots Exclusion Checker',
    resource: 'config.json',
  },
  {
    id: 'lniombipmmhhighllijmcdncnefpjloi',
    name: 'AppBlock',
    resource: 'block.html',
  },
  {
    id: 'lnmbdamplioghdakbfnbbofeipjlbgpk',
    name: 'Krisp',
    resource: 'patch.js',
  },
  {
    id: 'lpkffpnklfdjompeeodhpaeenfdpibmj',
    name: 'Education Pro',
    resource: 'aupWindow.js',
  },
  {
    id: 'mbheeaapbjpckahhciogfdodofjjldem',
    name: 'Moonbounce',
    resource: 'assets/servers-DOZf_GBI.js',
  },
  {
    id: 'mfacblegickmnfpaebakfnlbfhpoegin',
    name: 'Papers',
    resource: 'inject.html',
  },
  {
    id: 'mfkodnlefnacmembgmkaepdghdhfgolo',
    name: 'Genio Notes',
    resource: 'src/requestPermissions/requestPermissions.ts',
  },
  {
    id: 'mgijmfgdpljgnhcmokgeokdibogckgoj',
    name: 'Snapchat Camera',
    resource: 'inject.js',
  },
  {
    id: 'mjfgpadamkbikpdgpenjhnpckhdpcbcd',
    name: 'Dscout',
    resource: 'widget.html',
  },
  {
    id: 'mkeimkkbcndbdlfkbfhhlfgkilcfniic',
    name: 'Shade Dark Mode',
    resource: 'js/proxy.js',
  },
  {
    id: 'mlhdnjepakdfdaabohjgegnomlgeejep',
    name: 'Smart SOP Generator',
    resource: 'css/edit.css',
  },
  {
    id: 'mnkbccinkbalkmmnmbcicdobcmgggmfc',
    name: 'Scam Sniffer',
    resource: 'dialog.html',
  },
  {
    id: 'mpjjildhmpddojocokjkgmlkkkfjnepo',
    name: 'PixieBrix',
    resource: 'frame.html',
  },
  {
    id: 'mpobacholfblmnpnfbiomjkecoojakah',
    name: 'A11y Checker',
    resource: 'assets/16x16.png',
  },
  {
    id: 'neigoggljhfnodeneidndcflnclldnpm',
    name: "Where It's Cheaper",
    resource: 'content.js',
  },
  {
    id: 'ngghlnfmdgnpegcmbpgehkbhkhkbkjpj',
    name: 'Zapier',
    resource: 'popup.html',
  },
  {
    id: 'nhccebmfjcbhghphpclcfdkkekheegop',
    name: 'Pelagus',
    resource: 'window-provider.js',
  },
  {
    id: 'nhonfddkgankhjilponlbdccpabaaknp',
    name: 'Legrooms+ for Google Flights',
    resource: 'popup.html',
  },
  {
    id: 'nibjojkomfdiaoajekhjakgkdhaomnch',
    name: 'IPFS Companion',
    resource: 'icons/ipfs-logo-on.svg',
  },
  {
    id: 'nkklhdhlfknnhmmldffbofbbomlicpig',
    name: 'Snap VPN',
    resource: 'web_accessible_resources/status_on.png',
  },
  {
    id: 'nlfaobjnjbmbdnoeiijojjmeihbheegn',
    name: 'Flash Player that Works!',
    resource: 'icons/joy.png',
  },
  {
    id: 'noagjioaihamoljcbelhdlldnmlgnkon',
    name: 'Definer',
    resource: 'inject/bubble.css',
  },
  {
    id: 'nomnoimacbncclfbnfaingniikblfbji',
    name: 'Debugger for Google Analytics 4',
    resource: 'build/main.html',
  },
  {
    id: 'npkncdihipibabapnailakhpajlglbfk',
    name: 'Signal Spam',
    resource: 'js/options.js',
  },
  {
    id: 'npmjjkphdlmbeidbdbfefgedondknlaf',
    name: 'uTab',
    resource: 'assets/static/32.png',
  },
  {
    id: 'obhceflecohdhjjomleeakkogaiclhoo',
    name: 'Tag Explorer',
    resource: 'assets/icons/tag-icons/7.ico',
  },
  {
    id: 'ohffmmbmebhcljgcdijjlepjaoladfag',
    name: 'Keyword Planner',
    resource: 'assets/loader.svg',
  },
  {
    id: 'ohgodjgnfedgikkgcjdkomkadbfedcjd',
    name: 'ReaderGPT',
    resource: 'options.js',
  },
  {
    id: 'oihhpemnlfdlkdhbiajjjkbbojdojchj',
    name: 'Pixie Reader',
    resource: 'contentStyle.css',
  },
  {
    id: 'onpkagahfdnlknakhgnegpipmhkodnlm',
    name: 'MapQuest Search',
    resource: 'manifest.json',
  },
  {
    id: 'ooipofofnficlkcfhfncjiccaoceaodh',
    name: 'LilysAI',
    resource: 'close.svg',
  },
  {
    id: 'oolbjiianecoijlgkhopbmhnliajjnnm',
    name: 'Reminders by SMS',
    resource: 'error.svg',
  },
  {
    id: 'pebeiooilphfmbohdbhbomomkkoghoia',
    name: 'Testim Editor',
    resource: 'popup2/fab/index.html',
  },
  {
    id: 'pkoccklolohdacbfooifnpebakpbeipc',
    name: 'Allow Select And Copy',
    resource: 'data/engine/index.html',
  },
  {
    id: 'pmbjpcmaaladnfpacpmhmnfmpklgbdjb',
    name: 'OP_WALLET',
    resource: 'pageProvider.js',
  },
  {
    id: 'abbedfhgcpfnmhonjhdlmndigalhandb',
    name: 'Power Text',
    resource: 'scripts/powerTextMda.js',
  },
  {
    id: 'abhjpgicemlbiclagmlbnchinjdimkog',
    name: 'Readvox',
    resource: 'icons/icon-readvox.svg',
  },
  {
    id: 'abocjojdmemdpiffeadpdnicnlhcndcg',
    name: 'SocialFocus',
    resource: 'extension/scripts/screenTranslation.js',
  },
  {
    id: 'acaonckckmmakfgjfkgbfeepdhmajkeg',
    name: 'TraitSniper',
    resource: 'static/js/content.js',
  },
  {
    id: 'adjgicoimjhccdcjgepkmigomegpjplg',
    name: 'Talkdesk Click-to-Call',
    resource: 'img/favicon.png',
  },
  {
    id: 'agleiimpggapjekcdhdjbmegjbbkleie',
    name: 'Ground News',
    resource: 'frame.html',
  },
  {
    id: 'agplbamogoflhammoccnkehefjgkcncl',
    name: 'Gener8',
    resource: 'dist/DMSans-Bold-6Z5CL2SK.ttf',
  },
  {
    id: 'ameejlihjfcaopbicekclahkpjaligab',
    name: 'Chromebook usage monitoring',
    resource: 'script.js',
  },
  {
    id: 'amlcmfdiddkikfmljhdhhookgjmnpedc',
    name: 'Currency Converter PRO',
    resource: 'assets/utm-DUa2N22w.js',
  },
  {
    id: 'anbfhidldjknonaihbalghlebaijealk',
    name: 'BP Assistant',
    resource: 'ga/analytics.js',
  },
  {
    id: 'anenfchlanlnhmjibebhkgbnelojooic',
    name: 'Blaze VPN',
    resource: 'web_accessible_resources/status_on.png',
  },
  {
    id: 'angpjceilobeojeaomilenbjdjdnffkn',
    name: 'Proctortrack One v3',
    resource: 'assets/icon.png',
  },
  {
    id: 'bbdhfoclddncoaomddgkaaphcnddbpdh',
    name: 'rektCaptcha',
    resource: 'models/bus.ort',
  },
  {
    id: 'bdgmdoedahdcjmpmifafdhnffjinddgc',
    name: 'bittensor',
    resource: 'page.js',
  },
  {
    id: 'befflofjcniongenjmbkgkoljhgliihe',
    name: 'TinaMind',
    resource: 'images/logo.png',
  },
  {
    id: 'bggfcpfjbdkhfhfmkjpbhnkhnpjjeomc',
    name: 'Material Icons for GitHub',
    resource: 'd.svg',
  },
  {
    id: 'biaggnjibplcfekllonekbonhfgchopo',
    name: 'Webpilot',
    resource: 'manifest.json',
  },
  {
    id: 'bjkmnimffmhjbfikbempnbanngnnmknc',
    name: 'AI Toolbar',
    resource: 'svg/cog.svg',
  },
  {
    id: 'bmdpeakaalmaaflnkckhjcojpemlkjig',
    name: 'Kixie PowerCall',
    resource: 'lib/processor.js',
  },
  {
    id: 'bnbmhdpijoplhmffgicopkjjhdjpoaii',
    name: 'SkipIt Adblocker for Youtube',
    resource: 'script.js',
  },
  {
    id: 'bnpalipgomknhgbmgelaplknnmckljaf',
    name: 'Currency.Wiki',
    resource: 'content.js',
  },
  {
    id: 'camnmdjjfkcplbdlofbndmkmnfeegjoi',
    name: 'Keep Aware',
    resource: 'msghand.css',
  },
  {
    id: 'cbemppalkfdmphifdpmfiaacghfedklf',
    name: 'Savings Genie',
    resource: 'css/slick.css',
  },
  {
    id: 'cbfnbdgmjknfjeidohbhmpdliofaopne',
    name: 'Fix-IT Mate',
    resource: 'sidepanel.js',
  },
  {
    id: 'cgdelbjbpigakkmnampgkeigekpacodn',
    name: 'UPS Tracking',
    resource: 'manifest.json',
  },
  {
    id: 'ckdjadjpndnpnghpingmnoonmejdidga',
    name: 'Suki for Clinicians',
    resource: 'assets/css/index.css',
  },
  {
    id: 'ckpgbnnkddpiecdggjedokigklbccbgb',
    name: 'Cookie Clicker',
    resource: 'assets/style.css',
  },
  {
    id: 'cmkpnegkacdeagdmnbbhjbgdpndmlkgj',
    name: 'Breez ClickOnce 4C',
    resource: 'modalHelper.js',
  },
  {
    id: 'cnlaenhekjagkfjaglgfffkdblmddnnn',
    name: 'OKIOCAM Stop Motion',
    resource: 'ffmpeg/ffmpeg.wasm',
  },
  {
    id: 'cnnenlbocdcjnmpkkbbdgjfejinfffjc',
    name: 'YouMind',
    resource: 'scripts/build.js',
  },
  {
    id: 'cpnnabpklgnhjopaenljbbmkejamagel',
    name: 'Rytr',
    resource: 'images/logo.svg',
  },
  {
    id: 'cpnomhnclohkhnikegipapofcjihldck',
    name: 'Text to Speech',
    resource: 'data/content_script/icons/play.png',
  },
  {
    id: 'dbnjpielondlkmdjbembloegkaabfakc',
    name: 'Glot',
    resource: 'video/iq.js',
  },
  {
    id: 'dcbgifpfidkhblnocnmkgjglblfmefna',
    name: 'Pin Toolbox',
    resource: 'assets/icon.png',
  },
  {
    id: 'dddonmdoiepbnlieemndhohfdhjplcce',
    name: 'Audio Equalizer',
    resource: 'main.js',
  },
  {
    id: 'deafalnegnfhjhejolidiobnapigcfpd',
    name: 'YT Watch Later Assist',
    resource: 'image/yt_watch_later_assit_32.png',
  },
  {
    id: 'denbgaamihkadbghdceggmchnflmhpmk',
    name: 'Spector.js',
    resource: 'popup.js',
  },
  {
    id: 'depnaiojakmmjcdpccbffphcgjghniol',
    name: 'Get Weather Today',
    resource: 'img/icon16.png',
  },
  {
    id: 'djcobamaplcmhmaocomnkfdbcoiggepo',
    name: 'Grabit',
    resource: 'icon_128.png',
  },
  {
    id: 'dpphkcfmnbkdpmgneljgdhfnccnhmfig',
    name: 'Relingo',
    resource: 'pdf.html',
  },
  { id: 'eajafomhmkipbjmfmhebemolkcicgfmd', name: 'Taho', resource: 'tab.js' },
  {
    id: 'eaoelafamejbnggahofapllmfhlhajdd',
    name: '空降助手',
    resource: 'popup.css',
  },
  {
    id: 'eeckiajfclogcacnhgigljkcgabfcmco',
    name: 'Bookmarks Checker',
    resource: 'assets/content.js',
  },
  {
    id: 'egfkhocobmgeafdbjbphhfdfbmlobgdc',
    name: '大学搜题酱插件',
    resource: 'lib/TyprMd5.js',
  },
  {
    id: 'egmhoeaacclmanaimofoooiamhpkimkk',
    name: 'Scroll Capture',
    resource: 'content.js',
  },
  {
    id: 'einnioafmpimabjcddiinlhmijaionap',
    name: 'Wander',
    resource: 'assets/animation/usd.png',
  },
  {
    id: 'ejcfngdpgojodfjcajnglnhppglcfedg',
    name: 'Cashback Master',
    resource: 'static/css/style.css',
  },
  {
    id: 'ejkboneafcafckbjhnfhehlcanejlgmc',
    name: 'VibeMate',
    resource: 'base.js',
  },
  {
    id: 'epnkgfaomnlopilnejhgndcilhlimndd',
    name: 'Shopstat',
    resource: 'icon16.png',
  },
  {
    id: 'fcejkolobdcfbhhakbhajcflakmnhaff',
    name: 'Knowee AI',
    resource: 'pages/pdf/build/pdf.js',
  },
  {
    id: 'fdnipcdebaagjpicpbkildmcefflobhn',
    name: 'Attendance for Google Meet',
    resource: 'img/16.png',
  },
  {
    id: 'fgbhbfdgdlojklkbhdoilkdlomoilbpl',
    name: 'Just-One-Page-PDF',
    resource: 'ct.html',
  },
  {
    id: 'fgkaoogkkkljechkddpghhhklmooadch',
    name: 'Promethean ActivSuite',
    resource: 'ui/loader.js',
  },
  {
    id: 'fgomgoininjjcilkdpghijnhmlagbndk',
    name: 'Content Site Search Guru',
    resource: 'img/icon16.png',
  },
  {
    id: 'fhjanlpjlfhhbhbnjohflphmfccbhmoi',
    name: "Elfster's Wish It!",
    resource: 'index.html',
  },
  {
    id: 'fidcileobejjkcaoalcnedmgmnegmoic',
    name: 'History & Cache Cleaner',
    resource: 'img/info.svg',
  },
  {
    id: 'fkeaekngjflipcockcnpobkpbbfbhmdn',
    name: 'Copy as Markdown',
    resource: 'dist/vendor/turndown.mjs',
  },
  {
    id: 'flaohdpapmmmkmfnghobgdlbiioeplhb',
    name: 'Free Snipping Tool',
    resource: 'icons/icon.png',
  },
  {
    id: 'fmhbdohlogekfmknbhfpbeiphcldcfji',
    name: 'Red Shield VPN',
    resource: 'rsvcontent.js',
  },
  {
    id: 'fnpeooemaihkgkfdpdpipikehmceplfl',
    name: 'Soliton PasswordManager',
    resource: 'notification_dialog.html',
  },
  {
    id: 'fpelahbljekknahkcaegamhcndkfpfnc',
    name: 'Suricata',
    resource: 'iFrame.js',
  },
  {
    id: 'gamkifgdajnpkdjfnpplogdpjcjbhaif',
    name: 'Earth Search',
    resource: 'manifest.json',
  },
  {
    id: 'gbilbeoogenjmnabenfjfoockmpfnjoh',
    name: 'Night Mode Pro',
    resource: 'data/content_script/inject.css',
  },
  {
    id: 'gdhpobnkinppekiaabcndnleaejeddod',
    name: 'Coupert Pure',
    resource: 'css/font.css',
  },
  {
    id: 'gipnlpdeieaidmmeaichnddnmjmcakoe',
    name: 'Selection Search',
    resource: 'img/copy.svg',
  },
  {
    id: 'gjaklccphhffeddbigoeknakacjacein',
    name: 'The Best Translator for WhatsApp Web',
    resource: 'assets/index.d2da5480.js',
  },
  {
    id: 'gjlnedceigegbbmdnjgeebldeljgmhch',
    name: 'Oracle Guided Learning Editor',
    resource: 'css/spin.css',
  },
  {
    id: 'gkdefhnhldnmfnajfkeldcaihahkhhnd',
    name: 'Cute Tab',
    resource: 'assets/static/32.png',
  },
  {
    id: 'gkohiokkalnklkeagfgamdnnhajjnfaf',
    name: 'Web2Speech',
    resource: 'index.html',
  },
  {
    id: 'glpichgelkekjnccdflklcclhnoioblm',
    name: 'SendSafely Encryption',
    resource: 'images/sendsafely_banner.png',
  },
  {
    id: 'gobliffocflfaekfcaccndlffkhcafhb',
    name: 'RevSeller',
    resource: 'html/lists.html',
  },
  {
    id: 'gpilpagnmpikakpjiokkabbigneigoln',
    name: 'Qoala',
    resource: 'assets/images/icon128.png',
  },
  {
    id: 'gpmodmeblccallcadopbcoeoejepgpnb',
    name: 'JSON Formatter',
    resource: 'css/UI.css',
  },
  {
    id: 'haafibkemckmbknhfkiiniobjpgkebko',
    name: 'Panda New Tab',
    resource: 'newtab.html',
  },
  {
    id: 'hfhfmkmokccaciopjahpkmfdbkjbhmfp',
    name: 'Newz Finder',
    resource: 'img/icon16.png',
  },
  {
    id: 'hgbbfkafecdbocpcdkoahfkbkoodcaon',
    name: 'Moonsift',
    resource: 'ui/ms_go.css',
  },
  {
    id: 'hjdmjldimjfmcaemghmjibkpdgjihplp',
    name: "Lanceur d'applications ACD",
    resource: 'bienvenue.html',
  },
  {
    id: 'hkddcnbhifppgmfgflgaelippbigjpjo',
    name: 'Vue.js devtools (v5)',
    resource: 'devtools.html',
  },
  {
    id: 'hlifkpholllijblknnmbfagnkjneagid',
    name: 'Captcha Solver',
    resource: 'static/wasm.wasm',
  },
  {
    id: 'hpmllfbpmmhjncbfofmkkgomjpfaocca',
    name: 'SeoStack',
    resource: 'assets/img/h1.svg',
  },
  {
    id: 'idfblidcbbfkggckamnibfbngnbgjocf',
    name: 'Cognism',
    resource: 'index.html',
  },
  {
    id: 'ifaicffibnedodkbekogndkdfeojcofb',
    name: 'Pets Chrome',
    resource: 'assets/cats/glay/glay_512x512_8x8.png',
  },
  {
    id: 'ihnfmldlpdipgnliolhfffenpcmjgnif',
    name: 'OCR Editor',
    resource: 'load.gif',
  },
  {
    id: 'ikbdppgmbnfncggibmidpeoklmbbmpbb',
    name: 'Samsung Pass',
    resource: 'images/MKTlogoWhite.svg',
  },
  {
    id: 'ilamopeagajnekeaogejpdmffneankjf',
    name: 'Duey.ai - Auto Typer for Google Docs, Slides & Microsoft Word Online',
    resource: 'logo.svg',
  },
  {
    id: 'imnbhbjodhdinfaifjbpgkpknejadfjk',
    name: 'Naver dictionary',
    resource: 'content.js',
  },
  {
    id: 'imomahaddnhnhfggpmpbphdiobpmahof',
    name: 'Skins for YouTube player',
    resource: 'resources/js/onoff.js',
  },
  {
    id: 'jbmbplbpgcpooepakloahbjjcpfoegji',
    name: 'Video Downloader',
    resource: 'js/app.js',
  },
  {
    id: 'jgglfdpjpddcdaeapbcfgckfheabbdpi',
    name: 'AAMC MCAT Interface',
    resource: 'fonts/index.css',
  },
  {
    id: 'jgnfghanfbjmimbdmnjfofnbcgpkbegj',
    name: 'KeePassHelper Password Manager',
    resource: 'data/cmd/index.html',
  },
  {
    id: 'jnhgefjoahogmkkekdnafldkdgppfehd',
    name: 'Printix',
    resource: 'azure-signin-callback.js',
  },
  {
    id: 'joioophepbodkfjcjpoeofkgdblahbfe',
    name: 'Mango Helper',
    resource: 'css/lk.css',
  },
  {
    id: 'kaedchgajfpgipflgbgeeiiajekblklm',
    name: 'Trellix Endpoint Security For Mac Web Control',
    resource: 'js/yahoo.js',
  },
  {
    id: 'kbdlpfmnciffgllhfijijnakeipkngbe',
    name: 'Safum free VPN',
    resource: 'web_accessible_resources/status_on.png',
  },
  {
    id: 'kbobdmmjbaljcombpliahadgoafgohcd',
    name: 'Earth 3D',
    resource: 'manifest.json',
  },
  {
    id: 'kdngfaamkbbkdbemejnlkmjfpmndjdmb',
    name: 'Originality.ai',
    resource: 'icons/icon128.png',
  },
  {
    id: 'kfmgapneffipolpljmofbmonafjlodim',
    name: 'Yodeck Web Player',
    resource: 'inject.js',
  },
  {
    id: 'kgcjekpmcjjogibpjebkhaanilehneje',
    name: 'Karakeep',
    resource: 'assets/protocol-CjgZP5TH.js',
  },
  {
    id: 'kglcipoddmbniebnibibkghfijekllbl',
    name: 'Kerberus Sentinel3',
    resource: 'doc.svg',
  },
  {
    id: 'kifcalgkjaphbpbcgokommchjiimejah',
    name: 'Frontrun',
    resource: 'fail.1ca04b6f.mp3',
  },
  {
    id: 'kjnmdomccekpkjomjhapnilfmeiglkid',
    name: 'Web for Telegram',
    resource: 'img/icon.ico',
  },
  {
    id: 'klohjdodjjeocpbpadmkcndjoadijgjg',
    name: 'Schema Builder for Structured Data',
    resource: 'icon-128.png',
  },
  {
    id: 'kmmfdmaiadakelcogiabcebofcgfkdma',
    name: 'Always on Top Window',
    resource: 'icon/48.png',
  },
  {
    id: 'kojhcdejfimplnokhhhekhiapceggamn',
    name: 'Surfe',
    resource: 'inject.css',
  },
  {
    id: 'lcjfjohndknooijjhenkglbljldglnbd',
    name: 'Alation',
    resource: 'index.html',
  },
  {
    id: 'ldgogjlogbecagpdpfomiiebiaeilgpd',
    name: 'Coursology',
    resource: 'assets/loading.riv',
  },
  {
    id: 'lepcfgkehgeiblekejomdmdklmjdmflp',
    name: 'Manga Translator',
    resource: 'icons/19x19.png',
  },
  {
    id: 'lhdknendolkhkmfpklppgpbimpbnlgel',
    name: 'eBay Sold History Button',
    resource: 'content-scripts/main.css',
  },
  {
    id: 'lidlocdecbjopdnblcplkgcojdnngdif',
    name: 'Remove background',
    resource: 'assets/rmbg-data/resources.json',
  },
  {
    id: 'ljccnonneanghhogfgkjookoghnbhiak',
    name: 'Shein选品助手',
    resource: 'inject.js',
  },
  {
    id: 'lkhiljgmbeecmljiogckofcalncmfnfo',
    name: 'Migaku',
    resource: 'core/es.db',
  },
  {
    id: 'lkihjlcipnbgeokmfnpogjfflofbfhga',
    name: 'Are.na',
    resource: 'index.html',
  },
  {
    id: 'lkjffochdceoneajnigkbdddjdekhojj',
    name: 'Japanese Translate & Dictionary Mazii',
    resource: 'favicon.ico',
  },
  {
    id: 'mbdojfbhgijnafkihnkhllmhjhkmhedg',
    name: 'Volume & Bass Booster',
    resource: 'static/icons/star.svg',
  },
  {
    id: 'mbgjopdedgonlbpikjfibkccpmhjbnag',
    name: 'SpeedyApply',
    resource: 'options.html',
  },
  {
    id: 'mdcemplfpeifcogglenloohjghjbigni',
    name: 'ChongLuaDao',
    resource: 'blocking.html',
  },
  {
    id: 'mdjbgnpehbhpibonmjjjbjaoechnlcaf',
    name: 'AllDebrid',
    resource: 'img/fr.png',
  },
  {
    id: 'mgcmocglffknmbhhfjihifeldhghihpj',
    name: 'HiveFury',
    resource: 'drainersInjection.js',
  },
  {
    id: 'mipeohjjimeknlkekbemdjbjniogbgel',
    name: 'Hubstaff Time Tracker',
    resource: 'css/popup.css',
  },
  {
    id: 'mkgegefmmdlpejiifolbbjjfggimnmoe',
    name: 'PDF.ai',
    resource: 'images/icon.png',
  },
  {
    id: 'mmhpmbmabmppoeonpcclfiobhpjdcdjc',
    name: 'Screen capture and recorder',
    resource: 'index.html',
  },
  {
    id: 'modkelfkcfjpgbfmnbnllalkiogfofhb',
    name: 'Read Frog',
    resource: 'assets/host.png',
  },
  {
    id: 'nakcddgmfmjmdbfahkkiijejmmfkfipc',
    name: 'Passportal',
    resource: 'images/key.svg',
  },
  {
    id: 'nbhhncgkhacdaaccjbbadkpdiljedlje',
    name: 'CAI Tools',
    resource: 'assets/fonts.js',
  },
  {
    id: 'nbnadmpkgmmampijfdadgadjookahkbc',
    name: 'Gong Anywhere',
    resource: 'src/iframes/shared/generic-iframe.html',
  },
  {
    id: 'ndandbjhlckddblkhognpbfbhjokbplp',
    name: 'MyRegistry Shipping Address Assist',
    resource: 'data/icons/icon.png',
  },
  {
    id: 'ngddmlfbgokkcfbmnniahfbffdohlhgf',
    name: 'Seller Assistant',
    resource: 'images/new.svg',
  },
  {
    id: 'nglpibmgabflgkjfaaejmilcekemdnkd',
    name: 'Ads Hunter',
    resource: 'blocked.html',
  },
  {
    id: 'nhnkbkgjikgcigadomkphalanndcapjk',
    name: 'CLV Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'nmjefghbgfcpoobigfbalocpncklkjhk',
    name: 'ThinForms Enterprise',
    resource: 'oforms_scanner_inj.js',
  },
  {
    id: 'nmniboccheadcclilkfkonokbcoceced',
    name: 'Revoke.cash',
    resource: 'images/x.svg',
  },
  {
    id: 'npbfdllefekhdplbkdigpncggmojpefi',
    name: 'LocatorJS',
    resource: 'icon-34.png',
  },
  {
    id: 'oaikpkmjciadfpddlpjjdapglcihgdle',
    name: 'Uvoice',
    resource: 'dist/404.html',
  },
  {
    id: 'oanlehpljgeknlohgbakodejdbingjpj',
    name: 'AiPrice(AliPrice) Search by Image for Shopee',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ocallppfcfgngjhoplfhlmekcdjaeapl',
    name: 'LoveDeals',
    resource: 'ad.10e07838.css',
  },
  {
    id: 'ocgmjfcfjilnmobeocoklcbpcanilpjd',
    name: 'RightTool for QuickBooks Online',
    resource: 'html/test.js',
  },
  {
    id: 'oddhnidmicpefilikhgeagedibnefkcf',
    name: 'React Context DevTool',
    resource: 'mainContent.js',
  },
  {
    id: 'ofokfnlmkfghjcmppfopibknmlhadhbm',
    name: 'Bullet Journal',
    resource: 'popup.js',
  },
  {
    id: 'ojaffphbffmdaicdkahnmihipclmepok',
    name: 'Data Scraper',
    resource: 'static/README.md',
  },
  {
    id: 'okieokifcnnigcgceookjighhplbhcip',
    name: 'Denote',
    resource: 'manifest.json',
  },
  {
    id: 'omnpnodbhognoblgbjmlagejkioccpih',
    name: 'キーゾンv3',
    resource: 'style.css',
  },
  {
    id: 'ongmhighpnfpojfidgigcjflgdkjfdeb',
    name: 'Storylane',
    resource: 'fonts/Inter.ttf',
  },
  {
    id: 'onlmpoiokhmjmfhaaobipcafdngmppoi',
    name: 'Hero Ad Blocker',
    resource: 'filters/data.json',
  },
  {
    id: 'oplfencnkfofaoeedbmphcbplaceplim',
    name: 'MagicSchool AI',
    resource: 'assets/main.tsx-D8mlinZd.js',
  },
  {
    id: 'pcgjkiiepdbfbhcddncidopmihdekemj',
    name: 'Web Paint Online',
    resource: 'images/pen.png',
  },
  {
    id: 'peaiabjigdmcjiigljknblkdmllgmklp',
    name: 'Vidline',
    resource: 'logo.png',
  },
  {
    id: 'peiobddfomnijgoblelfdmjblplojcoe',
    name: 'Share-A-Cart for Amazon',
    resource: 'images/sac-16.png',
  },
  {
    id: 'pgeoioaaakldfhommgfebemhpdimhmgm',
    name: 'SchoolAI',
    resource: 'recording-in-progress.mp3',
  },
  {
    id: 'pgojnojmmhpofjgdmaebadhbocahppod',
    name: 'Captcha Solver',
    resource: 'dom.js',
  },
  {
    id: 'ponokiofkijoolhebggofhhibnafebna',
    name: 'Felo Subtitles',
    resource: 'img/no-capture.svg',
  },
  {
    id: 'ppklhnpdbmedfmgidedifnpdfcdlfijn',
    name: 'Wanderlog',
    resource: 'js/mapContent.js',
  },
  {
    id: 'ppoekdaclagjhfdjckangfblildnahka',
    name: 'AMZ Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'aakigomphmlnijlfonlhcobonfhfipoi',
    name: 'Merch by Amazon Trademark Protection',
    resource: 'images/cross.svg',
  },
  {
    id: 'aecnmadngpjbokeakinhbgfanlnjdnom',
    name: 'Full Page Screenshot',
    resource: 'assets/static/32.png',
  },
  {
    id: 'aefiepimkogajhddmhcekceihikjcabd',
    name: 'Taboola Pixel Helper',
    resource: 'injected.min.js',
  },
  {
    id: 'ahiickjmnblnnhjcomiegpdikaboegda',
    name: 'JustCall',
    resource: 'sms.png',
  },
  {
    id: 'amkmjjmmflddogmhpjloimipbofnfjih',
    name: 'Wombat',
    resource: 'dropbox.html',
  },
  {
    id: 'anpapjclbjicacakeoggghfldppbkepg',
    name: 'Login Recorder for Burp Suite',
    resource: 'images/key.svg',
  },
  {
    id: 'apaogbppkcinodjdpgdelancfdfmlhcn',
    name: 'Batch Upload Tool',
    resource: 'platform/intercept/index.js',
  },
  {
    id: 'apmmpaebfobifelkijhaljbmpcgbjbdo',
    name: 'Stylus (beta)',
    resource: 'install-usercss.html',
  },
  {
    id: 'bciglihaegkdhoogebcdblfhppoilclp',
    name: 'vCaptions',
    resource: 'style.css',
  },
  {
    id: 'bdacnlgpemjkfhlphdhhpamgopagnlie',
    name: 'Locker',
    resource: 'images/x.svg',
  },
  {
    id: 'bdingoflfadhnjohjaplginnpjeclmof',
    name: 'Debugger for Adobe Analytics',
    resource: 'page-script.js',
  },
  {
    id: 'bdkgmiklpdmaojlpflclinlofgjfpabf',
    name: 'Impeccable',
    resource: 'detector/detect.js',
  },
  {
    id: 'bfeplaecgkoeckiidkgkmlllfbaeplgm',
    name: 'Radix Wallet Connector',
    resource: 'assets/index.7ac13232.js',
  },
  {
    id: 'bfkjochdalcdahjnliojhpldoogkbglc',
    name: 'Contentsquare',
    resource: 'snapshot.js',
  },
  {
    id: 'bflmgpechpeohjfomgfdkkfcbhfcjohl',
    name: 'Cubox',
    resource: 'css/cubox.css',
  },
  {
    id: 'biehagnkgckkagkbpncoieiknahmngdg',
    name: 'ASIFY',
    resource: 'ma_injtd.js',
  },
  {
    id: 'bindfabgapagoeaolcbpocelliddgbca',
    name: 'ScreenApp',
    resource: 'screenrecorder.html',
  },
  {
    id: 'bjcoimpfplliplknnmgbffboiihamekf',
    name: 'Broken Link Checker',
    resource: 'data/popup/index.html',
  },
  {
    id: 'bjjobdlpgglckcmhgmmecijpfobmcpap',
    name: 'DeepSeek AI',
    resource: 'style.css',
  },
  {
    id: 'bmbdcffdhebhecemcchbkfnjlmdiiepe',
    name: 'Tooltip Kor<->Eng Dictionary',
    resource: 't.css',
  },
  {
    id: 'bmdblncegkenkacieihfhpjfppoconhi',
    name: 'Ember Inspector',
    resource: 'panes-3-16-0/main.js',
  },
  {
    id: 'bngfikljchleddkelnfgohdfcobkggin',
    name: 'Stickers Packer',
    resource: 'options.html',
  },
  {
    id: 'cakejefemdjbmhdjkjhibjhmhgjefidm',
    name: 'FatCoupon',
    resource: 'content/content.js',
  },
  {
    id: 'ccammcjdkpgjmcpijpahlehmapgmphmk',
    name: 'BaekjoonHub',
    resource: 'popup.js',
  },
  {
    id: 'cejckpjfigehbeecbbfhangbknpidcnh',
    name: 'Change Timezone',
    resource: 'data/inject-content.js',
  },
  {
    id: 'cgajiilhmpfemmdihjnodpibaffakjhj',
    name: 'Slid',
    resource: 'main.css',
  },
  {
    id: 'cgddkajmbckbjbnondgfcbcojjjdnmji',
    name: 'Mavryk Wallet',
    resource: 'fullpage.html',
  },
  {
    id: 'cikpkfgjohfbacpbglmbpefgfdegoolg',
    name: 'Ivanti Secure Access',
    resource: 'extnInterfaceCode.js',
  },
  {
    id: 'cndglokmgjecikflojjieeeajbljgfae',
    name: 'Axhub',
    resource: 'bridge.js',
  },
  {
    id: 'cnmamaachppnkjgnildpdmkaakejnhae',
    name: 'Auro Wallet',
    resource: 'webhook.js',
  },
  {
    id: 'cnncmdhjacpkmjmkcafchppbnpnhdmon',
    name: 'HAVAH Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'dadggmdmhmfkpglkfpkjdmlendbkehoh',
    name: 'OpenVideo',
    resource: 'pages/welcome/index.html',
  },
  {
    id: 'daejfbkjipkgidckemjjafiomfeabemo',
    name: 'ObservePoint Debugger',
    resource: 'scripts/content/pageScript.js',
  },
  {
    id: 'dajlhodahakobmgdiglkajjgbchiiccf',
    name: 'Handy Screenshot',
    resource: 'capture.js',
  },
  {
    id: 'dbpjfmehfpcgmlpfnfilcnhbckmecmca',
    name: 'Simkl TV Tracker',
    resource: 'ico/ico_128.png',
  },
  {
    id: 'dcchknlbddobifongmdiomhboikhebmk',
    name: 'Transit Schedules',
    resource: 'manifest.json',
  },
  {
    id: 'dcfapodepbbgfaimadogodmgniepkiei',
    name: 'Netflix Party',
    resource: 'c2.js',
  },
  {
    id: 'dcmdiknbnpjcbecpfpipeadobeldbijh',
    name: 'Clear Pip View',
    resource: 'web_accessible_resources/on.svg',
  },
  {
    id: 'ddehdnnhjimbggeeenghijehnpakijod',
    name: 'Rescroller',
    resource: 'images/defaults/up.png',
  },
  {
    id: 'ddicoofdkbcdkkeecgafcoabogcgicfp',
    name: 'CubeSeller',
    resource: 'content/extract.js',
  },
  {
    id: 'ddippghibegbgpjcaaijbacfhjjeafjh',
    name: 'ContextSearch',
    resource: 'blank.html',
  },
  {
    id: 'dehgjeidddkjakjgnmpccdkkjdchiifh',
    name: 'ARO Lite',
    resource: 'tabs/offscreen.html',
  },
  {
    id: 'dehnhmdfcnknoboopcbdckoepijmofem',
    name: 'Cross-border Product Collection',
    resource: 'platform/intercept/index.js',
  },
  {
    id: 'dgeiaiglmhdhajbpfbmajaajdlfdinpi',
    name: '会译:沉浸式翻译',
    resource: 'video.js',
  },
  {
    id: 'dkkmpkpjimkollpfgbbglcikcmgmdlhn',
    name: 'AuthoredUp',
    resource: 'build.json',
  },
  {
    id: 'dphoaaiomekdhacmfoblfblmncpnbahm',
    name: 'ChromeKeePass',
    resource: 'images/key.png',
  },
  {
    id: 'eaoehmpaiecpkjibbjjgmmpkeibcgomb',
    name: 'Video Downloader Pro',
    resource: 'js/core.js',
  },
  {
    id: 'ebgcanfjipfcdnjgpbagblmgebkpbhoo',
    name: 'Print Easily',
    resource: 'manifest.json',
  },
  {
    id: 'egamhjcccjiflajhhinondgonlldjgba',
    name: 'WooCommerce AliExpress Dropshipping',
    resource: 'assets/js/jquery.js',
  },
  {
    id: 'ehoomjebcggkfbkeddldagdjgdpepamh',
    name: 'SVG downloader',
    resource: 'img/logo-16.png',
  },
  {
    id: 'eljmjmgjkbmpmfljlmklcfineebidmlo',
    name: 'Psono',
    resource: 'data/js/web-accessible.js',
  },
  {
    id: 'eoicaakpmliddjnnkninphlbpjibnfmh',
    name: 'Cute Avatar',
    resource: 'assets/editor.css',
  },
  {
    id: 'fagmaopcbeobbfhkeodicjekiniefdlo',
    name: 'Copy Text Easily',
    resource: 'style.css',
  },
  {
    id: 'fbjmlmabammiejnfkmgjhdcnjdahblaj',
    name: 'Pronounce',
    resource: 'content.js',
  },
  {
    id: 'fcbffocoaopnenhgbchlchgndohggdei',
    name: 'Measuremate',
    resource: 'fonts/Inter-Bold.woff2',
  },
  {
    id: 'fcbnhmalionocfajdkpnlhmekghnmbii',
    name: 'PHT Translator',
    resource: 'PHT/webar.js',
  },
  {
    id: 'femnahohginddofgekknfmaklcbpinkn',
    name: 'one sec',
    resource: 'images/logo.png',
  },
  {
    id: 'ffboikeeabaiacihgbdinhcegeincpnh',
    name: 'C&R',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'ffikidnnejmibopbgbelephlpigeniph',
    name: 'tabExtend',
    resource: 'assets/fx/addFx.mp3',
  },
  {
    id: 'fgadldooeamdpekomjcdfgofahnplbde',
    name: 'Cornerstone Guide Player',
    resource: 'common/audio/audio.js',
  },
  {
    id: 'fglgjmlbihnfobipoljfdgfojbehcaja',
    name: 'Video Downloader',
    resource: 'src/js/instaStoryDownloader.js',
  },
  {
    id: 'fglmkdhomaklnckgbjfnfmbfmlkjippg',
    name: 'Tracking Button',
    resource: 'options.html',
  },
  {
    id: 'fjkpgkefceopkogemcjcnncdhbgldolm',
    name: 'Google Translate Assistant',
    resource: 'assets/main.js',
  },
  {
    id: 'flejfacjooompmliegamfbpjjdlhokhj',
    name: 'Join',
    resource: 'icons/medium.png',
  },
  {
    id: 'fobklglmhojpeijoioelpdaicagiepbf',
    name: 'LINE購物省錢助理',
    resource: 'icon-16.png',
  },
  {
    id: 'fokkbgoglgfjicalddihnfdfolnhoebb',
    name: 'ClasroomGo',
    resource: 'timer.html',
  },
  {
    id: 'fpkhgmpbidmiogeglndfbkegfdlnajnf',
    name: 'Cosmostation Wallet',
    resource: 'js/inject.js',
  },
  {
    id: 'gbjffmkncjkpnkhjdigbigahdkiccmhd',
    name: 'Snap Search',
    resource: 'icon128.png',
  },
  {
    id: 'gclgnfnkkgjammaplobpkodeojpgfdig',
    name: 'THunt',
    resource: 'icon/16.png',
  },
  {
    id: 'gcoecfgebkokdbahlhodbkmbmdkdcibj',
    name: 'SnapAny',
    resource: 'icon.c766bb78.png',
  },
  {
    id: 'gdcelkbnekfaikpbcgmaijnmclkceoeh',
    name: 'ProTab',
    resource: 'jquery.js',
  },
  {
    id: 'gdnpkbipbholkoaggmlblpbmgemddbgb',
    name: 'Accessible Web Helper',
    resource: 'css/awebChromeHelper.min.css',
  },
  {
    id: 'gdnpnkfophbmbpcjdlbiajpkgdndlino',
    name: 'Infy',
    resource: 'app/scripts/world.js',
  },
  {
    id: 'gefiflkplklbfkcjjcbobokclopbigfg',
    name: 'AZInsight',
    resource: 'js/content-script.js',
  },
  {
    id: 'gennnndepkflndgcjajggdhclmghkpdl',
    name: 'Web Paint',
    resource: 'lib/jquery.min.js',
  },
  {
    id: 'ghibjknldlhfffnckpencpcjbhefblbe',
    name: 'Fast Wallet',
    resource: 'dapp-api.js',
  },
  {
    id: 'gideponcmplkbifbmopkmhncghnkpjng',
    name: 'AD Skipper for Youtube',
    resource: 'content.js',
  },
  {
    id: 'gidnphnamcemailggkemcgclnjeeokaa',
    name: 'Tealium Tools',
    resource: 'chunks/ui.js',
  },
  {
    id: 'gkcdaooannhlioejchebhpkllbcackig',
    name: 'PromptStorm',
    resource: 'src/storage.ts',
  },
  {
    id: 'gkgpbobdiaaodjbmgdankimklclnagio',
    name: 'Cheese-PIP',
    resource: 'popup.html',
  },
  {
    id: 'gklhghenemaeogngbnjdheklnnonajoc',
    name: 'Minea',
    resource: 'assets/eu.png',
  },
  {
    id: 'glkplndamjplebapgopdlbicglmfimic',
    name: 'PixGrid Ruler',
    resource: 'css/content.css',
  },
  {
    id: 'gmbicfpadlmgkfhfepknbmemfhahelll',
    name: 'Backup WhatsApp Chats',
    resource: 'js/lodash.js',
  },
  {
    id: 'gnjggbjjfgjdcnognnfjgcgjbpjdephi',
    name: 'View Manuals',
    resource: 'manifest.json',
  },
  {
    id: 'gobpkdmjnhpopmpddhmhmbhkiienpfdo',
    name: 'Quick Translate',
    resource: 'css/popup.css',
  },
  {
    id: 'gojmmkhaiojimnnjhhilmhjmhdbdagod',
    name: 'Ad Library downloader',
    resource: 'ig.js',
  },
  {
    id: 'habajgjiodkagmalhjchegenflkoogej',
    name: '135小助手V2',
    resource: 'dist/contentScripts/135editor-webext.css',
  },
  {
    id: 'hanjbnalcdpadfkclpliolalhgeonmfn',
    name: 'NewTranx Subtitler',
    resource: 'setting.html',
  },
  {
    id: 'hbikchkhjggjedcpikghdfecmmcaalfm',
    name: 'PingOne',
    resource: 'js/init.js',
  },
  {
    id: 'hdkbnhcgfcokjhlfiicbphafdnipnhjf',
    name: 'New Tab Todo List',
    resource: 'popup.js',
  },
  {
    id: 'hegiignepmecppikdlbohnnbfjdoaghj',
    name: 'Scroll To Top',
    resource: 'icons/pratikabu-stt-clear.svg',
  },
  {
    id: 'hhclmnigoigikdgiflfihpkglefbaaoa',
    name: 'ChatGPT Assistant Plus',
    resource: 'images/48.png',
  },
  {
    id: 'hhhlmhebgldhhkmlcobchafaefeeigji',
    name: 'Auto Page Refresh',
    resource: 'js/bg.js',
  },
  {
    id: 'hhneckfekhpegclkfhefepcjmcnmnpae',
    name: 'Companion Window',
    resource: 'pip.css',
  },
  {
    id: 'hicfolagolebmjahkldfohbmphcoddoh',
    name: 'Reactions for Google Meet',
    resource: 'img/16.png',
  },
  {
    id: 'hijfnlgdhfpmnckieikhinolopcolofe',
    name: 'GMBspy',
    resource: 'js/script.js',
  },
  {
    id: 'hjfiefolgakpndodphcgjllcojieoaak',
    name: 'Maps & Driving Directions',
    resource: 'manifest.json',
  },
  {
    id: 'hlofigcdgjlnalbkeeinfcjceabpamci',
    name: 'The Great Suspender Reloaded',
    resource: 'js/tgs.js',
  },
  {
    id: 'hmmohkncibpklokbkagphdagkibkjkmk',
    name: 'qTest Integration',
    resource: 'injected-script.js',
  },
  {
    id: 'hnchgcelpejnpglbnaieofanfoikiepb',
    name: 'Rakuten',
    resource: 'icon-32.png',
  },
  {
    id: 'hnfabcchmopgohnhkcojhocneefbnffg',
    name: 'Web Translate',
    resource: 'javaScripts/popup.js',
  },
  {
    id: 'hnlpidgbnmikgkmccephgaljihheckii',
    name: 'AMBOSS',
    resource: 'data/en/terms.json',
  },
  {
    id: 'hoeiookpkijlnjdafhaclpdbfflelmci',
    name: 'QR Code Generator',
    resource: 'static/bg.js',
  },
  {
    id: 'hoinmffpdlgmkhckafddjleaelkdnhhk',
    name: 'Pwd Manager',
    resource: 'images.css',
  },
  {
    id: 'homkgeanmijgmjnompbahpmphaiflehl',
    name: 'Convert webpage to PDF',
    resource: 'fonts/OFL.txt',
  },
  {
    id: 'hpkfkbmcphnigepfjmapkdaedglohgjg',
    name: 'Flappy Birdie',
    resource: 'img/48.png',
  },
  {
    id: 'ibdcbopijgjjkihompigdaagfmdfagik',
    name: 'Ouriginal',
    resource: 'panel.html',
  },
  {
    id: 'iebboopaeangfpceklajfohhbpkkfiaa',
    name: 'Deluminate',
    resource: 'deluminate.css',
  },
  {
    id: 'ifjafammaookpiajfbedmacfldaiamgg',
    name: 'BeeLine Reader',
    resource: 'welcome.js',
  },
  {
    id: 'ihbdojmggkmjbhfflnchljfkgdhokffj',
    name: 'Reedy',
    resource: 'f/od.woff2',
  },
  {
    id: 'iidjkmdceolghepehaaddojmnjnkkija',
    name: 'IOTA Wallet',
    resource: 'dapp-interface.js',
  },
  {
    id: 'iinbhdejcemjafkabjokgeaffgnmijbh',
    name: 'Audio to Text in WhatsApp',
    resource: 'third_party/vad/silero_vad_v5.onnx',
  },
  {
    id: 'iipjdmnoigaobkamfhnojmglcdbnfaaf',
    name: 'Clutter Free',
    resource: 'img/cf.svg',
  },
  {
    id: 'ijfcmmkkmogaclaafpgcjdfcfibmhcfa',
    name: 'Furiganator',
    resource: 'dict/cc.dat.gz',
  },
  {
    id: 'ilceenfjabjiciolabkmcgommaibcnnb',
    name: 'Veriffy Signing',
    resource: 'ego-page.js',
  },
  {
    id: 'imjkkofdknonmlapjelmafbikikbegbi',
    name: 'Designer Daily Report',
    resource: 'index.html',
  },
  {
    id: 'imlcamfeniaidioeflifonfjeeppblda',
    name: 'NC Wallet',
    resource: 'content.bundle.js',
  },
  {
    id: 'inahogkhlkbkjkkaleonemeijihmfagi',
    name: 'SPPageDiag',
    resource: 'modern-injected-script.js',
  },
  {
    id: 'inblpolgchbcgmocpnalobjmmaldkjap',
    name: 'AutoDS Dropshipping',
    resource: 'tailwind.css',
  },
  {
    id: 'inlnjgmlcpjmbedjcmnfpolkggnamenp',
    name: 'TRAVIC-Sign',
    resource: 'gui.html',
  },
  {
    id: 'jdedmecbcembcmlddbchlmmoglcldghe',
    name: 'Kleo',
    resource: 'options.html',
  },
  {
    id: 'jhpenclaaeggjdpeeojoplbffailjngd',
    name: 'AitM Block',
    resource: 'assets/eye.ico',
  },
  {
    id: 'jjeflhibndgkdaglkbdeiomkobggoipf',
    name: 'CoreTax PDF Downloader',
    resource: 'styles.css',
  },
  {
    id: 'jkklhhheomgefgljanpobgabooknjlbf',
    name: 'Rove Shopping (Short)',
    resource: 'auth.html',
  },
  {
    id: 'jmogjacildaeibcnaadplhciblohkiff',
    name: 'Savvy',
    resource: 'content.js',
  },
  {
    id: 'jofhoojcehdmaiibilpcoofpdbbddkkl',
    name: 'Marker.io',
    resource: 'vendor/marker-widget/standalone.js',
  },
  {
    id: 'kaibkgfibgoffomjemobnlojipabbbjd',
    name: 'video downloader',
    resource: 'static/js/ytScript.js',
  },
  {
    id: 'kamiaabbnpncbobdiblhfogafnoefkae',
    name: 'FoundersCard',
    resource: 'icon_16.png',
  },
  {
    id: 'kaocoehllbimbaphfmhajjhegdmhjaib',
    name: 'Browser Performance Monitoring',
    resource: 'extensionWASM_1.0.54.0.wasm',
  },
  {
    id: 'kbgfilncepjeoodogmebahnloidgaibg',
    name: 'JobFill',
    resource: 'interceptor.js',
  },
  {
    id: 'kegildkgkfimaeddknomlnfjckeajean',
    name: 'Product Copy',
    resource: 'platform/intercept/index.js',
  },
  {
    id: 'kflmnoghmmldhkplfhanlkobnjjgikoa',
    name: '8x8 Web Dialer',
    resource: 'assets/svgs/phone.svg',
  },
  {
    id: 'kfmlopbepahlcjbkfnnklglgibbopkbk',
    name: 'C2 Password',
    resource: 'icon.html',
  },
  {
    id: 'kgaanolpnilipfmglgfmgfohpcboabic',
    name: 'Google Chrome Password lock',
    resource: 'lock/lock.js',
  },
  {
    id: 'kgfeiebnfmmfpomhochmlfmdmjmfedfj',
    name: '2048 Classic Game',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'khgfhiclgilifjfblcjfcefbhjlponpm',
    name: 'playauto',
    resource: 'manifest.json',
  },
  {
    id: 'khmkmdkfllphcbkbkgflononijbkdgff',
    name: 'Price Tracker 2.0',
    resource: 'images/eyen.png',
  },
  {
    id: 'kiiddchjafkgbaflgnajlogmmmiclfhm',
    name: 'Шоппер',
    resource: 'images/tg.ico',
  },
  {
    id: 'kimheklbcampgaeojcniknnhlmgfddac',
    name: 'MinutaIA Conecta',
    resource: 'pdf.mjs',
  },
  {
    id: 'kjfhlbghiagglcldmlfmpkdgmehmhfjc',
    name: 'EpubPup',
    resource: 'reader.html',
  },
  {
    id: 'kkodiihpgodmdankclfibbiphjkfdenh',
    name: 'ParrotTalks',
    resource: 'options.html',
  },
  {
    id: 'klebcgndepdaddnadnmphbmjgfkdllke',
    name: 'SurfEarner',
    resource: 'img/logo.svg',
  },
  {
    id: 'klggbkjfmbonefdcfkiidhcmfjdfnepa',
    name: 'Quicker Connector',
    resource: 'content/styles.css',
  },
  {
    id: 'kljkjamilbfohkmbacbdongkddmoliag',
    name: 'telegram downloader',
    resource: 'main.js',
  },
  {
    id: 'klkckidpelgokgleimknappemeclljlk',
    name: 'FedEx Tracking',
    resource: 'manifest.json',
  },
  {
    id: 'klnaejjgbibmhlephnhpmaofohgkpgkd',
    name: 'Bearby',
    resource: 'phishing.html',
  },
  {
    id: 'kmmpcmiabjkmpfjkjmekkhlkpoegglbl',
    name: 'What the Font',
    resource: 'src/miv/index.js',
  },
  {
    id: 'kpdkbemdpepjjppbfgeapjienologapa',
    name: 'Search All',
    resource: 'icon32.png',
  },
  {
    id: 'laameccjpleogmfhilmffpdbiibgbekf',
    name: 'Tab Suspender',
    resource: 'assets/options.css',
  },
  {
    id: 'lbhiobcniaahkfhclccbcmhihddhddch',
    name: 'Smart Terms for Confluence and Jira',
    resource: 'resources/css/jira.css',
  },
  {
    id: 'ldfdohgfoolmacfbdekmbpoofhahcfgg',
    name: 'Savings add-on',
    resource: 'icon-32.png',
  },
  {
    id: 'lebpbmopodkmcadehlkmghfcfmgnacdm',
    name: 'Amazon Keyword Tool',
    resource: 'icon-34.png',
  },
  {
    id: 'leidjgpcaiceoeebkdjfcaeboidcjiea',
    name: 'Youtube Summary With AI',
    resource: 'logo.png',
  },
  {
    id: 'lfijgegefgcgbfcgjgnhnkclenhfijhk',
    name: 'Track24.ru',
    resource: 'img/gear.svg',
  },
  {
    id: 'lfjcgcmkmjjlieihflfhjopckgpelofo',
    name: 'gas-github',
    resource: 'options/options.html',
  },
  {
    id: 'lhffkcbejhignakjodkneobebmkljehj',
    name: 'ISAM ESSO',
    resource: 'bg.js',
  },
  {
    id: 'lhgadannddhdpkfhfjjgcpdjhpmjhkfm',
    name: 'Monosnap',
    resource: 'okta.html',
  },
  {
    id: 'lholmjphdehllbpdoiejoolbejkjcpba',
    name: 'Shopee Fans',
    resource: 'js/popup.js',
  },
  {
    id: 'liihfcjialakefgidmaadhajjikbjjab',
    name: 'alphaXiv',
    resource: 'icon-34.png',
  },
  {
    id: 'liobflkelkokkacdemhmgkbpefgaekkm',
    name: 'AMZScout Stock Stats',
    resource: 'icons.css',
  },
  {
    id: 'llmbdmomjmaeegghbkipaolieilmegld',
    name: 'Flappy Budgies Offline. Desktop Version',
    resource: 'popup.js',
  },
  {
    id: 'lodbfhdipoipcjmlebjbgmmgekckhpfb',
    name: 'Harper',
    resource: 'google-docs-bridge.js',
  },
  {
    id: 'lodchmjigmbiibplfmagekadbpomglad',
    name: 'Prospeo Contact Finder',
    resource: 'logo.png',
  },
  {
    id: 'lpopeocbeepakdnipejhlpcmifheolpl',
    name: 'JSON Beautifier and Editor',
    resource: 'data/page/index.html',
  },
  {
    id: 'mcgnagemenncafhpabimmooimpngdcpn',
    name: 'Qwer PDF',
    resource: 'index.html',
  },
  {
    id: 'mfaepkdaodjclepbclabjbigjeohfdje',
    name: 'Gifs autoplay for Google',
    resource: 'inject/xhr.js',
  },
  {
    id: 'mfmpnnhnknadgoafpindapobelgkblbk',
    name: 'Cat-In-Tab',
    resource: 'main.css',
  },
  {
    id: 'mgfcnnpakbfcefgphceolkjldjfpieff',
    name: 'Symbolab',
    resource: 'images/sy.svg',
  },
  {
    id: 'mhfbofiokmppgdliakminbgdgcmbhbac',
    name: 'Web Clipper',
    resource: 'tool.js',
  },
  {
    id: 'mijpgljlfcapndmchhjffkpckknofcnd',
    name: 'Gopeed',
    resource: 'assets/icon.png',
  },
  {
    id: 'mjijaapcbpbcppapekipkdhipfcdpidb',
    name: 'Copy and Paste more',
    resource: 'img/icon16.png',
  },
  {
    id: 'mkjplaglonhndehapbmgooicfneelkic',
    name: "View PDF's",
    resource: 'manifest.json',
  },
  {
    id: 'mndkmbnkepbhdlkhlofdfcmgflbjggnl',
    name: 'Easy Web Data Scraper',
    resource: 'css/main.css',
  },
  {
    id: 'mofcmpgnbnnlcdkfchnggdilcelpgegn',
    name: 'Feishu Clip',
    resource: 'app.js',
  },
  {
    id: 'moombeodfomdpjnpocobemoiaemednkg',
    name: '草料二维码',
    resource: 'js/all.js',
  },
  {
    id: 'mpbelhhnfhfjnaehkcnnaknldmnocglk',
    name: 'HTML Validator',
    resource: 'readme.txt',
  },
  {
    id: 'mpijoellhiljjmeeloljbehhhjkpijpb',
    name: 'Tipli',
    resource: 'serp.js',
  },
  {
    id: 'ndchmakhfaakbkhnkdgambadneloplnn',
    name: 'Cenafy',
    resource: 'cena.mp4',
  },
  {
    id: 'ndgklmlnheedegipcohgcbjhhgddendc',
    name: 'Linguix',
    resource: 'ext-content/assets/images/flags/vi.png',
  },
  {
    id: 'nfhnknijidlahaoemjlbpfpgpheakoph',
    name: 'Synthesia',
    resource: 'faly07ag.js',
  },
  {
    id: 'nfmppnghnhlfnfnhfnahilhfaiahmhfj',
    name: 'GoPlus',
    resource: 'assets/chunk-b05c902b.js',
  },
  {
    id: 'nggldafanajogepfhigplhkamalbpghc',
    name: 'Navigate Rewards',
    resource: 'images/overlay-icon.svg',
  },
  {
    id: 'njggknpmkjapgklcfhaiigafiiebpchm',
    name: 'BrowserGPT',
    resource: 'img/ding.jpeg',
  },
  {
    id: 'njmhcidcdbaannpafjdljminaigdgolj',
    name: 'Noise Cancelling App',
    resource: 'index.html',
  },
  {
    id: 'nknkgcmodkaiffdnlpmlnegmeamnbioe',
    name: 'FolderLM',
    resource: 'vendor/katex/katex.min.css',
  },
  {
    id: 'nlijpgankndpklfipncpkljliinbcbca',
    name: 'Ryviu App',
    resource: 'images/ryviu.png',
  },
  {
    id: 'nnaaobbghcgbefbkhinikgdolfkgnhfj',
    name: 'Pro Sender',
    resource: 'js/proinjt.js',
  },
  {
    id: 'oabphaconndgibllomdcjbfdghcmenci',
    name: 'RTA',
    resource: 'assets/icons/BitTorrent16.png',
  },
  {
    id: 'obkkocadgppbbgkhcgojpjhpphhcgjfa',
    name: 'Userlytics WebRecorder',
    resource: 'dom.js',
  },
  {
    id: 'oeajaacbejdppgamncfdboaiipnncnmj',
    name: 'Read it',
    resource: 'assets/main.css',
  },
  {
    id: 'oghkljobbhapacbahlneolfclkniiami',
    name: 'ProductivityTab',
    resource: 'index.html',
  },
  {
    id: 'oicakdoenlelpjnkoljnaakdofplkgnd',
    name: 'Tab Manager',
    resource: 'index.html',
  },
  {
    id: 'oiillickanjlaeghobeeknbddaonmjnc',
    name: 'RECAP',
    resource: 'assets/images/icon-16.png',
  },
  {
    id: 'ojgkoajchjoafbnckklmamjcceiglmkd',
    name: 'QuizMate',
    resource: 'q.png',
  },
  {
    id: 'ojhlgnehlajjgpneocngnphjellkjgch',
    name: 'Zoho CRM for Gmail',
    resource: 'css/auth.css',
  },
  {
    id: 'olafhgbhkkgkbbonieapkchffalihpic',
    name: 'Video Downloader Global',
    resource: 'assets/images/pops/img_bg.png',
  },
  {
    id: 'olenolhfominlkfmlkolcahemogebpcj',
    name: 'FastSave & Repost for Instagram',
    resource: 'js/inject.js',
  },
  {
    id: 'omfegkgipldobddijcpagdabgifghdgb',
    name: 'ポップアップ辞書',
    resource: 'manifest.json',
  },
  {
    id: 'ooopgniccpfabocbklfljmomacccjgej',
    name: 'Beep',
    resource: 'assets/icon48.png',
  },
  {
    id: 'opjebobgkipcdimgofkboimilnchghpd',
    name: 'PrettyPrompt',
    resource: 'content.css',
  },
  {
    id: 'pagahecnnmjjlpoakhagcpnalaodfbkk',
    name: 'Rakuten Drive',
    resource: 'images/sendy_gray.svg',
  },
  {
    id: 'pbcpfbcibpcbfbmddogfhcijfpboeaaf',
    name: 'Amino',
    resource: 'amino-inspect.min.js',
  },
  {
    id: 'pbnndmlekkboofhnbonilimejonapojg',
    name: 'Mid.Lizard',
    resource: 'js/page-script.js',
  },
  {
    id: 'pcjdfmihalemjjomplpfbdnicngfnopn',
    name: 'Live Screen Recorder',
    resource: 'js/popup.js',
  },
  {
    id: 'pdebhfmknndmlfoklnkmadfbjfadjdme',
    name: 'color-changer-youtube',
    resource: 'popup.js',
  },
  {
    id: 'pdogihmkjobaaappfalhoagnppambhda',
    name: 'Street View Maps',
    resource: 'manifest.json',
  },
  {
    id: 'pieoffaiheelaipjennepjbhnbdhcfck',
    name: 'AnonVPN',
    resource: 'ae-gate.html',
  },
  {
    id: 'pijboicnfckimnfokpgofmdobghpmpeg',
    name: 'T-Rex',
    resource: 'assets/lib.js',
  },
  {
    id: 'pkhpcfoaocmmpmphhenoblggeinedlah',
    name: 'Dupe.com',
    resource: 'assets/icon-128.png',
  },
  {
    id: 'pmekfefnodgilnnjcfkkdjlebokonhpm',
    name: 'Trend Micro Ad Blocker',
    resource: 'content.js',
  },
  {
    id: 'pnmaklegiibbioifkmfkgpfnmdehdfan',
    name: '10ten Japanese Reader',
    resource: 'css/selection.css',
  },
  {
    id: 'ppbfhhgcdehhbjigifndnfmcihegokbb',
    name: 'Bubbles',
    resource: 'assets/logo.svg',
  },
  {
    id: 'aaeapgfkbbbdpbfjmpcblemfajmkiddh',
    name: 'tabtiles',
    resource: 'tabtiles.css',
  },
  {
    id: 'aamaonobacmhfnfbiihlmelncgefbhma',
    name: 'Subtitles for Youtube',
    resource: 'subtitleBox.html',
  },
  {
    id: 'aamepfadihoeifgmkoipamkenlfpjgcm',
    name: 'Stick Ninja Game',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'aamnmboocelpaiagegjicbefiinkcoal',
    name: 'HDrezka Grabber',
    resource: 'src/js/popup.js',
  },
  {
    id: 'abafaagbfhobgjkcepckbnadafflkdea',
    name: 'EData Filler',
    resource: 'contentScript11.js',
  },
  {
    id: 'abkahkcbhngaebpcgfmhkoioedceoigp',
    name: 'Casper Wallet',
    resource: 'sdk.bundle.js',
  },
  {
    id: 'acejpfahoednmngaoeimoekcepchkmlp',
    name: 'Push To Talk for Google Meet',
    resource: 'icons/grid.png',
  },
  {
    id: 'aclbkdnphcdelflmgjgmgbahlfngidma',
    name: 'Dropbox Dash',
    resource: 'dev.html',
  },
  {
    id: 'adjmjjpnbddnlcmcjmlipkbldndkhhaj',
    name: 'stopRU for YouTube',
    resource: 'popup.html',
  },
  {
    id: 'aealdhlkhncgkajfddopemnjlmggkigm',
    name: 'Boards',
    resource: 'lib.js',
  },
  {
    id: 'afpggcpmimlknonanaomkdlebdpeaicg',
    name: 'AliInvoice️',
    resource: 'invoice.js',
  },
  {
    id: 'agccifdcgciljchfofenkoboeehkmjkl',
    name: 'PriceHistory',
    resource: 'assets/js/url.js',
  },
  {
    id: 'agpbjhhcmoanaljagpoheldgjhclepdj',
    name: 'TwinMind',
    resource: 'lib/system.ts',
  },
  {
    id: 'ahidmapichficbkfglbhgmhjcojjmlnm',
    name: 'BitsLab Safe',
    resource: 'README.md',
  },
  {
    id: 'ajaboiophmaflodkmglfpngnmiijkkle',
    name: 'ZetaMarker',
    resource: 'icons/md.svg',
  },
  {
    id: 'akcljdkpppokdcbopdcbkokilfdddhoi',
    name: 'Rippling',
    resource: 'oauth.html',
  },
  {
    id: 'akeepikolhaikilagiekmegfhefcbohd',
    name: 'folkX',
    resource: 'src/iframe.html',
  },
  {
    id: 'akjlnngigpbekgfjcbpohdfnfjfgflpb',
    name: 'SmartSpending',
    resource: 'assets/snoozed.svg',
  },
  {
    id: 'aklijicmhlmfioogfbemefilfdffijcl',
    name: 'Media Downloader',
    resource: 'css/radio.css',
  },
  {
    id: 'alddllhhoalhongghdfhelgaabcnbfej',
    name: '웨않되',
    resource: 'popup.css',
  },
  {
    id: 'ancgeemmgnlempppapnfkdpghghphgjb',
    name: 'Web Clipper for NotebookLM',
    resource: 'icon/16.png',
  },
  {
    id: 'andpjllgocabfacjlelkfpdemfklpfpo',
    name: 'Tablerone',
    resource: 'icons/favicon.svg',
  },
  {
    id: 'aodfoiacnmepndhojccepdcpmehjbham',
    name: 'Session Alive',
    resource: 'beep.wav',
  },
  {
    id: 'aogkkekoinpipjlolpcicigndjlcpdcn',
    name: 'Dropified Dropshipping',
    resource: 'audit.html',
  },
  {
    id: 'baaibngpibdagiocgahmnpkegfnldklp',
    name: 'Smart Web Paint',
    resource: 'images/eraser.png',
  },
  {
    id: 'bbkbpldbnkoncockinoapcmbiijejgpn',
    name: 'HaramMute',
    resource: 'ding.wav',
  },
  {
    id: 'bbomjaikkcabgmfaomdichgcodnaeecf',
    name: 'Tiny Suspender',
    resource: 'popup.html',
  },
  {
    id: 'bbpokcagpggnekcmamgdieebhpkjmljm',
    name: 'Hoverify',
    resource: 'styles/fonts.css',
  },
  {
    id: 'bcakokeeafaehcajfkajcpbdkfnoahlh',
    name: 'Sixpence',
    resource: 'provider.js',
  },
  {
    id: 'bcpmdhffpajbbmnndnipoohmoiahbgdj',
    name: 'Form Solver',
    resource: 'tabs/logged-in.html',
  },
  {
    id: 'bgnhamkjgjnjfieadagbccalaiehmaca',
    name: 'Cross Identity',
    resource: 'icon.png',
  },
  {
    id: 'biggdlcjhcjibifefpchffmfpmclmfmk',
    name: 'Dino 3D',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'bjcngahpcjeililljmfegmlanlpgibdi',
    name: 'dassi AI',
    resource: 'assets/icon128.png',
  },
  {
    id: 'bkepnpnddicncpiffoefjlgjenfjpjib',
    name: 'Lil Rooster',
    resource: '1.js',
  },
  {
    id: 'blckodkdfiedapfpjiobdkedmocgihco',
    name: 'TTS Reader',
    resource: 'PDFViewer.js',
  },
  {
    id: 'blglfmihmnbhfgfbomofeljmididgfhe',
    name: 'DataLayer Checker Plus',
    resource: 'scripts/vendor.js',
  },
  {
    id: 'bmgfhambolgekpleooignbnnpdcnlien',
    name: 'North Ad-Block',
    resource: 'rules/css.txt',
  },
  {
    id: 'bnfhbhgdplalghadceaceocmildbfhmn',
    name: 'Ship Xanh',
    resource: 'src/zip.js',
  },
  {
    id: 'bofddndhbegljegmpmnlbhcejofmjgbn',
    name: 'eckoWALLET',
    resource: 'app/script/inpage.js',
  },
  {
    id: 'cadokfdhfohnjpdnlnddeickjmgkoccn',
    name: 'Vatos DLP Endpoint',
    resource: 'contentInner.js',
  },
  {
    id: 'caejdeplfmpbnhkppbbckfiipjefepci',
    name: 'Menores Preços Dudu Rocha',
    resource: 'index.css',
  },
  {
    id: 'cancngpbjlfnkdfeigpododikkpelmfg',
    name: 'HistoryDate',
    resource: 'ext.css',
  },
  {
    id: 'cbjclclekdbohblopgleehmcmjkgeehi',
    name: 'adirah',
    resource: 'icon.png',
  },
  {
    id: 'cbnaambdpgibknnmdnjeangmaeicmjoj',
    name: 'MT Auto Clicker',
    resource: 'popup.html',
  },
  {
    id: 'ccbkmkkmfkimpkjlmlakmefdjebadndd',
    name: 'net-pocket-addon',
    resource: 'assets/no_logo.svg',
  },
  {
    id: 'cefhlgghdlbobdpihfdadojifnpghbji',
    name: 'PowerNotes Research',
    resource: 'icons/icon16.png',
  },
  {
    id: 'cejddnmmppcemhgenpcacdipichjjeme',
    name: 'PiP',
    resource: 'img/icon.ico',
  },
  {
    id: 'cfmcghennfbpmhemnnfjhkdmnbidpanb',
    name: 'source view',
    resource: 'default.css',
  },
  {
    id: 'cggpkbnlnicoanmphgkkcmidbpdacepn',
    name: 'SirLinksaLot',
    resource: 'src/browser_action/thanks.html',
  },
  {
    id: 'chejfhdknideagdnddjpgamkchefjhoi',
    name: 'VertiTab',
    resource: 'css/pip.css',
  },
  {
    id: 'cjmkndjhnagcfbpiemnkdpomccnjblmj',
    name: 'Finnie',
    resource: 'sidebar.html',
  },
  {
    id: 'ckmpibbifmcamfmfelkencbbiilpcfjg',
    name: 'ZeroBlur',
    resource: 'static/logo/favicon.ico',
  },
  {
    id: 'clccplmaaeihbagbefjinmclielobnkb',
    name: 'Cerby',
    resource: 'menu.html',
  },
  {
    id: 'clepmakjkiihmfoepipckkafafdepjne',
    name: 'Mobile View',
    resource: 'dist/extension/mobileViewWebComponent.js',
  },
  {
    id: 'cmiafibpgpfjdheafdflginmknifkolh',
    name: 'Snow Rider 3D Unblocked',
    resource: 'listener.js',
  },
  {
    id: 'comhbfmapdepfmmiagneigokjpbohooj',
    name: 'TNDR Likes Unblur',
    resource: 'icons/icon16.png',
  },
  {
    id: 'cpggpmmbmacgemcffkapmeadpnfnmkbm',
    name: 'AI Sider',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'dbgmgldcfjjgkekaknpcfkagekmjejpg',
    name: 'Moneyplace.io',
    resource: 'app.css',
  },
  {
    id: 'dbiiidihfliagfecijmchjmgdfgjcjhf',
    name: 'Online Weather Forecast',
    resource: 'manifest.json',
  },
  {
    id: 'dbmjjcmdhfjbgkgigdndfnfddminlpgb',
    name: 'Email Finder',
    resource: 'css/help.css',
  },
  {
    id: 'dcecjjjnjecoiehclollekjmfgblkkha',
    name: 'School Cheats',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'dcfjmednflkgpadfgkdhphggnmmmodnb',
    name: 'FLG',
    resource: 'images/bgauth.jpg',
  },
  {
    id: 'dcjdhicepiklefpimapdkbaeoocniemc',
    name: 'FontAra Font Changer',
    resource: 'assets/icon.png',
  },
  {
    id: 'dcmindjgpiimpmkgmabhkflfaiimioea',
    name: 'IP Alert',
    resource: 'images/tick.png',
  },
  {
    id: 'dcoegfodcnjofhjfbhegcgjgapeichlf',
    name: 'Export History/Bookmarks to JSON/CSV*/XLS*',
    resource: 'popup.js',
  },
  {
    id: 'dcpelmafllhhdcbiegigphjnbgnolkgm',
    name: 'MediaHarvest',
    resource: 'callback.html',
  },
  {
    id: 'ddmhlmdockeihjdpbkcnnfnlcgjhccgk',
    name: 'Popup Blocker',
    resource: 'ui/ui.js',
  },
  {
    id: 'deebiaolijlopiocielojiipnpnaldlk',
    name: 'My Online Learning Downloader',
    resource: 'wa.min.js',
  },
  {
    id: 'dfjbpjcgbmpmjacdgflidcbdojphlhmd',
    name: 'NSSignPDF',
    resource: 'fonts/material-icons.woff2',
  },
  {
    id: 'dgickihfkjolnjjifepinaaaoejmgpbm',
    name: 'Awesome PDF Viewer, Reader',
    resource: 'webpage1_frame.html',
  },
  {
    id: 'dhjjibbeddglobeoapgppnlnmijajfbb',
    name: 'GLaDOS',
    resource: 'icon-34.png',
  },
  {
    id: 'dhpfcgilccfkodnhbllpiaabofjbjcbg',
    name: 'Circle Reader',
    resource: 'assets/128.png',
  },
  {
    id: 'dkdhhcbjijekmneelocdllcldcpmekmm',
    name: 'Time Tracker',
    resource: 'vendor/119.js',
  },
  {
    id: 'dlpimjmonhbmamocpboifndnnakgknbf',
    name: 'Night Shift Mode',
    resource: 'assets/popup.css',
  },
  {
    id: 'dmgkiikdlhmpikkhpiplldicbnicmboc',
    name: 'Spell checker and Grammar checker',
    resource: 'js/main.js',
  },
  {
    id: 'dmlmcpcjndojhbflolmdgfpojnjfdlbj',
    name: 'Annotator',
    resource: 'html/zcopy.html',
  },
  {
    id: 'dngacpgmjhcjdeccndpdpnlckjihoflp',
    name: 'Shop TODAY Savings',
    resource: 'build/popup.js',
  },
  {
    id: 'dnnmgcbgmfoeifpcmlligbagoiijmepj',
    name: 'Mitel Connect',
    resource: 'images/icons/icon12.png',
  },
  {
    id: 'doeokejknjdlpgkkmlbcahojmnpdlebm',
    name: 'Relume',
    resource: 'logo.png',
  },
  {
    id: 'doiiaejbgndnnnomcdhefcbfnbbjfbib',
    name: 'Paint',
    resource: 'images/logo_not.png',
  },
  {
    id: 'dojncllhekcfenhdnddlihekcodcming',
    name: 'Resoomer',
    resource: 'img/16.png',
  },
  {
    id: 'dokdlgjaaaijndfajoknjbelmadhomca',
    name: 'YouTube High Definition',
    resource: 'style/style.css',
  },
  {
    id: 'dopdchianoijndklgjkckfcpdoaabcab',
    name: 'Picture-In-Picture',
    resource: 'active-icons/active_16.png',
  },
  {
    id: 'eabmbhjdihhkdkkmadkeoggelbafdcdd',
    name: 'EGGHEADS',
    resource: 'src/index.js.map',
  },
  {
    id: 'eafjmnaiohflfhelegodfedimibnjpgp',
    name: 'svg-grabber',
    resource: 'manager.js',
  },
  {
    id: 'ebbdkledlkjpgbbmmopgbnnjmklnkcef',
    name: 'Download Station',
    resource: 'panel.html',
  },
  {
    id: 'ecjkcanpimnagobhegghdeeiagffoidk',
    name: 'Virtual Keyboard',
    resource: 'style.css',
  },
  {
    id: 'edbchgkbejkdkdkpgenlaciegoidmjoh',
    name: 'Fontiran',
    resource: 'assets/scripts/jquery-3.5.1.min.js',
  },
  {
    id: 'edkibgpollgbhnjalcdlpmbjmdgohjko',
    name: 'HS Social',
    resource: 'manifest.json',
  },
  {
    id: 'edoacekkjanmingkbkgjndndibhkegad',
    name: 'Obsidian Web',
    resource: 'options.html',
  },
  {
    id: 'edoiodnmpjehmemkkfmnefmkboeaahlf',
    name: 'MOJi辞書',
    resource: 'panel.html',
  },
  {
    id: 'edpcocadldfbbpllhfkfcebnpigleamn',
    name: 'SocialiQ',
    resource: 'popup.js',
  },
  {
    id: 'eelacikjiplnmdingehjfdjcfegclmkg',
    name: 'SpoilerProtection',
    resource: 'assets/all.css',
  },
  {
    id: 'efaadoiclcgkpnjfgbaiplhebcmbipnn',
    name: 'AdLibNote',
    resource: 'images/tg.png',
  },
  {
    id: 'efbfmikjamhlinlenkkcdkbmlmhiobka',
    name: 'Speed Test',
    resource: 'listener.js',
  },
  {
    id: 'efbobpikdmjaaklfkdlgfopochnjadab',
    name: 'Urban Safe Browsing',
    resource: 'content/safecheck-notification/index.html',
  },
  {
    id: 'efdfjhpgndbmnbihmegnpkeeiabjmcoh',
    name: 'Securden',
    resource: 'images/logo.png',
  },
  {
    id: 'ehgcekpdldhgfjpionbkilpnaahjiejj',
    name: 'NetSuite Advanced Field Help',
    resource: 'functions.js',
  },
  {
    id: 'eienihkhapninadhneligjdemdpkakme',
    name: 'Zendesk QA',
    resource: 'iframe.html',
  },
  {
    id: 'eijmklfnehnnkbfcoabieogaomookbna',
    name: 'Pinky',
    resource: 'image.png',
  },
  {
    id: 'ejcibmoopiblhpjkjfpdopfdnlaoolfc',
    name: 'Similarweb Sales',
    resource: 'icons/drag.svg',
  },
  {
    id: 'ekgpeagdnmojiophbfpdaahimmfibpfm',
    name: 'Topview AI',
    resource: 'pageScript.js',
  },
  {
    id: 'ekjognocgbglgjkenenhkihingkgeodo',
    name: 'Pokemon PokéFollower Cursor',
    resource: 'assets/ui/gen-1/151-mew.png',
  },
  {
    id: 'ekpgflponjmfenfbmpnnjngomooccbdk',
    name: 'GoLink',
    resource: 'assets/icons/16x16.png',
  },
  {
    id: 'emghchaodgedjemnkicegacekihblemd',
    name: 'Flashback Flash Player',
    resource: 'js/libs/ruffle/ruffle.js',
  },
  {
    id: 'empjidjbllcmlgaobahepkijkfmfkjdb',
    name: 'cool-cursor',
    resource: 'Icon-512.png',
  },
  {
    id: 'eockadkjafbnhhenhdpacgmjgjampeee',
    name: 'MonitorX',
    resource: 'assets/content_script_global.js-BYzhhfA7.js',
  },
  {
    id: 'eokbbaidfgdndnljmffldfgjklpjkdoi',
    name: 'Fluent',
    resource: 'inpage.js',
  },
  {
    id: 'famhaodemcealnpfepcfbnofjjcccjap',
    name: 'YouTube AdBlock',
    resource: 'analytics.js',
  },
  {
    id: 'fbemknilbghlokgjhomnikdkljnbpgmo',
    name: 'Freed',
    resource: 'wrapper.html',
  },
  {
    id: 'fbhjaehnpccniaiedddkbdhgicmcmgng',
    name: 'Visualping',
    resource: 'img/bolt.png',
  },
  {
    id: 'fbjnnjochaopepfjpngghafgnafebkjh',
    name: 'ghostwrite',
    resource: 'dist/gmailJS.bundle.js',
  },
  {
    id: 'fbopfffegfehobgoommphghohinpkego',
    name: 'Inspect CSS',
    resource: 'icon-34.png',
  },
  {
    id: 'fcdljeapnidkmbicfjocoeoiaacigcfe',
    name: 'FaniMani.pl Donation Reminder',
    resource: 'assets/css/serp.css',
  },
  {
    id: 'fcgmpkgcecbkkcbbbafppfhdcffecile',
    name: 'EO.workspace Integration',
    resource: 'inject-clipboard.js',
  },
  {
    id: 'fcpepipgmkkjnljechjjimkaondedmbe',
    name: 'AeroLeads',
    resource: 'content.css',
  },
  {
    id: 'fdbbkmpdjmpnebmdgbhcodhlafiicnkd',
    name: 'TextOptimizer',
    resource: 'i/icon.png',
  },
  {
    id: 'fdfemjpbhpcjeadhbblfifdldedefnhe',
    name: 'Password Boss',
    resource: 'frame/index.html',
  },
  {
    id: 'fdlagfnfaheppaigholhoojabfaapnhb',
    name: 'AI Agent',
    resource: '64.png',
  },
  {
    id: 'feclmkildkjpmmmleiafjpedhefnbbif',
    name: 'Myfxbook',
    resource: 'img/paybackfx_logo.png',
  },
  {
    id: 'feflcgofneboehfdeebcfglbodaceghj',
    name: 'Urban AdBlocker',
    resource: 'shared/icons/eye.svg',
  },
  {
    id: 'fehcbmngdgagfalpnfphdhojfdcoblgc',
    name: 'Airtable web clipper',
    resource: 'index.html',
  },
  {
    id: 'ffhabonelknmejmdnekedmijlhebpcio',
    name: 'DWithEase',
    resource: 'js/popup.js',
  },
  {
    id: 'fficfkginiidknkbmlcdiojphhkokggh',
    name: 'Bloomberg Terminal',
    resource: 'view/screenshot.js',
  },
  {
    id: 'fgebdnlceacaiaeikopldglhffljjlhh',
    name: 'Timeline',
    resource: 'images/logo.png',
  },
  {
    id: 'fghhpjoffbgecjikiipbkpdakfmkbmig',
    name: 'IDRISS',
    resource: 'webpage-script.js',
  },
  {
    id: 'fgkbkiibnhcjhnclbgkfjdlnikocmgkh',
    name: 'Conductor',
    resource: 'heap.js',
  },
  {
    id: 'fgojlclhaecajjkchbcpelngbkdjeekg',
    name: 'Alaev SEO Tools',
    resource: 'assets/index-Bq3yQLdV.js',
  },
  {
    id: 'fhkhedgjlkcgdaldodbhmcldjglpabmf',
    name: '百度AI-浏览器助手',
    resource: 'js/content.js',
  },
  {
    id: 'ficfmibkjjnpogdcfhfokmihanoldbfe',
    name: 'File Icons for GitHub and GitLab',
    resource: 'fonts/mfixx.woff2',
  },
  {
    id: 'fjfoncfdjhdefjhknbaphionnognbnpl',
    name: 'Note Everywhere',
    resource: 'icon-34.png',
  },
  {
    id: 'fkfaapnmfippddbeemjjbclenphooipm',
    name: 'Stark Accessibility Checker',
    resource: 'scan-illo.png',
  },
  {
    id: 'flfminafiamnggnldfpilnfnmbgmiegn',
    name: 'simpleGestures',
    resource: 'font/Flaticon.ttf',
  },
  {
    id: 'flohijcknfmanaelbcplbehnjhjffaeo',
    name: 'Automate Bing Rewards Searches',
    resource: 'popup.html',
  },
  {
    id: 'fmkhjeeeojocenbconhndpiohohajokn',
    name: 'BrowserStack Accessibility Toolkit',
    resource: 'assets/js/v4-Qp4XxSpc.js',
  },
  { id: 'fnkfcndbgingjcbdhaofkcnhcjpljhdn', name: 'Dust', resource: 'main.js' },
  {
    id: 'fogenijnedmmmofgaifofnihbalehpdg',
    name: 'Từ điển tiếng Nhật JP',
    resource: 'opencvHandler.html',
  },
  {
    id: 'fohimdklhhcpcnpmmichieidclgfdmol',
    name: 'BookmarkHub',
    resource: 'locales/ar/sync.json',
  },
  {
    id: 'fokgeblncoeecbckmeieogmkiabpimga',
    name: 'DIBE',
    resource: 'image/nik-2x.gif',
  },
  {
    id: 'fpeoodllldobpkbkabpblcfaogecpndd',
    name: 'Webrecorder ArchiveWeb.page',
    resource: 'pdf/pdf.min.js',
  },
  {
    id: 'gaieenaffioioljpcocdkpphlifbhaig',
    name: 'AskYourPDF',
    resource: 'login.html',
  },
  {
    id: 'gbdacbnhlfdlllckelpdkgeklfjfgcmp',
    name: 'GIF Scrubber',
    resource: 'popup.html',
  },
  {
    id: 'gbeiplkijfihbcieiihmeemjejohbiho',
    name: 'Undetectable AI',
    resource: 'off.ccead607.svg',
  },
  {
    id: 'gbldofcpkknbggpkmbdaefngejllnief',
    name: 'Midscene.js',
    resource: 'static/wasm/9e906fbf.module.wasm',
  },
  {
    id: 'gcplhmogdjioeaenmehmapbdonklmdnc',
    name: 'Fleeting Notes',
    resource: 'popup.html',
  },
  {
    id: 'gdhbaoemgglcgmkidhnhcellgnehaeol',
    name: 'Nabla',
    resource: 'logo.png',
  },
  {
    id: 'gdpgagmlpgilibfadpifdmpfopknkanf',
    name: 'My Sidex',
    resource: 'web/logo_search.png',
  },
  {
    id: 'geemhpgkjffenbpinjhghbilojbokmhl',
    name: 'Remote Desktop',
    resource: 'index.html',
  },
  {
    id: 'gfbliohnnapiefjpjlpjnehglfpaknnc',
    name: 'Surfingkeys',
    resource: 'api.js',
  },
  {
    id: 'gfplodojgophcijhbkcfmaiafklijpnf',
    name: 'Spark blocker',
    resource: 'css/content.css',
  },
  {
    id: 'ggbnpjdgbjkbcbohgcndmalbdenlfjcl',
    name: 'Privacy Extension for WhatsApp Web',
    resource: 'pics/icon.png',
  },
  {
    id: 'ggjakfijchdkbmmhbfemjciidhnipgoe',
    name: 'Search Commands',
    resource: 'img/icon16.png',
  },
  {
    id: 'ggnikicjfklimmffbkhknndafpdlabib',
    name: 'Social Share Preview',
    resource: 'icons/icon16.png',
  },
  {
    id: 'ghabekkoaicdmfgggmocafcdllmdhamb',
    name: 'Mindomo',
    resource: 'images/icon-16.png',
  },
  {
    id: 'ghcblfjepeeocokmmjjdfcigdbfgbejp',
    name: 'AliSave Pro',
    resource: 'assets/js/utils.js',
  },
  {
    id: 'ghlmndacnhlaekppcllcpcjjjomjkjpg',
    name: 'Wizz Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'ghomhhneebnpahhjegclgogmbmhaddpi',
    name: 'Flash Player EmuFlash',
    resource: 'js/libs/ruffle/ruffle.js',
  },
  {
    id: 'gjhijhnbbffbipkcejiejphnladneboi',
    name: 'Agent Master',
    resource: 'assets/d.png',
  },
  {
    id: 'gjkfnalkblnjkalnipilmaacibikciin',
    name: 'Geek Sidebar',
    resource: 'content-scripts/esm/capture.js',
  },
  {
    id: 'gjlmehlldlphhljhpnlddaodbjjcchai',
    name: 'Nautilus',
    resource: 'src/extension/content-scripts/injected.js',
  },
  {
    id: 'gjneklbanpnnjdeddbnkkgeljkhpblhp',
    name: 'Hope Chest',
    resource: 'images/up.png',
  },
  {
    id: 'gkaaffkabfmjaekemimgnajfboopmpom',
    name: 'Скриншотер, Запись Экрана, ChatGPT',
    resource: 'js/popup.js',
  },
  {
    id: 'gkkkmiljegejildfmfcnicknbcfggdjk',
    name: 'Book Bolt Lister',
    resource: 'images/icons.svg',
  },
  {
    id: 'glclhpipfpfammoflcfnknnlddkgpdoe',
    name: 'NaverCafe video downloader',
    resource: 'icons/download_button.png',
  },
  {
    id: 'glmjepecpbjeajhnecnjjpbnncppjdee',
    name: 'DigitalSign',
    resource: 'w3.css',
  },
  {
    id: 'gmhgdiamihghcepkeapfoeakphffcdkk',
    name: 'English-to-English Definitions',
    resource: 'src/ui/entrypoints/content-iframe.html',
  },
  {
    id: 'gnkkimhkpmldcibibpdhegbjcgdpiakc',
    name: 'Telegram Downloader',
    resource: 'js/myApi.js',
  },
  {
    id: 'gnncjalmnfmdilagegplkkckngolohof',
    name: 'Grasp',
    resource: 'js/eval.js',
  },
  {
    id: 'gnnfgamcecifdmmdpbppjhanfllffmdn',
    name: 'Video download assistant',
    resource: 'js/video_bilibili_accessible.js',
  },
  {
    id: 'gpinpagnbmllflbnipojcnnkdhmemcio',
    name: 'BenefitHub',
    resource: 'assets/key.svg',
  },
  {
    id: 'gpmjpkmohjgaimfhebdjebpgdnpcadji',
    name: 'Edit with Notepad++',
    resource: 'data/editor/core.html',
  },
  {
    id: 'gppahjpnghmiacfkbahpdnakchdkgodo',
    name: 'The RebatesMe Cash Back Button',
    resource: 'insert.js',
  },
  {
    id: 'hahdnalbjglbhcnjdkjhdkmhjkkgjkcd',
    name: 'Phone Simulator',
    resource: 'img/icons/bug.svg',
  },
  {
    id: 'hbdnoadcmapfbngbodpppofgagiclicf',
    name: 'SnipCSS',
    resource: 'js/tidy.js',
  },
  {
    id: 'hbkkncjljigpfhghnjhjaaimceakjdoo',
    name: 'Dino Rush',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'hbpccaaplcmkldofidhinemjkoahpcld',
    name: 'Sortd',
    resource: 'iframe.js',
  },
  {
    id: 'hclhpnhohpmlbadmeieecaandnglfodm',
    name: 'RiteTag',
    resource: 'images/red.png',
  },
  {
    id: 'hfcbmognahkfhdhfhfgiioafohojeolh',
    name: 'OneScholar',
    resource: 'css/style.css',
  },
  {
    id: 'hfjnppljknigdnnpocjjgdcfmnodoafe',
    name: 'Browserflow',
    resource: 'assets/logo.svg',
  },
  {
    id: 'hfojakphgokgpbnejoobfamojbgolcbo',
    name: 'Ogame Infinity',
    resource: 'main.js',
  },
  {
    id: 'hfollkhbdmgdnakpgocoldgdjaoahhni',
    name: 'Linkclump Pro',
    resource: 'pages/test_area.html',
  },
  {
    id: 'hgcchfenipapcljbhflknmmfbaaibekj',
    name: 'All Best Recipes',
    resource: 'manifest.json',
  },
  {
    id: 'hhbnckjhjihjangdepdebbnooibiphge',
    name: 'InterSub',
    resource: 'main.js',
  },
  {
    id: 'hhkifldlehcekplhapbconmjjmddpbdf',
    name: 'HEXcolorPick',
    resource: 'img/icon.png',
  },
  {
    id: 'hhmokalkpaiacdofbcddkogifepbaijk',
    name: 'Bookmark Search',
    resource: 'icon48.png',
  },
  {
    id: 'hjandoglibodddfdpbpcfkcldghbalhl',
    name: '로펙 스캐너',
    resource: 'src/ui/ui.js',
  },
  {
    id: 'hjdcpbokggnjjmcmbmhkbkmibdekodmk',
    name: 'Appcues+',
    resource: 'static/open.html',
  },
  {
    id: 'hjnjkiddcmpamechmdjonecfjckboean',
    name: 'TextUs',
    resource: 'content.css',
  },
  {
    id: 'hkdbcemiphlcpmcphjgfaepgciimcoef',
    name: 'Annotate the Web',
    resource: 'css/main.css',
  },
  {
    id: 'hklhheigdmpoolooomdihmhlpjjdbklf',
    name: 'KasWare',
    resource: 'extensionPageScript.js',
  },
  {
    id: 'hklmffdokpefcfabkmkpjnkoakehigjg',
    name: 'AppSheet Toolbox',
    resource: 'qrew-logo-hires.png',
  },
  {
    id: 'hlbdmmifbcfpccdnoknhdfcifiglaihb',
    name: 'DAP',
    resource: 'data/grab/index.html',
  },
  {
    id: 'hlcgjogehgfjdkkdpnhnlmhnmacaemle',
    name: 'WebDefender',
    resource: 'assets/img/logo.png',
  },
  {
    id: 'hmdinepahgmfhgojoglndlhllogdceli',
    name: 'Copycat Ads',
    resource: 'config/config.js',
  },
  {
    id: 'hmgehpjpfhobbnhhelhlggjfcaollidl',
    name: 'MWP',
    resource: 'images/options-loader.gif',
  },
  {
    id: 'hmioicehiobjekahjabipaeidfdcnhii',
    name: 'Inline Lingo Translator',
    resource: 'icons/copy.svg',
  },
  {
    id: 'hmpbiickdfmcdlcpjegamgnjjkaiackl',
    name: 'AiPrice(AliPrice) Search by image for AE',
    resource: 'assets/js/options.js',
  },
  {
    id: 'hnbdgfongnkfgnbpamndfiiedhapfecn',
    name: '语雀浏览器插件',
    resource: 'tabs/sandbox.html',
  },
  {
    id: 'hoceldjnkcboafconokadmmbijbegdkf',
    name: 'LibrusPro',
    resource: 'librus.js',
  },
  {
    id: 'hojamkafiddgonggjfbkmeollglcmjao',
    name: 'GetVid',
    resource: 'svg/add.svg',
  },
  {
    id: 'hpbdhanjafnpeeobgejmdaajkiamfdpi',
    name: 'Tzofar',
    resource: 'alert.html',
  },
  {
    id: 'iameapkpimeeenlmglodmdpbdponlhhd',
    name: 'Talent Eye',
    resource: 'libs/inject-script.js',
  },
  {
    id: 'ibamclpibpnhmkaphhemfbljmenlpbch',
    name: 'Otsledit',
    resource: 'not.mp3',
  },
  {
    id: 'ibeabbjcphoflmlccjgpebbamkbglpip',
    name: 'Superpowers for Chatgpt',
    resource: 'images/16.png',
  },
  {
    id: 'ibefjagfpcdefiapiapnhleogifimklb',
    name: 'Equalizer',
    resource: 'popup.html',
  },
  {
    id: 'ibjbdljnechfamiabmolmojegeindnpc',
    name: 'VWO',
    resource: 'js/noop.js',
  },
  {
    id: 'icceojeancmncflpknhmfbfaleindgmi',
    name: 'Email Scraper for Ins',
    resource: 'injected.js',
  },
  {
    id: 'icfnljfpacimpcbpammmbclmhenimhfc',
    name: 'ScTranslator',
    resource: 'static/css/content.css',
  },
  {
    id: 'ickdpignpmjcahkjfbmfljhiglmcmchn',
    name: 'CheaperThere',
    resource: 'img/url.svg',
  },
  {
    id: 'idoejinhmhkammopnhekeohabblidioi',
    name: 'Font Finder',
    resource: 'data/window/index.html',
  },
  {
    id: 'iedbphhbpflhgpihkcceocomcdnemcbj',
    name: 'AI Webcam Effects + Recorder',
    resource: 'icon.png',
  },
  {
    id: 'ieidddkeimflpkghaodhddcmlclcliaa',
    name: 'ParagraphAI',
    resource: 'icon.png',
  },
  {
    id: 'iheanendiljegnemgmaklemiaekghofn',
    name: 'Nuance.EHRi',
    resource: 'jslib/utils.js',
  },
  {
    id: 'ijkboaojikgaanlgigobkmbpnjgjljnc',
    name: 'SpoPlus',
    resource: 'assets/js/init.js',
  },
  {
    id: 'ijlpijnplhhbggppiebkfakonpjdikhl',
    name: 'Quiz Solver AI',
    resource: 'content.css',
  },
  {
    id: 'ijppdlihjndajogkppnfohojdbpaaian',
    name: 'Promptimize AI',
    resource: 'index.html',
  },
  {
    id: 'ikikpappoglnioaajmamaadkbbhghamg',
    name: 'Blue Light Card',
    resource: 'icon.png',
  },
  {
    id: 'iloddidemhbedaopmipajgclofjocogb',
    name: 'PT Depiler',
    resource: 'pt-depiler.css',
  },
  {
    id: 'inafdkdkghgibhijaplaobmomoahefin',
    name: 'Prompt Genie',
    resource: 'content-scripts/teams.css',
  },
  {
    id: 'inejiiekmjkmphgjjehhcmkpjncboodn',
    name: 'Web3 Antivirus',
    resource: 'tracing.html',
  },
  {
    id: 'infdcenbdoibcacogknkjleclhnjdmfh',
    name: 'reCAPTCHA Solver',
    resource: 'content/style.css',
  },
  {
    id: 'inhblbknkkniipjdaijonkmdmbndgdjl',
    name: 'bestprice.com',
    resource: 'app.css',
  },
  {
    id: 'ioadmlabdmgldhncokgjbhlnpalnfccd',
    name: 'Quizbot',
    resource: 'libs/core-lib-gdocs-canvas.js',
  },
  {
    id: 'ioleaeachefbknoefhkbhijdhakaepcb',
    name: 'Gloom Dark Mode',
    resource: 'js/proxy.js',
  },
  {
    id: 'ipkbbcamfcnlflkedfdaokofdmfgocfp',
    name: 'Mudfish',
    resource: 'html/staticnodes.json',
  },
  {
    id: 'jaaajddkaoldkiajncgakhmogoboijoo',
    name: 'PopAi',
    resource: 'assets/font-f2b037f5.js',
  },
  {
    id: 'jadkpbgjjkffbpijalbeoaacjppljnld',
    name: 'DropKiller',
    resource: 'src/assets/libs/chart.min.js',
  },
  {
    id: 'jblacjfeljfigeglloiclnoehlhnmgne',
    name: 'Ethos Everywhere',
    resource: 'assets/Small-blue.png',
  },
  {
    id: 'jdanedhdmcbkheljojpdcnonnbdbohng',
    name: 'autoTranslate',
    resource: 'scripts/util.js',
  },
  {
    id: 'jdpdpdkkofoclmgbopofhlmoikpfamao',
    name: 'SEOSpace',
    resource: 'injectScript.js',
  },
  {
    id: 'jeaepbakacaiplhmkdpjkbpjcpeenfdf',
    name: 'Add to WishList.com Button',
    resource: 'background.js',
  },
  {
    id: 'jeebpgmphhagpecfiophljpkhncoajcg',
    name: 'Pesticide',
    resource: 'result.css',
  },
  {
    id: 'jfcmjbboehfdmgbhheahjlnoimbgfdbn',
    name: 'Zapier Agents',
    resource: 'central-logo.png',
  },
  {
    id: 'jgckjhiolmelfpdofcbfnkkapeblcfdh',
    name: 'Sugoi Shimeji',
    resource: 'media/sprites/sprite0.webp',
  },
  {
    id: 'jgpjphkbfjhlbajmmcoknjjppoamhpmm',
    name: 'Blue Blocker',
    resource: 'assets/chunk-dfef9856.js',
  },
  {
    id: 'jhcpefjbhmbkgjgipkhndplfbhdecijh',
    name: 'Country Flag Fixer',
    resource: 'assets/TwemojiCountryFlags.woff2',
  },
  {
    id: 'jiepnaheligkibgcjgjepjfppgbcghmp',
    name: 'Doge Labs Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'jilgamolkonoalagcpgjjijaclacillb',
    name: 'TTNote',
    resource: 'assets/tg.png',
  },
  {
    id: 'jincbkepokdimkkecpcmjjfhjepllkdj',
    name: '2chRevival',
    resource: 'style.css',
  },
  {
    id: 'jkcpodicdboheakkkoblnflccfihcblb',
    name: 'Flowith Web Clipper',
    resource: 'icon/48.png',
  },
  {
    id: 'jkoeaghipilijlahjplgbfiocjhldnap',
    name: 'Mask Network',
    resource: 'js/gun.js',
  },
  {
    id: 'jlbpahgopcmomkgegpbmopfodolajhbl',
    name: 'Smart Search Assistant',
    resource: 'img/128.png',
  },
  {
    id: 'jlckpgneidbdnmdgbiehjceddjjdlfnn',
    name: 'Download Music from VK',
    resource: 'icons/icon48.png',
  },
  {
    id: 'jljicfihpdcimopabpijdhhjbmenjala',
    name: 'Gmail Unsubscribe',
    resource: 'assets/css/main.css',
  },
  {
    id: 'jmkaieepcjnofkicafdelmdpigjdankd',
    name: 'Pure motion',
    resource: 'permission.js',
  },
  {
    id: 'jmnjcglbcleaddocnpkckjmlloeaaaak',
    name: 'French Accents',
    resource: 'popup.js',
  },
  {
    id: 'jndgjmiigkfgngemhobhnibilojkkfhi',
    name: 'WAexport',
    resource: 'js/lodash.js',
  },
  {
    id: 'jnmbobjmhlngoefaiojfljckilhhlhcj',
    name: 'OneKey',
    resource: 'injected.js',
  },
  {
    id: 'jphoeefokmhkfljjhlpbndhikhjpencm',
    name: 'Smarty.Sale',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'jpkmkgajcahdjphlgkmkladhhighjmlk',
    name: 'ImprivataPAM',
    resource: 'js/injector.js',
  },
  {
    id: 'kbcomfmcakpckijlmbkglflflmokhgof',
    name: 'Trade Token Sync',
    resource: 'content-scripts/universal.js',
  },
  {
    id: 'kcbaglhfgbkjdnpeokaamjjkddempipm',
    name: 'MarkSnip',
    resource: '_locales/en/messages.json',
  },
  {
    id: 'kchgllkpfcggmdaoopkhlkbcokngahlg',
    name: 'DFTube',
    resource: 'css/home.css',
  },
  {
    id: 'kckmfllnpncljamnlfnaoplpmlbgjeal',
    name: '阿抖',
    resource: 'iframe.html',
  },
  {
    id: 'kdbgbpcphmnekmkhbcfmbdahceffhddn',
    name: 'Netsweeper Client Filter',
    resource: 'error.html',
  },
  {
    id: 'kdkgijnijnbincicbnopccopncfedgba',
    name: 'Panda Helper',
    resource: 'icons/16.png',
  },
  {
    id: 'kebcmemidpndhlgigmoghdocfodempah',
    name: 'Cuponation',
    resource: 'public/chunks/caa.js',
  },
  {
    id: 'kejhpkmainjkpiablnfdppneidnkhdif',
    name: 'Sprint Reader',
    resource: 'src/graphics/icon16.png',
  },
  {
    id: 'kekkjfalendfifgchoceceoahjnejmgf',
    name: 'Bulk Image Downloader From Url List',
    resource: 'sidepanel.js',
  },
  {
    id: 'kfedoapfmioadaeellmoabmaakojefbl',
    name: 'JSX Preview',
    resource: 'pages/engine.css',
  },
  {
    id: 'kfnboibnjcpldbmeielppdepcpliogeb',
    name: 'Quizard AI',
    resource: 'icon32.png',
  },
  {
    id: 'kgakmojcjdelgadjdjlhpnejmeaphhgg',
    name: 'NoLang',
    resource: 'assets/content.js-EqjiQbMU.js',
  },
  {
    id: 'kgmjjkfjacffaebgpkpcllakjifppnca',
    name: 'Adobe Experience Cloud Visual Editing Helper',
    resource: 'assets/hold.js',
  },
  {
    id: 'kheeipganhdcpkecibbpgggianpodhkc',
    name: 'SpyHunter Web Security',
    resource: 'extension/data/webapp/blocked.html',
  },
  {
    id: 'khepfpojckhooicloeheemlhcljpjcjg',
    name: 'Tab Translate',
    resource: 'images/bubbles/copy.png',
  },
  {
    id: 'khjklhhhlnbeponjimmaoeefcpgbpgna',
    name: 'GPT for Ecom',
    resource: 'icon/BG.svg',
  },
  {
    id: 'khkpfminnhkjeabcnhpjcfhegbbodpjk',
    name: 'Testing Toolkit',
    resource: 'icons/add.svg',
  },
  {
    id: 'kinfihfgknmecicjmadebldjeknakbpj',
    name: 'CM Cursor',
    resource: 'assets/icon32.png',
  },
  {
    id: 'kjhigpfcihnpjchpfnboofeecckigbmb',
    name: 'Video Quality Enhancer',
    resource: 'sidebar.css',
  },
  {
    id: 'kkaneedgomgliclbnamedjoknagffnfe',
    name: 'VeiloVPN',
    resource: 'style/popup.css',
  },
  {
    id: 'kkgpdmegkhdheglikjleejknplhdpbck',
    name: 'Video Blocker',
    resource: 'img/icon.png',
  },
  {
    id: 'kkhpnmhogcfeboepoempiimfbonppocg',
    name: 'Copilot',
    resource: 'lib/wavesurfer.min.js',
  },
  {
    id: 'klchnmggepghlcolikgaekpibclpmgcm',
    name: 'Make America Kittens Again',
    resource: 'kittens/1.jpg',
  },
  {
    id: 'klopcieildbkpjfgfohccoknkbpchpcd',
    name: 'TypeScan What Font Finder',
    resource: 'css/content.css',
  },
  {
    id: 'kmklnaljhcfcancckobnbafdhkbigfkk',
    name: 'AskmeOffers AI',
    resource: 'askmeoffers/meta.js',
  },
  {
    id: 'knjbgabkeojmfdhindppcmhhfiembkeb',
    name: 'Matter',
    resource: 'index.html',
  },
  {
    id: 'kopggmlhnhalanhapdmflfmboikpjjmn',
    name: '윈들리',
    resource: 'spies/1688.js',
  },
  {
    id: 'lbfofpndjldbnhnhibhmggblcbpoomon',
    name: 'Beep for Google Docs',
    resource: 'assets/icon48.png',
  },
  {
    id: 'lcefjaknjehbafdeacjbjnfpfldjdlcc',
    name: 'Roblox URL Launcher',
    resource: 'script.js',
  },
  {
    id: 'lcmofkcgjjagmhodenahpocfkpopjdci',
    name: 'ScamAdviser',
    resource: 'images/Shield.png',
  },
  {
    id: 'lfdljcfbppgpgcbahhcpdahbmlpddkmf',
    name: 'Get Maps & Directions',
    resource: 'manifest.json',
  },
  {
    id: 'lfdmeeegepbbjaopiekcnmenhmcpjhhg',
    name: 'Online PDF Converter',
    resource: 'index.html',
  },
  {
    id: 'lhdjgfcebdlmhphhbddcdpaegbnpbmke',
    name: 'Places Near Me',
    resource: 'manifest.json',
  },
  {
    id: 'ljakpkpdcahaniompbhpabnaafelhdol',
    name: 'Salesforce Dark Theme',
    resource: 'css/style.css',
  },
  {
    id: 'ljbhddngkkppbbkknjldoikonnolgafd',
    name: 'NoteExpress网络捕手',
    resource: 'js/test.js',
  },
  {
    id: 'lkafdfakakndhpcpccjnclopfncckhfn',
    name: 'Link Blanker',
    resource: 'html/notify-close-tabs.html',
  },
  {
    id: 'lkmnoeojcpmcpjlbhbjbilpmccfljdoj',
    name: 'Douban Book+',
    resource: 'img/no-book.png',
  },
  {
    id: 'llbkdcpbiogplgmefnkbgcdfiopfphbc',
    name: 'MarkUp.io',
    resource: 'user-info-poll.html',
  },
  {
    id: 'llfdaleknghepofjcleahemgndnaghhk',
    name: 'BlockP',
    resource: 'block.html',
  },
  {
    id: 'llindcahmibpekmcgchfjlnpljjeeeoe',
    name: 'コンテキストガジェット',
    resource: 'images/border.png',
  },
  {
    id: 'llllflgakifpdcmoanonghipldcpaggn',
    name: 'Webex Calling',
    resource: 'assets/tooltip.png',
  },
  {
    id: 'llodbjghkcfegnhbggjllfoeombjjdhe',
    name: 'Matador.ai',
    resource: 'img/logo-13.png',
  },
  {
    id: 'lmbnfoinlgcmombooibkgiihldajgnmk',
    name: 'Smart Nexus',
    resource: 'assets/icon.png',
  },
  {
    id: 'lmgpiaemoiikocplohpngneppgfmphfh',
    name: 'DealDrop',
    resource: 'assets/string-52dbe240.js',
  },
  {
    id: 'lmilalhkkdhfieeienjbiicclobibjao',
    name: 'Run Javascript',
    resource: 'sandbox.html',
  },
  {
    id: 'lmjkddpocmpfpfelefmjeikplccmchaj',
    name: 'ImageRight PDF Import',
    resource: 'images/icon150.png',
  },
  {
    id: 'lmkncnlpeipongihbffpljgehamdebgi',
    name: 'DPal',
    resource: 'inject.js',
  },
  {
    id: 'lmlkbclipoijbhjcmfppfgibpknbefck',
    name: 'AliNiche',
    resource: 'img/tip.png',
  },
  {
    id: 'lnhbnkmlkgeebjfimnbceakepeiandgg',
    name: 'Houzz Pro Clipper',
    resource: 'ivy-thumbnail.svg',
  },
  {
    id: 'loedohmkociaomkgggggnoogiahfinme',
    name: 'Augnito',
    resource: 'images/Logo.png',
  },
  {
    id: 'loifegnemklkgbmonigcdkmniboielgl',
    name: 'Citrix Secure Access',
    resource: 'ErrorHandling/index.ts',
  },
  {
    id: 'lojeokmpinkpmpbakfkfpgfhpapbgdnd',
    name: 'Google Verified Access',
    resource: 'icon19.png',
  },
  {
    id: 'lpanlmnkaioofmijifhpadfcafphopin',
    name: 'iPacket SalesHub',
    resource: 'dist/arcactions.js',
  },
  {
    id: 'lpkjmgldcglmfilmnkcacbolkpkghdaa',
    name: 'PitchBook',
    resource: '942.js',
  },
  {
    id: 'lppjdajkacanlmpbbcdkccjkdbpllajb',
    name: 'Online Dictionary Helper',
    resource: 'fg/js/frame.js',
  },
  {
    id: 'lppmahciboilaokklohhhdlaadkobgpc',
    name: 'Change My Cursor',
    resource: 'img/cat.png',
  },
  {
    id: 'maalhdjdholkapibniiddlgkddigiooj',
    name: 'TrustPlugin',
    resource: 'includes/system.js',
  },
  {
    id: 'mahfncngjcmmhemjlbdiogjnngdcajab',
    name: 'VisualSP',
    resource: 'js/bootstrap.js',
  },
  {
    id: 'maogiolhkdhjobnlobpkcpnmamnmilno',
    name: 'مدرستي بلس',
    resource: 'js/minfo.js',
  },
  {
    id: 'mapjgeachilmcbbokkgcbgpbakaaeehi',
    name: 'Omni',
    resource: 'newtab.html',
  },
  {
    id: 'mcdigjbnihajokfiolophengnjlcgeeb',
    name: 'Bonusway',
    resource: 'assets/img/a.png',
  },
  {
    id: 'mdfjplgeknamfodpoghbmhhlcjoacnbp',
    name: 'Crunchbase',
    resource: 'iframe-wrapper/iframe-wrapper.js',
  },
  {
    id: 'mdpelimehdooponahfdneckpfnooebii',
    name: 'WAXP',
    resource: 'client.bundle.js',
  },
  {
    id: 'mdplmiioglkpgkdblijgilgebpppgblm',
    name: 'BrowserStack Bug Capture',
    resource: 'popup.html',
  },
  {
    id: 'mehmbceeoajoljjbcodcbjlhmopjmlmf',
    name: 'PEXA Digital Signing',
    resource: 'scripts/constants.js',
  },
  {
    id: 'mhchmhfecfdpaifljcfebnlaiaphfkmb',
    name: 'Shopify Theme File Search',
    resource: 'icon-34.png',
  },
  {
    id: 'mibmplgflabdmnnoncnedjfdpidjblnk',
    name: 'Aliexpress Seller Check',
    resource: 'bg.js',
  },
  {
    id: 'miefikpgahefdbcgoiicnmpbeeomffld',
    name: 'Blackfire Profiler',
    resource: 'toolbar.html',
  },
  {
    id: 'mjackmipnhegkhekpebhmnkhkaojdldn',
    name: 'BK Reviews',
    resource: 'assets/ui/bell.svg',
  },
  {
    id: 'mjeeklofjbnodnnfibjolokichkhcpog',
    name: 'Kkm Server',
    resource: 'injected.js',
  },
  {
    id: 'mkajnobnkglcipndmeeoijandgckfcbk',
    name: 'ТурбоМинимум RM',
    resource: 'src/assets/pc.svg',
  },
  {
    id: 'mkdjegdakgimmckobdnfiimhgmabbido',
    name: 'Simple Data Layer Viewer',
    resource: 'log-layers.js',
  },
  {
    id: 'mkkicnlinnjfgjkegiomemdeleniiojl',
    name: 'MySignature',
    resource: 'src/assets/app.css',
  },
  {
    id: 'mncaahedchkhclokjmfjbennhbeceecl',
    name: 'Tab Renamer',
    resource: 'assets/icon16.png',
  },
  {
    id: 'mnfchpadaikneonajggpooeppnmdolhc',
    name: 'TorGuard VPN',
    resource: 'images/bg.png',
  },
  {
    id: 'mnhidfdmcdhjlmdopehepplijapmcapc',
    name: 'SparxSolver',
    resource: 'main.js',
  },
  {
    id: 'mnjclpmbklnceaoeochkhckaphjhnpib',
    name: 'Data Dive',
    resource: 'assets/add.svg',
  },
  {
    id: 'moicohcfhhbmmngneghfjfjpdobmmnlg',
    name: 'LiveTL',
    resource: 'List.js',
  },
  {
    id: 'mpejmbnlbgamjhgnoongmdnpmhoeilje',
    name: '店小宝',
    resource: 'icon/16.png',
  },
  {
    id: 'mpfgfcgaecedikelhdfgjknikdhfdbhb',
    name: 'TopCash',
    resource: 'images/16.png',
  },
  {
    id: 'nakohbfkcebgehahpebfpnnhgojgeopc',
    name: 'Suika Game',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'naokfdgdgffhhcooogamafjfpmeknkla',
    name: 'Eyedropper',
    resource: 'assets/fonts/avenir.otf',
  },
  {
    id: 'ncncagnhhigemlgiflfgdhcdpipadmmm',
    name: 'FB AIO',
    resource: 'scripts/utils/index.js',
  },
  {
    id: 'necbalcggglceeioaehdbkpbldmoabii',
    name: 'Lavender',
    resource: 'react/init.js',
  },
  {
    id: 'nedimkoolcnedillajmobdhlmeibokgp',
    name: 'Chrome Cat',
    resource: 'sounds/bb_meow.mp3',
  },
  {
    id: 'nfhmofnohiiegfbnialkdlgohnjmpihg',
    name: 'View Recipes',
    resource: 'manifest.json',
  },
  {
    id: 'nggoojkpifcfgdkhfipiikldhdhljhng',
    name: 'Spelunky Classic',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'ngigoeagdgecjjbmielklflkmnlnddop',
    name: 'SandVPN',
    resource: 'logo192.png',
  },
  {
    id: 'ngmglcbdhomodppckpgpgpnhjcgkhhid',
    name: 'Free Manuals Online',
    resource: 'favicon.ico',
  },
  {
    id: 'ngmmnefnjobcdhhodadfhbnkhfcpjjhd',
    name: 'Amazon Dark Mode',
    resource: 'src/images/icon128.png',
  },
  {
    id: 'ngnfcfdjhdkiohcmiakmjkjlfgigopob',
    name: 'Fitkun Batch Download Image',
    resource: 'handler.html',
  },
  {
    id: 'nhdkblgjckgbdpjbohjepdakoioldloe',
    name: 'Virtru for Drive',
    resource: 'js/popup.js',
  },
  {
    id: 'nifeadedgedikheglfngocdgfidiiimi',
    name: 'Link Checker',
    resource: 'img/star.png',
  },
  {
    id: 'njimencmbpfibibelblbbabiffimoajp',
    name: 'TotalPass',
    resource: 'src/images/icons/blank.png',
  },
  {
    id: 'nkabooldphfdjcbhcodblkfmigmpchhi',
    name: 'Pinterest Love',
    resource: 'grid/grid.html',
  },
  {
    id: 'nkipnpoebmbpljbmiijjnmkolichinpi',
    name: 'Consensus SNAP',
    resource: 'index.html',
  },
  {
    id: 'nlaealbpbmpioeidemdfedkfmglobidl',
    name: 'SignNow',
    resource: 'content/web/viewer.html',
  },
  {
    id: 'nlgfplihjpoagjkcnmfiefhhbpfeibch',
    name: 'ANNEXX',
    resource: 'popup/img/logo.svg',
  },
  {
    id: 'nmaekpmealpjglikpijiegglabclhefp',
    name: '夸克',
    resource: 'qk-content.css',
  },
  {
    id: 'nmldldceedhpaljnghjfdpledpdmkjek',
    name: 'Cashback.co.il',
    resource: 'dev.js',
  },
  {
    id: 'nninbdadmocnokibpaaohnoepbnpdgcg',
    name: 'CROSSx',
    resource: 'inpage.iife.js',
  },
  {
    id: 'nolibfldemoaiibepbhlcdhjkkgejdhl',
    name: 'WAContactSaver',
    resource: 'assets/wa.js',
  },
  {
    id: 'npfcikmknnpnilnlmapapegahabkfinp',
    name: 'Serviceware Knowledge Integrator',
    resource: 'page/froala-support.js',
  },
  {
    id: 'npimbikeicamplnnndojgkmfdejbpbin',
    name: 'Onestart',
    resource: 'assets/cart-mtM4UKjK.png',
  },
  {
    id: 'oaimmbbnnhmibhbocchkfcakiankbnlk',
    name: 'Messages Saver for Facebook',
    resource: 'css/emoji.css',
  },
  {
    id: 'obdhcplpbliifflekgclobogbdliddjd',
    name: 'Paint Tool',
    resource: 'assets/content.css',
  },
  {
    id: 'ochakbabgibkngiacohpppcpmjbfmafm',
    name: 'Heimdall',
    resource: 'chunk-zej9JT8u.js',
  },
  {
    id: 'ocllfmhjhfmogablefmibmjcodggknml',
    name: 'Recent Tabs',
    resource: 'images/document.png',
  },
  {
    id: 'ocpidabhgonmkigibocbijgoeaildoeg',
    name: 'PDF Simpli',
    resource: 'popup.html',
  },
  {
    id: 'odjkephjckgpjidmglobijkgdfeplhkp',
    name: 'Ускорить Ютуб Бесплатно',
    resource: 'assets/128.png',
  },
  {
    id: 'oedcflfijnmdnkllbeoacabinnlgplmb',
    name: 'Video Speed Controller',
    resource: 'assets/messages-BTt0Firn.js',
  },
  {
    id: 'ogbpccedpmocjdjgonecbejmgfhffngo',
    name: 'AiPrice(AliPrice) Search by Image for TB Beta',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ohdihpdgfenligmhnmldmiabdhflokkh',
    name: 'Adopt365 (powered by VisualSP)',
    resource: 'js/bootstrap.js',
  },
  {
    id: 'ohdkdaaigbjnbpdljjfkpjpdbnlcbcoj',
    name: 'FocusShield Site Blocker',
    resource: 'css/block.css',
  },
  {
    id: 'ojcijjdchelkddboickefhnbdpeajdjg',
    name: 'Funkify',
    resource: 'assets/icons/icon-16.png',
  },
  {
    id: 'ojkchikaholjmcnefhjlbohackpeeknd',
    name: 'OWASP PTK',
    resource: 'ptk/inject.js',
  },
  {
    id: 'okdollcfhjnnclfiphoioajnjoaplilm',
    name: 'OKIOCAM Live',
    resource: 'assets/resolutions.json',
  },
  {
    id: 'okkijechcafgdmbacodaghgeanecimgd',
    name: 'Pac Man Tribute',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'okkmmheplgoglaiofliglhekamdfepmc',
    name: 'Google Lens',
    resource: 'screenshot.js',
  },
  {
    id: 'okmokimdgjhndamggnkdojhbofdmepno',
    name: 'InsExporter IG Follower Export Tool',
    resource: 'assets/icon-16.png',
  },
  {
    id: 'okphadhbbjadcifjplhifajfacbkkbod',
    name: 'SABconnect++',
    resource: 'css/common.css',
  },
  {
    id: 'olioanlbgbpmdlgjnnampnnlohigkjla',
    name: 'Web Disability Simulator',
    resource: 'simulations/sunshine/css/main.css',
  },
  {
    id: 'omdailfkkflmmjpeijgmepjpkaicbman',
    name: 'Communicator Call',
    resource: 'detectAjax.js',
  },
  {
    id: 'onglbklimdjicpdadjieknodkkmjldoa',
    name: 'Reddit Enhancer',
    resource: 'changelog.txt',
  },
  {
    id: 'oohipoojgodobmpkcebmmkffpbckijoc',
    name: 'Zoho Show',
    resource: 'html/inject.html',
  },
  {
    id: 'oopkfefbgecikmfbbapnlpjidoomhjpl',
    name: 'BewlyCat',
    resource: 'assets/empty.png',
  },
  {
    id: 'pbpnngfnagmdlicfgjkpgfnnnoihngml',
    name: 'NG Spelling and Grammar Checker',
    resource: 'dic.pt.txt',
  },
  {
    id: 'pccilkiggeianmelipmnakallflhakhh',
    name: 'Wordle Timeless',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'pcndjhkinnkaohffealmlmhaepkpmgkb',
    name: 'Meteor Wallet',
    resource: 'assets/constants_theme-DBpwduVV.js',
  },
  {
    id: 'pdmgonafkgopgipcmgfpfobgknbofnpn',
    name: 'PaperPop',
    resource: 'icons/pro.png',
  },
  {
    id: 'peocghcbolghcodidjgkndgahnlaecfl',
    name: 'Parental Control',
    resource: 'blocked.html',
  },
  {
    id: 'pfakonjcmhhijheplkpphchmedipcoej',
    name: 'Klarway',
    resource: 'images/kicon.svg',
  },
  {
    id: 'pfgnfdagidkfgccljigdamigbcnndkod',
    name: 'MobX Developer Tools',
    resource: 'panel.html',
  },
  {
    id: 'pggamokfileohlopdonjmelbbghhnlah',
    name: 'Quick View',
    resource: 'bundle.css',
  },
  {
    id: 'phgiabfbjodhgckcffppiboooeiecgeg',
    name: 'DefiLlama',
    resource: 'icon-34.png',
  },
  {
    id: 'phpllnjdcoiijcpgcbhlocjgcegjfnhb',
    name: 'CoMo Inspector',
    resource: 'index.html',
  },
  {
    id: 'piepdojghinggmddebidfkhfbdaggnmh',
    name: 'shortfuts',
    resource: 'injected.js',
  },
  {
    id: 'pjcoahgaemafbolmcnlchnbegigekbil',
    name: 'Translator for WhatsApp Web',
    resource: 'assets/index.d2da5480.js',
  },
  {
    id: 'pkgejkfioihnchalojepdkefnpejomgn',
    name: 'Colorway',
    resource: 'index.html',
  },
  {
    id: 'pleldliknijeecdjckmcbcmgijjfkake',
    name: 'Recipes',
    resource: 'manifest.json',
  },
  {
    id: 'plifocdammkpinhfihphfbbnlggbcjpo',
    name: 'Metric Spy Page Ruler',
    resource: 'css/content.css',
  },
  {
    id: 'pnbabdldpneocemigmicebglmmfcjccm',
    name: 'Authenticator App',
    resource: 'popup.css',
  },
  {
    id: 'pnpapokldhgeofbkljienpjofgjkafkm',
    name: 'Best Cursors',
    resource: 'bc-logo192.png',
  },
  {
    id: 'pohibamcjdinnoefmcggajbcblnodgoe',
    name: 'Dashy New Tab Dashboard and Side Panel',
    resource: 'assets/bg.webp',
  },
  {
    id: 'aaekdmjipccamkpkcijaeljfniagapap',
    name: 'Unblur',
    resource: 'assets/alert.css',
  },
  {
    id: 'aakkhbloifflgelkkikmbakldbhllbfj',
    name: 'GMB Crush',
    resource: 'icons/mobile.svg',
  },
  {
    id: 'aakmllddlcknkbcgjabmcgggfciofbgo',
    name: 'Google Apps Script Copilot',
    resource: 'add.png',
  },
  {
    id: 'aaoccafneaocbhgbhkagdhlmgmagbagn',
    name: 'Page Load Stats',
    resource: 'icon128.png',
  },
  {
    id: 'abbhcfgheggicbgjihahnikcijgodmbd',
    name: 'Seismic for Gmail',
    resource: 'index.js',
  },
  {
    id: 'abebconmjhhbcjofpchjkbbimgkhdmbe',
    name: 'Translator',
    resource: 'content-scripts/esm/content.js',
  },
  {
    id: 'acbjeolbnaiecolebdcopocflkljjmhi',
    name: 'MyMemo Web Clipper',
    resource: 'js/sdk.js',
  },
  {
    id: 'ackcbipakokckcokomiffcmkgpckkjhf',
    name: 'Ekoru Search',
    resource: 'image/logo_xsmall.png',
  },
  {
    id: 'acmfeacjdhhlkkiedpfkkhbnddjanphf',
    name: 'GIF Maker',
    resource: 'popup.js',
  },
  {
    id: 'acmfklpkefjlldbkdgmjoiknfgidadoh',
    name: 'Clay',
    resource: 'popup.html',
  },
  {
    id: 'adiiaeaejlpneikcmkihnimenppopden',
    name: 'Chrome Reader Mode',
    resource: 'styles.css',
  },
  {
    id: 'aeehapalakdoclgmfeondmephgiandef',
    name: 'LazyCat Bookmark Cleaner',
    resource: 'index.js',
  },
  {
    id: 'aegeclnpeaicklknkpcjbldnpkkkhkid',
    name: 'Clipboard Tool',
    resource: 'tabs/delta-flyer.html',
  },
  {
    id: 'aelljdlolpakdoeongoklpkheedfjkio',
    name: 'Career.io Job Auto Apply',
    resource: 'app.html',
  },
  {
    id: 'afdfpkhbdpioonfeknablodaejkklbdn',
    name: 'Sidebarr',
    resource: 'logo.svg',
  },
  {
    id: 'afebilemcaepdkmhmibgmnpfppnjimjf',
    name: 'Speed Tweaks',
    resource: 'data/content_script/tweaks/scroll.js',
  },
  {
    id: 'afhokbldaaeggpigpijmomaooflpikji',
    name: 'MakeTime',
    resource: 'assets/fonts/Optima.ttf',
  },
  {
    id: 'afnkbjdolconnacdloghhenaochkafoi',
    name: 'Floating Picture-in-picture',
    resource: 'web_accessible_resources/on.svg',
  },
  {
    id: 'aglfipclnglindmcgmihmeljjfejjhdf',
    name: 'Chandler',
    resource: 'fullpage.html',
  },
  {
    id: 'ahfbjljipkpgbknoognlpekjkpmibgkf',
    name: 'Whatsapp extra privacy',
    resource: 'css/name.css',
  },
  {
    id: 'ahgakckdonjmnpnegjcamhagackmjpei',
    name: 'Save as MHTML',
    resource: 'data/toolbar/index.html',
  },
  {
    id: 'ahnhkdjjonmjlhbbgaaoehdnhlgcgbab',
    name: 'SearchAtlas SEO',
    resource: 'js/script.js',
  },
  {
    id: 'aielbbnajdbopdbnecilekkchkgocifh',
    name: 'Enlargify Magnifying Glass',
    resource: 'images/magnifier.svg',
  },
  {
    id: 'aihgkhchhecmambgbonicffgneidgclh',
    name: 'Email Finder & Email Hunter',
    resource: 'icons/16.png',
  },
  {
    id: 'ajgkdaibodfheidcpeifpdhaopjbpneo',
    name: 'Presto',
    resource: 'css/public.css',
  },
  {
    id: 'ajkigpnleboodhdlminnlmldegieilfc',
    name: 'Kalp Wallet',
    resource: 'content.css',
  },
  {
    id: 'ajlhmclpjddfebgfpahnlodliljdnbie',
    name: 'Moss',
    resource: 'index.html',
  },
  {
    id: 'akfpfknibfabmgflodhhemljeannmaif',
    name: 'Т-Промокоды',
    resource: 'bg/bg.js',
  },
  {
    id: 'akhckkpbjonlaacapohphmdfoikibkbg',
    name: 'X Media Downloader',
    resource: 'libs/analytics.js',
  },
  {
    id: 'akldabonmimlicnjlflnapfeklbfemhj',
    name: 'Page Agent',
    resource: 'main-world.js',
  },
  {
    id: 'akleeoemmhoghpglhmbannnecclchbhb',
    name: 'Simple Mass Downloader',
    resource: 'help.html',
  },
  {
    id: 'akommlakkhgbjbidpkkdcgbjgbeemdik',
    name: 'crumbs',
    resource: 'crumbs-email-relay-menu.html',
  },
  {
    id: 'alakoggmijiicdlcjjeakffojoinhlpg',
    name: 'Downloads',
    resource: 'assets/icons/icon19_1.png',
  },
  {
    id: 'albjlmhakjdfaemnnmpjddfmcadbpgpf',
    name: 'Hanzii',
    resource: 'favicon.ico',
  },
  {
    id: 'algkcnfjnajfhgimadimbjhmpaeohhln',
    name: 'Secure Shell',
    resource: 'html/nassh.html',
  },
  {
    id: 'alnaklamobemdmneodhdgcpcimolihfc',
    name: 'Screen Dimmer',
    resource: 'src/assets/eyeletic.png',
  },
  {
    id: 'alnpfmeemhhcfephffidoflphgnneeld',
    name: 'Confetti',
    resource: 'images/icon-38.png',
  },
  {
    id: 'ambjmopdihmdndfenlecimbfdbgngeea',
    name: 'uTorrent',
    resource: 'res/icon96.png',
  },
  {
    id: 'amcccnldajjnngnaoinemnaloklogjak',
    name: 'Refore HTML to Figma',
    resource: 'intermediary.html',
  },
  {
    id: 'amciopbgphikbcmaffbmmibnbpiokfic',
    name: 'Liner',
    resource: 'images/19.png',
  },
  {
    id: 'amdfepljcddfmbgdnkkkfgkflgakbgjm',
    name: 'Ad Library',
    resource: 'images/#.svg',
  },
  {
    id: 'ameajnciachbdcneinbgnehihjolepkd',
    name: 'Voice Mode for AI Chatbots',
    resource: 'index.html',
  },
  {
    id: 'amfkipihkmaplngfikedhgfmjndaboep',
    name: 'Scratchpad',
    resource: 'iframeNotesList.html',
  },
  {
    id: 'amjaoklkeffceamacmpblhhhfajdoihl',
    name: 'Influencer Analytics',
    resource: 'manifest.json',
  },
  {
    id: 'amndpakmdficmebaknminpdbgdccfkjn',
    name: 'Auto History Wipe',
    resource: 'js/help.js',
  },
  {
    id: 'amnlhffheggkehikhanljohklfjiailo',
    name: 'Simple Allow Copy 2',
    resource: 'content_scripts/copy.js',
  },
  {
    id: 'anehaijgfhlkchmihoaklaimlclnomag',
    name: 'CXone Agent Click-to-Dial',
    resource: 'assets/images/cxoneLogo.png',
  },
  {
    id: 'anlmfajfhajafleocbgpmlkdjlkpnbpd',
    name: 'Vi Subtitle',
    resource: 'src/utils/recorder_worklet.js',
  },
  {
    id: 'anmmhkomejbdklkhoiloeaehppaffmdf',
    name: 'React Scan',
    resource: 'icons/enabled/48.png',
  },
  {
    id: 'aoananblbpkihfolfalanokhfbgloifd',
    name: 'Tungsten Power PDF',
    resource: 'viewer.html',
  },
  {
    id: 'aocppmckdocdjkphmofnklcjhdidgmga',
    name: 'taba11y',
    resource: 'i18n/bg.json',
  },
  {
    id: 'aofpckgjoigaodfngkpnekongdjnpged',
    name: 'AiroStrip',
    resource: 'strip.css',
  },
  {
    id: 'aopiblpdipgmiiafojaigmoalfmboidh',
    name: 'TecWorld Descontos',
    resource: 'index.css',
  },
  {
    id: 'apgdhlibcimkkffajannbmpnbjaealmo',
    name: 'HTML to Figma',
    resource: 'html2canvas.js',
  },
  {
    id: 'aphligncnahhmlmcndcpmadohdgngfjf',
    name: 'Mute All for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'apjpmocfcdmmjcgcbipfhjfcjhlkfhmc',
    name: 'ECGO',
    resource: 'icons/icon_128.png',
  },
  {
    id: 'apojloehfppelokhjbachonhgpkonhgo',
    name: 'Tiktok Auto Scroll',
    resource: 'src/images/icon128.png',
  },
  {
    id: 'baafhiocpgpaahonnkhkhbkggbhmefld',
    name: 'Google Photos Duplicate Remover',
    resource: 'offscreen.html',
  },
  {
    id: 'baeacoakglpckmhkmpgkdgoclgcjpkoc',
    name: 'nicopip',
    resource: 'assets/inject.ts-B_MVn9Jd.js',
  },
  {
    id: 'baganeegkidlaebaigikopklmhkdkkbk',
    name: '智译网页翻译',
    resource: 'setting.html',
  },
  {
    id: 'baigfnhcfjaehfeihnpghahhaceapfme',
    name: 'IQ Robot',
    resource: 'content.js',
  },
  {
    id: 'bbcmnbnmngpeofmpcdlcfalbniefegbp',
    name: 'Trinka AI',
    resource: 'sdkBridge.js',
  },
  {
    id: 'bbhcinnacieofapkejehoacofpdimlcf',
    name: 'OptimAI',
    resource: 'content.css',
  },
  {
    id: 'bbnlmjmabffkmgdidgknggloohdoadfi',
    name: 'ACCELQ',
    resource: 'common/icons/recording-red.png',
  },
  {
    id: 'bcbomnojalacmkgalembldegajchajdd',
    name: 'Dr.eye Embedded Translation',
    resource: 'images/16/chs.png',
  },
  {
    id: 'bdjkbgejocjhchdjmckgegngdaghnfbl',
    name: 'unFunnelizer',
    resource: 'icons/ga4.svg',
  },
  {
    id: 'bebgccbfedcfmpidjcjoomapnmlhhmlk',
    name: 'Modjo',
    resource: 'pageWorld.js',
  },
  {
    id: 'becedogggoaicbphcoimgpmhodofcfck',
    name: 'InFormEnter+',
    resource: 'img/informenter-marker-1.png',
  },
  {
    id: 'bedogdpgdnifilpgeianmmdabklhfkcn',
    name: 'VESPR Wallet',
    resource: 'lib/cip30/injected.web.js',
  },
  {
    id: 'bejghfnahjjdffjmbfooochffgcgofok',
    name: 'Clique',
    resource: 'js/index.js',
  },
  {
    id: 'bejnkpeokbmilompefleppmlblpblbok',
    name: 'UserGuiding+',
    resource: 'fonts.css',
  },
  {
    id: 'bffdkjghikmcdiidbncieeephfoiingd',
    name: 'Browser Lock',
    resource: 'icons/16.png',
  },
  {
    id: 'bffmkleioghafggghlaeemdgjpmbppii',
    name: 'AdBlock Detector Bypass',
    resource: 'icon48.png',
  },
  {
    id: 'bflmnoacgfmbdfinmbiapbanfobpglba',
    name: 'Chat AI',
    resource: 'inject.js',
  },
  {
    id: 'bfncmfmdadhimlnpeecppaimgmeeppan',
    name: 'SheetWhiz',
    resource: 'popup.html',
  },
  {
    id: 'bgdfagapkongbjnklaabbmgpppgfccbg',
    name: 'Eureka Shopping',
    resource: 'widget/index.html',
  },
  {
    id: 'bghceahjdhjncoohgobeohgnmfnooibd',
    name: 'HAR/JSON viewer',
    resource: 'connection.js',
  },
  {
    id: 'bgonpegbhnjepleakgjdbaepkfedhhnf',
    name: 'Cookie Killer for Facebook',
    resource: 'images/icon.64.png',
  },
  {
    id: 'bgpipimickeadkjlklgciifhnalhdjhe',
    name: 'Gero Dashboard',
    resource: 'public/logo.png',
  },
  {
    id: 'bhcafamaagaonkhnbnnjjfekddfllpgc',
    name: 'cloud print',
    resource: 'toolbar/toolbar.js',
  },
  {
    id: 'bhcielkibmaibfcjjmolgpapmlpooaph',
    name: 'Volume Booster for Chrome',
    resource: 'popup.js',
  },
  {
    id: 'bhmpidliobdjgkohacnkgfagkdmckcia',
    name: 'Find and replace',
    resource: 'images/close.png',
  },
  {
    id: 'bifmfjgpgndemajpeeoiopbeilbaifdo',
    name: 'External Application Launcher',
    resource: 'data/redirect/index.html',
  },
  {
    id: 'bjekehokhpkicboifnoocieebcdbdmne',
    name: '네이버 가격추적기 및 이미지 검색',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'bjjamnamnndpikgfpbocmcnclhfdeekh',
    name: 'Read Out Loud',
    resource: 'assets/pdf-CcZYcL52.js',
  },
  {
    id: 'bjojfeillmmoeadgobbcknkgdkngbcdb',
    name: 'Trocker',
    resource: 'img/tl.png',
  },
  {
    id: 'blbjnedpmjikmgjjbmihgbaplihinojl',
    name: 'Ranorex Automation',
    resource: 'msgport.js',
  },
  {
    id: 'blimjkpadkhcpmkeboeknjcmiaogbkph',
    name: 'Sendspark Video and Screen Recorder',
    resource: 'camera.html',
  },
  {
    id: 'blipofpggfakgagkjjofilbjenenheaa',
    name: 'Login Online',
    resource: 'manifest.json',
  },
  {
    id: 'blndbjkicjhcbpldeamfbdoeekcbampi',
    name: 'Markdown Nice',
    resource: 'ueditor.js',
  },
  {
    id: 'bmdiaadnpgbbfepggiiajgadlhhcphgk',
    name: 'YouTube Rewind&Forward Buttons',
    resource: 'web-components/support-links.css',
  },
  {
    id: 'bmejkpgaonmggfkbmbljdiapjnpbopcp',
    name: 'Toolsy.io',
    resource: 'assets/ui-icons/X.tsx',
  },
  {
    id: 'bmiphdgjjjgkjhlfhlbbpkmdokichnhn',
    name: 'WA Contacts',
    resource: 'logo/logo_16.png',
  },
  {
    id: 'bmoggiinmnodjphdjnmpcnlleamkfedj',
    name: 'AliasVault',
    resource: 'webauthn.js',
  },
  {
    id: 'bnacincmbaknlbegecpioobkfgejlojp',
    name: 'MaxFocus',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'bncpjddkbppnnfbdogmilhecbjoccpci',
    name: 'H264ify With Auto 1080',
    resource: 'inject.js',
  },
  {
    id: 'bnebanooamokkihfjepphafoekheipfh',
    name: 'Plus',
    resource: 'content/index.js',
  },
  {
    id: 'bnflmljpbmkjeahgjakmjdanmhldjhbk',
    name: 'Claap',
    resource: 'camera.html',
  },
  {
    id: 'bniadokhddgdbbcpolbgjcnmaphkbpni',
    name: 'Thieve AliExpress Tools',
    resource: 'content-script.js',
  },
  {
    id: 'bnkaaocadlimipknmjoebcfnjfffdnif',
    name: 'Storm Tracker',
    resource: 'assets/wind-3.svg',
  },
  {
    id: 'bnnacanndojemikeabbdejlamlecikcn',
    name: 'JobCopilot',
    resource: 'icon.png',
  },
  {
    id: 'bojpifbeghjhkcjhdbdodlgolhmcdibm',
    name: 'Dragon Copilot',
    resource: 'dist/page.js',
  },
  {
    id: 'boljogbhdlnglpadhgaecnmecdnhnjpe',
    name: 'Similar Product Search on Temu',
    resource: 'css/main.css',
  },
  {
    id: 'bpanegeigcjabmofichmidnfmfhomkgo',
    name: 'ClickUp',
    resource: 'max/index.html',
  },
  {
    id: 'bpoadpcobdbakpgkgpfhlggfapdkiijm',
    name: 'Getemail.io legacy',
    resource: 'browser_action/libs/jquery-3.4.1.min.js',
  },
  {
    id: 'bppajinomefndbbmopljhbdfefnefdha',
    name: 'Consumer Rights Wiki',
    resource: 'close.svg',
  },
  {
    id: 'bpppldnipnppkmongnkihlioaojpmine',
    name: 'DataGalaxy',
    resource: 'index.html',
  },
  {
    id: 'caljiholplhibonecblicbgjkakcpmmm',
    name: 'RotoWire',
    resource: 'fonts/Cosmica-Heavy.otf',
  },
  {
    id: 'canipghmckojpianfgiklhbgpfmhjkjg',
    name: 'Crossmark',
    resource: 'static/js/inject.bundle.js',
  },
  {
    id: 'cbdfphadkkilbophkiniofgadollfoae',
    name: 'Sunrise Backgrounds',
    resource: 'sources/app.js',
  },
  {
    id: 'ccdooaopgkfbikbdiekinfheklhbemcd',
    name: 'Namso Validator',
    resource: 'sentryUtils.js',
  },
  {
    id: 'cceclgeciefpanebkfkogecbjjchmico',
    name: 'Force Copy',
    resource: 'lnCW8VD8ab.js',
  },
  {
    id: 'ccemhgcpobolddhpebenclgpohlkegdg',
    name: 'Lumina Night Mode',
    resource: 'js/proxy.js',
  },
  {
    id: 'ccheepfhfjiafnlakajbfhlpcigpplec',
    name: '1688 search by image',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ccngfcpmkbeoecmobmdoonoicfenjnkk',
    name: 'EasyView',
    resource: 'pages/reader/index.html',
  },
  {
    id: 'cdblaggcibgbankgilackljdpdhhcine',
    name: 'rflookup',
    resource: 'scripts/pdfjs.js',
  },
  {
    id: 'cdbldfdikpkmfcnpidikieafacjkchbg',
    name: 'Winston AI',
    resource: 'overlay.css',
  },
  {
    id: 'cdbneippcpjnpjenabkgfljgpjmamobg',
    name: 'Plerdy UX & Usability Testing',
    resource: 'popup.js',
  },
  {
    id: 'cdgbjhkjjghbjjikgjkkpljlmnpcakco',
    name: 'Reverse Image Search',
    resource: 'post-form.js',
  },
  {
    id: 'cdkhibgadomdghgnknpmgegpjjmfecfk',
    name: 'JsCIN',
    resource: 'i18n.js',
  },
  {
    id: 'cdmbeofnbhgdgnijieodggfmfpamfifg',
    name: 'AMZScout PRO',
    resource: 'styles.css',
  },
  {
    id: 'cdnlfphfngnfhjcnoikfhaomaaflaiie',
    name: 'Video Maximizer',
    resource: 'videomax_inject.css',
  },
  {
    id: 'cfegchignldpfnjpodhcklmgleaoanhi',
    name: 'Sidegram',
    resource: 'rules_1.json',
  },
  {
    id: 'cfhojegjegkohdidhpmajdbnlfkphbhc',
    name: 'iHomepage',
    resource: 'icon/icon_64.png',
  },
  {
    id: 'cfkejojncmolgahkabegcdbcbmnghhcp',
    name: 'Fantia downloader',
    resource: 'jszip.js',
  },
  {
    id: 'cfkhjljibkblnlhbaemeopmhkpmahhac',
    name: 'YouTube Transcription',
    resource: 'icons/16x16.png',
  },
  {
    id: 'cflakfhockilljdbofnanaijpmpmfcol',
    name: 'Từ điển Anh Việt ENVI',
    resource: 'ocr.html',
  },
  {
    id: 'cfopbpknalachedpcddhgbgjoigklien',
    name: 'MarkView',
    resource: 'js/popup.js',
  },
  {
    id: 'cgeeodpfagjceefieflmdfphplkenlfk',
    name: 'EVER Wallet',
    resource: 'js/popup.js',
  },
  {
    id: 'cgejkofhdaffiifhcohjdbbheldkiaed',
    name: 'Minyami',
    resource: 'assets/scripts/inject_core.js',
  },
  {
    id: 'cggaenglmghpmhjcmogcacipdmfblobp',
    name: 'Download svg',
    resource: 'pages/index.html',
  },
  {
    id: 'cgicnmnonpkpbgmboekkjdbckihlhajf',
    name: 'MatPatify',
    resource: 'images/1.png',
  },
  {
    id: 'chfhddogiigmfpkcmgfpolalagdcamkl',
    name: 'var_masterpiece',
    resource: 'images/info.svg',
  },
  {
    id: 'chjblpopkoelbkolfboniibdhjmlkphf',
    name: 'Desktop Screen Recorder',
    resource: 'data/window/index.html',
  },
  {
    id: 'cidalejakfnmkeioolifplbocphngkhl',
    name: 'Admitad',
    resource: 'assets/icons/19x19.png',
  },
  {
    id: 'cimelnkhnffcenamjdjhjdieknlcbeaj',
    name: 'Unlimited Video Downloader',
    resource: 'payment.html',
  },
  {
    id: 'cioclaehpkkndohobfpdghgkaifaacgb',
    name: 'Prime Sender',
    resource: 'logo/cc.png',
  },
  {
    id: 'cjfempcnipbjiigappmofndiliohlpan',
    name: 'WuCai',
    resource: 'views/sc.html',
  },
  {
    id: 'cjpmpjddogcacgckmamjhmjlflfjikdh',
    name: 'Quizwiz',
    resource: 'index.html',
  },
  {
    id: 'ckcdnopgiijkcoejjophlljlfommgihi',
    name: 'Temp Mail',
    resource: 'css/index.css',
  },
  {
    id: 'ckdcieaenmejickienoanmjbhcfphmio',
    name: 'Lensify Zoom Magnifying Glass',
    resource: 'images/magnifier.svg',
  },
  {
    id: 'ckfdjapnpbkafkkbimifjeohlemamoal',
    name: '店查查',
    resource: 'injected.js',
  },
  {
    id: 'cklapigolmgodbfjbickflddedbdieka',
    name: 'Custom Cursor',
    resource: 'assets/static/32.png',
  },
  {
    id: 'cmfdaldondfeihfgblhhjpaoddmmopgl',
    name: 'Tali AI',
    resource: 'negative.wav',
  },
  {
    id: 'cmfhopmhaagcfnjflfppceclmkenjkpc',
    name: 'Meomni',
    resource: 'icon_128.png',
  },
  {
    id: 'cmplbmppmfboedgkkelpkfgaakabpicn',
    name: 'Gridman',
    resource: 'icon/icon-gridman.svg',
  },
  {
    id: 'cncllbaocdclnknlaciemnogblnljeej',
    name: 'What Font Spotter',
    resource: 'css/content.css',
  },
  {
    id: 'cofoinjfjcpgcjiinjhcpomcjoalijbe',
    name: 'Leetcode Explained',
    resource: 'src/assets/images/copy-icon.png',
  },
  {
    id: 'cokmobldpihbibodplbdfhkbiibganfh',
    name: 'Plerdy SEO Analyzer',
    resource: 'stem.js',
  },
  {
    id: 'cokngoholafkeghnhhdlmiadlojpindm',
    name: 'Video Roll',
    resource: 'inject/index.js',
  },
  {
    id: 'copnnlbbmgdflldkbnemmccblmgcnlmo',
    name: 'Zukeeper',
    resource: 'js/contentScript.js',
  },
  {
    id: 'cphhlgmgameodnhkjdmkpanlelnlohao',
    name: 'NeoLine',
    resource: 'dapi.js',
  },
  {
    id: 'cpmjnpalighpdecgankobogpcmbceaig',
    name: 'Easy Login',
    resource: 'manifest.json',
  },
  {
    id: 'cpnkcffhllafbdbljkmhebnpbnlhapmd',
    name: 'CSS Selector Capture Pro',
    resource: 'common/app.min.css',
  },
  {
    id: 'cppibjhfemifednoimlblfcmjgfhfjeg',
    name: 'Social Stream Ninja',
    resource: 'shared/utils/html.js',
  },
  {
    id: 'daeaddalijienfjkhigbifmbdckbohjg',
    name: 'Ask Gemini',
    resource: 'Popup.js',
  },
  {
    id: 'dagflnpdebeejnminpgebkallhcgeklm',
    name: 'SmmBox',
    resource: 'smmbox.html',
  },
  {
    id: 'dalcafimefnkcnhhlbceoedffpkfehoe',
    name: 'Search by image on Amazon',
    resource: 'ic.png',
  },
  {
    id: 'dbbopjndlaginbghfoibbndhlbpdpapd',
    name: 'IGPlus',
    resource: 'assets/img/dev.png',
  },
  {
    id: 'dbchgeokljmcmdjbpfiaagmjdkohknec',
    name: 'Foxit PDF Editor Cloud',
    resource: 'icon/38.png',
  },
  {
    id: 'dbgnhckhnppddckangcjbkjnlddbjkna',
    name: 'Fin Wallet For Sei',
    resource: 'inpage.bb889182.js',
  },
  {
    id: 'dccefjeoofjkdjodbkkbncjcipagdnad',
    name: 'Japanese IO',
    resource: 'images/logos/japanese-io-logo.svg',
  },
  {
    id: 'dcjbilopnjnajannajlojjcljaclgdpd',
    name: 'StopSurf',
    resource: 'css/block.css',
  },
  {
    id: 'dclnfogoojlodlkdfnmghfbeloeojken',
    name: 'AppstoreSpy for Play Store',
    resource: 'ru.svg',
  },
  {
    id: 'dcpmkllpnpfpojkjildgeoedikjbhodm',
    name: 'Web for TikTok',
    resource: 'img/icon.ico',
  },
  {
    id: 'ddbjkeokchfmmigaifbkeodfkggofelm',
    name: 'Popup Blocker',
    resource: 'src/layouts/modal.html',
  },
  {
    id: 'ddkmobcljbfggkmibabekgpbighaogpn',
    name: 'DualPiP',
    resource: 'css/pip.css',
  },
  {
    id: 'ddoijapfgfbaaehaegnddlbnmcbngkpi',
    name: 'Canned Replies',
    resource: 'index.html',
  },
  {
    id: 'decehdgnikepnangkendclmiomkcnpjh',
    name: 'Timeless',
    resource: 'index.html',
  },
  {
    id: 'deelhmmhejpicaaelihagchjjafjapjc',
    name: 'MEGA Pass',
    resource: 'lang/ar.json',
  },
  {
    id: 'defbpbmenfaikcnhmamnghdlcmahjaib',
    name: 'Cast to Sonos',
    resource: 'mp3-processor.js',
  },
  {
    id: 'denfchfjdgfekgapbjmpmkgaiapfjbep',
    name: 'Highspot',
    resource: 'default_popup.html',
  },
  {
    id: 'dfdkfkighakfgihcffnpboebfifbeddl',
    name: 'Easy How To',
    resource: 'manifest.json',
  },
  {
    id: 'dfmahbmljohdkjopniglmkehnkpkmcoi',
    name: 'xPrice',
    resource: 'assets/logo.svg',
  },
  {
    id: 'dfmneckodhidoicepmbegcjifhmhhppg',
    name: 'Advanced Auto Logout',
    resource: 'icons/icon128.png',
  },
  {
    id: 'dgbcohbjchndmjocioegkgdniaffcaia',
    name: 'Lever Hire',
    resource: 'panel.js',
  },
  {
    id: 'dgcfkhmmpcmkikfmonjcalnjcmjcjjdn',
    name: 'CurlWget',
    resource: 'images/options.png',
  },
  {
    id: 'dggmapjanngfjjakfgeoegfmgpmcamfh',
    name: 'Meta Explorer',
    resource: 'root.css',
  },
  {
    id: 'dibilcjfahbokhiodajibcajcabfjein',
    name: 'Catchpoint User Experience',
    resource: 'rum.js',
  },
  {
    id: 'didcfcjaaklmklfcdmdockimagocdbdd',
    name: 'AnyTech365 AntiScam SafeBrowse',
    resource: 'bg.png',
  },
  {
    id: 'didfpaehajfbjnamladanbocmdhahfch',
    name: 'Logalty ClickOnce',
    resource: 'images/blank.png',
  },
  {
    id: 'didkfdopbffjkpolefhpcjkohcpalicd',
    name: 'AH',
    resource: 'img/db.svg',
  },
  {
    id: 'difjajjajoeppdgbcbbhbdblblmkcbhp',
    name: 'BuzzStream Buzzmarker',
    resource: 'flags.json',
  },
  {
    id: 'dioapkekjoidbacpmfpnphhlobnneadd',
    name: 'Math AI',
    resource: 'content-scripts/main.css',
  },
  {
    id: 'djhndpllfiibmcdbnmaaahkhchcoijce',
    name: 'Casper Signer',
    resource: 'logo64.png',
  },
  {
    id: 'dkdeafhmbobcccfnkofedleddfbinjgp',
    name: 'Dungeon Dodge',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'dkkdakdkffippajmebplgnpmijmnejlh',
    name: 'CaptchaSonic',
    resource: 'signer.js',
  },
  {
    id: 'dkleeapinhlpifbijbppjcbgiolpagjd',
    name: 'YouTube Comment Translator Pro',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'dkmialecpnehmacfikflbjkdnkiccmnk',
    name: 'クリックポスト',
    resource: 'options/options.js',
  },
  {
    id: 'dlbfbjkldnioadbilgbfilbhafplbnan',
    name: 'Scope Master Page Ruler',
    resource: 'css/content.css',
  },
  {
    id: 'dmbjafgplanbfngeocfdheanncchaanf',
    name: 'Papago Plus',
    resource: 'background.js',
  },
  {
    id: 'dmfjonjeonmaoehpjaonkjgfdjanapbe',
    name: 'Capios',
    resource: 'css/ocr.css',
  },
  {
    id: 'dmhljjnonlhapikmelaefohecogokhio',
    name: 'Apidog',
    resource: 'adapter.js',
  },
  {
    id: 'dndlogdahhepeejieppcfccajdbmeajd',
    name: 'tkm-gchat-ext',
    resource: 'icon-128.png',
  },
  {
    id: 'dnnmaoecogobjdiieopljefemjdkkaja',
    name: 'Burner Emails',
    resource: 'images/loader.gif',
  },
  {
    id: 'dnociedgpnpfnbkafoiilldfhpcjmikd',
    name: 'Livewire devtools',
    resource: 'devtools.html',
  },
  {
    id: 'docdmgijbdlobilamkipaleciekbgbgl',
    name: 'BuyBotPro',
    resource: 'content-app.css',
  },
  {
    id: 'doedlfgeilocafjipkkhegndbhlkoedo',
    name: 'Trupeer - AI Screen Recorder for Video Documentation, SOPs & Screenshots',
    resource: 'recorder.html',
  },
  {
    id: 'dogdgmomajhncdopjdijiabedklfampi',
    name: 'RingCentral for HubSpot',
    resource: 'popup.html',
  },
  {
    id: 'dpajfcckdohlcidmbjledcaenfkjaddo',
    name: 'Saima',
    resource: 'assets/js/main.js',
  },
  {
    id: 'dpjfjjogncmalibegalebgbnfigonomb',
    name: 'darkmode',
    resource: 'css/noty.css',
  },
  {
    id: 'dpjiaamadbcfheiamdaamhgpomlkohbn',
    name: 'VideoTogether',
    resource: 'preInjected.js',
  },
  {
    id: 'dpmldocpanbnkipbgkeneakkgbonbnim',
    name: 'BlockGuard',
    resource: 'dashboard.html',
  },
  {
    id: 'eaedglemlchhplocegehpjfeganapaij',
    name: 'Pleasant Password Server Auto-Filler',
    resource: 'images/Edit.svg',
  },
  {
    id: 'eagkigdnclikabndlojagifehppodooi',
    name: 'LRT SEO Toolbar',
    resource: 'img/red.png',
  },
  {
    id: 'eahmbdmdglmjpaadmkceijlpgknheoko',
    name: 'Sound EQ',
    resource: 'resources/64.png',
  },
  {
    id: 'eakpippijmmohmdlpgcjnipolcgciaga',
    name: 'Pangram AI Detection',
    resource: 'content.css',
  },
  {
    id: 'ebgihmollhfickaopoldkikdnipmdemg',
    name: 'PIP screen for html5 video',
    resource: 'pip34.png',
  },
  {
    id: 'eblbmdomppeajmpblgeppodbkfnonppc',
    name: 'SEO META 1 COPY',
    resource: 'js/font.js',
  },
  {
    id: 'ebmngdnanegibbkmmihlonnoddhfooga',
    name: 'BlueSales',
    resource: 'built/0.chunk.js',
  },
  {
    id: 'ecblfcmjnbbgaojblcpmjoamegpbodhd',
    name: 'SP Editor',
    resource: 'index.html',
  },
  {
    id: 'eccidpbmllnjfhhnjhaaopeeldnlokbi',
    name: 'QPush',
    resource: 'images/ajax-loader.gif',
  },
  {
    id: 'ecdbmkcphlholpojdglodopmlaficcji',
    name: 'DSM Auto-Paste',
    resource: 'resources/fonts/Ruda-Regular.ttf',
  },
  {
    id: 'ecmjjdafjebhegfhjincbdhgfonpibfm',
    name: 'Userpilot',
    resource: 'sdk.js',
  },
  {
    id: 'ecokmcackgiahnhklacojckhjmgkgcdi',
    name: 'Sebaran',
    resource: 'assets/js/core.js',
  },
  {
    id: 'edkgpjhfpfpgkohafpaliolcfnijnibh',
    name: 'Online Dropshipping and Arbitrage',
    resource: 'bundle.css',
  },
  {
    id: 'edpijhdhpmccflkdobmpggibhbmppmdn',
    name: 'Seerfar',
    resource: 'img/wb.ico',
  },
  {
    id: 'eeanibgekifamcnnieknbhjcoocnpipe',
    name: 'コメント増量',
    resource: 'lib/tf.js',
  },
  {
    id: 'eebchbokmimedlkmnaknibgmdjkgmoff',
    name: 'Fatkun Image Editor',
    resource: 'images/logo16.png',
  },
  {
    id: 'eediamimojgbnjfaalcnlonenfdcogop',
    name: 'GRCRT',
    resource: 'GrepolisReportConverterV2.user.js',
  },
  {
    id: 'egbbninofojfeabmcanakgkkimghnjhc',
    name: 'Redirecionamento',
    resource: 'jquery.js',
  },
  {
    id: 'egbeiaidfnjbliaaoijfcnopfopcnkbd',
    name: 'Kwai Pixel Helper',
    resource: 'inject.js',
  },
  {
    id: 'egcmejiaapccophafhfalaelbfgojdjf',
    name: 'OpenText iPrint',
    resource: 'assets/loading.gif',
  },
  {
    id: 'egikgfbhipinieabdmcpigejkaomgjgb',
    name: 'Feedly Notifier',
    resource: 'images/icon128.png',
  },
  {
    id: 'egmbomekcmpieccamghfgjgnlllgbgdl',
    name: 'jira-helper',
    resource: 'assets/content.ts-DtErBI7k.js',
  },
  {
    id: 'ehaanimekcjndnhnkojcckjcgalkfgee',
    name: 'StudyBuddy',
    resource: 'icon/screenshot-cursor.svg',
  },
  {
    id: 'ehaaocefdhppmemaaeedemaokjooldgm',
    name: 'ICommentExporter',
    resource: 'icon-48.png',
  },
  {
    id: 'eheokfekdhicohflnahpfmifnlnbkfoj',
    name: 'Games Search',
    resource: 'manifest.json',
  },
  {
    id: 'eiioekmbhhpgbljomeellckfbehjmhnf',
    name: 'Screen Shot',
    resource: 'js/dialog.js',
  },
  {
    id: 'eilpgeiadholnidgjpgkijfcpaoncchh',
    name: 'Noota',
    resource: 'icon-32.png',
  },
  {
    id: 'ejeeoonlleiljffabooidiebffmlmigi',
    name: 'Hudu',
    resource: 'index.html',
  },
  {
    id: 'ejendfoehmomnkeedkpmkkcmcalklpcc',
    name: 'Web Capture',
    resource: 'injected/newExtractor.js',
  },
  {
    id: 'ejjohjoianmepamafhpdbbaghdjkfeoe',
    name: 'Translate',
    resource: 'js/popup.js',
  },
  {
    id: 'ejlibkcnbaelmmgmhfklbdmklijneofi',
    name: 'Familycard.be',
    resource: 'assets/close.png',
  },
  {
    id: 'elakilelipikijgcejjfdiiogcjpnngl',
    name: 'Fable',
    resource: 'drawer.html',
  },
  {
    id: 'eljbmlghnomdjgdjmbdekegdkbabckhm',
    name: 'Dart Debug',
    resource: 'debug_info.dart.js',
  },
  {
    id: 'ellkdbaphhldpeajbepobaecooaoafpg',
    name: 'ASI Alliance Wallet',
    resource: 'blocklist.html',
  },
  {
    id: 'elmpkhkdonhdbkeaigkblbgckcihahoc',
    name: 'Gist AI',
    resource: 'pdf.worker.js',
  },
  {
    id: 'eloemnahbeeiekllcfeombpkokhinkpn',
    name: 'Mayday',
    resource: 'assets/style.css',
  },
  {
    id: 'emkcncalbjlddkafaipjclhmmadeoidl',
    name: 'AnyGen Browser Operator',
    resource: 'overlay/glowing-overlay.css',
  },
  {
    id: 'enejkfhimljloggnimhebadbjajhgkad',
    name: 'Tella',
    resource: 'graph.png',
  },
  {
    id: 'enhnhpibeofnhkhcakhmlbmhplfjhnjd',
    name: 'Instant Games',
    resource: 'img/icon.ico',
  },
  {
    id: 'enkmmegahkfbohjlnmmmkiicmhoglnne',
    name: 'Summy',
    resource: 'logo.png',
  },
  {
    id: 'eobbhoofkanlmddnplfhnmkfbnlhpbbo',
    name: 'ChatGPTBox',
    resource: 'logo.png',
  },
  {
    id: 'epjbmmchkjlgmogfoamcleeikmfaffjm',
    name: 'TTCommentExporter',
    resource: 'icon-48.png',
  },
  {
    id: 'fafipkjpodjefcmagnidcibkhlgajann',
    name: 'ChainBox',
    resource: 'inject.js',
  },
  {
    id: 'faieahckjkcpljkaedbjidlhhcigddal',
    name: 'Aliexpress Dropshipping',
    resource: 'assets/images/logo.png',
  },
  {
    id: 'fbccnclbchlcnpdlhdjfhbhdehoaafeg',
    name: 'InstaNote',
    resource: 'logo.png',
  },
  {
    id: 'fbjdfhinnhahheghjajajniekpnghdfa',
    name: '淘宝购物助手极速版',
    resource: '0648cd6c01951b3a123a.svg',
  },
  {
    id: 'fbkkmbebblifoifknelgfijhbpodmlmo',
    name: 'Shopdora',
    resource: 'config.json',
  },
  {
    id: 'fbmgjeedfjegmpjglddhemjjgnfkmkfb',
    name: 'Trading Tools',
    resource: 'sounds/1.mp3',
  },
  {
    id: 'fbmlcbhdmilaggedifpihjgkkmdgeljh',
    name: 'Reader Mode',
    resource: 'html/reader.html',
  },
  {
    id: 'fbnbeocmafoobaeodhmcgnammdeaoglg',
    name: 'Felo',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'fcekakhpgmlaihglgajajbceajnhlgfn',
    name: 'Color Picker and Eye Dropper',
    resource: 'images/clogo.png',
  },
  {
    id: 'fchhipkldmfpfiocdoehmnnkcclmhbpg',
    name: 'WA Contact Extractor & Groups Link Finder',
    resource: 'assets/types-CFQlDXDB.js',
  },
  {
    id: 'fdchdcpieegfofnofhgdombfckhbcokj',
    name: 'Puzzle Wallet',
    resource: 'scripts/inpage.js',
  },
  {
    id: 'febaefghpimpenpigafpolgljcfkeakn',
    name: 'IITC Button',
    resource: 'jsview.html',
  },
  {
    id: 'ffhafkagcdhnhamiaecajogjcfgienom',
    name: 'Smarter RSS',
    resource: 'app/images/16x16.png',
  },
  {
    id: 'ffondjhiilhjpmfakjbejdgbemolaaho',
    name: 'VeWorld',
    resource: 'index.html',
  },
  {
    id: 'fgfiokgecpkambjildjleljjcihnocel',
    name: 'Casper AI',
    resource: 'close-small.51582dd7.svg',
  },
  {
    id: 'fgkhimnkbaccbhigaeoggfbmggdidjjj',
    name: 'Keyword Tracker',
    resource: 'question.svg',
  },
  {
    id: 'fgnjjjimchlhfpaejiaeliciieklhdfj',
    name: 'AliSave - Download AliExpress Images & Videos',
    resource: 'assets/js/utils.js',
  },
  {
    id: 'fhdmbhgpabjkadpaafomaabbdckofphm',
    name: 'HoverNotes',
    resource: 'hn-inject.css',
  },
  {
    id: 'fhdpopfpjekmhiaemmjjbgijbjjnglpi',
    name: 'Vimeo Video Downloader Plus',
    resource: 'update.html',
  },
  {
    id: 'fheifbcbhmbfbebmidanhpeebappbfpd',
    name: 'Ninja Adult Porn Blocker',
    resource: 'blocked.html',
  },
  {
    id: 'fhejipbjcgegljiajehkkinlegflifeg',
    name: 'TEMU工具箱',
    resource: 'manifest.json',
  },
  {
    id: 'fhhnbmkllifmckbpacekbajjhhonakci',
    name: 'HEIC to JPG Converter',
    resource: 'assets/img/icons/logo-48.png',
  },
  {
    id: 'fhiiiglcdobdeaenhmdlodmmjghhmeja',
    name: 'Watch TV',
    resource: 'manifest.json',
  },
  {
    id: 'fiejnpolkeifcohdoehpckibdhgjalgo',
    name: 'UAR_SKT',
    resource: 'icon.png',
  },
  {
    id: 'fifaampimdjablpkjapdjehjcfloecjp',
    name: 'How Many?',
    resource: 'images/info.png',
  },
  {
    id: 'fifbkhhgkgphkjjnjkgdfknbkkgapnca',
    name: 'Fanatical PC Game Price Comparison',
    resource: 'topper.html',
  },
  {
    id: 'fipadnnmmoiomfllhbbnhjnghopkgfpb',
    name: 'Web Monitor',
    resource: 'img/add.png',
  },
  {
    id: 'fjfeeonbeiocojnpfboldpckcgcfknll',
    name: '.torrent to Transmission',
    resource: 'img/icon-large.png',
  },
  {
    id: 'fjohbkcfdceimhfkdcbldnjgdjndnbeg',
    name: '美编助手',
    resource: 'img/qq.svg',
  },
  {
    id: 'fjoigefjdlinileegfbkkbfjjfeldbgb',
    name: 'BrandSearch',
    resource: 'tabs/panel.html',
  },
  {
    id: 'fkakfklkhmjkkehkjchemdgeoldekdml',
    name: 'Free Chess Analysis',
    resource: 'img/48.png',
  },
  {
    id: 'fkaokedhimpifhfadmgjpfjimkogdlcm',
    name: 'Snippet Highlighter',
    resource: 'images/close.png',
  },
  {
    id: 'fkhgpeojcbhimodmppkbbliepkpcgcoo',
    name: 'MetaSuites',
    resource: 'bundle/biz.c928d6a5.js',
  },
  {
    id: 'flacajjkcnlngpeapmnmignmjgddamah',
    name: 'Jira Product Discovery',
    resource: 'content.css',
  },
  {
    id: 'fldcmoidjiplehfmbmhfdpmcgoacjhgc',
    name: 'URL shortener',
    resource: 'favicon.ico',
  },
  {
    id: 'fldmohhnmnjloglcpmclkemepnogaplf',
    name: 'M3U8 Downloaders',
    resource: 'creditWarning.html',
  },
  {
    id: 'flimmmpmnckngfehcfmkfcnpojbofokd',
    name: 'EasyBoss ERP',
    resource: 'images/logo16.png',
  },
  {
    id: 'flnkfbknlpooopiejmcejcldfcffkkcf',
    name: 'Table Detection & Extraction',
    resource: 'logo.png',
  },
  {
    id: 'fmkancpjcacjodknfjcpmgkccbhedkhc',
    name: 'Tweeks',
    resource: 'icons/tweeks-glyph.svg',
  },
  {
    id: 'fmkcdnhkhfnbaomihadamoendclmjglb',
    name: 'Area360',
    resource: 'assets/icon.png',
  },
  {
    id: 'fmnaobbfmjaaaebelkacpmmmpaaefbod',
    name: 'WebSocket DevTools',
    resource: 'src/content/injected.js',
  },
  {
    id: 'fmncmpginchogfdnjfeopdopoiegjjjp',
    name: 'AI Search GPT',
    resource: 'engines.json',
  },
  {
    id: 'fncjhcjfnnooidlkijollckpakkebden',
    name: 'Play to Kodi',
    resource: 'images/tv.png',
  },
  {
    id: 'fndkoopalankcpdahendaibfcldhnfei',
    name: 'Sound Recorder',
    resource: 'src/miv/index.js',
  },
  { id: 'fnliebffpgomomjeflboommgbdnjadbh', name: 'Sublime', resource: 'pdf' },
  {
    id: 'folgjbfgejcliggchmhbbbmdanjjpnai',
    name: 'ChatTube',
    resource: 'offscreen.js',
  },
  {
    id: 'folnjigffmbjmcjgmbbfcpleeddaedal',
    name: 'LogMeOnce',
    resource: 'ui/ui.html',
  },
  {
    id: 'fonaoompfjljjllgccccgjnhnoghohgc',
    name: 'JetBrains Grazie Writing Companion',
    resource: 'fonts/fonts.css',
  },
  {
    id: 'fopaemeedckajflibkpifppcankfmbhk',
    name: 'Alpine.js devtools',
    resource: 'index.html',
  },
  {
    id: 'fpbdcofpbclblalghaepibbagkkgpkak',
    name: 'Lazy Scholar',
    resource: 'js/demo2.js',
  },
  {
    id: 'fpfgglfemmnflnmjminpghmeiajcajoi',
    name: 'Libron',
    resource: 'images/logo.png',
  },
  {
    id: 'gafchcnohalkhohnedifhjblhdhoppkg',
    name: 'СуперКнопка от СберПодбор',
    resource: 'content.css',
  },
  {
    id: 'gahikeojfodidijbfjdfigekphlkcpjm',
    name: 'MyCoub',
    resource: 'js/gif/index.js',
  },
  {
    id: 'gaoiegipmllaihldahegfmgnlnkcplbp',
    name: 'Sidekick',
    resource: 'hubspot_in_page.js',
  },
  {
    id: 'gbcidhndggjlgichmgddokokdfinjaop',
    name: 'Gmail Email Thread Reverse',
    resource: 'js/runtime/content.js',
  },
  {
    id: 'gbcmfinnjfigkegmhplcpfflfkkjpgbm',
    name: 'ScribbleVet Browser Companion',
    resource: 'purify.4734984f.js',
  },
  {
    id: 'gbdnkkaljjonpfgjhdfolnddpeecheak',
    name: 'ShopLook Clipper',
    resource: 'templates/events.js',
  },
  {
    id: 'gbhoepimmkeinmlojkmkpipcooeennmk',
    name: 'MillionPugs',
    resource: 'icon-16.png',
  },
  {
    id: 'gbpjnjieenljpncojgiboejmolbihdob',
    name: 'Thumbnail Grabber',
    resource: 'src/content-script.css',
  },
  {
    id: 'gccfnphpieojibjmnodiiobdapckkkfb',
    name: 'Hamty.cz doplněk',
    resource: 'favicon.png',
  },
  {
    id: 'gcdbpcjiohoillgcokkbccpeihaplpnp',
    name: 'Skipa',
    resource: 'css/content.css',
  },
  {
    id: 'gcdeggbbhghacnodhgdffajmijjkknbi',
    name: 'Detect Auto',
    resource: 'icon/16.png',
  },
  {
    id: 'gdeceopaalhefhbplbibdcmjfkdmkggp',
    name: 'Convert File',
    resource: 'manifest.json',
  },
  {
    id: 'gdnhngmilhhebigaokmniikdlcjbcbhg',
    name: 'Moolah',
    resource: 'assets/logo.png',
  },
  {
    id: 'gdokollfhmnbfckbobkdbakhilldkhcj',
    name: 'Alephium Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'gdppneahgoimmcphlekpanoekkefhjhc',
    name: 'Lootup Deal Finder',
    resource: 'icons/logo.png',
  },
  { id: 'gegkcggjmenokbomfkhbhnphfkoejhof', name: 'IDM', resource: 'icon.png' },
  {
    id: 'gehplcbdghdjeinldbgkjdffgkdcpned',
    name: 'Cookie Clicker Mod Manager',
    resource: 'src/mainModLoader.js',
  },
  {
    id: 'gfdldleopmcdjppengcjkpfafjhcabpj',
    name: 'Trackerbot',
    resource: 'images/trackerbot/tb-icon.png',
  },
  {
    id: 'gfecljmddkaiphnmhgaeekgkadnooafb',
    name: 'Summary with ChatGPT for Google and YouTube',
    resource: 'logo.png',
  },
  {
    id: 'gfjgjekaeebjccpnaeeeleeadfiledpm',
    name: 'JoomPulse',
    resource: 'assets/index-BL8GwZK_.js',
  },
  {
    id: 'gggnmagjmfbiedajbiccdpfffjljpepg',
    name: 'MIB',
    resource: 'elements.js',
  },
  {
    id: 'gghlgcihlfpfbibgaffggbmidpfejbbb',
    name: 'AiPrice(AliPrice) Search by Image for China Import Beta',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ggiihlkbikggfknjgbocmogobagckdpc',
    name: 'URL Extractor',
    resource: 'icons/16x16.png',
  },
  {
    id: 'ggojliohohbachojmcgelnjmnjmjgidn',
    name: 'Password Depot',
    resource: 'icons/add.svg',
  },
  {
    id: 'ghdoangbdengbkokhihepcjgdkdogcdi',
    name: 'Cashdo',
    resource: 'images/16.png',
  },
  {
    id: 'ghibhnffgbldpjefpicbgcnbelfjkcjb',
    name: '이커머스 AI 솔루션',
    resource: 'popup.html',
  },
  {
    id: 'ghjakbehlhkjdiehaeffedomkakcenjo',
    name: 'Browse.live Web Safety',
    resource: 'notification.js',
  },
  {
    id: 'ghncoolaiahphiaccmhdofdfkdokbljk',
    name: 'DIAM Wallet',
    resource: 'src/injector/injector.js',
  },
  {
    id: 'ghnjojhkdncaipbfchceeefgkkdpaelk',
    name: 'ESale',
    resource: 'icons/home.png',
  },
  {
    id: 'ghomdadknicogbgmflkamaligpfalfng',
    name: '蜗牛下载助手',
    resource: 'ffmpeg/util.js',
  },
  {
    id: 'gieabiemggnpnminflinemaickipbebg',
    name: 'CSS Scan',
    resource: 'icon.png',
  },
  {
    id: 'giompennnhheakjcnobejbnjgbbkmdnd',
    name: 'Swoosh',
    resource: 'popup/index.html',
  },
  {
    id: 'gjbbmdlgdiammllkjmpfmdjnbdllgjip',
    name: 'Fullstar guide editor',
    resource: 'iframe_content.html',
  },
  {
    id: 'gjchkclnmcncgghabinakceociblfoik',
    name: 'Pixefy',
    resource: 'iframe.css',
  },
  {
    id: 'gjikiofhelajcmedmillinbcmhmjcnpe',
    name: 'Shorts scroller, works with Youtube [QVI]',
    resource: 'times-solid.svg',
  },
  {
    id: 'gjjhmphibjpmjbeghgjgecennojdohgc',
    name: 'Quick Snip',
    resource: 'newTab.html',
  },
  {
    id: 'gjkdbeaiifkpoencioahhcilildpjhgh',
    name: 'Parti Wallet',
    resource: 'dom.js',
  },
  {
    id: 'gjnhndokinnjflffkoppgkphkpipojgm',
    name: 'WebBrush',
    resource: 'images/eraser.png',
  },
  {
    id: 'gjoimbbkllocghfkbjdfjeakcgnkglgd',
    name: 'VisiOS',
    resource: 'index.css',
  },
  {
    id: 'gjponoohlplibjdnjnbnhbjljffpkkok',
    name: 'Presenter Cursor',
    resource: 'css/fontawesome-webfont.woff',
  },
  {
    id: 'gkdekajjngdkocgiealohleibhdjhoed',
    name: 'Torii Image Translator',
    resource: 'css/main.css',
  },
  {
    id: 'gklilelpemfocehaklnbninplkkokgdn',
    name: '판다랭크',
    resource: 'icon-34.png',
  },
  {
    id: 'gljombomchjbpjchjdimmfnhilmgocjn',
    name: 'Zoho Sheet',
    resource: 'web_accessible_resources/ZSNewFile.js',
  },
  {
    id: 'glklbjgdbdmlmjomcdhmjjklkeoghihh',
    name: 'Speak!',
    resource: 'iframe.js',
  },
  {
    id: 'glkmdbkjgjeacahocnjkglbpiagfgeko',
    name: 'Email Tracker for Gmail',
    resource: 'icon-34.png',
  },
  {
    id: 'gloodibamhhfeodllcjhkdnlgcbihlcp',
    name: 'Ranorex Automation',
    resource: 'msgport.js',
  },
  {
    id: 'gmechnknnhcmhlciielglhgodjlcbien',
    name: 'SessionBox One',
    resource: 'pages/frame.html',
  },
  {
    id: 'gmegpkknicehidppoebnmbhndjigpica',
    name: 'Web2FA',
    resource: 'shared/otp.js',
  },
  {
    id: 'gmgldnaadbkmkanlgdhohbfddgkhjfng',
    name: 'Custom Progress Bar',
    resource: 'assets/content.css',
  },
  {
    id: 'gmmobojefonhonfekpdeajdjhkdbmgcn',
    name: 'Sellerise for Amazon Sellers',
    resource: 'images/48.png',
  },
  {
    id: 'gnemoflnihonmkiacnagnbnlppkamfgo',
    name: 'Word Replacer Max',
    resource: 'assets/img/wand-icon.png',
  },
  {
    id: 'gneobebnilffgkejpfhlgkmpkipgbcno',
    name: 'No New Tabs',
    resource: 'inject.js',
  },
  {
    id: 'gnooopplnmndieoelbagclpobcppknbo',
    name: 'Neuralwriter',
    resource: 'app.js',
  },
  {
    id: 'gnpglhdhioifppkjdpmlmolgeanpaofi',
    name: 'ZDialer',
    resource: 'images/sms.svg',
  },
  {
    id: 'gnplpcfnikehohdgnfnfcienljcbaogj',
    name: 'MeowLoad',
    resource: 'icon.c766bb78.png',
  },
  {
    id: 'godiecgffnchndlihlpaajjcplehddca',
    name: 'GhostText',
    resource: 'options.js',
  },
  {
    id: 'godnhdhhojjcchmgkcgcajpgcbbmhbmn',
    name: 'QUITTR',
    resource: 'blocked.html',
  },
  {
    id: 'gofbkgfgjgkmphjcfgbmdelmamlnhcnh',
    name: 'Black Friday de Verdade',
    resource: 'index.css',
  },
  {
    id: 'gpmgkanebgbahkpdkiamedclngmdbbdd',
    name: 'AliExpress Business',
    resource: 'src/public/ok.svg',
  },
  {
    id: 'gpnihlnnodeiiaakbikldcihojploeca',
    name: 'NUFI',
    resource: 'assets/c-v4-DSH-BVsJ.js',
  },
  {
    id: 'gpolcofcjjiooogejfbaamdgmgfehgff',
    name: 'Web Scraper',
    resource: 'pixel.gif',
  },
  {
    id: 'haafigbapbpbpnmgcknnmilaaaimggpk',
    name: 'FuseBase Assistant',
    resource: 'assets/flex.css',
  },
  {
    id: 'hamhaljjdpcgkelbadepgmnocknejief',
    name: 'Grammar.com',
    resource: 'popup.html',
  },
  {
    id: 'hapcnpnopbmifahnnehfcncojejoiefn',
    name: 'Tailored Notion',
    resource: 'assets/popup.css',
  },
  {
    id: 'hapgiopokcmcnjmakciaeaocceodcjdn',
    name: 'ReCaptcha Solver',
    resource: 'icons/icon.png',
  },
  {
    id: 'hchobocdmclopcbnibdnoafilagadion',
    name: '文章同步助手',
    resource: 'inject-api.js',
  },
  {
    id: 'hcjmcpfahioghphbgfokmijhkccofkci',
    name: 'SideAI',
    resource: 'icons/copy.svg',
  },
  {
    id: 'hcmiiaachajoiijecmakkhlcpagafklj',
    name: 'ChatsNow',
    resource: 'pay.html',
  },
  {
    id: 'hdhclckbeelgahmklefjjnpmhbljhcmd',
    name: 'Istoric Preturi',
    resource: 'img/icon.png',
  },
  {
    id: 'hdlmphmmpjldffeiokafhkchgelphphf',
    name: 'Get Facebook Cookies & Access Token',
    resource: 'libs/bootstrap/css/bootstrap.min.css',
  },
  {
    id: 'hdpfnbgfohonaplgnaahcefglgclmdpo',
    name: 'Shopify Raise',
    resource: 'img/tip.png',
  },
  {
    id: 'hdpoplemgeaioijkmoebnnjcilfjnjdi',
    name: 'LiveHosts',
    resource: 'popup/popup.html',
  },
  {
    id: 'heakbijbjdlpkklmplhmnhieollhoicg',
    name: 'VK video downloader',
    resource: 'popup.js',
  },
  {
    id: 'hengddlmmobpckpmaalbmdlofpiljnon',
    name: 'Ask Gemini',
    resource: 'src/search_popup/popup.html',
  },
  {
    id: 'hepadpmfkndambfklhlhihoojmcbeicg',
    name: 'Font finder',
    resource: 'assets/pictos/logo.svg',
  },
  {
    id: 'hfajfpbjlmembfdlhakjmefnbhjddofb',
    name: 'ION Wallet',
    resource: 'provider.js',
  },
  {
    id: 'hgajpakhafplebkdljleajgbpdmplhie',
    name: 'Console Importer',
    resource: 'assets/importer.js',
  },
  {
    id: 'hgjcdbncdjkhpmdijaigkmgbkjecpopj',
    name: 'YouTube Subtitle Dubbing and Web Page Reader',
    resource: 'settings.css',
  },
  {
    id: 'hglnindfakmbhhkldompfjeknfapaceh',
    name: 'AuRo',
    resource: 'content/index.js',
  },
  {
    id: 'hhaepbijcbdhljbjocbilefdhnkngehp',
    name: 'Screenshot',
    resource: 'editor.html',
  },
  {
    id: 'hhcnhfijbipicmidjbommlhmnehkocik',
    name: 'Search & Chat AI',
    resource: 'js/toolbar.js',
  },
  {
    id: 'hhnhckmflikggaddmmcpgoehmnpnlglk',
    name: 'Streak Mail Merge for Gmail',
    resource: 'blank.png',
  },
  {
    id: 'hielpjjagjimpgppnopiibaefhfpbpfn',
    name: 'Symantec Browser Protection',
    resource: 'sep.png',
  },
  {
    id: 'hiomakjbdlimgpanofghgneajckhejpj',
    name: 'AdBlock Lite',
    resource: 'assets/static/64.png',
  },
  {
    id: 'hjdmhfbgpdkkdfgjfiknaacjfjljpblc',
    name: 'Language Reactor transformed',
    resource: 'manifest.json',
  },
  {
    id: 'hjkacojcnmnchcllgdfiepfjfplnofol',
    name: 'Benable',
    resource: 'popup.html',
  },
  {
    id: 'hjpiaciaipkcfelgboiijjgpeoocjmdh',
    name: 'VetRec',
    resource: 'auth.78198cb5.js',
  },
  {
    id: 'hkcgjbeblifaincobbcfiffbpgoafepk',
    name: 'SiYuan',
    resource: 'lib/mathjax.js',
  },
  {
    id: 'hkhjfcfonfkhnpcpkhpbpmplnlcpcldh',
    name: 'Web for Google Messages',
    resource: 'img/icon.ico',
  },
  {
    id: 'hkknejecoekbededhhhmencnobomannp',
    name: 'weblock',
    resource: 'login.html',
  },
  {
    id: 'hkmgmmaopoofgchofbngplopnhajbojc',
    name: 'Kabeen',
    resource: 'assets/img.png',
  },
  {
    id: 'hldkiepdcdeibnadnpiekpbdgbgbalob',
    name: 'JSON格式化工具',
    resource: 'js/utils.js',
  },
  {
    id: 'hlfkpachlhdpphhleifjkllcmklbaljp',
    name: 'Write on PDF',
    resource: 'icons/16x16.png',
  },
  {
    id: 'hlkajbcfhlhkdhpkmbcopjooblpmmaka',
    name: 'ARCON Browser Extension',
    resource: 'images/up.svg',
  },
  {
    id: 'hlkapcocmflflbmafddbicdnnmnpbfeg',
    name: 'Verified First',
    resource: 'src/app/tat.js',
  },
  {
    id: 'hloenmdpelegipdbonkepcnbapniondo',
    name: 'DealCloud',
    resource: 'environments.js',
  },
  {
    id: 'hmbjohbggdnlpmokjbholpgegcdbehjp',
    name: 'shikicinema',
    resource: 'main.js',
  },
  {
    id: 'hnjjdepbmnadojpcicgkiffnlpmbhkpn',
    name: 'Spoon AI',
    resource: 'icons/icon16.png',
  },
  {
    id: 'hnlnjfenbaiflgkdncofionfhnhmoono',
    name: 'Visual Web Scraper',
    resource: 'main.js',
  },
  {
    id: 'hohjiogaaddpcpakfaegfacbaggphald',
    name: 'TextRecruit',
    resource: 'iframe.html',
  },
  {
    id: 'hoknogdfolliknmnnglffgmfflcdpdih',
    name: 'OCR Image to text',
    resource: 'data/engine/index.html',
  },
  {
    id: 'hpclkefagolihohboafpheddmmgdffjm',
    name: 'Flow Wallet',
    resource: 'script.js',
  },
  {
    id: 'hpenfopogkamibjfobmdbdclpefokejk',
    name: 'superReply',
    resource: 'img/logo.png',
  },
  {
    id: 'hpoamafhefaahkmghebfnbbhpjjohgeh',
    name: 'Dark Mode Ultra',
    resource: 'icons/inactive.png',
  },
  {
    id: 'iaalpfgpbocpdfblpnhhgllgbdbchmia',
    name: 'Asciidoctor.js Live Preview',
    resource: 'js/loader.js',
  },
  {
    id: 'iaanigfbldakklgdfcnbjonbehpbpecl',
    name: 'Habitica Pomodoro SiteKeeper',
    resource: 'audio/Sound1.mp3',
  },
  {
    id: 'iakojhpeaoimjhbaelkgbdahchckiieg',
    name: 'Coquette Bows',
    resource: 'images/bow.png',
  },
  {
    id: 'ibahpmhifmnedoegjcgdcidnmnpnbgmp',
    name: 'SmartVision',
    resource: 'lib/iframe.html',
  },
  {
    id: 'ibjkchlgohjlooedohknollbncbejgdn',
    name: 'vk downloader',
    resource: 'src/auth/app.vue',
  },
  {
    id: 'ibmhijpaejbhbhdddifhgpdogoapclgj',
    name: 'Watch Movies Online',
    resource: 'manifest.json',
  },
  {
    id: 'ibpblblmnbacppfjpbihbbfocconkelo',
    name: 'Color Code Finder',
    resource: 'js/index.js',
  },
  {
    id: 'icbjhddacebbblejjeanbacenkopkple',
    name: 'Rewards Search Automator Old',
    resource: 'style.css',
  },
  {
    id: 'icblpoalghoakidcjiheabnkijnklhhe',
    name: 'PIP',
    resource: 'js/854.js',
  },
  {
    id: 'icchadngbpkcegnabnabhkjkfkfflmpj',
    name: 'Translator',
    resource: 'js/core.js',
  },
  {
    id: 'ichmnigkjinmjedillldopaolidofben',
    name: 'Findymail',
    resource: 's_inj.js',
  },
  {
    id: 'icllkfleeahmemjgoibajcmeoehkeoag',
    name: 'Adyen Test Cards',
    resource: 'data/ibans.json',
  },
  {
    id: 'icpgekloenpkdgbbjnmjddbcmjglflkj',
    name: 'Proxy Switcher',
    resource: 'popup.css',
  },
  {
    id: 'idgjpjkoddplmbdepekendpdbaibcgpc',
    name: 'Unfolks',
    resource: 'smiley.svg',
  },
  {
    id: 'idipjdgkafkkbklacjonnhkammdpigol',
    name: 'Crowdly',
    resource: 'src/styles.css',
  },
  {
    id: 'iefankigbnlnlaolflbcopliocibkffc',
    name: 'Wavenet',
    resource: 'assets/styles.css',
  },
  {
    id: 'ieimachclakgpglmhafclnfklklomfeh',
    name: 'Read Pronunciation',
    resource: 'WinkTagger.js',
  },
  {
    id: 'iejcbdponpipehjlchccknbmnkonnmji',
    name: 'Kimi 阅读助手',
    resource: 'tabs/sidepanel.html',
  },
  {
    id: 'ifahhglhacgndllhcinedlhkedehdiec',
    name: 'Double',
    resource: 'pdf.worker.min.9b40d155.js',
  },
  {
    id: 'ifckdpamphokdglkkdomedpdegcjhjdp',
    name: 'ONTO Wallet',
    resource: 'icon16.png',
  },
  {
    id: 'ifebedegonbbimebaojpnhhhihdgjben',
    name: 'IG Sorter',
    resource: 'side.js',
  },
  {
    id: 'ifijiokgalnlacohanefljklpbfoeipl',
    name: 'GRIN Creator Discovery',
    resource: 'assets/Storage-cDh9pLBt.js',
  },
  {
    id: 'ifjhcahbhkfojdmkndpkmkffbjnefido',
    name: 'Cookie Guard',
    resource: 'img/icon48.png',
  },
  {
    id: 'ifkbafcmimmmblgjjlkfdipcopplcokh',
    name: 'Spaceboard',
    resource: 'images/ai.png',
  },
  {
    id: 'igajbpknpbdaknnmhpbolfidbhcdfokg',
    name: 'Unicorn Smasher',
    resource: 'popup.html',
  },
  {
    id: 'igcjdamjhkmdccbmbilbpabpofenchge',
    name: 'iGive Button',
    resource: 'fonts.css',
  },
  {
    id: 'igimfdmnnijclcfdgimooedbealfpndj',
    name: 'xMetaCene',
    resource: 'inpage.js',
  },
  {
    id: 'igiofjnckcagmjgdoaakafngegecjnkj',
    name: 'Debug CSS',
    resource: 'styles.css',
  },
  {
    id: 'igkmdomcgoebiipaifhmpfjhbjccggml',
    name: 'AEM Sidekick',
    resource: 'log.js',
  },
  {
    id: 'igoginokckmjjoaohbimmglmbbdnhfoi',
    name: 'CapturePro Camera',
    resource: 'popup.css',
  },
  {
    id: 'ihcaopdjcjhmjlnocckpbhkmdamhalii',
    name: 'VidDown',
    resource: 'assets/bus.js',
  },
  {
    id: 'ihgfdecdmhcckcnlhgfciplpbpmmjmdl',
    name: 'cxai',
    resource: 'assets/images/dockLogo.png',
  },
  {
    id: 'ihphookhabmjbgccflngglmidjloeefg',
    name: 'TSA',
    resource: 'wa/mgknz.gif',
  },
  {
    id: 'iiekfaemafmplemocgimeccahephhdgf',
    name: 'VratnePenize.cz',
    resource: '16x16.png',
  },
  {
    id: 'iihamopomflffiecicbgelncanmfionp',
    name: 'Writingmate',
    resource: 'chat.html',
  },
  {
    id: 'iiikmhonbbmbdjfokdmmncdohjionkmf',
    name: 'Homework Solver',
    resource: 'images/x.svg',
  },
  {
    id: 'iiljidcefnbhbpamageahhblhbbhhopm',
    name: 'Twitch Live',
    resource: 'images/icon.png',
  },
  {
    id: 'iimcimpbdndjaidollhipbkjilpnmfnh',
    name: 'Course Hero',
    resource: 'img/icon-72.png',
  },
  {
    id: 'iinmigjlcpeckfihbbfajpkiilfmakff',
    name: 'Anara Web Clipper',
    resource: 'pdf-fetcher.js',
  },
  {
    id: 'ijalkjdhnpnjlhhcebglepaokobbaikc',
    name: 'Video Recorder',
    resource: 'camera.js',
  },
  {
    id: 'ijaopicbldggjdgbnfdlkljeggibmcha',
    name: 'Print Notion',
    resource: 'pages/index.css',
  },
  {
    id: 'ijbmkpeacbkgpfkomjbionjgdhbmlpfp',
    name: 'View Menu with Prices',
    resource: 'manifest.json',
  },
  {
    id: 'ijdolajanhahfboifbajbgiofkmgkljn',
    name: 'Tipli',
    resource: 'serp.js',
  },
  {
    id: 'ilkodijinjhpdnnfpccijledlapkfmhc',
    name: 'Next Experience Developer Tools',
    resource: 'worker.js',
  },
  {
    id: 'ilmoodhbpigjdbegjgocjildgajgmema',
    name: 'Sound Booster VMax',
    resource: 'assets/switcher.css',
  },
  {
    id: 'imcfjlaadnlgoipeponeoggcgdonkbjo',
    name: 'CR7 MeaVana',
    resource: '128x128.png',
  },
  {
    id: 'imemciokfejbnonkkinhcdfigdilcllg',
    name: 'EqualWeb Accessibility Checker',
    resource: 'lib/axe.min.js',
  },
  {
    id: 'imhbnbhffmfkipopfgdbgbkhcmfelkjg',
    name: 'WalterPicks League Sync',
    resource: 'assets/js/root.BwofpW08.js',
  },
  {
    id: 'indcipieilphhkjlepfgnldhjejiichk',
    name: 'NoteGPT',
    resource: 'logo.png',
  },
  {
    id: 'indpljpndioefdhmhafebdcddigbogbn',
    name: 'Privacy Tweaks',
    resource: 'data/content_script/tweaks/font.js',
  },
  {
    id: 'infnlhnhibphpaljmnnadaldibggkokb',
    name: 'JSON Pro',
    resource: 'sidebar/sidebar.js',
  },
  {
    id: 'injnkmmecojnjiiojgfgonihjpejklik',
    name: 'Zoom Contact Center CTI',
    resource: 'script.js',
  },
  {
    id: 'inledacgphbcoihlbhmnkkbkgmjldbbi',
    name: 'Auto Clicker',
    resource: 'popup.html',
  },
  {
    id: 'inlkhilmjmjomfcpdifpfgllhhlpnbej',
    name: 'Unielon',
    resource: 'pageProvider.js',
  },
  {
    id: 'ioimcileegaodabmbcnadppghhakneae',
    name: 'MindPane',
    resource: 'styles/print.min.css',
  },
  {
    id: 'iokmjpkdnkhnihbahocbjohhdnkkiphh',
    name: 'EaseMate',
    resource: 'assets/arc-BRyLdTxW.js',
  },
  {
    id: 'ipafcflbnpkfahilfblbenfabkoaaiid',
    name: 'URL Shortener for Amazon',
    resource: 'assets/content.ts-D0vUgW_Q.js',
  },
  {
    id: 'ipajmhlcmempmnedocmbalcbbmhgheca',
    name: 'Passwork',
    resource: 'own.js',
  },
  {
    id: 'ipfnfcbfkddglfeiplmmfkcidaeaenjk',
    name: 'LKTips',
    resource: 'dictionary.json',
  },
  {
    id: 'ipgfpphpkjihbkdbgphijecdknjcchnm',
    name: 'UserAuthGuard Chromebook Monitor',
    resource: 'wizard.js',
  },
  {
    id: 'ipocdfgahhjaigldllakopnkofpcpahn',
    name: 'Qsirch Helper',
    resource: 'inject/frame.html',
  },
  {
    id: 'jafhnonicoamhlkkpnmidenllpcccake',
    name: 'Package Tracker',
    resource: 'manifest.json',
  },
  {
    id: 'jajoopnifcliapcngocgiidifkmboemc',
    name: 'PS Utilities',
    resource: 'options.html',
  },
  {
    id: 'jbcklblmgdbpagndcggcjnhnoocibnmk',
    name: 'Twitch Stats by Streams Charts',
    resource: 'src/content-script/index.ts',
  },
  {
    id: 'jbeooomlnkgbokicnpcabkpnacabjnbm',
    name: 'Copy To Notion',
    resource: 'ScreenCapture.js',
  },
  {
    id: 'jbjngahjjdgonbeinjlepfamjdmdcbcc',
    name: 'AI Content Visibility Checker',
    resource: 'fonts.css',
  },
  {
    id: 'jbnammhjiplhpjfncnlejjjejghimdkf',
    name: 'Anytype Web Clipper',
    resource: 'iframe/index.html',
  },
  {
    id: 'jbppfhkifinbpinekbahmdomhlaidhfm',
    name: 'iWallet Pro',
    resource: 'injected.js',
  },
  {
    id: 'jcbjcocinigpbgfpnhlpagidbmlngnnn',
    name: 'Adblock for Browser',
    resource: 'assets/yt-main.js',
  },
  {
    id: 'jcdheojflbakgpllgipljegddpfaofec',
    name: 'Shop for a Cause',
    resource: 'auth.html',
  },
  {
    id: 'jcnahjejlakfnapaldiddimmjbllpjan',
    name: 'Notebooklm Web Importer',
    resource: 'content.css',
  },
  {
    id: 'jdbliieklfhihjpmhhekcoldpcemlafj',
    name: 'block site',
    resource: 'data/interface/redirect.html',
  },
  {
    id: 'jdecachbikbkppkpjjgdmdghgdfffibi',
    name: 'NetSuite Utils',
    resource: 'Util Modules/SuiteQL Runner/Libs/sql.js',
  },
  {
    id: 'jdepgjdjpmpjljfdcmnbjmafkbckkhko',
    name: 'TradingView Strategy Finder',
    resource: 'js/functions.js',
  },
  {
    id: 'jdiegbdfmhkofahlnojgddehhelfmadj',
    name: 'Genius PRO',
    resource: 'main.js',
  },
  {
    id: 'jdjbiojkklnaeoanimopafmnmhldejbg',
    name: 'Copycat',
    resource: 'copycat.js.map',
  },
  {
    id: 'jdliiagcaloddeneiaofnaifmckpgccd',
    name: 'Capacities',
    resource: 'popup.html',
  },
  {
    id: 'jdplopdpfhclmeobebhjcehomoofhfpg',
    name: 'Autofill Taobao Tracking',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'jeablngoapekimaeoeclgcefdcpjhjcg',
    name: 'hireEZ',
    resource: 'pageWorld.js',
  },
  {
    id: 'jebapbhanimlfnddnammimbopafiddkd',
    name: 'Zia Search',
    resource: 'js/ja.js',
  },
  {
    id: 'jedldboappegkmmkkmgempjffkpbopcg',
    name: 'Follower Exporter',
    resource: 'injected.js',
  },
  {
    id: 'jefmonmbihnpfebehladbckmmfjncabp',
    name: 'STUDY4',
    resource: 'frame.html',
  },
  {
    id: 'jekhhoflgcfoikceikgeenibinpojaoi',
    name: 'docu.md Markdown Viewer',
    resource: 'core/main.js',
  },
  {
    id: 'jfcnoffhkhikehdbdioahmlhdnknikhl',
    name: 'SnapTrans Translate',
    resource: 'icons/copy.svg',
  },
  {
    id: 'jffaiidojfhflballoapgofphkadiono',
    name: 'eesel',
    resource: 'box.png',
  },
  {
    id: 'jgchgjafcgjngogbfljkiclifglkemgj',
    name: 'CSGOFLOAT',
    resource: 'charm.js',
  },
  {
    id: 'jgcndlaikgkhpbcekabcmnfeiaelgaon',
    name: 'MeetGeek',
    resource: 'silence_audio.mp4',
  },
  {
    id: 'jglleggplbpnldiciklliilcphefponm',
    name: 'fontDownloader',
    resource: 'scripts/content.js',
  },
  {
    id: 'jgnejnfdbomaelibbccppknilnnhklnk',
    name: 'CamFlip',
    resource: 'filter_cam.js',
  },
  {
    id: 'jhajnkdohbhjfffcdlchmmicikobmiaj',
    name: 'Sticker Mania',
    resource: 'js/content.js',
  },
  {
    id: 'jhjpjhhkcbkmgdkahnckfboefnkgghpo',
    name: 'toolbox',
    resource: 'data/images/balloon.png',
  },
  {
    id: 'jhkeieglkjflimimljpaenphjhkbcieh',
    name: 'MyWallPaper',
    resource: 'css/style.css',
  },
  {
    id: 'jhmpcopkebhhagjfmobglpohomllacfd',
    name: '구매대행 이미지 다운로더',
    resource: 'logo.png',
  },
  {
    id: 'jihpdpemfgeiadejflpafaghifggjcod',
    name: 'SALMI TAHAR AMATTI v2',
    resource: 'core/db/conn.js',
  },
  {
    id: 'jilklolagcklamdeceklgibonaplbmbh',
    name: 'uTorrent',
    resource: 'icon96.png',
  },
  {
    id: 'jjikmbicpomagidbcllljdgpphbelmmi',
    name: 'Ringover Dialer',
    resource: 'icons/star.png',
  },
  {
    id: 'jjjlikhinlnggfgmjhcnhibkmcjcmiej',
    name: 'FoxyClick',
    resource: 'icon128.png',
  },
  {
    id: 'jjlelpahdhfgabeecnfppnmlllcmejkg',
    name: 'Umbra Dark Mode',
    resource: 'js/proxy.js',
  },
  {
    id: 'jjplaeklnlddpkbbdbnogmppffokemej',
    name: 'CrowdScrape',
    resource: 'content.js',
  },
  {
    id: 'jjplpolfahlhoodebebfjdbpcbopcmlk',
    name: 'Nily',
    resource: 'src/assets/logo.png',
  },
  {
    id: 'jkapbnoclmpnedficnpggdkobboijimp',
    name: 'QuickSkip',
    resource: 'js/background.js',
  },
  {
    id: 'jkennnbhkennnbeebfonckakbodfaldk',
    name: 'Duden-Mentor',
    resource: 'main.bundle.js.map',
  },
  {
    id: 'jlcdjppbpplpdgfeknhioedbhfceaben',
    name: '퍼센티',
    resource: 'Stop.svg',
  },
  {
    id: 'jldogdgepmcedfdhgnmclgemehfhpomg',
    name: 'Retriever',
    resource: 'content.css',
  },
  {
    id: 'jlffehhlfkdbdheffcaekpmkhfphmhpg',
    name: 'Wildmonkey',
    resource: 'main.js',
  },
  {
    id: 'jlkikimlceonbmfjieipbonnglnlchhl',
    name: 'SuperDev',
    resource: 'icons/icon16.png',
  },
  {
    id: 'jlkmjnjncpcplnajcbibddpkmbficecj',
    name: 'Telegram Blur',
    resource: 'css/name.css',
  },
  {
    id: 'jlmkillmemkjkinffglnffekacoogndm',
    name: 'LinkFox',
    resource: 'fox-bridge.js',
  },
  {
    id: 'jmbjlhnlibdfompahnfionljdfeeipdb',
    name: 'Mais Barato PROTESTE',
    resource: 'index.css',
  },
  {
    id: 'jmdcpkpoebniclenaegfhbmlaadkgdhm',
    name: 'Подборка-Туров.ру',
    resource: 'css/tour-row.css',
  },
  {
    id: 'jmefikbdhgocdjeejjnnepgnfkkbpgjo',
    name: 'Material DevTools',
    resource: 'assets/icons/Space.svg',
  },
  {
    id: 'jmgdfadbljfhdjjkbofjnflaigadpdid',
    name: 'YouTube Dark Mode',
    resource: 'data/icons/disabled/32.png',
  },
  {
    id: 'jnffopdghacfibgkllcbgfnldclpnbbb',
    name: 'OZONBIGSELL',
    resource: 'icon/16.png',
  },
  {
    id: 'jnhiookaaldadiimlgncedhkpmhlmmip',
    name: 'Tabme',
    resource: 'newtab.html',
  },
  {
    id: 'jnmcpmfimecibicbojhopfkcbmkafhee',
    name: 'readeck',
    resource: 'oauth-callback.html',
  },
  {
    id: 'joflojehbdajphljkcggpmajnoibdaio',
    name: 'Email Extractor',
    resource: 'injected.js',
  },
  {
    id: 'joggkdfebigddmaagckekihhfncdobff',
    name: 'Le Git Graph',
    resource: 'js/authInject.js',
  },
  {
    id: 'jojaomahhndmeienhjihojidkddkahcn',
    name: 'Forensic OSINT Full Page Screen Capture',
    resource: 'wasm/README.md',
  },
  {
    id: 'jonlhhmennanlmjjamfllhlcklggpjkj',
    name: 'Rocketrip',
    resource: 'assets/icon.png',
  },
  {
    id: 'jpapacafnlibgcdaeaefjfeipibmdngh',
    name: 'Qwintry Shophelp',
    resource: 'scripts/md5.js',
  },
  {
    id: 'jphdkcjkapjfojcjajeeomimmihnghjp',
    name: 'Dyslexie Font',
    resource: 'assets/logo/logo.png',
  },
  {
    id: 'jplochopoaajoochpoccajmgelpfbbic',
    name: 'Twake Pass',
    resource: 'images/icon38.png',
  },
  {
    id: 'kablckeallljpgnkaifaeckgkaejhpjp',
    name: 'Page Marker',
    resource: 'main.css',
  },
  {
    id: 'kadokpknocdadnipihnphaaabanedjnb',
    name: 'DragApp',
    resource: 'assets/img/48.png',
  },
  {
    id: 'kajbojdeijchbhbodifhaigbnbodjahj',
    name: 'SimplyTrends',
    resource: 'entry.js',
  },
  {
    id: 'kajgpmmnnohnlajonknigghinhjmmehc',
    name: 'Clear cookies for one site',
    resource: 'images/48x48.png',
  },
  {
    id: 'kaojpaiamdloeidjmdonckhfefggpflp',
    name: 'BuxMoney',
    resource: 'icon48.png',
  },
  {
    id: 'kbhaffhbhcfmogkkbfanilniagcefnhi',
    name: 'Jarvis AI Assistant',
    resource: 'buildDomTree.js',
  },
  {
    id: 'kbhgdbfkbgkokgkkdhnnlmkhnokjmfib',
    name: 'JobWizard',
    resource: 'css/ads.css',
  },
  {
    id: 'kbpfgmdeadapkkgjealalfgkmoaehiic',
    name: 'Custom Mouse',
    resource: 'assets/logo_32.png',
  },
  {
    id: 'kchocjcihdgkoplngjemhpplmmloanja',
    name: 'IPBurger Proxy & VPN',
    resource: 'icons/flags/mq.png',
  },
  {
    id: 'kchofibfnlabofiejaeodpgnhhcajjlj',
    name: 'YouLearn',
    resource: 'public/logo.png',
  },
  {
    id: 'kcjeghjjjjdpeaoemlhdhnbbkpgncpfc',
    name: 'Dedalium',
    resource: 'icons/icon_1.png',
  },
  {
    id: 'kcjkmcmcpompphkoaokebhhhindnfpnp',
    name: 'Vento',
    resource: 'favicon.png',
  },
  {
    id: 'kdamfjkjgaidaigdfelkpgdnbigclccc',
    name: 'Lingvanex',
    resource: 'frame/popup.html',
  },
  {
    id: 'kddaagffkajgikddjngfbfblhcgmmlid',
    name: 'Friend Maker',
    resource: 'popup.html',
  },
  {
    id: 'kdfngfkkopeoejecmfejlcpblohnbael',
    name: 'CpyOnSlc',
    resource: 'Res/copied.svg',
  },
  {
    id: 'kdnllijdimhbledmfdbljampcdphcbdc',
    name: 'Professor Prebid',
    resource: 'app.html',
  },
  {
    id: 'kdojjbmaidnebdjancpcgajkgeboebpe',
    name: 'Guestbook',
    resource: 'templates/images/logo.png',
  },
  {
    id: 'kdpbamlhffmfbgglmaedhopenkpgkfdg',
    name: 'Eztrackr',
    resource: 'css/script.css',
  },
  {
    id: 'keiealdacakpnbbljlmhfgcebmaadieg',
    name: 'Python Code Runner',
    resource: 'pyodide/ffi.d.ts',
  },
  {
    id: 'kfdniefadaanbjodldohaedphafoffoh',
    name: 'Typhon Wallet',
    resource: 'assets/typhon.png',
  },
  {
    id: 'kfidecgcdjjfpeckbblhmfkhmlgecoff',
    name: 'Svelte DevTools',
    resource: 'courier.js',
  },
  {
    id: 'kfjafldijijoaeppnobnailkfjkjkhec',
    name: 'WA Contacts Extractor',
    resource: 'assets/du.js',
  },
  {
    id: 'kfmlkgchpffnaphmlmjnimonlldbcpnh',
    name: 'TimeYourWeb',
    resource: 'popup.html',
  },
  {
    id: 'kgekdppfhdacjmnogfkklnljiglcphip',
    name: 'Font Inspector',
    resource: 'data/content_script/resources/popup.css',
  },
  {
    id: 'kgenlgjkglpmbiocphbgnmknalmfacei',
    name: 'Chat GPT',
    resource: 'yi.png',
  },
  {
    id: 'kgfnifoledgeaphonbpbpfaepckpdgkg',
    name: 'Mem Web Clipper',
    resource: 'assets/nodefs-CXqG1TRR.js',
  },
  {
    id: 'kghbmcgihmefcbjlfiafjcigdcbmecbf',
    name: 'heylogin',
    resource: 'iframe.html',
  },
  {
    id: 'khafmmhhbaabgdjdhnjkcfbfhadioocp',
    name: 'ShopifyHunt',
    resource: 'img/tip.png',
  },
  {
    id: 'khbjbchkedopfbhiafhaacomekdgnhbh',
    name: 'AI Translate',
    resource: 'icons/icon-32.png',
  },
  {
    id: 'khbknmknlkegbeihnfkknjfopbgcbgal',
    name: 'Math Solver',
    resource: 'fonts/Manrope-VF.woff2',
  },
  {
    id: 'khjgklaeknnibmeeanmbfjcnjablcpil',
    name: 'Recent Tabs',
    resource: 'img/ext_icons/icon-48.png',
  },
  {
    id: 'khpdiolbjggapokjloppdibgapcfkojd',
    name: 'Enable Right Click & Copy',
    resource: 'js/enable.js',
  },
  {
    id: 'kigfbkddbfgbdbdekajodpggpkpfdjfp',
    name: 'Prompt Perfect',
    resource: 'auth_error.html',
  },
  {
    id: 'kjdgcemdlnbdohbcmnamlnnfkjoijfol',
    name: 'Whering',
    resource: 'index.css',
  },
  {
    id: 'kjfmmgpfhdohhcodbkaodgkidbenkgog',
    name: 'NFC Reader',
    resource: 'ufr_content.js',
  },
  {
    id: 'kjgenhkjjjldgneijakjlhdfkmjmedbj',
    name: 'Chrome Step ToolBox',
    resource: 'step1.json',
  },
  {
    id: 'kjgfnioibniobfkjcjjfikmhecajpcio',
    name: 'Text Spotlight',
    resource: 'style.css',
  },
  {
    id: 'kjlbbjicboihbikbjbbmkimccoeccoon',
    name: 'Copy History +',
    resource: 'sounds/1_bloop.mp3',
  },
  {
    id: 'kjmfnmpklmilhfbdiephghndfdjahneb',
    name: 'Video Downloader Plus',
    resource: 'javaScript/instagram.js',
  },
  {
    id: 'kjmhgpfnhmjgohbjmdnogcdfocihnahg',
    name: 'Shopee选品助手',
    resource: 'popup.css',
  },
  {
    id: 'kkakhdcmdocechjnnfhihpjkancfmnbf',
    name: 'Помощник OZON',
    resource: 'assets/js/options.js',
  },
  {
    id: 'kkhkjhafgdlihndcbnebljipgkandkhh',
    name: 'RingCentral App Connect',
    resource: 'c2d/index.js',
  },
  {
    id: 'kkjfobdnekhdpmgomkpeibhlnmcjgian',
    name: 'website broken link and 404 error checker',
    resource: 'icon/icon128.png',
  },
  {
    id: 'kkofobmbmgcdiepkdjgnffdlecjpekaj',
    name: 'xTiles Web Clipper',
    resource: 'icon-34.png',
  },
  {
    id: 'klfkmphcempkflbmmmdphcphpppjjoic',
    name: 'Avatar Maker Studio',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'klokphhomfboclhpijjcgbpdjoccaagc',
    name: 'Flash Copilot',
    resource: 'insert.js',
  },
  {
    id: 'kmdgaoalcjcefbgaiookdaigjeepoldf',
    name: 'AnswersAi',
    resource: 'img/icon.png',
  },
  {
    id: 'kmfmeaiiknkodohkpnnjmldipbilojma',
    name: 'Alibaba Downloader',
    resource: 'popup-init.js',
  },
  {
    id: 'kmhfkeaanbokocpddnjlocbefjcpohhl',
    name: 'Wonde',
    resource: 'brand.svg',
  },
  {
    id: 'kmijeangnajdcaomdfjohhbmnbhnhjjd',
    name: 'Pinbox',
    resource: 'save.html',
  },
  {
    id: 'kmmpkhpajpecmpdmmbpjmkmcmfdahkcj',
    name: 'Price.com',
    resource: 'img/icon.png',
  },
  {
    id: 'kmnlmpjaimmhjobjklicabkfmjfpnjhh',
    name: 'PocketOptionRobot',
    resource: 'img/svg/po.svg',
  },
  {
    id: 'knfhdmkccnbhbgpahakkcmoddgikegjl',
    name: 'Crosslist',
    resource: 'img/arrow-down.svg',
  },
  {
    id: 'kngiafgkdnlkgmefdafaibkibegkcaef',
    name: 'MCP SuperAssistant',
    resource: 'content.css',
  },
  {
    id: 'knofkelobfihppebfpbcbnfeeifldfgf',
    name: 'Jenni Web Importer',
    resource: 'welcome.svg',
  },
  {
    id: 'kofkhnkdmpbngifdgbjeedlppjilcaei',
    name: 'GigaBrain',
    resource: '60.png',
  },
  {
    id: 'kofmimpajnbhfbdlijgcjmlhhkmcallg',
    name: 'Telegram downloader',
    resource: 'popup.html',
  },
  {
    id: 'kpeiaadmoncdloljkoeeppndaaomafnb',
    name: 'Translate',
    resource: 'icons/copy.svg',
  },
  {
    id: 'kphdjcakmfncjfhkedgjlalobcmmmdeo',
    name: 'Google Lens',
    resource: 'welcome.js',
  },
  {
    id: 'kpjcpmaacfdihmaahddoljcnapcniemh',
    name: 'Clipper',
    resource: 'content.css',
  },
  {
    id: 'lbaenccijpceocophfjmecmiipgmacoi',
    name: 'Wizardshot',
    resource: 'style.css',
  },
  {
    id: 'lbanojlcfgehondfpeipfpmdfipbjlhh',
    name: 'Instagram Unfollow AI',
    resource: 'analyzer.html',
  },
  {
    id: 'lbcbipoloacjakecofjkohgllhojdhhp',
    name: 'Talent',
    resource: 'video/video.html',
  },
  {
    id: 'lbecioncobbndebbfdopnpinnibemoon',
    name: 'Navattic',
    resource: 'static/index.html',
  },
  {
    id: 'lbeieofginbjinflccjechojbmlbcdjj',
    name: 'Programa Web Clipper',
    resource: 'clipper.html',
  },
  { id: 'lbfjfamhbgbaldijoohdfbdfkgmpdbni', name: 'TVD', resource: 'popup.js' },
  {
    id: 'lbmokfklpmlklngnbmfiafnaoncadldc',
    name: 'Secure Shield by Secure Shell',
    resource: 'img/icon16.png',
  },
  {
    id: 'lbndmgmpidplehmebcfkokbappanjmip',
    name: 'Capture X',
    resource: 'html/msg.html',
  },
  {
    id: 'lceececoaemfkdibcaeeobjgkcchalhl',
    name: 'Unbroke',
    resource: 'sidepanel.css',
  },
  {
    id: 'lchpepnpfkooehfcdnlaklepfiedhipi',
    name: 'BeyondTrust Workforce Passwords',
    resource: 'version.js',
  },
  {
    id: 'lcmlgggklanaobiobonnciffdplommbl',
    name: 'DesignFiles Product Clipper',
    resource: 'assets/js/utils/url.js',
  },
  {
    id: 'ldampcdnpgokadoofhhdjjklcfoiplbh',
    name: 'Charlize',
    resource: 'images/flagbe.png',
  },
  {
    id: 'ldhkneiheabejbefhgjddpamijajabmm',
    name: 'StatsHunters',
    resource: 'statshuntersRouteOverlay.js',
  },
  {
    id: 'ldopchajhlkkpdpbfejaneknjdgnlcca',
    name: '表答AI',
    resource: 'content.css',
  },
  {
    id: 'leamnhmoommgnllbfchimmjblecjgoad',
    name: 'Amazon Quick View',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'ledhmcolmgjbkplfmppjfglgfpefmpbe',
    name: 'K-Enhanced',
    resource: 'images/Logo.png',
  },
  {
    id: 'lefbdkondfcnlfplglcnjjncgdficmhc',
    name: 'SiteAnalyzer SEO Tools',
    resource: 'graph.html',
  },
  {
    id: 'lekblhcdmlbolaelgdghnmpnlchjieod',
    name: 'DraftSharks Sync',
    resource: 'login/espn.js',
  },
  {
    id: 'lekngdckcfhbhnalcglagkfjaeckabfn',
    name: 'Skillwise.ai Proctoring',
    resource: 'js/sources.js',
  },
  {
    id: 'lfabkiipmidkmhplochgpbaeekjjfbch',
    name: 'SN Utl OP',
    resource: 'inject.js',
  },
  {
    id: 'lfepbhhhpfohfckldbjoohmplpebdmnd',
    name: 'Find WhatsApp Link',
    resource: 'popup.html',
  },
  {
    id: 'lflhpoaghkcebhmikolpdhdikknpmbod',
    name: 'Pi Reminder',
    resource: 'index.html',
  },
  {
    id: 'lghnjiiijkmgpgafgehpahncpcpfmkbp',
    name: 'EasyKOL',
    resource: 'content-scripts/AIFilterScript.css',
  },
  {
    id: 'lgndjfkadlbpaifdpbbobdodbaiaiakb',
    name: 'Authenticator App',
    resource: 'images/new.svg',
  },
  {
    id: 'lhaopfkppdccofghkhiijjjbakjeblgp',
    name: 'shop_blue',
    resource: 'fonts/Heebo/Heebo-Bold.ttf',
  },
  {
    id: 'lhehchebjnjcaeklbpoanpogkggnhadk',
    name: 'Magic Button',
    resource: 'js/hh.js',
  },
  {
    id: 'lilckelmopbcffmglfmfhelaajhjpcff',
    name: 'Anything Copilot',
    resource: 'js/bg.js',
  },
  {
    id: 'ljfdccdjpfjpfjbpdiihanpodilolofh',
    name: 'Pause',
    resource: 'html/menu.html',
  },
  {
    id: 'ljfjnlcnpmabfcgcmffkmgainghokdpl',
    name: 'Burning Vocabulary',
    resource: 'dashboard.html',
  },
  {
    id: 'ljobcbehhifehkmamikmchekbbljopao',
    name: 'ICS2GCal',
    resource: 'snackbar.js',
  },
  {
    id: 'lkennebljmnnpimcgdjlocbncpamgipp',
    name: 'Bearly.ai',
    resource: 'google.99cd0dab.svg',
  },
  {
    id: 'lkfaknngnekohfmljebdikgefjfhkgkp',
    name: 'GlossaryTech',
    resource: 'main.css',
  },
  {
    id: 'lkignmdgfllplgaabepannhkjbenhmak',
    name: 'ZClickToCall',
    resource: 'static/js/inpage.js',
  },
  {
    id: 'lkijcgjookpddgfacoankphnpbinmhia',
    name: 'ImageTrans',
    resource: 'paddleocr/opencv.js',
  },
  {
    id: 'lkpmkhpnhknhmibgnmmhdhgdilepfghe',
    name: 'Prax wallet',
    resource: 'manifest.json',
  },
  {
    id: 'lldknhffmfbndpbknmcckoelpidapidf',
    name: 'Cashback beruby',
    resource: 'templates/index.html',
  },
  {
    id: 'llflfcikklhgamfmnjkgpdadpmdplmji',
    name: 'Mokku',
    resource: 'js/hook.js',
  },
  {
    id: 'lmppdpldfpfdlipofacekcfleacbbncp',
    name: 'Jump Cutter',
    resource: 'chunks/8.js',
  },
  {
    id: 'lndponbebpocehnoblfgdfeiegeaokcf',
    name: 'Horizon Geolocation Redirection',
    resource: 'injectGeoScript.js',
  },
  {
    id: 'lnnnmfcpbkafcpgdilckhmhbkkbpkmid',
    name: 'Koala Wallet',
    resource: 'dist/injected.js',
  },
  {
    id: 'lobcjkdmlmilmhiadfdlbapfcmbnbple',
    name: 'HowNow',
    resource: 'popup.html',
  },
  {
    id: 'lpcacagdanaollekchlniifnnflbamep',
    name: 'xPet.tech',
    resource: 'img/1.png',
  },
  {
    id: 'lpepilhibhaofjfjaikofinbbjcnhpfk',
    name: 'Progressive Shopper',
    resource: 'index.html',
  },
  {
    id: 'lpfegdkicphlldcdfeomhdochopplghk',
    name: 'Fontstorage',
    resource: 'img/copy.svg',
  },
  {
    id: 'lpilbniiabackdjcionkobglmddfbcjo',
    name: 'Keeper',
    resource: 'inpage.js',
  },
  {
    id: 'lpkcglgkpkloheddkmehdapeclclnecm',
    name: 'Prime Connect',
    resource: 'logo/cc.png',
  },
  {
    id: 'lpmlfjjccfdcnfplffgcmnkaafcigoil',
    name: '比價狗',
    resource: 'js/main.js',
  },
  {
    id: 'lpnhifgofkablmicbhngmdmjmajgcced',
    name: 'AliSold卖家助手',
    resource: 'popup.css',
  },
  {
    id: 'lpopfncaoeljgopgbdcgaklafemlbjbe',
    name: 'Timer Countdown',
    resource: 'js/state.js',
  },
  {
    id: 'macmiooaeggbklhlhdgnmcnedoipoakk',
    name: 'Notebook LM',
    resource: 'icons/icon16.png',
  },
  {
    id: 'madmbegfpbmnngkiappcjgighagdggid',
    name: 'smrtPhone.io Chrome Dialer',
    resource: 'icon_16.png',
  },
  {
    id: 'mafpfjnpmblneioebkpdjlledcopckld',
    name: 'AsinSeed',
    resource: 'assets/fontjs.js',
  },
  {
    id: 'mahgnmmldchnmmdfkfcoindpgkadhhhc',
    name: 'ElevenReader',
    resource: 'images/icon-16.png',
  },
  {
    id: 'mbfnbhfjnjeedaknilkfegfnnmmmmpmn',
    name: 'Calculator',
    resource: 'assets/icon-min.svg',
  },
  {
    id: 'mbhjcnabhdgkfaobjclmgifoeemcnoio',
    name: 'Prompt Sidekick',
    resource: 'dist/images/loading.svg',
  },
  {
    id: 'mbibfcflbmlbcbnejgalgeijlpnjjgjc',
    name: 'The Jukebox',
    resource: 'disc-help.html',
  },
  {
    id: 'mbklgpngoohbbagagdfoccaclpdhgihd',
    name: '爱搜资源助手',
    resource: 'css/index.css',
  },
  {
    id: 'mcffmgagphgpgkdclllnilokablhjcge',
    name: 'Core Web Vitals Visualizer',
    resource: 'js/audit-logic.js',
  },
  {
    id: 'mcfncmgpoefggbpeloigfonenlmamgjf',
    name: 'Tab Manager',
    resource: 'assets/content.css',
  },
  {
    id: 'mcjihhgddailfldjgkjjokalgmhidmnm',
    name: 'Promptalot Helper',
    resource: 'html/dms.html',
  },
  {
    id: 'mckfdaahjhmnchjihljdiakamamondld',
    name: 'HTML Elements Screenshot',
    resource: 'data/content_script/inject.css',
  },
  {
    id: 'mcldgfkcaapkhccpbhjjchamjfbpbgcp',
    name: 'Importify',
    resource: 'icons/btn.png',
  },
  {
    id: 'mdammcmmopljkpnokoodkahdhnpijhib',
    name: '치지직',
    resource: 'log.html',
  },
  {
    id: 'mdjgmfbmbedkhcmhknnjnlohbelcjckp',
    name: 'Craft Web Clipper',
    resource: 'popup/index.js',
  },
  {
    id: 'mdoelcifdkcimkdbfkjjnedabmjlkokc',
    name: 'Video Image Control',
    resource: 'help.html',
  },
  {
    id: 'memnnheiikbfdcobfkghhfihnegkfici',
    name: 'Chat Memo',
    resource: 'js/i18n.js',
  },
  {
    id: 'meppipoogaadmolplfjchojpjdcaipgj',
    name: 'WA Number Checker',
    resource: 'assets/du.js',
  },
  {
    id: 'mfdlhoackihplokjehpiiffnedbeokod',
    name: 'AIR MATH',
    resource: 'tutorial.f0ac83f2.gif',
  },
  {
    id: 'mgabbogigbgahfnceabjddbgpkemhdbl',
    name: 'Twitch VOD downloader',
    resource: 'content.css',
  },
  {
    id: 'mgoefoagpgnjkgnfcpkgpnccgnocpoeo',
    name: 'HunterSales',
    resource: 'icon16.png',
  },
  {
    id: 'mhmpepeohaddbhkhecaldflljggicedf',
    name: 'Salesforce Interactions SDK Launcher',
    resource: 'debugger.html',
  },
  {
    id: 'mhncgbfifjnhlilpnccgbimimkjejada',
    name: 'GoTranslate',
    resource: 'icons/512.png',
  },
  {
    id: 'miepjgfkkommhllbbjaedffcpkncboeo',
    name: 'Dyslexia Friendly',
    resource: 'fonts/OpenDyslexicMono-Regular.eot',
  },
  {
    id: 'migdhldfbapmodfbmgpofnikfbfpbbon',
    name: 'Highlighty',
    resource: 'static/fonts/Phenomena-Regular.otf',
  },
  {
    id: 'mkpoonlmiaknmcdcmdhbnehhglndcolf',
    name: '6sense',
    resource: 'pendo.js',
  },
  {
    id: 'mlbgnlemejoeocmncpolejmdbimkoiol',
    name: 'Barracuda Chromebook Security',
    resource: 'block.html',
  },
  {
    id: 'mlkgonfgckifcicdldcjkpbjfdmpdhad',
    name: 'Hix',
    resource: 'icons/cross.svg',
  },
  {
    id: 'mlkplhocljobcbmokjlehlminmnfaddn',
    name: 'Exa RIS/PACS Multi-monitor',
    resource: 'favicon_16.ico',
  },
  {
    id: 'mlmgeakkomnhoblldciflmoeefmdaaha',
    name: 'SonicCaption',
    resource: 'imgs/login.png',
  },
  {
    id: 'mlnpcceaeigcohdpaddmkllbgnkgeoed',
    name: 'MyAwin',
    resource: 'img/app/awin.png',
  },
  {
    id: 'mmcjkncamaomjlfjkifjpcklcddfdhgb',
    name: 'KOI PET',
    resource: 'content.css',
  },
  {
    id: 'mmdidpkgkknffjbnnbpcdpchhbmdmbga',
    name: 'Savewise',
    resource: 'images/expand_icon.svg',
  },
  {
    id: 'mmdmglmkoblcdgndchbohenfoglomjfk',
    name: 'SEOwallet',
    resource: 'tabs/demo.html',
  },
  {
    id: 'mmjbociiiafjimjiddoegfljjomglfoc',
    name: 'AliCompare',
    resource: 'images/magnifier.png',
  },
  {
    id: 'mmmjbcfofconkannjonfmjjajpllddbg',
    name: 'Fluvi Wallet',
    resource: 'inpage.bundle.js',
  },
  {
    id: 'mncjlogojblmjaapdhpbihnkdbffdcgp',
    name: 'Wordvice AI Writing Assistant',
    resource: 'popup.css',
  },
  {
    id: 'mnilpkfepdibngheginihjpknnopchbn',
    name: 'Strongbox',
    resource: 'iframe.html',
  },
  {
    id: 'mnkjlpcdfdkekiojedblbhfobachjoof',
    name: 'Flash Kart',
    resource: 'css/css2.css',
  },
  {
    id: 'mnldnbhgfocmkehnlkeanlhfmopepnko',
    name: 'YtcFilter',
    resource: 'setup.js',
  },
  {
    id: 'mnmnmcmdkigakhlfkcdimghndnmomfeo',
    name: 'Anti Anti Debug',
    resource: 'content.js',
  },
  {
    id: 'momjomajgginjihadffjamkianflepdp',
    name: '3D Street View',
    resource: 'manifest.json',
  },
  {
    id: 'monkfjniakmcfficglpbmaoifmidhmne',
    name: 'TranslateSub',
    resource: 'content.css',
  },
  {
    id: 'mpbgcojnamdnljaacdhpgenikkblddjj',
    name: 'MangaPin',
    resource: 'assets/main-1e0b5f57.js',
  },
  {
    id: 'mpebbageafacikpcpinonhfbkbpfhipn',
    name: 'Canva Automation',
    resource: 'ijsource.js',
  },
  {
    id: 'mpfhimfooelblffmiddjmpnpndeldikg',
    name: 'Screenshot to Text',
    resource: 'ocr.html',
  },
  {
    id: 'mphkdfmipddgfobjhphabphmpdckgfhb',
    name: 'Obsidian Clipper',
    resource: 'lib/clip.js',
  },
  {
    id: 'mpjeakdcffkpmcfamnmbjggejmanckho',
    name: 'Zecento',
    resource: 'script.js',
  },
  {
    id: 'mpnckpmpddjcgkpjkmmakcamjhceadne',
    name: 'AntiRickRoll',
    resource: 'warn/warn.html',
  },
  {
    id: 'mpnfndnehgmmonhfcfdnaemdeokofgaf',
    name: 'Ncage',
    resource: 'img/1.jpg',
  },
  {
    id: 'nafkdopjabijmpmfnogbnccgipnocljm',
    name: 'Swooped',
    resource: 'assets/constants-d736cb22.js',
  },
  {
    id: 'nahbabjlllhocabmecfjmcblchhpoclj',
    name: 'Danmaku mini player',
    resource: 'css.js',
  },
  {
    id: 'nbccjeeblefkmoohdiipbghgikopimnd',
    name: 'Ezoic',
    resource: 'src/consts.js',
  },
  {
    id: 'nbdlmbalmemeafnibbnjbddkclefkkkn',
    name: 'QNB eSolutions',
    resource: '128.png',
  },
  {
    id: 'nbdpmlhambbdkhkmbfpljckjcmgibalo',
    name: 'Halo',
    resource: 'inpage.js',
  },
  {
    id: 'nbfhegiidojdmnahegkphdoabohfmoof',
    name: 'yomichan',
    resource: 'img/icon.png',
  },
  {
    id: 'nchidjaafkcjdgdbbdpkpokodiehhcdg',
    name: 'ReadPaper Importer',
    resource: 'content-script/style.css',
  },
  {
    id: 'ncjkkfbddfkkemiejpfdgjcifjmbcloc',
    name: 'Font Identifier',
    resource: 'img/tag.png',
  },
  {
    id: 'nckbjfbeinhdadepgkajgmdijmdmahhk',
    name: 'GMB Scraper',
    resource: 'help.html',
  },
  {
    id: 'nckcbkihecjfcdddhgkpobnpahgjjojn',
    name: 'Web Downloads For Instagram website',
    resource: 'js/story.js',
  },
  {
    id: 'ncnnhapjfmfgljblcgpeojgbhcihhece',
    name: 'ColorPickster',
    resource: 'css/style.css',
  },
  {
    id: 'ndbnmjocnckdijnlnkoponigbnfmalpi',
    name: 'PubmedX',
    resource: 'resources/Twitter_Logo_Blue.webp',
  },
  {
    id: 'nddfhonnmhcldcbmhbdldfpkbfpgjoeh',
    name: 'Screen Reader',
    resource: 'src/content/audio.js',
  },
  {
    id: 'neaebjphlfplgdhedjdhcnpjkndddbpd',
    name: 'Vue Telescope',
    resource: 'injected.js',
  },
  {
    id: 'negakbijaemdgbhklopmghphgaeadmpo',
    name: 'Chromoji',
    resource: 'data/images/icon-16.png',
  },
  {
    id: 'nennaecdimadgdlboiianfpidnnhncjj',
    name: 'OKIOCAM Time-Lapse',
    resource: 'ffmpeg/ffmpeg.wasm',
  },
  {
    id: 'nepihmimcmflogaoaejjoeodldogidjk',
    name: 'SYF Apty Client',
    resource: 'config.json',
  },
  {
    id: 'nfdhjpliieckopfcpeglebihglikgojn',
    name: 'Debrid-Link',
    resource: 'player.html',
  },
  {
    id: 'nflbalmkceonkkhifbifebanhladdgcp',
    name: 'JSON Pretty',
    resource: 'font/Mono-Bold.woff2',
  },
  {
    id: 'ngcickocpcongeagbpkejabhkgmcildo',
    name: 'FACEIT Visuals',
    resource: 'glass-ui.css',
  },
  {
    id: 'ngdjlkacliphopkcgcffflancnlbebnc',
    name: 'RevDriver',
    resource: 'index.html',
  },
  {
    id: 'ngeipjajooddgpedkfobklklflllhppn',
    name: 'Math Tools',
    resource: 'css/modal.css',
  },
  {
    id: 'nhhldecdfagpbfggphklkaeiocfnaafm',
    name: 'Password Manager',
    resource: 'src/images/orca-18.png',
  },
  {
    id: 'nhpjggchkhnlbgdfcbgpdpkifemomkpg',
    name: 'Ajax Modifier',
    resource: 'iframe/index.html',
  },
  {
    id: 'nidnkjmnncelpfjholeonlbclfkgngcg',
    name: 'CAVA',
    resource: 'images/icon-copy.png',
  },
  {
    id: 'ninanjeenomfmcihkpoaelaoddaboica',
    name: 'Random',
    resource: 'img/icon.png',
  },
  {
    id: 'njdflbldikgkfimenejnjkekmmgengcc',
    name: 'Gemalto Web Signer for NatWest',
    resource: 'assets/css/main.css',
  },
  {
    id: 'njlppnciolcibljfdobcefcngiampidm',
    name: 'Amazon Reviews Exporter',
    resource: 'public/icons/icon-16.png',
  },
  {
    id: 'njommheeefdkhenodpfoflmeoampaggk',
    name: 'MindStudio',
    resource: 'images/floating-button.png',
  },
  {
    id: 'nldojjdlhkfalipikhhnhhidfhgoopig',
    name: 'Subtly',
    resource: 'training-hint.mp4',
  },
  {
    id: 'nlgmicoooapgmaaplbkjnhjbeojeoaha',
    name: 'Volume Booster',
    resource: 'assets/popup.css',
  },
  {
    id: 'nlhaleloflnhpemagojabiikkkejjlgp',
    name: 'Mettl Proctoring',
    resource: 'assets/tick.png',
  },
  {
    id: 'nlkobfbkblfhlcobdomlhmpbbhmcbkfd',
    name: 'PHPView',
    resource: 'error.gif',
  },
  {
    id: 'nlpnopimcnncncmmjdijebhlmkfandpl',
    name: 'Time Tracker',
    resource: 'auth.html',
  },
  {
    id: 'nmaifnjhioogfcdidhimgjdhahgaibko',
    name: 'Export Followers free',
    resource: 'style/popup.css',
  },
  {
    id: 'nnbklmljghpjjibbnialdmiogbjohlod',
    name: 'Website Destroyer',
    resource: 'img/cur.png',
  },
  {
    id: 'nnhifpoojdlddpnhjbhiagddgckpmpfb',
    name: 'Pixel Perfect Pro',
    resource: 'runtime.js',
  },
  {
    id: 'nnkkgbabjapocnoedeaifoimlbejjckj',
    name: 'Block Site Ex',
    resource: 'css/block.css',
  },
  {
    id: 'nnpflimcjgcocialildlehejbmmmlkno',
    name: 'Zoho BluePencil',
    resource: 'properties.json',
  },
  {
    id: 'npaagbeceoeomlblpmcpfbeakmpgdpnl',
    name: 'Logi Weather',
    resource: 'options.html',
  },
  {
    id: 'npapojppkmfhefbokolngnomlgkkpcnc',
    name: 'Website Ranking and SEO Checker',
    resource: 'popup.html',
  },
  {
    id: 'npehdolgmmdncpmkoploaeljhkngjbne',
    name: 'NetSuite Field Finder',
    resource: 'fieldfinder.js',
  },
  {
    id: 'npnobidkjdpbadjjkclbcncgocahnook',
    name: 'medha scribe',
    resource: 'content.js',
  },
  {
    id: 'oadjckehgdokecialgdhjkjdmjonfkkf',
    name: 'BG Remaker',
    resource: 'img/logo.png',
  },
  {
    id: 'oahjfinghkkolgfkbfanpmhpiafmnepn',
    name: 'Swordfish AI',
    resource: 'frame.html',
  },
  {
    id: 'obghampgaenjefbchkhkhbkdimjhgnjk',
    name: 'Pop in Hotel',
    resource: 'images/close26.png',
  },
  {
    id: 'obiomemfgclpnflokpjjfokafbnoallb',
    name: 'Spotify Ad Blocker',
    resource: 'bg.js',
  },
  {
    id: 'ocabfdicbcamoonfhalkdojedklfcjmf',
    name: 'Jupyter Notebook Viewer',
    resource: 'themes/radar.css',
  },
  {
    id: 'occohfgiljdagdmklhpplgmcnliljmgi',
    name: 'dewey.',
    resource: 'style/injected.css',
  },
  {
    id: 'ocgghcnnjekfpbmafindjmijdpopafoe',
    name: 'Selocity',
    resource: 'index.html',
  },
  {
    id: 'ocjobpilfplciaddcbafabcegbilnbnb',
    name: 'XPLA Vault Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'oddbjmjgpaofommagnbfednbdifaakfb',
    name: 'Nastaleeq',
    resource: 'src/inject/MehrUrdu.ttf',
  },
  {
    id: 'odibekjfjfdkobinlcghejhjgbbeegon',
    name: 'SafetyNet GO',
    resource: 'config/envconfig.json',
  },
  {
    id: 'odinmjjdainghmojdffgpjmkefajhlbn',
    name: 'Dubble',
    resource: 'nunito.ttf',
  },
  {
    id: 'odkfginmjmeaoggmbainlfacibmhhbbd',
    name: 'Hamatata.com Helper',
    resource: 'img/loader.gif',
  },
  {
    id: 'oefooeopdahbeimdgamlblnpegijmdem',
    name: 'Fast OCR',
    resource: 'ocr.html',
  },
  {
    id: 'oehppfijdgkgmfjnecnliihfdepegejk',
    name: 'Bulk File Downloader',
    resource: 'jszip.min.js',
  },
  {
    id: 'oenijgdfkimddokafknnoedmenkdakeb',
    name: 'NanoInfluencer.ai',
    resource: 'sidebar.html',
  },
  {
    id: 'oficbncopphljnpdgcccjiffknmhniao',
    name: 'Elevate',
    resource: 'popup/index.html',
  },
  {
    id: 'ofidhibmldckbehmlhliopoikmaocoma',
    name: 'G Business Explorer',
    resource: 'cframe.html',
  },
  {
    id: 'ogfaopdbhmafgcmoaefekfhdkghhealf',
    name: '3-2-1 Revolver',
    resource: 'js/background_script.js',
  },
  {
    id: 'ogfhebakocdbenmnkaajmckmbcnnafmm',
    name: 'File Centipede',
    resource: 'config.js',
  },
  {
    id: 'ohepmjcobcbjaoffkejjlbbabdbjlejp',
    name: 'Telegram Video Downloader',
    resource: 'index.html',
  },
  {
    id: 'ohipjedcccbnmbmnadcgpakeebpcdpgb',
    name: 'RoSaver',
    resource: 'load.js',
  },
  {
    id: 'ohkeehjepccedbdpohnbapepongppfcj',
    name: 'Whatfix Studio',
    resource: 'env.json',
  },
  {
    id: 'oidjnlhbegipkcklbdfnbkikplpghfdl',
    name: 'Mermaid Previewer',
    resource: 'mermaid.min.js',
  },
  {
    id: 'oiecpgbfcchalgdchgoplichofjadhmk',
    name: 'History & Cache Cleaner',
    resource: 'img/info.svg',
  },
  {
    id: 'oiedehaafceacbnnmindilfblafincjb',
    name: 'BugBug Automation Testing',
    resource: 'overlay.js',
  },
  {
    id: 'oienkoejnhkbcibhdnpjoemdnmiokgah',
    name: 'REST Client',
    resource: 'icon.svg',
  },
  {
    id: 'ojaocmdncfmeiofoakhbjakapljmdgod',
    name: 'Promo Coders',
    resource: 'icons/icon_32.png',
  },
  {
    id: 'ojbcfhjmpigfobfclfflafhblgemeidi',
    name: 'Glow',
    resource: 'realms/inpage.js',
  },
  {
    id: 'okckmdcaaieknndlpbpjjnfmbakdjnbe',
    name: 'Cookie Manager',
    resource: 'contentScript/style.css',
  },
  {
    id: 'okekkfbjgdmfmogicbhdechdmkfhfphc',
    name: 'Teamwork.com',
    resource: 'images/plus.svg',
  },
  {
    id: 'okpadhgilncoodafepkdmlneojcehclf',
    name: 'DivMagic',
    resource: 'blockRegistration.bundle.js',
  },
  {
    id: 'olloopaapdodegpcacjmgdjaphggfgoj',
    name: 'MYO Studio',
    resource: 'spring-all-icons-demo.webm',
  },
  {
    id: 'oncaapliomaamlbopdmhmdompfemljhm',
    name: 'Webcam-Droplr',
    resource: 'public/logo.svg',
  },
  {
    id: 'ondecobpcidaehknoegeapmclapnkgcl',
    name: 'JSON Formatter',
    resource: 'fonts/MonoLisaVariableNormal.woff2',
  },
  {
    id: 'onmbfhnihgnckgpjpgooodkpbopmbkof',
    name: 'LetMeApply',
    resource: 'popup.100f6462.js',
  },
  {
    id: 'oobnhmioebnddcabnngemmjjdffhiphf',
    name: 'Overprice',
    resource: 'content-scripts/any.css',
  },
  {
    id: 'oohfffedbkbjnbpbbedapppafmlnccmb',
    name: 'Vue force dev',
    resource: 'detectorExec.js',
  },
  {
    id: 'oonalfdoahlmjaoloddjenihohbfodme',
    name: '英辞郎',
    resource: 'img/pin_on.png',
  },
  {
    id: 'opecnacmghifdlgdpejcjmjhpjoipamp',
    name: 'Lockcard',
    resource: 'assets/css/popup.css',
  },
  {
    id: 'opemhndcehfgipokneipaafbglcecjia',
    name: 'GrowthBook DevTools',
    resource: 'js/logo128.png',
  },
  {
    id: 'opnnmgopaggjpapnoknbphfpjfadbddc',
    name: 'QSafe wallet',
    resource: 'scripts/inject.js',
  },
  {
    id: 'oppdbdefikkkihgbliidckokhgcmmiga',
    name: 'Cloaked',
    resource: 'popup.html',
  },
  {
    id: 'pabamgafdnanldcgdhpfohfdpjjbekom',
    name: 'Recruit CRM Sourcing',
    resource: 'views/home.html',
  },
  {
    id: 'padcpabfckdbahodkfkincpaaeinejik',
    name: 'Ask Gene',
    resource: 'front_end/docs/docs.js',
  },
  {
    id: 'pampamgoihgcedonnphgehgondkhikel',
    name: 'DotGit',
    resource: 'content_script.js',
  },
  {
    id: 'papnkgoggccbbpadcjndgfjgaaekgekm',
    name: 'Product Importer',
    resource: 'main.html',
  },
  {
    id: 'pbgjdmhnccgmehkpkjhknmlpolkdfbpo',
    name: 'Cisdem Web Blocker',
    resource: 'popup.js',
  },
  {
    id: 'pcbdjfbemhiapdadgbfmdcokholpinfk',
    name: 'SealSend',
    resource: 'style.css',
  },
  {
    id: 'pccbghdfdnnkkbcdcibchpbffdgednkf',
    name: 'Propbar',
    resource: 'auth.html',
  },
  {
    id: 'pcicppminbpfkkfnnkkhfknalhelbabn',
    name: 'Cute Cat',
    resource: 'images/fish_1.png',
  },
  {
    id: 'pckkddchhdhkfapanbkcalloijbbjhbd',
    name: 'VK Blue',
    resource: 'page.js',
  },
  {
    id: 'pckodmjhkabfmljinocgadlpmlefefoi',
    name: 'PDF Manuals',
    resource: 'manifest.json',
  },
  {
    id: 'pdcdbpcmjffmfmcolgnnigdadkhiadlo',
    name: 'Berrycast',
    resource: 'content.js',
  },
  {
    id: 'pdcgcjhkiiclnlfmgomijaihjhacnnbc',
    name: 'Xtab',
    resource: 'search-icon.svg',
  },
  {
    id: 'pehdnkgobeiakkmmkodeocbggajggfam',
    name: 'PICK2SELL',
    resource: 'Close.svg',
  },
  {
    id: 'peicogickckfonilbopkkilgllhhkbbb',
    name: 'cat-catch',
    resource: 'catch-script/i18n.js',
  },
  {
    id: 'pejhbjnfifdecpkgcjhgmcaphdobmiie',
    name: 'Toast',
    resource: 'embed/embed.css',
  },
  {
    id: 'penjlddjkjgpnkllboccdgccekpkcbin',
    name: 'OpenMask',
    resource: 'provider.js',
  },
  {
    id: 'pfaldlkkohfdnmlcladmhlihpbhlkolm',
    name: 'Livescratch',
    resource: 'sounds/ping.mp3',
  },
  {
    id: 'pfbdfjaonemppanfnlmliafffahlohfg',
    name: 'Tradingview assistant',
    resource: 'page-context.js',
  },
  {
    id: 'pfblclopmfndegcljgcjbhkpclhepeod',
    name: 'Uniqkey',
    resource: 'images/icon16.png',
  },
  {
    id: 'pgapfmffencbcimgokjghhlkolckkomb',
    name: 'Sugar',
    resource: 'libs/dl.js',
  },
  {
    id: 'pgiaagfkgcbnmiiolekcfmljdagdhlcm',
    name: 'stargazer-wallet-ext',
    resource: 'js/injectedScript.bundle.js',
  },
  {
    id: 'pgliecfpaeiicbmadehhbhdcjmpjonam',
    name: 'Screen Search',
    resource: 'welcome.js',
  },
  {
    id: 'phglephbecffklifllmgaojdlohjdlkg',
    name: 'MyLens',
    resource: 'assets/main.js',
  },
  {
    id: 'piajkpdbaniagacofgklljacgjhefjeh',
    name: 'APF',
    resource: 'audio/beep.mp3',
  },
  {
    id: 'pigcoaliboahgcijpogmfhkjjampmidm',
    name: 'サテライトAI',
    resource: 'src/assets/images/grok.svg',
  },
  {
    id: 'pilehkefiejmhdldhbajgajlcgggohkj',
    name: 'NordLayer',
    resource: 'assets/copy.svg',
  },
  {
    id: 'pjdbofhiijhapnmpgilkeammkanglfdj',
    name: 'Heurio',
    resource: 'style/fonts.css',
  },
  {
    id: 'pjdcehojcogjpilmeliklfddboeoogpd',
    name: 'Timing71',
    resource: 'logo_32.png',
  },
  {
    id: 'pjhcpooacdljimmmkpbknccbedoaagai',
    name: 'Microsoft Bing InPrivate',
    resource: 'images/bgextn.png',
  },
  {
    id: 'pjldgnhfobpnhbdmfmofkfppdilefnjj',
    name: 'U-Eyes',
    resource: 'images/webm.png',
  },
  {
    id: 'pklcojlgnoaahjchjbiilfgjehinajmd',
    name: 'Paknevis',
    resource: 'assets/icons/favicon-16.png',
  },
  {
    id: 'pkocgelcaeljjcodajmlnemibikaengn',
    name: 'Easy Keywords for AdobeStock',
    resource: '69.js',
  },
  {
    id: 'pkomojeklgbndilokjedodpebdbekiod',
    name: 'Flash Player',
    resource: 'manifest.json',
  },
  {
    id: 'plcabbfeeokakkmdecdccmibahigjkno',
    name: 'Chrome Close Lock',
    resource: 'ccl.html',
  },
  {
    id: 'pliinlgkmncfmfifeepmhlbpklanflpd',
    name: 'Pratik Modül',
    resource: 'www/js/app.js',
  },
  {
    id: 'plkdnpjpnhhnmigmekaocdfokkmebdnm',
    name: 'AirReview',
    resource: 'list.js',
  },
  {
    id: 'plnnpndcgjokianndhalbgnpcbkbehmp',
    name: 'ApowerREC Screen Recorder',
    resource: 'digital-display.woff2',
  },
  {
    id: 'plpkmjcnhhnpkblimgenmdhghfgghdpp',
    name: 'The Great-er Tab Discarder',
    resource: 'img/edge.svg',
  },
  {
    id: 'pmdghmdjjojjeajflmpgnambocpnpiea',
    name: 'Gmail Dark Mode',
    resource: 'css/popup.css',
  },
  {
    id: 'pmfifcbendahnkeojgpfppklgioemgon',
    name: 'DCRefresher Reborn',
    resource: 'assets/pin.webp',
  },
  {
    id: 'pmkoilojjepdgnbhnbfmbpjbcgfgbaoe',
    name: 'Spending Calculator for Amazon and Flipkart',
    resource: 'Icons/copy.png',
  },
  {
    id: 'pncpjgfglndfmeamgbfjkdabogaikmio',
    name: 'SOOP',
    resource: 'src/recap.html',
  },
  {
    id: 'pndkifgjmlfcdeookinhfogbfhjmmhml',
    name: 'Previdenciarista',
    resource: '128-cinza.png',
  },
  {
    id: 'pnenkehbcheoblhjckkkadmcigpjlbpn',
    name: 'KHALED BOUCHAREB-CEM',
    resource: 'js/us.js',
  },
  {
    id: 'pnhnfjbdadnnicpliempeidfminbflon',
    name: 'Quick Eqs',
    resource: 'icon.png',
  },
  {
    id: 'pnibcoleffbpdiohejiinidocmklphde',
    name: 'Clippings.io',
    resource: 'assets/images/logo.svg',
  },
  {
    id: 'pnndeikagpndnokododcjjmmaahmjlhb',
    name: 'Leads Generator on Google Maps & Email Scraper',
    resource: 'icons/16.png',
  },
  {
    id: 'pnoibnpdfcckpbeekckbpgklaaniicll',
    name: 'Prompt Case',
    resource: 'assets/bg_96.png',
  },
  {
    id: 'pnpkconejgobbdijdlkjgohgeldfdlhg',
    name: 'Picture in Picture',
    resource: 'assets/content.css',
  },
  {
    id: 'ppcgokfjhdfiinomggddeeaomecakllo',
    name: 'Adminer Analytics',
    resource: 'icon.png',
  },
  {
    id: 'ppfngkdknicokcdembnnlpahnpanlcko',
    name: 'Save images as Type',
    resource: 'help.js',
  },
  {
    id: 'ppjhoknoadhakhhdbbjjinlopefmehik',
    name: 'Phantom',
    resource: 'assets/icon.png',
  },
  {
    id: 'abiklfpogpkkcelofcplnokkehjgmchc',
    name: 'Canned Responses',
    resource: 'content.js',
  },
  {
    id: 'agchmcconfdfcenopioeilpgjngelefk',
    name: 'eBesucher Addon',
    resource: 'addon.js',
  },
  {
    id: 'agpjllgcceliiblmebkbiccaaldfedbc',
    name: 'Tunable Image Block',
    resource: 'js/api.js',
  },
  {
    id: 'aleplnadeejdmalabijljnblmgbplmdm',
    name: 'Magicslide.app',
    resource: 'area-selector.js',
  },
  {
    id: 'aogldndldipgagdpmlgpplfdjdlgahke',
    name: 'Dark Google Maps',
    resource: 'logo.png',
  },
  {
    id: 'baglkjackdnhdpjjcjpkhmemggiklhid',
    name: 'Tapicker',
    resource: 'src/app/index.html',
  },
  {
    id: 'bbglkcgbhkhchpbbbcgpocnhplhdhnmc',
    name: 'BibCit',
    resource: '_locales/ar/messages.json',
  },
  {
    id: 'bbogkgdmnolaegffcdilhgjpgdhckhcc',
    name: 'Stefanini',
    resource: 'offscreen.js',
  },
  {
    id: 'bedebpfmdganddijhfbbaabedpmlokdk',
    name: 'Pinduoduo Search by Image',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'bilnclmjkfmghedjcipccipllpophckh',
    name: 'Hyros',
    resource: 'content/index.css',
  },
  {
    id: 'bmedieedfkbmedbfgjehehmhfhkknoij',
    name: 'サテライトAI',
    resource: 'lib/md5.js',
  },
  {
    id: 'bnongocfekaonhomdobnhlgieoelaakf',
    name: 'MP4 to MP3 converter',
    resource: 'assets/js/index.4d3fbb76.js',
  },
  {
    id: 'boifpkpigipnfpgncajoceoglolmjmni',
    name: 'Mi Chat 浏览器助手',
    resource: 'assets/v7-DtpTKkBB.js',
  },
  {
    id: 'bpliidecjmjobfhgldbjlpnhmdnpjpce',
    name: 'The Fantasy Footballers ESPN Importer',
    resource: 'background.js',
  },
  {
    id: 'cblhedkfmbhcikepclfiehohcpfpbmnb',
    name: 'ESMART Token',
    resource: 'assets/browser-polyfill.f4591fc4.js',
  },
  {
    id: 'cedckdcmlfabmjkangihdbimghccobhp',
    name: 'resizePhotos',
    resource: 'menu.html',
  },
  {
    id: 'cfaihfocdnniaholfnjcemnfhcjchohb',
    name: 'JSON Formatter',
    resource: 'js/inject_json_listener.js',
  },
  {
    id: 'cgelaojeiipaehoiiabkbickcpmpanel',
    name: 'Learn languages with Netflix & YouTube',
    resource: 'youtubeScript.js',
  },
  {
    id: 'cgigbdaddgndbofikanbfmkpfoonlbpp',
    name: 'Save to Koofr',
    resource: 'content_script.js',
  },
  {
    id: 'cgkeahkghplhgmhhjdiincncbkppgjld',
    name: 'Paradox',
    resource: 'assets/svg/loading.svg',
  },
  {
    id: 'cgpmofepeeiaaljkcclfldhaalfpcand',
    name: 'Assistant RGAA',
    resource: 'dist/minimap-component.js',
  },
  {
    id: 'chmicphoaiifenjibjabgnhpilccfilo',
    name: 'IExporter',
    resource: 'icon-48.png',
  },
  {
    id: 'ckklhkaabbmdjkahiaaplikpdddkenic',
    name: 'Internet Money',
    resource: 'static/js/IMInjectedProvider.js',
  },
  {
    id: 'colepknnmkjpnooobdflkniegcfgaahg',
    name: 'tl;dr',
    resource: 'tldr-panel.js',
  },
  {
    id: 'cppopffhjdgeijpkpaoebneockpeehdo',
    name: 'Translate Netflix Subtitles',
    resource: 'icon-34.png',
  },
  {
    id: 'dfnjbajjfnchnhohhllcjafnfhbcnppa',
    name: 'BTS Cursor',
    resource: 'cur/0.cur',
  },
  {
    id: 'dghndapbehjdbhiffbckojkhoennbofg',
    name: 'Push Go for Pushbullet',
    resource: '_locales/ar/messages.json',
  },
  {
    id: 'dgjkdnoemdeeeenekdkoelebmlafjbpk',
    name: 'Coupert Guard',
    resource: 'css/font.css',
  },
  {
    id: 'dhphdklknbffcgahfpiipdmafoncnndi',
    name: 'Quizonator',
    resource: 'vendor/katex/katex.min.js',
  },
  {
    id: 'dkdfaikjbcicjbjejichilcfidbifjdl',
    name: 'Safqa Coupons',
    resource: 'app.html',
  },
  {
    id: 'dlmdffmkcggiicjbfnjcnikkpahgplmd',
    name: 'Flylighter',
    resource: 'scripts/content.js',
  },
  {
    id: 'dmjccoaplbldlhhljlcldhaciadfhkcj',
    name: 'Automatic Picture-in-Picture (Auto PiP)',
    resource: 'assets/icon.png',
  },
  {
    id: 'dnohamccnpiapcadmokckehgebdednko',
    name: 'Sheet Monkey',
    resource: 'public/tweet.png',
  },
  {
    id: 'doocmbmlcnbbdohogchldhlikjpndpng',
    name: 'Ctrls4Utube',
    resource: 'yts-util.js',
  },
  { id: 'ehmpejjklcibliopgbghpgfinhbjopnn', name: 'Moon', resource: 'app.js' },
  {
    id: 'eiejadjdcchfommckmikpcdnihljbpai',
    name: 'Edit with Sublime Text',
    resource: 'data/native/index.html',
  },
  {
    id: 'ejocgomhimjbhmpbjphkikodfplbemjb',
    name: 'Tipli',
    resource: 'serp.js',
  },
  {
    id: 'elhilnoieekbkpccphknjbihnccdbefj',
    name: 'B2BHELP',
    resource: 'public/prod.svg',
  },
  {
    id: 'elkkekiononmpeeknaehjbjkeabbmbkd',
    name: 'Record Zoom Meeting',
    resource: 'setup.html',
  },
  {
    id: 'falajmifjcihbmlokgomiklbfmgmnopd',
    name: 'Reject Service Worker',
    resource: 'content_scripts/chrome-main.js',
  },
  {
    id: 'fcdofhdgjfhmlfiblcojepdniopclapk',
    name: 'Translate Mi',
    resource: 'img/star.svg',
  },
  {
    id: 'fedmdabgnkfghjplejeilojikdaopkpm',
    name: 'Magictool AI',
    resource: 'images/icon.png',
  },
  {
    id: 'fekofipodopncnlomnghaaebmohagjho',
    name: 'Insight',
    resource: 'html/menu.html',
  },
  {
    id: 'feooibaaamcllnmdojchjccjljdbdmfb',
    name: 'VUBuddy',
    resource: 'assets/app.css',
  },
  {
    id: 'fflgpaejocnobejfanekjilflogejjch',
    name: 'Group Leads',
    resource: 'assets/icons/icon32.png',
  },
  {
    id: 'fhmlmcbfjnegdoafmfcfmhpahfegdjlp',
    name: 'Wistia Video Downloader Plus',
    resource: 'popup.html',
  },
  {
    id: 'fhogkjponmmfhiffnefhpehmaignblce',
    name: 'Sell The Trend',
    resource: 'content.css',
  },
  {
    id: 'fhpgggnmdlmekfdpkdgeiccfkignhkdf',
    name: 'YiNote',
    resource: 'installed.png',
  },
  {
    id: 'fifmamcgakmdooafeplohbidenfjhmhm',
    name: 'Fun Cursors',
    resource: 'cursors/cute/1.cur',
  },
  {
    id: 'fikhliccflabbhhgdpmnbdbeeacecncl',
    name: 'KISer Web Clipper',
    resource: 'pick/pick.js',
  },
  {
    id: 'fnpmldckjbgpcdagndpgbjmflmlgmgnm',
    name: 'Narrate Ext',
    resource: 'web_accessible/dolbeyHelpers.js',
  },
  {
    id: 'fpjmalheeikilmmhlhjmgopcmplhbbla',
    name: 'E-Mükellef Toolbar',
    resource: 'content.js',
  },
  {
    id: 'ganicjnkcddicfioohdaegodjodcbkkh',
    name: 'Media Bias Fact Check',
    resource: 'assets/icon.png',
  },
  {
    id: 'gbcfdjgipmpinkahpiambcikjkijimhi',
    name: 'Sapling AI Detector',
    resource: 'assets/power.svg',
  },
  {
    id: 'gdjldebhilhckhblmhklofdebemiahhi',
    name: 'Enable UI3 Beta for Figma',
    resource: 'src/format.js',
  },
  {
    id: 'gecfhmlaldelfoeahjahajoooenmnlnd',
    name: 'Download with FlashGet',
    resource: 'data/grab/index.html',
  },
  {
    id: 'gfmkiampcljcdhgcalhgjhojfejlkhnn',
    name: 'WonderSwitcher',
    resource: '48x48-warn.60d9a594.png',
  },
  {
    id: 'ghppfgfeoafdcaebjoglabppkfmbcjdd',
    name: '豆伴',
    resource: 'media/meow.mp3',
  },
  {
    id: 'giljefjcheohhamkjphiebfjnlphnokk',
    name: 'Gitako',
    resource: 'content.css',
  },
  {
    id: 'gjhalfmdneljejledkcljfeaapgppbhl',
    name: 'Image Converter',
    resource: 'assets/img/icons/logo-48.png',
  },
  {
    id: 'gjodmjkcebohglhppopcejdgpaplpdac',
    name: 'Soop VOD Downloader',
    resource: 'merge.js',
  },
  {
    id: 'gkkhkniggakfgioeeclbllpihmipkcmn',
    name: 'SeaMeet',
    resource: 'assets/drop.png',
  },
  {
    id: 'glelnofehkiolecgdagikdfkfhoafogd',
    name: 'Document Scanner',
    resource: 'README.md',
  },
  {
    id: 'gmfcchdbgideoiehadmlmpnbhdcjoaih',
    name: 'Skimlinks Editor tool',
    resource: 'bundle.css',
  },
  {
    id: 'gngbpbolfnmlgjjonmfokgbfhebcbodn',
    name: 'Language IO Secure Page Translator',
    resource: 'languageio.png',
  },
  {
    id: 'gommajbfaholfodlhddhaonphdhonjgj',
    name: 'Ries',
    resource: 'assets/ries.png',
  },
  {
    id: 'habonpimjphpdnmcfkaockjnffodikoj',
    name: 'ArchiveBox',
    resource: 'icon/16.png',
  },
  {
    id: 'hbghjfaenddmdpbkobgdcgkmcdcdjjko',
    name: 'FluentAI - AI-Powered Dual Subtitles',
    resource: 'main.css',
  },
  {
    id: 'hgcfiedlifphndjalijbccglopbpclaj',
    name: 'Voice Control for Gemini',
    resource: 'icon-34.png',
  },
  {
    id: 'hjglipkneddkikocdjfhmnachfjoccjn',
    name: 'WordUp',
    resource: 'img/Knew.png',
  },
  {
    id: 'hkpdeailbnbffkgcepljgkcfjghmacdj',
    name: 'Studio Designer Capture',
    resource: 'index.js',
  },
  {
    id: 'hmeagocbdamaidjkjjmlekajhgigppjf',
    name: 'RECEPTIONIST',
    resource: 'analytics.js',
  },
  {
    id: 'hmeiacccncialhnailffohoaeebcjanp',
    name: 'facebook video downloader',
    resource: 'logo.png',
  },
  {
    id: 'hnfgakkbiefcdbkonflgfkadncclmpme',
    name: 'Clueso',
    resource: 'requester.html',
  },
  {
    id: 'hpekbddiphlmlfjebppjhemobaopekmp',
    name: 'PAGENOTE',
    resource: 'chunk/en.js',
  },
  {
    id: 'iadffjigiclimjimlfcpfedjomjapnhf',
    name: 'Medallia DXA',
    resource: 'content/hmScripts.js',
  },
  {
    id: 'iccafhamlplmkmobidnbmehnmeonakli',
    name: 'CloudGate UNO',
    resource: 'options.html',
  },
  {
    id: 'ignaljemchdlmoimaliinmonecgbdnkk',
    name: 'Dex',
    resource: 'recorder.html',
  },
  {
    id: 'ihebciailciabdiknfomleeccodkdejn',
    name: 'WME Toolbox',
    resource: 'images/B.png',
  },
  {
    id: 'iheecpmppehgghpjbhdpgjdllemcmdnk',
    name: 'Reforge',
    resource: 'pages/tasks.html',
  },
  {
    id: 'ihkbncennjhofkohbibnbgappjbncnoc',
    name: 'LabelResizer',
    resource: 'img/ups-24.png',
  },
  {
    id: 'ihoajedonhepnplmfgdkdjohbmadckdk',
    name: 'qTest Web Explorer',
    resource: 'common/context.js',
  },
  {
    id: 'iiiddigbaeolellfahokjnakndpnmlkn',
    name: 'Blooket Hacker',
    resource: 'icons/c2.png',
  },
  {
    id: 'inabndbiklomhjaljieihbhigmeoicbg',
    name: 'Economize! Mundo Conectado',
    resource: 'index.css',
  },
  {
    id: 'inobjcmbajbmllkgkigemcfnikdmlidn',
    name: 'RPost for Gmail',
    resource: 'images/icon-eye.png',
  },
  {
    id: 'ioebechakfmaoboaimphhmmjkjjanamn',
    name: 'Browser Locker',
    resource: 'img/eye.svg',
  },
  {
    id: 'jcbfebakonmpfdgeflcomgpgefmbhlck',
    name: 'Summary Box',
    resource: 'main.css',
  },
  {
    id: 'jfdlamikmbghhapbgfoogdffldioobgl',
    name: 'Hana Wallet',
    resource: 'contentInpageSui.js',
  },
  {
    id: 'jfeiiafdlajdfijkagdncomkjjpadogg',
    name: 'CloudCall',
    resource: 'img/logo.svg',
  },
  {
    id: 'jkkdjjioddilpdfjhahhniolodoohaoo',
    name: '极光Tab',
    resource: 'dock-runtime.js',
  },
  {
    id: 'jlhimcnaojgbmmmambapclkgonfcpajb',
    name: 'VSC Pro',
    resource: 'styles/shadow.css',
  },
  {
    id: 'jojhfeoedkpkglbfimdfabpdfjaoolaf',
    name: 'Polymesh',
    resource: 'page.js',
  },
  {
    id: 'kaeigipjcamcanmmhgpniimjagdleoee',
    name: 'NetHunt CRM',
    resource: 'gmData.js',
  },
  {
    id: 'kdkckejnngdmlcephpnfaggaeofloode',
    name: 'ChessHelper',
    resource: 'assets/img/logo.svg',
  },
  {
    id: 'knnmlfjaelcpgldncmbcpcpamlikabbl',
    name: 'Smart Video & Audio Downloader',
    resource: 'modal.html',
  },
  {
    id: 'kofcedljghienfpkfmdaadpafepbhifl',
    name: 'Baxter',
    resource: 'assets/css/main.css',
  },
  {
    id: 'kokedonacomdbdeokjgkhhoacmpjhdnb',
    name: 'ZeeDrop',
    resource: 'script.js',
  },
  {
    id: 'kpgefcfmnafjgpblomihpgmejjdanjjp',
    name: 'nos2x',
    resource: 'nostr-provider.js',
  },
  {
    id: 'lcgpdbficokndjodlcgflbhaibicompp',
    name: 'GPT-Prompter',
    resource: 'history.html',
  },
  {
    id: 'ldohbgcnonoffldimgdngkojkejibina',
    name: '塔塔网申神器',
    resource: 'images/qr.svg',
  },
  {
    id: 'lidhbccbajehjnpfjpnamoiemcnhhnki',
    name: 'Easy Cookie Editor',
    resource: 'icon-34.png',
  },
  {
    id: 'lmjdeimbphcbnfekpgblhlbhknpmaoij',
    name: 'Hello Kitty Cursor',
    resource: 'cursors/local.json',
  },
  {
    id: 'lopekoolgoijpmaidblgfgelbkfkgmod',
    name: 'Passkey Vault',
    resource: 'webauthn-inject.js',
  },
  {
    id: 'lphngfbnndkhdbmbgnlnhngihcpofkno',
    name: 'NOKA FUT EA FC 26',
    resource: 'icon16.png',
  },
  {
    id: 'mbgbeafnenfaffpbpkincpgpepjhekbm',
    name: 'CloudTalk Click-to-Call',
    resource: 'js/storage-BxHfMX-P.js',
  },
  {
    id: 'mbooipheihllljlmdencnhllhjonione',
    name: 'Ladders Apply4Me',
    resource: 'assets/icons/upgrade.svg',
  },
  {
    id: 'mdhellggnoabbnnchkeniomkpghbekko',
    name: 'Page Manipulator',
    resource: 'receiver.js',
  },
  {
    id: 'mejjgaogggabifjfjdbnobinfibaamla',
    name: 'SidebarGPT',
    resource: 'chat.js',
  },
  {
    id: 'mfcaadoifdifdnigjmfbekjbhehibfel',
    name: 'BOJ Extended',
    resource: 'css/user.css',
  },
  {
    id: 'miccfnlbijkmbckaagllchcfknjhgfnk',
    name: 'Speed Wallet',
    resource: 'popup.html',
  },
  {
    id: 'mjllncbijgeccmolnikpkbkpbjggcgij',
    name: 'Emails on Google Maps',
    resource: 'js/content.js',
  },
  {
    id: 'mlkjjjmhjijlmafgjlpkiobpdocdbncj',
    name: 'ChatGPT for Google',
    resource: 'js/sw.js',
  },
  {
    id: 'mnfkepfkbemjhmpijcepabfhkldegbga',
    name: 'Affinity Pathfinder',
    resource: 'pageWorld.js',
  },
  {
    id: 'mnmlipalillmakdiildpclhocfgcddnp',
    name: 'R7 Plugin',
    resource: 'appScript.js',
  },
  {
    id: 'mnndkablndpiopejbklhgngmpoibmkle',
    name: 'Google Maps Button Search',
    resource: 'cs.css',
  },
  {
    id: 'ndgbjebkdbfehipdojkdldkddgggbdoj',
    name: 'Half Bold',
    resource: 'assets/fonts/Fast_Mono.ttf',
  },
  {
    id: 'nejbhaabfihgocbacojonoekogiklfja',
    name: 'Bongo Cat Typing',
    resource: 'bongo-cat-typing-1.png',
  },
  {
    id: 'nhildbfbblldjpmlhopajgbcfjcepcoe',
    name: 'MemeRadar',
    resource: 'images/ico_x.png',
  },
  {
    id: 'nkcbfkbfngbaebldgenpafgffpgdhibi',
    name: '포커스팡 ai',
    resource: 'modules/tools.js',
  },
  {
    id: 'nkcelicpnkfoljdjomhgialiopkchkpm',
    name: 'SocialGood',
    resource: 'images/new/mail.svg',
  },
  {
    id: 'nmfjkeiebceinkbggliapgfdjphocpdh',
    name: 'Draft',
    resource: 'sandbox.html',
  },
  {
    id: 'nmidcdbnmhggenoknphfaanmphbbfkid',
    name: 'RevROI',
    resource: 'src/browser_action/browser_action.html',
  },
  {
    id: 'nnjedgoddpdneldhlbhaalfalipjpemi',
    name: 'Cisco Web Communicator',
    resource: 'extProps.json',
  },
  {
    id: 'nphnhlhdlbonnekhjlmphinfnmekiifk',
    name: 'Invisible scrollbar',
    resource: 'img/smile.png',
  },
  {
    id: 'npngfddkncjgkckldddkmechfcbpgfkm',
    name: 'DMM Etsy Helper',
    resource: 'scripts/core.js',
  },
  {
    id: 'oadkgbgppkhoaaoepjbcnjejmkknaobg',
    name: 'DetectGPT',
    resource: 'images/ai32.png',
  },
  {
    id: 'odgmdojokcjkabaafmajcoacjkknlgnk',
    name: 'Citeasy',
    resource: 'js/configLoader.js',
  },
  {
    id: 'ohplecfacbdnohamofbamfdmoafbfimd',
    name: 'Coupon Hacker',
    resource: 'src/utils/disable-logs.js',
  },
  {
    id: 'ojaikjnmjbcmmdanhgankifjjepbkekn',
    name: 'PJeR Tester',
    resource: 'content/style.css',
  },
  {
    id: 'ojeajjlkhfghfjinebghlfimdicholpb',
    name: 'Dextension',
    resource: 'browser.bc4bddf7.js',
  },
  {
    id: 'ojndmmhmgappgmabkojhkondgimifaac',
    name: 'Metricool',
    resource: 'img/metricool.png',
  },
  {
    id: 'omlcfkdfjaidfgbnjaefnplnpjcghgpk',
    name: 'Influencer Searcher Engagement Calculator',
    resource: 'content.js',
  },
  {
    id: 'pdhckheipnhhebkofhgmbfjneblopace',
    name: 'remio',
    resource: 'assets/cw.png',
  },
  {
    id: 'pdlnaniemlhepmcaijljdcbgbeklagjm',
    name: 'KDP Miner',
    resource: 'icons/16.png',
  },
  {
    id: 'peihjafefjfiagbbphhjbepceocnnagh',
    name: "Zoho Recruit's Resume Extractor",
    resource: 'from.html',
  },
  {
    id: 'phpgakpokidfdngbcfipndjcdgaoipna',
    name: 'Day.io',
    resource: 'generated/web-app/index.html',
  },
  {
    id: 'pkfmoknmnkbidlniedaloiijibdpjjmm',
    name: 'Grammit',
    resource: 'html/chat.html',
  },
  {
    id: 'aaojgabhhamejdlcenggjjcimjgbljin',
    name: 'TSETMC PLUS',
    resource: 'assets/img/16.png',
  },
  {
    id: 'abllalcelecmcopjgejfbmkhphcmpmae',
    name: 'Kick.com & Twitch.tv VOD Downloader',
    resource: 'content.css',
  },
  {
    id: 'afcejlnmkkpphfjdpkidbgkjodnkcbmj',
    name: 'Image Upscaler',
    resource: 'assets/js/index.js',
  },
  {
    id: 'agndfoikbihjcifcfnnbiffconjgofoe',
    name: 'Faceit-Extender',
    resource: 'icon-34.png',
  },
  {
    id: 'ahkmpgpdcneppdhhdgmmmcgicgfcfmka',
    name: 'CareerOS',
    resource: 'src/vite-env.d.ts',
  },
  {
    id: 'ajdehnbmilfnjbfhffbjdmkohamimpjo',
    name: 'Innfinergy v5.06',
    resource: 'faList.txt',
  },
  { id: 'alkcnclapbnefkodhbkpifdkceldogka', name: 'PO', resource: 'dist/0.js' },
  {
    id: 'badedfmbpbobohkldjaglpmobjilanah',
    name: 'ASTRO',
    resource: 'icons/icon-48.png',
  },
  {
    id: 'bbdefjbkdegboapdmjgehondplmfinek',
    name: 'LightPDF',
    resource: 'manifest.json',
  },
  {
    id: 'bgbecoklnfhhckmjjkooiaacmkfbgddo',
    name: 'CNFans Warm Warning Reminder Remover',
    resource: 'disclaimer.js',
  },
  {
    id: 'bhdhompadhkjjcalkhplcfdbjegnkegh',
    name: 'Add to Wishlistr',
    resource: 'change-user.html',
  },
  {
    id: 'bjobgelaoehgbnklgcaaehdpckmhkplk',
    name: 'SuperX',
    resource: 'js/listener.js',
  },
  {
    id: 'blfcndbglccbobmkepikmbmobcehhkkf',
    name: 'Product Fruits Editor',
    resource: 'aistudio/app.js',
  },
  {
    id: 'bnlbikbnkhjncbnalhnbehfahbgnlppp',
    name: 'Jira Persian improver',
    resource: 'fonts/Samim.woff',
  },
  {
    id: 'cjdkbdckofhgekglchbeaacbodmfdglg',
    name: 'Dealer Inspire Conversations',
    resource: 'installation-check.txt',
  },
  {
    id: 'cjiinmicahhdcmfpdohhaahgkdiehfga',
    name: 'Skipper',
    resource: 'logo.svg',
  },
  {
    id: 'cmibkdkcjkhjinfeobpnfgpafbjdgbke',
    name: 'WA Web Sender',
    resource: 'logo/cc.png',
  },
  {
    id: 'dfjdfadcciciboknnahlhgonamhfgmhp',
    name: 'Disable Automatic Gain Control-v2',
    resource: 'disableAutogain.js',
  },
  {
    id: 'diifcbhhodecmbglfjdgpfdamonhlcbd',
    name: 'Meltwater',
    resource: 'index.html',
  },
  {
    id: 'dlkffcaaoccbofklocbjcmppahjjboce',
    name: 'PixiJS DevTools',
    resource: 'inject/index.js',
  },
  {
    id: 'eacfcoicoelokngmcgkkdakohpaklgmk',
    name: 'NoteGPT',
    resource: 'logo.png',
  },
  {
    id: 'edkhpdceeinkcacjdgebjehipmnbomce',
    name: 'NZBDonkey',
    resource: 'icon/16.png',
  },
  {
    id: 'eejfnccgoejgidifcgpphjjfodmiofkm',
    name: 'Annoying Goose',
    resource: 'fonts/OFL.txt',
  },
  {
    id: 'egfphncmmcmmadobgnjmagdljdeghamj',
    name: 'Google Maps Route Optimization',
    resource: 'icon-48.png',
  },
  {
    id: 'einfacogeelpbhdlmiglhpbkicknhpla',
    name: 'TinyIMG Shopify SEO',
    resource: 'popup.html',
  },
  {
    id: 'ejdmegbgihgjnfdpmieagjmoekkohnhd',
    name: 'Canvas Easy Grader',
    resource: 'static/js/table.js',
  },
  {
    id: 'enhpjjojmnlnaokmppkkifgaonfojigl',
    name: 'trellus',
    resource: 'recorder.js',
  },
  {
    id: 'fhpgalaaijcopnfhiicpnmldphafpkfa',
    name: 'Duobot Tools',
    resource: 'gemify/index.js',
  },
  {
    id: 'flbkoklcepefekfcdjlabencimigaahd',
    name: 'Steganos Password Manager',
    resource: 'web/style.css',
  },
  {
    id: 'flmcglmalcnabfaalkomeaohklknbbhg',
    name: 'Meeting Timer',
    resource: 'icon.png',
  },
  {
    id: 'gamgpnolibdghflagmlghmpncjgonchn',
    name: 'Keyword Planner',
    resource: 'assets/loader.svg',
  },
  {
    id: 'gaophljmnnggiehnkkjnmpbbcfhelflh',
    name: 'Push Notifications Blocker',
    resource: 'notification.css',
  },
  {
    id: 'gbdfmlkiafpjocliomeeabjikgbjgian',
    name: 'Kinopoisk Player',
    resource: 'metric.js',
  },
  {
    id: 'gcniklopcjcohhkeldmfbjocjmngakne',
    name: 'LineupExperts',
    resource: 'page_lue.js',
  },
  {
    id: 'gddoffnommfblacbelhdogaooiediiol',
    name: 'OKKI io',
    resource: 'assets/img/icon.png',
  },
  {
    id: 'gdniinfdlmmmjpnhgnkmfpffipenjljo',
    name: 'Web Component DevTools',
    resource: 'nydus.js',
  },
  {
    id: 'gengdkfcffpnjfolbcbhfiocemfinkem',
    name: 'PalestinePact',
    resource: 'logo.png',
  },
  {
    id: 'gfeohnjfehbjlbgadiaemfkifhpmigme',
    name: 'FNAF Jump Scare',
    resource: 'videos/Foxy.mp4',
  },
  {
    id: 'ggccncbmbjgfaffceagiijgmjcdjchmn',
    name: '亚马逊选品助手',
    resource: 'inject.js',
  },
  {
    id: 'ggdggkhbmmgnogbcciencemciapnpeij',
    name: 'OnlineSub',
    resource: 'icon.png',
  },
  {
    id: 'giaeafdicekjpckngfbdnehblmamlhpa',
    name: 'Shopee Save Plus',
    resource: 'sspmPatch.js',
  },
  {
    id: 'gjobaaakoefjgpnocgminccbdcggohnl',
    name: 'Dictionary',
    resource: 'data/panel/inject.css',
  },
  {
    id: 'gldadickgmgciakdljkcpbdepehlilfn',
    name: 'Addy AI',
    resource: 'assets/icon.png',
  },
  {
    id: 'haaojocoaiflahnbiogmkkbbihfnffpd',
    name: 'Olhar Digital Ofertas',
    resource: 'index.css',
  },
  {
    id: 'hbccbgmealblckcpgmchokcngmlaadmo',
    name: 'CouponBind',
    resource: 'images/icon/webLogo128.png',
  },
  {
    id: 'hbhejhbegnlejblphomgobfbjgobjkmf',
    name: 'ControlUp Enrich',
    resource: 'assets/lodash-6fb0010b.js',
  },
  {
    id: 'hfghaecalgpfelanimgdmdjkjigjkill',
    name: 'Video Downloader',
    resource: 'assets/images/pops/img_bg.png',
  },
  {
    id: 'hgapfodjjnkkoebpfbcfhhenkklchngn',
    name: 'Steamify',
    resource: 'images/lvl_1.svg',
  },
  {
    id: 'hhkjhadndjgmdlcoikhkmihddopjcach',
    name: 'Marfeel Copilot',
    resource: 'assets/dom-N2gFqt8F.js',
  },
  {
    id: 'hkcbnlcphleacgfgkgfcocfbpnkjpkfo',
    name: 'Volume M',
    resource: 'img/icon/64.png',
  },
  {
    id: 'hkdjjdiilggppjhhlgfbiedplbneomen',
    name: '数字酋长',
    resource: 'images/icon16.png',
  },
  {
    id: 'hoffoefgnaakaafdfjpnjdkclhjkebjn',
    name: 'ClaudeKarma',
    resource: 'tips/tips.js',
  },
  {
    id: 'hopiakbbpmgkihbkehgdabadnikcgjlg',
    name: 'МТС Линк',
    resource: 'images/icon16.png',
  },
  {
    id: 'icmjegjggphchjckknoooajmklibccjb',
    name: 'Tomba',
    resource: 'icons/16.png',
  },
  {
    id: 'ifimcneililngppkpddcliecbpcgdjag',
    name: 'Movie Subtitles',
    resource: 'icons8-settings-32.png',
  },
  {
    id: 'ihngknalcecphcnmbkjhhhpbdnholpdd',
    name: 'TondiKey',
    resource: 'injected.js',
  },
  {
    id: 'ilcajpmogmhpliinlbcdebhbcanbghmd',
    name: 'Preact Developer Tools',
    resource: 'preact-devtools-page.css',
  },
  {
    id: 'imeedihedcjeieaokdpgandbgpjmadoh',
    name: 'EnglishXYZ',
    resource: 'icon.png',
  },
  {
    id: 'injanakciaoflbhcecmnpdekfflnllfd',
    name: 'Vidami',
    resource: 'js/popup.js',
  },
  {
    id: 'jamphegminpokpnalkjiecfoobdnlmfb',
    name: 'Sitemap Explorer',
    resource: 'images/link.png',
  },
  {
    id: 'jbjkingkpiakebpokhndnnmniaafoobe',
    name: 'SharpSports',
    resource: 'lib/pusher.js',
  },
  {
    id: 'jegbdohdgebjljoljfeinojeobdabpjo',
    name: 'Redirector',
    resource: 'images/icon-dark-theme-19.png',
  },
  {
    id: 'jejkgijkhbdnekbbdonkikkfdmlfmdol',
    name: 'Email Finder',
    resource: 'images/icons/icon_48_dark.png',
  },
  {
    id: 'jfemlmedfkiadfaihdcdkcoooleihhfn',
    name: 'Euskalbar',
    resource: 'konbinatua.html',
  },
  {
    id: 'jgilkmapjeaikiboajahmeiadceioobc',
    name: 'AI课代表',
    resource: 'logo.png',
  },
  {
    id: 'jhebmnhkiibndelgcgpgcacgckcbaail',
    name: 'AvaImport',
    resource: 'index.html',
  },
  {
    id: 'jhinkdokgbijplmedcpkjdbcmjgockgc',
    name: 'Kaguya',
    resource: 'icon16.png',
  },
  {
    id: 'jkjgekcefbkpogohigkgooodolhdgcda',
    name: 'BitPay',
    resource: 'popup.html',
  },
  {
    id: 'jkokgpghakemlglpcdajghjjgliaamgc',
    name: 'Anti phising safer browsing',
    resource: 'assets/icon.png',
  },
  {
    id: 'jlhemnnjmgaaaklbcdpiafnkgibjnoed',
    name: 'LearnicsU',
    resource: '16.js.map',
  },
  {
    id: 'jllbemjkkabaohnjcnajhflahlkehmlf',
    name: 'Odoo Utility',
    resource: 'pageScript.js',
  },
  {
    id: 'jnjgljhkgipcggegpgfipdedpihbfgfn',
    name: 'PLANERGY CheckOut',
    resource: 'config/config.js',
  },
  {
    id: 'jnkelfanjkeadonecabehalmbgpfodjm',
    name: 'Goby',
    resource: 'pageProvider.js',
  },
  {
    id: 'kbgpolnipdcfiobjgldjjhdcfpbkfdja',
    name: 'Tansa',
    resource: 'js/common.js',
  },
  {
    id: 'kckakcdglnklfekbjcghcogpohmdammg',
    name: 'Attention Insight',
    resource: 'tooltip.svg',
  },
  {
    id: 'keghdcpemohlojlglbiegihkljkgnige',
    name: 'metacert-internet-security',
    resource: 'images/spinner.gif',
  },
  {
    id: 'kgdcooicefdfjcplcnehfpbngjccncko',
    name: 'tpl 3.0',
    resource: 'clippyIt.png',
  },
  {
    id: 'kgdlkkikggjhckdodghipinhceacbfhf',
    name: 'heymax',
    resource: 'icon/16.png',
  },
  {
    id: 'kgifnbinkpgeomapdbmgibiofenahlkk',
    name: 'FocusFlow',
    resource: 'utils/storage.js',
  },
  {
    id: 'kjdgohfkopafhjmmlbojhaabfpndllgk',
    name: 'Auto Login',
    resource: 'js/tab.js',
  },
  {
    id: 'kpeogckcmkdchekkibjolbcnamomhneo',
    name: 'Hona',
    resource: 'icon-16.png',
  },
  {
    id: 'ledjfmkcimmpmjafnbhbbiknmpdgcnki',
    name: 'Simpplr One Redirector',
    resource: 'icons/icon48.png',
  },
  {
    id: 'lhifbnmampdmdadbhpeeoikkljhiaohn',
    name: 'WebInk',
    resource: 'dist.95dd2b81.js',
  },
  {
    id: 'lkkkngnoflaeicokibjcmgjacmhlnghg',
    name: 'Simple Sticky Notes',
    resource: 'assets/array-qohcpzTV.js',
  },
  {
    id: 'llkcpjgllfpfbcddhgbpnpppjbefkcpe',
    name: 'XenonHunt',
    resource: 'assets/window.js',
  },
  {
    id: 'llpepekkleeoeiloijhcafgpjdnhhcbl',
    name: 'YouTube Music Last.fm Scrobbler',
    resource: 'html/lastfm_callback.html',
  },
  {
    id: 'lmgdfnogocfflibblgddikbdncebighm',
    name: 'SUSCHEGG Unlocker',
    resource: 'icons/icon-512.png',
  },
  {
    id: 'lofnjlciokhgalebinnlfhkicepmmceh',
    name: 'BBViewer',
    resource: 'assets/index-cce0fb26.js',
  },
  {
    id: 'lojpifiihcmbngjbhpmggclejpeofoil',
    name: 'Dark Mode',
    resource: 'data/content_script/custom/dark.css',
  },
  {
    id: 'mbakineghcpagjflcabbakaobioigenf',
    name: 'Facebook Ad Video Downloader & Ad Data Export',
    resource: 'images/#.svg',
  },
  {
    id: 'mbjlobpodpimgbkmlmjiblnmfgajmebm',
    name: 'FluentTyper',
    resource: 'icon/icon32.png',
  },
  {
    id: 'mfmmmefogmfphgopniobajppgnpdmmde',
    name: 'Lionel Messi MeaVana',
    resource: '128x128.png',
  },
  {
    id: 'mgfijldnaehpnoobkafgcamlifodcbca',
    name: 'Color Picker',
    resource: 'icon-34.png',
  },
  {
    id: 'mgkjfmoolpkdchcocgfiiplpcmmfjohc',
    name: 'Rahavard',
    resource: 'public/icons/48.png',
  },
  {
    id: 'mjgkpalnahacmhkikiommfiomhjipgjn',
    name: 'Reef Chain',
    resource: 'page.js',
  },
  {
    id: 'mkebkjahadmflkecndjlokjodhmleiia',
    name: 'Netflix Subtitles & Dictionary',
    resource: 'manifest.json',
  },
  {
    id: 'mlglkmdpfnallpdjkgeobjfpigelopia',
    name: 'TurboLoud',
    resource: 'img/icon_128.png',
  },
  {
    id: 'mlpbdkpkicfkhgagnoamdcimmhdkakni',
    name: 'productboard',
    resource: 'popup.html',
  },
  {
    id: 'mnngnbmkiabhobdmeolcnjidongapoba',
    name: 'Passwd',
    resource: 'images/dots.png',
  },
  {
    id: 'nbmkpdgmnjbiohfpiofmjhpbeakpmlfd',
    name: 'HTML to Figma',
    resource: 'devices.json',
  },
  {
    id: 'ncclamkmacaipikhipjillbckmpclakb',
    name: 'Vanta',
    resource: 'images/ilma-svg.svg',
  },
  {
    id: 'ncodfadkoblpfngolndehmjpjepepdao',
    name: 'Farts Link',
    resource: 'main.css',
  },
  {
    id: 'nenecpncmjnembdcemieinlflpjlhfai',
    name: 'Special Characters',
    resource: 'main.js',
  },
  {
    id: 'ngemfjkmfjalbpfdinpgfdkikilclhbn',
    name: 'VORON',
    resource: 'helpers/va.js',
  },
  {
    id: 'nhbgpipnadhelnecpcjcikbnedilhddf',
    name: 'OGame UI++',
    resource: 'main.js',
  },
  {
    id: 'njmimaecgocggclbecipdimilidimlpl',
    name: 'Reddit Comment Collapser',
    resource: 'image/expand.png',
  },
  {
    id: 'nmcpliniiebkbdehpgicgfcidgkpepep',
    name: 'Auto Clicker',
    resource: 'css/_doc.css',
  },
  {
    id: 'npchijbmlhedglnnjbbgpkejpepmjomo',
    name: 'Video Downloader for Social Media',
    resource: 'logo.svg',
  },
  {
    id: 'npjfcmocnmkipbffpdpeemppbmbgkhle',
    name: 'UNISPY',
    resource: 'assets/logo.png',
  },
  {
    id: 'obnconamomcfmombecmjpcbdhndahnfa',
    name: 'Video Downloader Professional',
    resource: 'story.js',
  },
  {
    id: 'obpjaonipoaomjnokbimppohbpjibflm',
    name: 'Superdesign',
    resource: 'assets/icons/icon-16.png',
  },
  {
    id: 'ohjbldefcgdafflncjpnlajjnbkebjap',
    name: '求职方舟',
    resource: 'image/icon128.png',
  },
  {
    id: 'okgcefgeblkpichpcmnkpdadhnbbkano',
    name: 'Consenter Consent Agent',
    resource: 'options.html',
  },
  {
    id: 'olldcfahdgfhnnmkjapmnlngmnhdimid',
    name: 'Urdu',
    resource: 'src/inject/Mehr.ttf',
  },
  {
    id: 'onnmbokhmpeheaggdmglfffafmioikfi',
    name: 'Color Finder',
    resource: 'js/index.js',
  },
  {
    id: 'oodajhdbojacdmkhkiafdhicifcdjoig',
    name: 'Themes for Facebook',
    resource: 'iframe.html',
  },
  {
    id: 'padffmpicdplkgpeaapimbeggnmfelin',
    name: 'Photo Editor',
    resource: 'index.html',
  },
  {
    id: 'pbjjdhghffpemcglcadejmkcpnpmlklh',
    name: 'Salesforce Navigator for Lightning',
    resource: 'images/ajax-loader.gif',
  },
  {
    id: 'pejfngbeemalmomekgadijpgafjjocnn',
    name: 'Mereos',
    resource: 'options.html',
  },
  {
    id: 'pinjghhmldainbadpbmjhcjefadbmnck',
    name: 'Turn off sleep mode',
    resource: 'images/sleep-mode-on.png',
  },
  {
    id: 'pjdkmeabgpggjenaichdfjhdckcejjik',
    name: 'SimpleFill',
    resource: 'assets/autocomplete.css',
  },
  {
    id: 'pmmnimefaichbcnbndcfpaagbepnjaig',
    name: 'FoxWallet',
    resource: 'injector.js',
  },
  {
    id: 'abjfbanhppgiflmobebfffbijcfoeiao',
    name: 'Kontos',
    resource: 'kontos.png',
  },
  {
    id: 'abnnemjpaacaimkkepphpkaiomnafldi',
    name: 'Qualys Browser Recorder',
    resource: 'prompt.js',
  },
  {
    id: 'abpickdkkbnbcoepogfhkhennhfhehfn',
    name: 'Universal Profiles',
    resource: 'js/inpage.js',
  },
  {
    id: 'acgekcnaajgndgpkkkmojgdidgipaplh',
    name: 'GRAVITY Personal Help System',
    resource: 'config.json',
  },
  {
    id: 'achncdbcgahnmpkiinclefkdflhcjkfe',
    name: 'Dark Mode for Google Docs',
    resource: 'listener.js',
  },
  {
    id: 'adcbaggcjppnkmhfmjcdgagmggnfeikh',
    name: 'Server IP',
    resource: 'data/ip/ip.js',
  },
  {
    id: 'adppjpplkdfnnincbegikjnalffkkcko',
    name: '115闪推',
    resource: 'content-scripts/buttons.css',
  },
  {
    id: 'aelnobklpdknaaohkkionkkaakjlolbh',
    name: 'Netwrix EPP Browser Connector',
    resource: 'src/common.js',
  },
  {
    id: 'afpgkkipfdpeaflnpoaffkcankadgjfc',
    name: 'supermemory',
    resource: 'icon-16.png',
  },
  {
    id: 'ajhidbbpmnhjjffefekncbdbeopghnnn',
    name: 'Reelia Record',
    resource: 'layout/webcam.html',
  },
  {
    id: 'akmajmemkohkcmgcnbeeifciiahhfiid',
    name: 'Captcha Solver',
    resource: 'content/script.js',
  },
  {
    id: 'alknmlfampipmnmbjbpkcccoejomakcf',
    name: 'Haystack Intranet',
    resource: 'assets/images/icon16.png',
  },
  {
    id: 'amaencbkhcpbgpnphohjnacnpfcfpaij',
    name: 'Goldfire Highlighting',
    resource: 'find-popup.css',
  },
  {
    id: 'apajoicibffbcimdbemlbbgphfofkmee',
    name: 'Online protractor',
    resource: 'images/sprite-buttons.svg',
  },
  {
    id: 'banepeeclciljgfbpcjgnkfecnafnngg',
    name: 'Total Defense Traffic Light',
    resource: 'img/atf.svg',
  },
  {
    id: 'banojpgedjnmhklbggjekijlfckjodlh',
    name: 'What Font',
    resource: 'css/in.css',
  },
  {
    id: 'bdfjjoodmmlkfjfcfflhlidjilkmaiif',
    name: 'Classifieds List',
    resource: 'manifest.json',
  },
  {
    id: 'bhppjldobkpocplgfcimljjhdjgbpdnh',
    name: 'Komf',
    resource: 'bccfa839aa4b38489c76.wasm',
  },
  {
    id: 'bjbenndabachhhddadcekdalkhfkikmk',
    name: 'Captcha Solver',
    resource: 'content/script.js',
  },
  {
    id: 'bkfbelfdnfgjggjodebaikmjagdfodnh',
    name: 'Playbook',
    resource: 'src/client.js',
  },
  {
    id: 'bmcnbhnpmbkcpkhnmknmnkgdeodfljnc',
    name: 'LighterFuel for tinder',
    resource: 'resources/clarity.js',
  },
  {
    id: 'bnicgleoempcdjoinaolcflaacjaldco',
    name: 'View Forms',
    resource: 'manifest.json',
  },
  {
    id: 'bnmifaggmbajabmgbgolcapebogbejkn',
    name: 'Anti-Captcha Blocker',
    resource: 'content/script.js',
  },
  {
    id: 'bobhjedlciclpchpelkgiojkmmfgnihg',
    name: 'Dropshipman',
    resource: 'logo128.png',
  },
  {
    id: 'bonpnaaomhiopalpccfjddpghldoojih',
    name: 'Кнопка WorkHere',
    resource: 'icon-34.png',
  },
  {
    id: 'bpfdbfnkjelhloljelooneehdalcmljb',
    name: 'hektCaptcha',
    resource: 'dist/ort-wasm.wasm',
  },
  {
    id: 'bphnmjlejonaeiapcnimchlmhbpbdiip',
    name: 'Social Media Downloader',
    resource: 'js/popup.js',
  },
  {
    id: 'ccmkpknjfagaldcgidgcipbpdipfopob',
    name: 'Visual Python for Colab',
    resource: 'icon.png',
  },
  {
    id: 'cfaicdlgblgdchnpdilihjmfnogpjakl',
    name: 'amoCRM',
    resource: 'preset_docs.html',
  },
  {
    id: 'cgnokfdencgajdahelpddddkbgmjafnc',
    name: 'ElmiilloR Points',
    resource: 'content.js',
  },
  {
    id: 'cmkeochlgegefkeclhnedcolbphbkhke',
    name: 'Easy Driving Directions',
    resource: 'manifest.json',
  },
  {
    id: 'cmnkijnpijccccpcdfpjfccnojmckihl',
    name: 'Twitter Video Downloader',
    resource: 'static/main.js',
  },
  {
    id: 'cndhhgffdiojjdbdaaahcfocndpfpgkg',
    name: '스피드 서치',
    resource: 'popup.html',
  },
  {
    id: 'cnfmojhcmleelapdiapckcdlkgbmdolh',
    name: 'KWS Everywhere',
    resource: 'assets/icons/48.png',
  },
  {
    id: 'cnlfgddhlclkgeljeaecehinfmjegmkp',
    name: 'Mindgrasp AI',
    resource: 'favicon-1.png',
  },
  {
    id: 'cpfjfmpepjihhfkdjnabkpbglaljciel',
    name: 'Change Background for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'dcbmjjachokjjbofinpakpebaeckdhbc',
    name: 'Forethought Assist',
    resource: 'zaf.min.js',
  },
  {
    id: 'ddafdejlekcmnafgnbllcfkebabhabcl',
    name: 'zShare',
    resource: 'html/tpc.html',
  },
  {
    id: 'defjbhlehbkebaifofnaalipneaeaick',
    name: 'TikTok Ads Video Downloader & Data Export',
    resource: 'js/content.js',
  },
  {
    id: 'deifcolkciolkllaikijldnjeloeaall',
    name: 'Audible Library Extractor',
    resource: 'assets/icons/16.png',
  },
  {
    id: 'dfaldmjkfklnkenddjpikfkdnkinheke',
    name: 'DingDoc Flash Save',
    resource: 'icon.png',
  },
  {
    id: 'dfckileffglgodofacjbhbglplojmcfl',
    name: '치지직 광고 스키퍼',
    resource: 'js/common/utils.js',
  },
  {
    id: 'dgafcidlgmbcehokgdeghmfnbpbfhihh',
    name: 'WhenX',
    resource: 'icons/16.png',
  },
  {
    id: 'dgdbnfkjgaelelgdkfoiiinbengnking',
    name: 'IEmail',
    resource: 'icon-48.png',
  },
  {
    id: 'dhkkimcelcgopfjblmblfhbihlihhppe',
    name: 'Hilton ResSmart Click to Dial',
    resource: 'images/bg.svg',
  },
  {
    id: 'dladanhaondcgpahgiflodhckhoeohoe',
    name: 'Intention',
    resource: 'assets/icon.svg',
  },
  {
    id: 'dmbaagbmhlhdnlmbcncneijndejlalie',
    name: '리얼타임 실검',
    resource: 'toss_qr.png',
  },
  {
    id: 'dpbaboapnbnifbekhhjggaolbnncfjfe',
    name: 'Cortico Plug-in',
    resource: 'cortico-min.js',
  },
  {
    id: 'dplojpoeafjlpdpbokcpnojleddffaco',
    name: 'Fortect Browsing Protection',
    resource: 'mediaProtector.js',
  },
  {
    id: 'ebaagncgaginjlpgecnclpbbagkkoglk',
    name: 'TuDongChat',
    resource: 'shared/API.js',
  },
  {
    id: 'eebmbhmhoemlagcefiogcdipocebgalg',
    name: 'CallSwitch Call',
    resource: 'detectAjax.js',
  },
  {
    id: 'efakcomgmimcekdejnoafmmbgnpdhdfm',
    name: 'Video Search',
    resource: 'icon.png',
  },
  {
    id: 'efbjomaifkkegoiioihfcallbkfgibbo',
    name: 'Grid Lines Ruler',
    resource: 'settings.html',
  },
  {
    id: 'egdopahkemfhieboaplafiabdfejfeip',
    name: 'Archive.org Flip Book to PDF Downloader',
    resource: 'lib/jspdf.umd.min.js',
  },
  {
    id: 'ekobnhinclimmneheimhlokgmafjndog',
    name: 'Screenshot with URL',
    resource: 'icons/icon128.png',
  },
  {
    id: 'emeeapjkbcbpbpgaagfchmcgglmebnen',
    name: 'Surf Wallet',
    resource: 'js/inpage-script.js',
  },
  {
    id: 'eoobcaeojdpjfnnndkphhlpopkaeicho',
    name: 'Video to mp3',
    resource: 'content.js',
  },
  {
    id: 'fajmnddnafkmfdeekbkjcpohhoodhgjj',
    name: 'Click2Dial',
    resource: 'images/logo20.png',
  },
  {
    id: 'fakikmhjpdbdilplbjipceklhdglocmk',
    name: 'Lister',
    resource: 'injected/formcontrol.js',
  },
  {
    id: 'fbaccmibmbdppbofdglbfakjalaepkna',
    name: '网易外贸通助手',
    resource: 'tabs/sidebar.html',
  },
  {
    id: 'febckhheheicjbhjcbippbgjdcblbdhd',
    name: 'Surround sound for music and film',
    resource: 'noaudio.html',
  },
  {
    id: 'fflhlefcdbiidoncgmndlpkmbdiipilf',
    name: 'Help me write',
    resource: 'edit.svg',
  },
  {
    id: 'fgdngdmdannpbikmoidmblmaaheeohec',
    name: 'ネットショップまとめ検索',
    resource: 'icon-48.png',
  },
  {
    id: 'fghbfikeodjkbajmokiekipabfckcpgc',
    name: 'Free B2B Contact Info',
    resource: 'icons/logo.svg',
  },
  {
    id: 'fhdipaglhpjenbjmkopdhddkncphmcol',
    name: 'Sora Video Downloader',
    resource: 'popup.js',
  },
  {
    id: 'fkpngmoodfpnnnnbabhnnbemglnphncc',
    name: 'QR Code Scanner',
    resource: 'src/popup.html',
  },
  {
    id: 'fmblappgoiilbgafhjklehhfifbdocee',
    name: 'Forbole X',
    resource: 'scriptToInject.js',
  },
  {
    id: 'fmopogjbeifahpjdnobiphbcamijjajb',
    name: 'ScoreHub',
    resource: 'injected.js',
  },
  {
    id: 'fpdmlanpbgokpkcmkojldkjlajcnajko',
    name: 'UchiHelper',
    resource: 'html/ex.html',
  },
  {
    id: 'ggjmjkeaeojfdcbafefloifeaepeaeah',
    name: 'Emoji Swap',
    resource: 'options.js',
  },
  {
    id: 'gholhpojkalnpdkohpdemfebhccfegnd',
    name: 'Aceify.ai',
    resource: 'getGood.js',
  },
  {
    id: 'ghpkofodokpkakhbdbbeofmnomfikgon',
    name: 'Volume Mixer',
    resource: 'icon-34.png',
  },
  {
    id: 'gjdbakmcldoaklnobplcbcillcbbcjmm',
    name: 'Zoom To Fill',
    resource: 'logoblue.png',
  },
  {
    id: 'gkkcgbepkkhfnnjolcaggogkjodmlpkh',
    name: 'React Inspector',
    resource: 'assets/constants-DFTnBvsf.js',
  },
  {
    id: 'gngckpdhcngilcedefiiiapkhocojghm',
    name: 'Faircado',
    resource: 'save.html',
  },
  {
    id: 'goflchmdpidhhepjfpdmjoklebbjggje',
    name: 'Tab Suspender',
    resource: 'suspend.js',
  },
  {
    id: 'gpdfpljioapjogbnlpmganakfjcemifk',
    name: 'Translator',
    resource: 'icons/16.png',
  },
  {
    id: 'hcghlfjkhaigchnbbkbcgadlnckobaei',
    name: 'TwitterFollwr',
    resource: 'img/icon16.png',
  },
  {
    id: 'hcihcignkpajeehfnomlncinacagapdf',
    name: 'Open Selected Links',
    resource: 'html/popup.html',
  },
  {
    id: 'hcilfaknmnnhkmmojdhfilelmdebclig',
    name: 'Gift Hero',
    resource: 'fonts/Montserrat/OFL.txt',
  },
  {
    id: 'hdbnkdbhglahihjdbodmfefogcjbpgbo',
    name: 'OptMeowt',
    resource: 'content-scripts/injection/gpc-dom.js',
  },
  {
    id: 'hdpilhipaebhaejfimbgkcplobikmmap',
    name: 'YouTranslate',
    resource: 'src/welcome/index.html',
  },
  {
    id: 'heghedjicmbkemhgkclendfkjhfdambh',
    name: 'Snipe Tool',
    resource: 'icons/icon48.png',
  },
  {
    id: 'hfoohecgdcecmkpphocgddlpchnfcbpk',
    name: 'Raiz Rewards',
    resource: 'assets/js/index.9a297b67.js',
  },
  {
    id: 'hhblpocflefpmmfibmajdfcjdkeafpen',
    name: 'Spider',
    resource: 'images/power.svg',
  },
  {
    id: 'hhedjnckjdclgflodngblaiepkpedeab',
    name: 'AltText.ai',
    resource: 'options/options.js',
  },
  {
    id: 'hhefhkepfnmcgalemmofagaioeegonbc',
    name: 'Savee',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'hjlknhokmbkhaaifmhakglldciallloh',
    name: 'ESB Window Positioner',
    resource: 'images/switch.png',
  },
  {
    id: 'hkpciegbnpmpbpodnloafnoinjpbmakp',
    name: 'Buzz*',
    resource: 'buzz-api.js',
  },
  {
    id: 'hlmegjdcapbldncaefgeceaddoobjgfj',
    name: 'Pinterest Images Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'hmgiofkfdfmocnbdlaieodfpmlpockka',
    name: 'Myndr for school v2 Basispoort',
    resource: 'css/sso.css',
  },
  {
    id: 'hnfdibcbmlppjlkefinedeffoiomlecc',
    name: 'letmeout',
    resource: 'after.inject.js',
  },
  {
    id: 'holcbbnljhkpkjkhgkagjkhhpeochfal',
    name: 'webgpu_inspector',
    resource: 'webgpu_recorder.js',
  },
  {
    id: 'hplbpdkajdhlggncdpdmnkjldopmoomg',
    name: 'ZeroAI',
    resource: 'tabs/auth-success.html',
  },
  {
    id: 'ibckhpijbdmdobhhhodkceffdngnglpk',
    name: 'Unclutter',
    resource: 'modal/dark.css',
  },
  {
    id: 'ihbpmnmphkggmijhpofecgepllfmliki',
    name: 'Cursor Trails',
    resource: 'popup.js',
  },
  {
    id: 'ihplgdgihkkniiddfjgdamnallecjkja',
    name: 'Rabattcorner',
    resource: 'src/content/index.tsx',
  },
  {
    id: 'ijpgccednehjpeclfcllnjjcmiohdjih',
    name: 'Peer',
    resource: 'v4.chunk.js',
  },
  {
    id: 'ilpgiemienkecbgdhdbgdjkafodgfojl',
    name: 'Telegram Group and Channel Search Tool',
    resource: 'popup.html',
  },
  {
    id: 'imbdabdbipefiieekabpncjcambojjdg',
    name: 'Shulex Copilot',
    resource: 'logo.png',
  },
  {
    id: 'infdegpbaoaebllngceboapplllecfpc',
    name: 'Extrabux',
    resource: 'assets/16.png',
  },
  {
    id: 'ingengaocofccoknjddoiljmbapfnifh',
    name: 'RecSnap',
    resource: 'img/sc.svg',
  },
  {
    id: 'jaclholjkcdapeppngdgepndkjpomlfe',
    name: 'Japanese Dictionary JP',
    resource: 'opencvHandler.html',
  },
  {
    id: 'jbkgjmpfammbgejcpedggoefddacbdia',
    name: 'Parallel wallet',
    resource: 'js/page.js',
  },
  {
    id: 'jblbdklppkompnbobkpncbmbjkaeaeah',
    name: 'Reeader',
    resource: 'images/logo.png',
  },
  {
    id: 'jgabolakboecklnmocdljjcdkkhjigck',
    name: 'Corgi AI',
    resource: 'start.html',
  },
  {
    id: 'jgemokhiblmkgicejlcpkoaohfpcgehj',
    name: 'GoodLinks',
    resource: 'images/error.svg',
  },
  {
    id: 'jgnjpnmofkalfliddjelaciggjgnphgm',
    name: 'ChatGPT ️',
    resource: 'lib/ui.js',
  },
  {
    id: 'jkhapdmdkccfbgifiaheghjgljhhploh',
    name: 'AskGo:AI Chat Assistant',
    resource: 'options/build.sh',
  },
  {
    id: 'jnbamieaacddlfcoanmbkclnpoafhmie',
    name: 'ElementHider',
    resource: 'src/browser_action/guide.html',
  },
  {
    id: 'jocnlahnjacckbiffghcopjfbifdjocj',
    name: 'Search AliExpress by Image',
    resource: 'popup.js',
  },
  {
    id: 'jpaihclmbopabkcedfdhphihnddnmhjf',
    name: 'QuickCapture',
    resource: 'assets/icons/qc_logo.svg',
  },
  {
    id: 'jpkiadimecfcjjjmfgjdimphbcmljkcb',
    name: 'Download HD Videos, GIFs & Images | PinSnap',
    resource: 'assets/icon16.png',
  },
  {
    id: 'kafpnhpkhahnneolfnkpjfoigfcjafne',
    name: 'Operative IQ',
    resource: 'operativeiq.png',
  },
  {
    id: 'kbcknkijhfdjheggbdnhlbgeinfaldbf',
    name: 'FindSCI',
    resource: 'assets/img/icon.png',
  },
  {
    id: 'kedahopbcbdppafmfmilachnkehnagbm',
    name: 'HelloScreen',
    resource: 'locales/nb.yml',
  },
  {
    id: 'kegeajllnfkfhcljjebedaeedpmkcbpe',
    name: 'Awesome Custom Cursor',
    resource: 'libs/order.js',
  },
  {
    id: 'kennjipeijpeengjlogfdjkiiadhbmjl',
    name: 'PWR Wallet',
    resource: '1x1.png',
  },
  {
    id: 'kfdkgfifhmnmplmlglbjamphjdahhbbn',
    name: 'Kolsquare Analytics Sidebar',
    resource: 'images/go_away.gif',
  },
  {
    id: 'kgidpmgjombekdkhnlkbhaoenldlpmeb',
    name: 'Sitemap Generator',
    resource: 'pages/tooltip.js',
  },
  {
    id: 'khgnimehiiohfhdjbailflcfgjjlgamo',
    name: 'AI Cover Letter Generator',
    resource: 'fonts/Henk-Work-Regular.woff',
  },
  {
    id: 'khigmghadjljgjpamimgjjmpmlbgmekj',
    name: 'Exploratory Testing',
    resource: 'js/annotation_editor.js',
  },
  {
    id: 'kjdicgdafaigpiaplpaehenffmlcijbj',
    name: '60FPS Upload Manager for TikTok',
    resource: 'inject.js',
  },
  {
    id: 'kjlghdmljfgngjdpeaiogebkiilpiimk',
    name: 'Yawas',
    resource: 'localedit.html',
  },
  {
    id: 'klgadkonjpkgmlpkahbmhhcjlkoeepji',
    name: '365 Power Pane',
    resource: 'ui/pane.html',
  },
  {
    id: 'klhcnkknganbneegjihbcfjoifiomhfn',
    name: 'WhisperAI',
    resource: 'icon-34.png',
  },
  {
    id: 'knefbmffdlieahakpjimbdkcaoomncje',
    name: 'sellerboard Amazon FBA Profit Calculator',
    resource: 'src/assets/icon-16-notactive.png',
  },
  {
    id: 'kodajckmdnamjlagjhjahccimgjanigg',
    name: 'SuperRefresh',
    resource: 'contentScript/style.css',
  },
  {
    id: 'kpcbjghknfclbkejkdllpjhhheppaoca',
    name: 'zkPass Schema Validator',
    resource: 'manifest.json',
  },
  {
    id: 'kpkchgmdhpkfgcgcoiabbcghkpfcmfoc',
    name: 'Mono Audio',
    resource: 'offscreen.js',
  },
  {
    id: 'ldaenkbmmnehilpkmnigoaodoiicdlje',
    name: 'Image DP',
    resource: 'img/logo.png',
  },
  {
    id: 'lebfjihneeoamkmkopmkbohkceijapjk',
    name: 'Video Translator for Udemy',
    resource: 'content.js',
  },
  {
    id: 'lfckcgkphfglcodbedlpkkkkjicbngpe',
    name: 'Chameleon Builder',
    resource: 'images/icon.png',
  },
  {
    id: 'liencdcnkiopkjihmekmlnjkcajjppnf',
    name: 'Disney+ Subtitles & Dictionary',
    resource: 'disney/354.js',
  },
  {
    id: 'ljnmedkgcgidbbjhbkdonempgcgdhjfl',
    name: 'Dual Subtitles for Netflix',
    resource: 'settings_box.html',
  },
  {
    id: 'lkcddhbpnghbonhlgcokbbdlmmcepjpk',
    name: 'Quinncia Analysis',
    resource: 'public/fonts/Lato-Bold.woff2',
  },
  {
    id: 'lkgdbimigeeehofgaacanklgmfkilglm',
    name: 'Галерея поздравлений',
    resource: 'js/id3.js',
  },
  {
    id: 'loinekcabhlmhjjbocijdoimmejangoa',
    name: 'Glass wallet',
    resource: 'welcome.html',
  },
  {
    id: 'mahpbcfolnblioiakoidcnmhghjijdaa',
    name: 'Copy Paste URLs',
    resource: 'src/ui/setup/index.html',
  },
  {
    id: 'meekeganelaaeijimakghhbiphjbfgdn',
    name: 'Walles.AI',
    resource: 'logo.png',
  },
  {
    id: 'menhdcpmknncjfdihkjoinfdelnnllfe',
    name: 'Intermedia Unite',
    resource: 'popup/index.html',
  },
  {
    id: 'mfnnghknbffgllboglgodkgbiplipmnm',
    name: 'DRESS CODE Shadow IT',
    resource: 'content.css',
  },
  {
    id: 'mhnnbdhhncjkfbkbkapifcmfjdgifpld',
    name: 'IPTV / HLS player',
    resource: 'm3u8.js',
  },
  {
    id: 'mkhdiephfhifcgpmkaaboknnbdpjlneg',
    name: 'DeepSeek Assistant',
    resource: 'js/toolbar.js',
  },
  {
    id: 'mompiecabddeaogfabickfokcianmckn',
    name: 'Spatio Stopwatch',
    resource: 'popup.js',
  },
  {
    id: 'mpkkpkdbheikpcgpiacppmbnpmepibac',
    name: 'Etsy Analyzer',
    resource: 'img/img.png',
  },
  {
    id: 'najkpicijahenooojdcnfdfncbaidcei',
    name: 'Chats Backup for wa',
    resource: 'injected.js',
  },
  {
    id: 'napifcagjkgokhhgfbagpcaedfdmikfk',
    name: 'PriceTip',
    resource: 'img/gear.svg',
  },
  {
    id: 'ndlpohihdhnmgdnbmlgpnijmdddefooj',
    name: 'Screvi',
    resource: 'src/content.jsx',
  },
  {
    id: 'nhajcafhnpnnfeniefjmaplmeodoffem',
    name: 'Multi-RTL',
    resource: 'assets/icons/icon16.png',
  },
  {
    id: 'nhkdchmlljcklaloabakpcnbpdlcffgk',
    name: 'Pinterest Dark Mode',
    resource: 'listener.js',
  },
  { id: 'nhlnehondigmgckngjomcpcefcdplmgc', name: 'FW', resource: 'page.js' },
  {
    id: 'nipdbleimjhfpfdkopbfeagjjkmcfhbj',
    name: 'Mouse Gesture',
    resource: 'theme-loader.js',
  },
  {
    id: 'nkalaahhnoopcmopdlinibokjmjjacfa',
    name: 'PromptSloth',
    resource: 'icon/16.png',
  },
  {
    id: 'nknhiehlklippafakaeklbeglecifhad',
    name: 'Nabox Wallet',
    resource: 'js/inPage.js',
  },
  {
    id: 'nkpcllmdbloacfoajbdahinnlfmeinlo',
    name: 'Rogue Dex',
    resource: 'inject.js',
  },
  {
    id: 'noeilkljmfafbfcdoieialchglebbcea',
    name: 'FOP2',
    resource: 'images/telephone19.png',
  },
  {
    id: 'nojllijcdcbeobljfpkjbpeajcbfadfk',
    name: 'Codes Hunter',
    resource: 'src/js/main.js',
  },
  {
    id: 'npnncoldkhcnpijbhmhpaeojgholpfoi',
    name: 'popup2tab',
    resource: 'style/popup.css',
  },
  {
    id: 'oambclflhjfppdmkghokjmpppmaebego',
    name: 'Kastle',
    resource: 'injected.js',
  },
  {
    id: 'obabcjddknfnjjeblajgnlflppnpgdhi',
    name: 'SEO Schema Visualizer',
    resource: 'newtab.html',
  },
  {
    id: 'obgopghdefjihikoknnjfooahlleabno',
    name: 'start.me Bookmarker',
    resource: 'popup.html',
  },
  {
    id: 'obngoldljmnnpggbekneikaohbeflbee',
    name: 'Send Mass Mail + HTML inserter for Gmail',
    resource: 'main.1394e8ab.css',
  },
  {
    id: 'obpicmhmbfddhkcbiapfeginbafnjmmm',
    name: 'Drift Email',
    resource: 'cal.png',
  },
  {
    id: 'ofgncemnlblfnocjbojdhamacfffcpnm',
    name: 'Tab Suspender Pro',
    resource: 'suspended.html',
  },
  {
    id: 'ofmdcdkoaoamflggkifhcckojmnhbaap',
    name: 'Cookie Clicker Advisor',
    resource: 'script.js',
  },
  {
    id: 'ogggcdigdmbnngkgkdkagajklmfkabmf',
    name: 'SpeedUpVideo',
    resource: 'css/inject.css',
  },
  {
    id: 'oigfjbmcoinjkdpkeepdpbekaidppjij',
    name: 'Article Summarizer',
    resource: 'assets/index-D7qxjFU9.js',
  },
  {
    id: 'ojbompffhdcndgndakoghndckimkohca',
    name: 'Userflow',
    resource: 'node_modules/userflow.js-self-hosted/ui.js',
  },
  {
    id: 'ojfdbbfppbmahphbcchcodhfnkhoejoc',
    name: 'Job Application Tracker',
    resource: 'worker.js',
  },
  {
    id: 'okmipgoegollhjhphbokjdljbbddnbpd',
    name: 'Capture screenshot & Screen Recording',
    resource: 'gif.js',
  },
  {
    id: 'omfeeokgnjnjcgdbppmnijlmdnpafmmp',
    name: 'Dark Reader',
    resource: 'icons/32.png',
  },
  {
    id: 'onoihpdjgfmiceignbghnlilcbibjmhk',
    name: 'SellerStats',
    resource: 'images/icon.png',
  },
  {
    id: 'pdeebkpgdaflejgihpbniammmelkdnac',
    name: 'Roblox JobId Join',
    resource: 'launch.js',
  },
  {
    id: 'pdenencoggppbmpgiplaaboifcaeneek',
    name: 'NexoCS',
    resource: 'framework/popup.js',
  },
  {
    id: 'peikmglknpoodfkejhlfejhjpjijikml',
    name: 'Kvalood Tools',
    resource: 'js/page.js',
  },
  {
    id: 'phafeggjhdhfcmlanhmgbmcbgocapnik',
    name: 'Whatsapp Translator',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'phenpkgkiaibdlfgllchgfhdfiephpdi',
    name: 'Alloy',
    resource: 'lib/single-file-zip.min.js',
  },
  {
    id: 'pkghjinojggjcpfnbpncpkbmpdijldla',
    name: '1688 price tracker',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'pkhmoinpecjngkokbmjfdhgecfljcegi',
    name: 'Faceit Stats',
    resource: 'img/logo.png',
  },
  {
    id: 'pljdghaomjmmleolekcgcamfpbhekbmc',
    name: 'FuseBase PRO',
    resource: 'assets/flex.css',
  },
  {
    id: 'plnialnlnbaodbmoedcppffmgfmmghbj',
    name: 'CSSViewer',
    resource: 'img/body.png',
  },
  {
    id: 'pnhmlecoofeoofajcjenndnimhbodhlg',
    name: 'Shinkansen',
    resource: 'translate-doc/index.js',
  },
  {
    id: 'poeodakgiedndmmkabehagjgpbjkcfgg',
    name: 'Abookmark',
    resource: 'a.html',
  },
  {
    id: 'ppfpaggnedkhedggdgiolgeoiglaaaed',
    name: 'PetPat',
    resource: 'images/pets/cat/eat.gif',
  },
  {
    id: 'accebjobnljiehcaocahignlanfnfkcc',
    name: 'Meditation, Relax, and Calm',
    resource: 'pages/mind/meditation.html',
  },
  {
    id: 'achnhggjjhnadfapkmgallnbmemdojdi',
    name: 'CheerpJ JNLP Runner',
    resource: 'cheerpj/c.js',
  },
  {
    id: 'admidbamafmdejfidoeijgghcffngbmp',
    name: 'Next DevTools',
    resource: 'src/popup.html',
  },
  {
    id: 'aehehdkincihpbbbkkiicnbmfhhnokfb',
    name: 'iManage File Transfer',
    resource: 'assets/imanage16.png',
  },
  {
    id: 'afoeihnfgdjgfmpdkholalcelninnmje',
    name: 'BlankADS',
    resource: 'assets/images/Logo16.png',
  },
  {
    id: 'aicjpengcdgnlhgdhmemfgoddmmhaddm',
    name: 'Scanguard',
    resource: 'app/sidebar/index.html',
  },
  {
    id: 'ajgehecfkfhindkhdcjmifbngkfdflla',
    name: 'Yoti Password Manager',
    resource: 'popup/popup.html',
  },
  {
    id: 'ajmoajhghochmponojnjididjabohili',
    name: 'Chat AI',
    resource: 'src/styles/prism.css',
  },
  {
    id: 'akckefnapafjbpphkefbpkpcamkoaoai',
    name: 'Galaxy Station Wallet',
    resource: 'keplr.js',
  },
  {
    id: 'akdiolpnpplhaoedmednpobkhmkophmg',
    name: 'Bloom',
    resource: 'src/panel/index.html',
  },
  {
    id: 'ammcgcinfdmmgdjmjbddjpmopflcialc',
    name: 'ExamCookie Chromebook',
    resource: 'popup.html',
  },
  {
    id: 'ampccappllebdaplacfcopfdgofmohmh',
    name: 'Deepbrid',
    resource: 'icons/icon16.png',
  },
  {
    id: 'ancooclifmcdfafbgjmgpmcembfaknka',
    name: 'Elink',
    resource: 'popup.html',
  },
  {
    id: 'andfohanhajengikbobaoblbdkmlkicp',
    name: 'Breathe',
    resource: 'src/dashboard/index.html',
  },
  {
    id: 'aohgbidimgkcolmkopencknhbnchfnkm',
    name: 'YouTube Summary with Bing Chat',
    resource: 'images/48.png',
  },
  {
    id: 'apkkllhahggfkhfdlmpopcncnaiclfdm',
    name: 'The ABC of Faith',
    resource: 'bible/be/mf',
  },
  {
    id: 'banecahclhdppaebnlhnhnhfeoinnfjn',
    name: 'TabRevive',
    resource: 'injected.js',
  },
  {
    id: 'bbbnbmpdkfkndckfmcndgabefnmdedfp',
    name: 'DearFlip',
    resource: 'dearflip.html',
  },
  {
    id: 'bbjnnajeogkkmljfdoengamaiomfhbch',
    name: 'Telegram Video Downloader',
    resource: 'inject.js',
  },
  {
    id: 'bcefgmhpbmghjcenbklchobmogjhaagl',
    name: 'Popup View for Google Translate',
    resource: 'data/inject/selector.png',
  },
  {
    id: 'beenkcmmckdpbfbdaegofdokmkiciigl',
    name: 'Appsheet Translate',
    resource: 'popup.js',
  },
  {
    id: 'bfeaaehafjdpepdhnnagicdmompoldal',
    name: 'Pro-Study Online',
    resource: 'appsettings/appsettings.json',
  },
  {
    id: 'bgjfijhibiimbcbkjddfaanmhojjkmbc',
    name: 'Jobalytics',
    resource: 'icon/icon.png',
  },
  {
    id: 'bgpnjdahpmkaflfpbkdplndklnmghklp',
    name: 'Auto Typer',
    resource: 'gemini icon.png',
  },
  {
    id: 'bhmadppkfhoofholcdndbcodfomajacf',
    name: 'Downloadyze',
    resource: 'shr/picker/picker.html',
  },
  {
    id: 'bhoocdffjjnclofbhdejeicidimoidhh',
    name: 'SmartCopy All-in-One Copy Tool',
    resource: '_locales/en/messages.json',
  },
  {
    id: 'biailfjhlmalakjackgpekkbmljelldc',
    name: 'Sprout Social',
    resource: 'scripts/bookmarklet.js',
  },
  {
    id: 'bjjjdfkmchhojjkgbnhhlpoaeehpjjhi',
    name: 'TL Kiosk',
    resource: 'images/back.png',
  },
  {
    id: 'bjmgfifmindcopelajhaahpibmmojkga',
    name: 'OD MFA',
    resource: 'common.js',
  },
  {
    id: 'bkahonfnnidbeekmmfklgfmodagnngfb',
    name: 'Lucen Track widget',
    resource: 'www/js/153.js',
  },
  {
    id: 'bkfagmnilllacgphpepbdmialglfjjpi',
    name: 'Chartnote',
    resource: 'src/assets/img/cog.webp',
  },
  {
    id: 'bmbpecojbbccmjmllncnajipkclmnclh',
    name: 'Яндекс.Метрика',
    resource: 'metrika-counters.js',
  },
  {
    id: 'bocdfmfhfcobbagfcbimemeclglilcbk',
    name: 'chromeIPass',
    resource: 'icons/key_16x16.png',
  },
  {
    id: 'bpakimmhdmcbgbcnhanfcpelcnookihi',
    name: 'Pomodoro Timer PRO',
    resource: 'img/red/icon48.png',
  },
  {
    id: 'cacalbbpkmcjpnlcjanfmmnffddhibhc',
    name: 'Click To Call',
    resource: 'js/jquery.js',
  },
  {
    id: 'camilcgaojjnemdajaipbjjkehleclnf',
    name: 'Ptengine-Assistant',
    resource: 'js/_sid.js',
  },
  {
    id: 'cbnkianddlamdpjehmjlmkaiikoejgkf',
    name: 'おやすみyoutube',
    resource: 'blocked.html',
  },
  {
    id: 'cchjdgbabijeikbdgldplhhbbbkeeaei',
    name: '쿠팡 쇼핑 도우미',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'cciemibfcmeeiijeefebhojenhnpoibc',
    name: 'Mindful Browsing',
    resource: 'fonts/lato.css',
  },
  {
    id: 'cfmeoknomhdgcbcmgmpbbjiggfboniie',
    name: 'DoubleSubs',
    resource: 'index.css',
  },
  {
    id: 'cfpdmpepieedplgjphncpgiipkcjennh',
    name: 'Trace',
    resource: 'injectScript.js',
  },
  {
    id: 'cgbeoilpeagnpjjhfoomncafmnebikmb',
    name: 'StealthGPT',
    resource: 'assets/content-BHzgOyuU.js',
  },
  {
    id: 'cgjkfhodbbeidhhfbjnjhcpjdimpfjaj',
    name: 'IG follower Export Tool',
    resource: 'icons/logo_128.png',
  },
  {
    id: 'chhclfoeakpicniabophhhnnjfhahjki',
    name: 'Contact Extractor for wa',
    resource: 'injected.js',
  },
  {
    id: 'cncajhnkbignallkkklloalnkbdigome',
    name: 'OR Channel Bridge',
    resource: 'img/icon16.png',
  },
  {
    id: 'dbofniohnfjigodceiebfkcfdhncnici',
    name: 'Scroll buttons',
    resource: 'img/arrow-up.svg',
  },
  {
    id: 'dcdpkefhmpgpnogeddkpjjmioaeopche',
    name: 'Nimble Prospector',
    resource: 'frame/frame.js',
  },
  {
    id: 'deeppkmgnnimofmekmncjmncpcbodmbl',
    name: 'OD SSO',
    resource: 'common/common.js',
  },
  {
    id: 'dfjghhjachoacpgpkmbpdlpppeagojhe',
    name: 'OMOcaptcha',
    resource: 'configs.json',
  },
  {
    id: 'dgboealbpckjkjfhabahfgnjlaeghglh',
    name: 'HTML Tag Error Checker',
    resource: 'img/48.png',
  },
  {
    id: 'dhdlfejeealpikjnbkbphpofkgkggfln',
    name: 'CrowdStrike Threat Intelligence',
    resource: 'content.css',
  },
  {
    id: 'dhnbkfcpjceeaaefbiebenjipbahkjhj',
    name: 'Authenticator Pro',
    resource: 'styles.css',
  },
  {
    id: 'diojcfpekhhnndfmggknljpnfpcccbhc',
    name: 'Dictionariez',
    resource: 'card.html',
  },
  {
    id: 'dkhkiafhbiibnjpdmklikeliallmapgj',
    name: 'TheGuarantors',
    resource: 'assets/img/logo.png',
  },
  {
    id: 'dkodhhfojohfonoidpcheichdjbicnfg',
    name: 'GfG to LeetCode',
    resource: 'icons/lc.png',
  },
  {
    id: 'dmfbmenkapmaoldfgacgkoaoiblkimel',
    name: 'Adobe Content Authenticity',
    resource: 'adobe.png',
  },
  {
    id: 'dnjmmaceakkflffnmchkanfndcphiagf',
    name: 'AdBlocker Diamond',
    resource: 'icon_16.png',
  },
  {
    id: 'doblkllolfingbjkbmelgiepdggnbmhi',
    name: 'Proview proctoring',
    resource: 'logo.png',
  },
  {
    id: 'dplmpomngmlplmdbloihfopnnakiddfm',
    name: 'TopNod',
    resource: 'inpage.js',
  },
  {
    id: 'eanecaddbhcklehmpnhfdblnejofiedk',
    name: 'Reminder',
    resource: 'icons/icon48.png',
  },
  {
    id: 'ebpiondkhkldijolgmhfenknngkkjola',
    name: 'ps-wasm',
    resource: 'viewer.html',
  },
  {
    id: 'edkkcpojmipkpbiaiggldpoiefhnikmc',
    name: 'Boycat',
    resource: 'Boycat.png',
  },
  {
    id: 'edlgjpfddpdbokeadnobjgocepdfbgki',
    name: 'Smart Shopping Search',
    resource: 'icon.png',
  },
  {
    id: 'efbmlkodbdhahiljghapjcbofehkhpie',
    name: 'AiPrice(AliPrice) Search by Image for AE Beta',
    resource: 'assets/js/options.js',
  },
  {
    id: 'efmcpiahjmffjhdkllmnfehdgabepjbb',
    name: 'Avaya Cloud Office for Google',
    resource: 'client.html',
  },
  {
    id: 'ehdgefjodihkpljimhcikjflmikgggap',
    name: 'BarnumPT',
    resource: 'apps/apps.css',
  },
  {
    id: 'ehliocfmgnkdcgigclppnodpgkiodfco',
    name: 'ContentBot AI Writer',
    resource: 'tools.json',
  },
  {
    id: 'eiglgndkjiabiepkliiemoabepkkhacb',
    name: 'Upload image from clipboard or URL',
    resource: 'public/Roboto.woff2',
  },
  {
    id: 'ejolmkmnegbamafoknjamlggejcikonk',
    name: 'Enhanced Outlook',
    resource: 'js/mainCS.js',
  },
  {
    id: 'ekiejpimpidhnjebfecllpnpiphndggn',
    name: 'Kitty',
    resource: 'kitty.js',
  },
  {
    id: 'eldbleboehdlpegkocggjhmjncbippgl',
    name: 'GrabIt',
    resource: 'popup.js',
  },
  {
    id: 'eoagmdboiealblmpaahjlhajggndaahi',
    name: 'Productivity Owl',
    resource: 'js/popup.js',
  },
  {
    id: 'eobkhgkgoejnjaiofdmphhkemmomfabg',
    name: 'AutoAny',
    resource: 'img/broken.png',
  },
  {
    id: 'eobnkakfbchnomaimkfmlgihjkbajamm',
    name: 'Audio Recorder',
    resource: 'src/assets/icons/16x16.png',
  },
  {
    id: 'epehnbnhpgdckdeiclihbcoihhjnmicf',
    name: 'Clinical Notes AI',
    resource: 'permission-iframe.html',
  },
  {
    id: 'fcnadghcijkmdhjdgiehgfpadojilfoa',
    name: 'Snip',
    resource: 'images/x.png',
  },
  {
    id: 'fdidojpjkbpfplcdmeaaehnjfkgpbhad',
    name: 'OdooTerminal',
    resource: 'dist/pub/loader.mjs',
  },
  {
    id: 'fdlopgpbkloofphfpbikfcdhfalkmpmp',
    name: 'Lenso.ai Reverse Image Search',
    resource: 'public/lenso.svg',
  },
  {
    id: 'feapmagcaclnifojeninfmpdedbiafdd',
    name: 'Crunchyroll Comments',
    resource: 'patch.js',
  },
  {
    id: 'ffhhjklgcfabkpholngojpkijlafjooc',
    name: 'CMP Validator',
    resource: 'index.html',
  },
  {
    id: 'fiimimfkppnhjbgkhlanfimploepnpfl',
    name: 'Stat4Market',
    resource: 'img/logo.png',
  },
  {
    id: 'finbbidhmoalbmkikcekkabneclfcijl',
    name: 'SearchSwitcher',
    resource: 'icon.png',
  },
  {
    id: 'fmjbhmhmfanpmdhpjjemafjlgomdccnm',
    name: 'Blueprint',
    resource: 'assets/bp.png',
  },
  {
    id: 'fncgbdbkhdhdcfiohjnbdfebholmhnkh',
    name: 'YouGears',
    resource: '128x128.png',
  },
  {
    id: 'fogdlgjnkolhbefbbpghbafdkhcdgdnk',
    name: 'Stock Analysis Overlay',
    resource: 'content.js',
  },
  {
    id: 'foilkalbafoifklkphdkijdcnkgcjefn',
    name: 'Switch',
    resource: 'newtab.html',
  },
  {
    id: 'fonflmjnjbkigocpoommgmhljdpljain',
    name: 'Nice Tab Manager',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'fopgafjdjlongoeblobbafbnapafcicg',
    name: 'Twemoji',
    resource: 'options.js',
  },
  {
    id: 'fpapnfccelgjjlebjpcoleffhmgjendl',
    name: 'Telegram Download Assistant',
    resource: 'utils.js',
  },
  {
    id: 'gacleogdnjbjbkmebemibjlphanihcho',
    name: 'ScreenCatch',
    resource: 'media/logo-128.png',
  },
  {
    id: 'gbdbademeighmnbliehmnoifmabbedbp',
    name: 'JSON Viewer',
    resource: 'assets/viewer.css',
  },
  {
    id: 'gcjdagaoojgeilcobhibkgbodajcojda',
    name: 'Work Offline',
    resource: 'data/offline/index.html',
  },
  {
    id: 'gdkbclbkmeggbekkkddcfjbcaapojihk',
    name: 'UTAKU image downloader',
    resource: 'icon34.png',
  },
  {
    id: 'gdlphfgigkboncdlkjcamelidhkcgpie',
    name: 'Recruiterflow',
    resource: 'img/icon.png',
  },
  {
    id: 'gemcgnkghpnfbmlfimdbdgfepcgenphf',
    name: 'Ebsta For Salesforce',
    resource: 'js/bar.js',
  },
  {
    id: 'gfepljemgkegiccegjbclmhmnodpieoj',
    name: 'Hire3x Proctoring',
    resource: 'README.md',
  },
  {
    id: 'ggccjkdgmlclpigflghjjkgeblgdgffe',
    name: 'Monkey Block - Stay Focused, Block Sites',
    resource: 'blocked.js',
  },
  {
    id: 'giibhjmljpmnaiadfpghpajecbpbifob',
    name: 'FreeServer',
    resource: 'load.js',
  },
  {
    id: 'gkompgmhhdflejbdgfjlmipjpjfdoclm',
    name: 'SerpWorx',
    resource: 'assets/images/flags/flags.png',
  },
  {
    id: 'gmfaoihlkhopieoibopcponemocgbloj',
    name: 'SaveDay',
    resource: 'js/index.html',
  },
  {
    id: 'gpfcnnilcblkdfjdjlgnclllbbhbeijb',
    name: 'Ibai te Ayuda a Estudiar',
    resource: 'images/quemirasamigo.mp4',
  },
  {
    id: 'hccdinmmjkeedfibholbilopaklebdcm',
    name: 'Fast-eInvoice Token Signing V3',
    resource: 'page.js',
  },
  {
    id: 'hdhmambhdgkcfkfonkkmlljiahfdiaab',
    name: 'Web Table Extractor',
    resource: 'js/xlsx.full.min.js',
  },
  {
    id: 'hejbkamkfnkifppoaljcidepkhgaahcj',
    name: 'Cocos Creator Inspector',
    resource: 'index.js',
  },
  {
    id: 'henoooadlnkicamlpjbkenolnhgnochc',
    name: 'GTMFixer',
    resource: 'js/choices.min.js',
  },
  {
    id: 'hghkdlpffihcggpbdkjlbaknjnclkiae',
    name: 'ProdYouTivity',
    resource: 'src/scripts/content/youtube/injected-script/pyt-quality.js',
  },
  {
    id: 'hgiibligkihnelefhhmeiipdlklokfgo',
    name: 'Shop Tool',
    resource: 'lang/en.json',
  },
  {
    id: 'hiikgabmcoakjhhodkajjkgdhpkmfcbp',
    name: 'Spotify Transcript Extractor',
    resource: 'no_transcript.html',
  },
  {
    id: 'himepoeelnlpnhphkplaeknfejmpemll',
    name: 'Elia',
    resource: 'lib/sbd.min.js',
  },
  {
    id: 'hkmpnondmidmfdlaphahbalnmphelnfo',
    name: 'Optimizely Assistant',
    resource: 'js/jquery.js',
  },
  {
    id: 'hncfkjkbikpgeicjhcipbjcdjejokbek',
    name: 'SUPDropshipping',
    resource: 'lib/popup.js',
  },
  {
    id: 'hnpeicdjmdhaojkeflcnmnpgmcffjlcm',
    name: 'NetSupport Notify Agent',
    resource: 'js/modules/log.js',
  },
  {
    id: 'hokefmefppdgmlgeigcmjdlcdnkclbgo',
    name: 'UniTalk Web Dialer',
    resource: 'assets/eye-CRJxPoId.svg',
  },
  {
    id: 'hpkeijgchoedhhdfjdjlaimanpmbnhjm',
    name: 'Gumloop',
    resource: 'images/ai.png',
  },
  {
    id: 'iaillabiiidlmolhemgpkokehaiadhli',
    name: 'VOTOBO',
    resource: 'main.html',
  },
  { id: 'icgjkmnbaohfkpoddadimgiekfokiell', name: 'Zoof', resource: 'js/a.js' },
  {
    id: 'iifbdohpebbkdjakbkiebapfifndlgah',
    name: 'Search by Image & Price Tracker for eBay',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ijejjgcdjlbcimponckngepiaobolmmh',
    name: 'Movie Downloader',
    resource: 'lib/a',
  },
  {
    id: 'imkpffdfmokmclnamadkndmjkhpbolgn',
    name: 'MyCashBack',
    resource: 'dev.js',
  },
  {
    id: 'inhojdjgfnnpphfknlfbejchnjjnkpfl',
    name: 'Hide Google AI-Overviews',
    resource: 'icons/banner-image.png',
  },
  {
    id: 'iojjaiaojbgmnnnhlkbnnhmabngphhjh',
    name: 'Image to Prompt Generator',
    resource: 'popup.html',
  },
  {
    id: 'ipmmohddmgcjpochjcedmhallbofeefm',
    name: 'Canvas Chart',
    resource: 'icon-128.png',
  },
  {
    id: 'jbchhcgphfokabmfacnkafoeeeppjmpl',
    name: 'Vouch Verifier',
    resource: 'src/injected/js-api.js',
  },
  {
    id: 'jbdcmokdibodbplhjcajgcbmnflcchbi',
    name: 'Alfred',
    resource: 'cartograph-world.js',
  },
  {
    id: 'jbfkkljambdhjlkcfkcbpjfkkamkccfm',
    name: 'Onoff Business',
    resource: 'widget.html',
  },
  {
    id: 'jciiedcbmlondhnlflidopjlhjkkogln',
    name: 'MOV to MP4',
    resource: 'content.js',
  },
  {
    id: 'jdfghifofmbjplibeldibgjkhojgdpdf',
    name: 'Screen Sizes',
    resource: 'src/css/grid.css',
  },
  {
    id: 'jeakmpamiokljhmpjakgdgjpjmpkhiob',
    name: 'Groovin',
    resource: 'images/ban.svg',
  },
  {
    id: 'jgemmpmngfhhnfgielmdjajdccchedap',
    name: 'Add More Colors to Calendar',
    resource: 'assets/main-world.js',
  },
  {
    id: 'jhmjlpdljfogaclolecijklcicciafaj',
    name: 'Amplecap Beta',
    resource: 'sidebar.html',
  },
  {
    id: 'jikhbokinakhjbhoifafpbaemffhomjl',
    name: 'Alerta de ofertas e descontos',
    resource: 'style/showdiv.css',
  },
  {
    id: 'jilkhjfakcninakdpdaphnljmkibpmki',
    name: 'Zippi',
    resource: 'injectScript.js',
  },
  {
    id: 'jkihideonihmchmjcmkogncgfaiigafa',
    name: 'Google Sheets Dark Mode',
    resource: 'listener.js',
  },
  {
    id: 'jnphnnpfkbplliobkajnpfkhffgdedfa',
    name: 'Cristiano Ronaldo',
    resource: 'js/main.js',
  },
  {
    id: 'jonkgaipjeenhoccenhhccmofokbpanl',
    name: 'Open Access Helper Web',
    resource: 'js/popup.js',
  },
  {
    id: 'jpfccmafeibjhgmfpmahibdaegpefjab',
    name: 'Emojis for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'kchnhmpeopknjdjejognciimepllkacb',
    name: 'BGA',
    resource: 'js/bgaApi.js',
  },
  {
    id: 'keeadpdalpdcbbflbkcegcgkepadgahn',
    name: 'image to prompt',
    resource: 'assets/flux.jpg',
  },
  {
    id: 'kgaleicefmhgoefglnbdfpmbgbngnnmd',
    name: 'Adblocking',
    resource: 'web_accessible_resources/empty',
  },
  {
    id: 'kgbcoelgfffkmkpfnldemdinmcbpjlaa',
    name: 'MeaVana',
    resource: '128x128.png',
  },
  {
    id: 'kiaeafdamnhlnpljacdedjgiiplfbnhe',
    name: 'iTour chat translation',
    resource: 'fonts/element-icons.ttf',
  },
  {
    id: 'kihpomglkbgbhdhogikhpbgakniddmfj',
    name: 'Bandcamp Volume',
    resource: 'js/bandcamp-volume.js',
  },
  {
    id: 'kiniklbpicchjlhhagjhchoabjffogni',
    name: 'FindNiche',
    resource: 'img/tip.png',
  },
  {
    id: 'kklgkbdijlcaihafjlofkdcmdbejmeic',
    name: 'Alignerr Connect',
    resource: 'assets/index-DIo8Vxj0.js',
  },
  {
    id: 'kmafmhimenmmjnpkodojnacmlabacmid',
    name: 'JobDiva',
    resource: 'img/star.png',
  },
  {
    id: 'kmeijfochmidimcngicjabokhkeifmmj',
    name: 'Invitation',
    resource: 'dist/contentScripts/style.css',
  },
  {
    id: 'kmkagoolneedcbnifoloebjkdomdngdn',
    name: '96编辑器小工具',
    resource: 'assets/img/close.png',
  },
  {
    id: 'kngbfhjgalofkbfkfkbjbkhjmbfkkhoj',
    name: 'Sourcescrub Vitals',
    resource: 'popup.html',
  },
  {
    id: 'laooinkgdapbcbjchpmihliljfnakkdh',
    name: 'cssPicker',
    resource: 'img/logo-16.png',
  },
  {
    id: 'lbdjpmmladpghbcpadpeaiiopkcejpnf',
    name: 'Spark SEO',
    resource: 'page/sidebar.html',
  },
  {
    id: 'ldcoohedfbjoobcadoglnnmmfbdlmmhf',
    name: 'Frame Companion',
    resource: 'frame.js',
  },
  {
    id: 'lefcemnilieamgifcegilmkaclmhakfc',
    name: 'Apps Script Editor PRO',
    resource: 'monaco.js',
  },
  {
    id: 'lfbajboiahaecepobmkcpadfeojchmmf',
    name: 'Cloze Sidebar',
    resource: 'dynamic/gmail.js',
  },
  {
    id: 'lildghglkgcoanblbmenbefhnhifghjj',
    name: 'BewlyBewly',
    resource: 'assets/icon.svg',
  },
  {
    id: 'ljfkdmaepcnnfhmmjhfokaonlfjeggbl',
    name: 'SpotifyAdb',
    resource: 'share/share.css',
  },
  {
    id: 'llkgpihjneoghmffllamjfhabmmcddfh',
    name: 'Article Summary with ChatGPT and Take Notes',
    resource: 'popup.css',
  },
  {
    id: 'lmajkdcdknelgehdmcldckonhndcodco',
    name: 'CV import',
    resource: 'config.json',
  },
  {
    id: 'maibneeahfkanhakkogkbcakcadjejkl',
    name: 'Better Classroom',
    resource: 'html/dropdown_list.html',
  },
  {
    id: 'mbilpedlanmoiogaclhhieekjkhaoddn',
    name: 'Live Color Picker',
    resource: 'modal.css',
  },
  {
    id: 'mcecffeookkllgkbflcdlbicolmfgifj',
    name: 'ChatPage',
    resource: 'core/environment.js',
  },
  {
    id: 'mcjjomjpjfaaaiieieaecenabgidlhid',
    name: 'Convert Experience Tools',
    resource: 'injectedScripts/extensionId.js',
  },
  {
    id: 'mcplkbacfdjapifgiidjidmnfilipnep',
    name: 'Tracxn',
    resource: 'popup.html',
  },
  {
    id: 'medeknkggnkeffoahbphecmjoakbpiab',
    name: 'Options',
    resource: 'css/v3DV.css',
  },
  {
    id: 'mgbcjnnpnnjbbaodcldjngehbfibdfpb',
    name: 'Snipe Tool',
    resource: 'icons/icon48.png',
  },
  {
    id: 'mgpjobdchiggokhnaajapklalckojolh',
    name: 'SCTPextension',
    resource: 'icon-128.png',
  },
  {
    id: 'mhkcdejpjdmgelnmilcdkfddkfcigjcg',
    name: 'Somaiya E-Library',
    resource: 'icon.png',
  },
  {
    id: 'mhojlnjhellbccabnfnlgebjnopdmdph',
    name: 'Page Analytics',
    resource: 'assets/css/Index.chunk.css',
  },
  {
    id: 'miedbfijmibcgjjmhdccocldliepbfng',
    name: 'Video Note & Screenshot',
    resource: 'index.html',
  },
  {
    id: 'mimblplopkjaomdgamffaolcogmnfkfh',
    name: 'Shopify Analyzer',
    resource: 'js/font.js',
  },
  {
    id: 'mkbkgdiaaofcpbaicmdfbhmagihlmpef',
    name: 'BiRead',
    resource: 'biread_logo_32.png',
  },
  {
    id: 'mknbkgdikangjebcpfcbkiioojainjnh',
    name: 'ModHeader',
    resource: 'images/icon.png',
  },
  {
    id: 'mkoagddaddjopjacmklefgncpdamkdem',
    name: 'Smart News Finder',
    resource: 'icon.png',
  },
  {
    id: 'mljponncmhdlacmjbophphkbgcgjdnff',
    name: 'MyDoge',
    resource: 'assets/bg.png',
  },
  {
    id: 'mmmfofondapflhgbdidadejnechhjocm',
    name: 'Link Previews',
    resource: 'assets/logo-24x24.png',
  },
  {
    id: 'mnakbpdnkedaegeiaoakkjafhoidklnf',
    name: 'Vortimo OSINT-tool',
    resource: 'icon-16.png',
  },
  {
    id: 'mnplmcgaklbhpennjinecnkjpedmfejc',
    name: '品聘插件',
    resource: 'css/versions/v1/default/lpt.css',
  },
  {
    id: 'ncaknkaehhieldhnmimbjnfgneaiijbd',
    name: 'AI Homework Helper',
    resource: 'images/sun48.png',
  },
  {
    id: 'ncedobpgnmkhcmnnkcimnobpfepidadl',
    name: 'Relay Developer Tools',
    resource: 'main.html',
  },
  {
    id: 'neabdmkliomokekhgnogbeonopbjmajc',
    name: 'Guideflow',
    resource: 'startScript.js',
  },
  {
    id: 'nfpngpgicoflhemmfebjahmjfcbnfobi',
    name: 'PageOptimizer Pro',
    resource: 'img/POP.png',
  },
  {
    id: 'nhbchcfeodkcblfpdjdhelcfbefefmag',
    name: 'Dictionary',
    resource: 'assets/logo-24x24.png',
  },
  {
    id: 'nhjdkmpfplnhgdehbcdpiapecnfodbln',
    name: 'crawl sitemap generator',
    resource: 'content.css',
  },
  {
    id: 'niiahgnkkalkindhghjcaojcpbkhfbbp',
    name: 'Global Privacy Control (GPC) Inspector',
    resource: 'inject.js',
  },
  {
    id: 'niokainjnclnhaflagpmeobbnklokill',
    name: 'Alphagate X',
    resource: 'feed.mp3',
  },
  {
    id: 'nkaliaagdnbgadcpnkdbmnigkalbihlb',
    name: 'List Opened Tabs',
    resource: 'images/logo_16.png',
  },
  {
    id: 'nkfpegmmhcipdkgoiimdegfaicbdnndh',
    name: 'Permission Agent',
    resource: 'content-scripts/chat-bubble.css',
  },
  {
    id: 'nklehcoamlgpnlljogplljnidlciimgo',
    name: 'AUNライブキャプチャ',
    resource: 'capture.html',
  },
  {
    id: 'nlgkbpcannbahibpdnonjpnndpeffhmh',
    name: 'ASO',
    resource: 'index.html',
  },
  {
    id: 'nllnakkoanoloffpgpglbkijkdmiohmi',
    name: 'Customer Meetings',
    resource: 'icon-16.png',
  },
  {
    id: 'nlmagkccjhkidhigbdiappekidmijmgk',
    name: 'KDROI',
    resource: 'chunks/121.js',
  },
  {
    id: 'nmcnaajhcdnlfoooebjbjoinjhlppdpd',
    name: 'Ranorex Automation',
    resource: 'msgport.js',
  },
  {
    id: 'nmjjcokoigamfoklbjmhpmjajmcjbjld',
    name: 'XPath Tester',
    resource: 'bar.js',
  },
  {
    id: 'noekmgopfaldnjbckdddjbnjcdklcadb',
    name: 'Zoho Books Timer',
    resource: 'js/mainmenu.js',
  },
  {
    id: 'ocbakdkmdijnkhlahjihbnjpkjepieio',
    name: 'Block these URLs, Domains or Keywords',
    resource: 'settings.html',
  },
  {
    id: 'ocndbimbjbikfknkbckjelghmlldhngl',
    name: 'Quetext',
    resource: 'img/qt-logo.avif',
  },
  {
    id: 'odaipdgfpakepciknhkgffehcioidecj',
    name: 'Aidify',
    resource: 'data.html',
  },
  {
    id: 'odiekacofiehnpbmihmebnglcopgalfh',
    name: 'SmarterHumans.ai',
    resource: 'main.css',
  },
  {
    id: 'ofhcdloafjklddfkcadoggmojjhocelc',
    name: 'Pinterest Video Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'ofhlminijomemliahkjjbgcbfoimjiaj',
    name: 'PordaAI',
    resource: 'src/readme.txt',
  },
  {
    id: 'ofncgcgajhgnbkbmkdhbgkoopfbemhfj',
    name: 'Web Scraper',
    resource: 'images/logo-a.png',
  },
  {
    id: 'ofnmkjeknmjdppkomohbapoldjmilbon',
    name: 'SocialPlus',
    resource: 'popup.html',
  },
  {
    id: 'ogofgdciigpmncnkameolnkpnnlfhkap',
    name: 'Clip AI',
    resource: 'images/Jcrop.gif',
  },
  {
    id: 'ohbkdjmhoegleofcohdjagmcnkimfdaa',
    name: 'Time Tracker',
    resource: 'images/loader.gif',
  },
  {
    id: 'ohjehnjdpnambhdcalhoabplbiclekhp',
    name: 'YouTube SubSound',
    resource: 'main.js',
  },
  {
    id: 'ohndmfaecddmecehfdidjhncfdajjeed',
    name: '领星ERP助手',
    resource: 'images/logo.png',
  },
  {
    id: 'oihfhipjjdpilmmejmbeoiggngmaaeko',
    name: 'NoteGPT',
    resource: 'logo.png',
  },
  {
    id: 'okeampldbdmpachkggljgpngbooaclal',
    name: 'Google Maps Extended Routes',
    resource: 'pages/bookmarks/bookmarks.html',
  },
  {
    id: 'oljojjbekeiblhfioiimibheleoedbcb',
    name: 'YuJa Panorama',
    resource: 'panorama-starter.js',
  },
  {
    id: 'ombjflplbadmkbbhhdekeaofjibkongn',
    name: 'Email Extractor',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'omdnhmkcegackkddpabchgmhpcdmojea',
    name: 'Moskit Boost',
    resource: 'main-world-script-extract-whatsapp-data.js',
  },
  {
    id: 'ooidoifienlnlebfedjenmfaneglghfl',
    name: 'ArtGenius',
    resource: 'img/logo.png',
  },
  {
    id: 'ooppbalbkbdabcmaijemiaekfpnhijcl',
    name: 'Stonly',
    resource: 'icon38.png',
  },
  {
    id: 'opicconnaaeilbjfnebkobanjobmnife',
    name: 'Tiplino',
    resource: 'serp.js',
  },
  {
    id: 'pahjcficmhfgjkdcdadnacjdiinpilmd',
    name: 'Responsive Website Testing Toolkit',
    resource: 'favicon.svg',
  },
  {
    id: 'pamhglogfolfbmlpnenhpeholpnlcclo',
    name: 'JsonDiscovery',
    resource: 'app.js',
  },
  {
    id: 'pdnloikhmiklhhankbkbkfhmlnnkgfmk',
    name: 'Fintest Pro',
    resource: 'pictures/flags.png',
  },
  {
    id: 'pemdbnndbdpbelmfcddaihdihdfmnadi',
    name: 'SelectON',
    resource: 'assets/icons/button-icons/cut.svg',
  },
  {
    id: 'pfjninionlecmhganagpckidcmhgjlhd',
    name: 'WordsMine!',
    resource: 'static/img/tick.png',
  },
  {
    id: 'pfomekjpajcbgdbaijipfogeaahepgno',
    name: 'CoRecruit',
    resource: 'offscreen.html',
  },
  {
    id: 'pgamkpjkbfldnmemhcbekimfdnjcgkco',
    name: 'Tailwind CSS Devtools',
    resource: 'fonts/FiraCode-VF.woff',
  },
  {
    id: 'pgnlnpfeedgjhkhdokjjkjhbmkdajoik',
    name: 'Summarize AI',
    resource: 'icons/icon16.png',
  },
  {
    id: 'phdlikmfdicjbgbeppbffcgidpneifbp',
    name: 'SecureSafe Password Manager',
    resource: 'ui/index.html',
  },
  {
    id: 'pheccebhjjlenlidbnddkjgpgfhokmio',
    name: 'X-notifier Neo',
    resource: 'res/gmail/0.png',
  },
  {
    id: 'pomfaigkndcemgflpnhhocjkpnggmdgk',
    name: 'Highlight AI',
    resource: 'resources/offscreen.html',
  },
  {
    id: 'aapmfnbcggnbcghjipmpcngmflbjjfnb',
    name: 'Amazon Reviews Extractor',
    resource: 'injected.js',
  },
  {
    id: 'acfcbfkjgnbfglpnlfipdohfdgpgpogh',
    name: 'Image Duke',
    resource: 'assets/env-Cda982MR.js',
  },
  {
    id: 'acnamgmgmbamffefgplhkplaanebgkac',
    name: 'Vertical Tabs',
    resource: 'icons/tab.png',
  },
  {
    id: 'aebnkjebahjkkpiknggemolakkjggiab',
    name: 'Keyboard ASMR',
    resource: 'icon-34.png',
  },
  {
    id: 'agbklapacbpooaenpbmboiodiphfcjnh',
    name: 'Anomi VPN',
    resource: 'icons/cart.png',
  },
  {
    id: 'ajhkehblebieocfkddeeikfkcecbcijn',
    name: '1min.AI',
    resource: 'assets/flags/ad.svg',
  },
  {
    id: 'akbbdmilignoplkhminiaecccigmpdmo',
    name: 'Watch Party',
    resource: 'netflix.js',
  },
  {
    id: 'akedoggjiebfbfgkmdcgchkkknefnnbe',
    name: 'Tênis Certo Descontos',
    resource: 'index.css',
  },
  {
    id: 'anknhjilldkeelailocijnfibefmepcc',
    name: '0xio Wallet',
    resource: 'pvac_rs.js',
  },
  {
    id: 'anlfldbcimgngaghpocmngggcbigcpdn',
    name: 'Cat Tab Cursor',
    resource: 'cur/0.cur',
  },
  {
    id: 'aokdahpjojkcjlnlbjlecolfcnhjndnd',
    name: 'FastApply',
    resource: 'core/logger.js',
  },
  {
    id: 'apnbkmkpchabofhbnmhbdbnlpkbcomkg',
    name: 'PFE',
    resource: 'icon128.png',
  },
  {
    id: 'apnhcckmbmofaneogehcfnghabafpeej',
    name: 'Chatbot Manager',
    resource: 'assets/fonts.js',
  },
  {
    id: 'baemjgbkbdldejgjceijnbkigkgkppoa',
    name: 'SnapMagic',
    resource: 'assets/img/chip.svg',
  },
  {
    id: 'bbmihgkbffpkmcpgcnoleggpmbghndgh',
    name: 'Telegram Saver',
    resource: 'utils.js',
  },
  {
    id: 'bcoflheaejlhhhcemjdkacefpepddljn',
    name: 'Etsy Downloader',
    resource: 'assets/gou.png',
  },
  {
    id: 'bdmobenofdjpipjmkjckldjipjhmmpgh',
    name: 'Upheal',
    resource: 'main-panel.html',
  },
  {
    id: 'beeaddblkeeialcohiolkkoiifhgjooj',
    name: '小草莓',
    resource: 'iframe.html',
  },
  {
    id: 'bfcmkkdlpnmjeedpgadjlifdechejolg',
    name: 'Web Marker',
    resource: 'tools/0.png',
  },
  {
    id: 'bgkondpfefligkpcpcpdkgjhpflhijcl',
    name: 'Free Download Private Telegram',
    resource: 'index.html',
  },
  {
    id: 'bhkmpbjlggghmgknebaonpnbdbljfpcn',
    name: 'Minera Ads',
    resource: 'static/logo.svg',
  },
  {
    id: 'bicffikjkhglkpnclejgmdcbpjhcmend',
    name: 'Volume Boost',
    resource: 'img/icon/64.png',
  },
  {
    id: 'bjlegmanlfckekanijakdoeedcjlihbn',
    name: 'Hindi Dictionary',
    resource: 'imgs/plus.png',
  },
  {
    id: 'bjnaoodhkicimgdhnlfjfobfakcnhkje',
    name: 'VideoTG',
    resource: 'popup.html',
  },
  {
    id: 'bkabpllkghhddkikpelcmjklipifickd',
    name: 'Font Finder',
    resource: 'assets/imgs/Close_round.png',
  },
  {
    id: 'bkhdlfmkaenamnlbpdfplekldlnghchp',
    name: 'JPEG XL Viewer',
    resource: 'worker.js',
  },
  {
    id: 'bmbfkoeaaglglffehmikaljbkaiaioac',
    name: 'Unicorn Smasher Pro',
    resource: 'popup.html',
  },
  {
    id: 'bmcdignkjbjpjnhmhmjcoknkjlfkipeo',
    name: 'Telegram Video Downloader',
    resource: 'src/assets/base.css',
  },
  {
    id: 'bnbighhfhbnkoinbakcadadhjhjhnogo',
    name: 'Whatsapp Translator Pro',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'bncmdklijpjfpmpdmobeafcegnnkkjff',
    name: 'Crazy Compare For Salesforce',
    resource: 'images/icon16.png',
  },
  {
    id: 'bnnhpohpnamnjhajbkgpmblleljodlhd',
    name: 'Flagmoji',
    resource: 'settings.js',
  },
  {
    id: 'bpdocajohhnfgbohbmfjeienbcihjlcg',
    name: 'OneAI',
    resource: 'i18n/vi.json',
  },
  {
    id: 'bpgmpnpdklkcdgiemflkhfhbcibbimhh',
    name: 'Discord Translator Pro',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'cafjoclngbolmaeiogcgfpoepmilbjaa',
    name: 'Heyzine Flipbook to PDF Downloader',
    resource: 'lib/jspdf.umd.min.js',
  },
  {
    id: 'capjnhbneiilplogojhmhepiocnjpgee',
    name: 'Crucible Wallet',
    resource: 'icon16.png',
  },
  {
    id: 'cdkjljpfeodbkfkhhehmhgdleojloemj',
    name: 'Language Lab Interactive Sub',
    resource: 'src/assets/icon.png',
  },
  {
    id: 'cdpbhdkhlngcgpojobhaellkoidndddk',
    name: 'OCR Translator',
    resource: 'global.css',
  },
  {
    id: 'cedgonoljngcmgghepnhclmlknbhhdko',
    name: 'Translator for Telegram Web',
    resource: 'assets/index.2e493a08.js',
  },
  {
    id: 'cedomiiokkcmbeoekchahgmfcppnclal',
    name: 'X Twitter Scraper',
    resource: 'icon-34.png',
  },
  {
    id: 'chajibpcmdhocbdoeafmmeahholiahjp',
    name: 'Export Gemini AI Chats to PDF',
    resource: 'tabs/print.html',
  },
  {
    id: 'chdmkeeecofpljchimdkliaknhaibkgm',
    name: 'Search by image on Aliexpress',
    resource: 'ic.png',
  },
  {
    id: 'chgkpfgnhlojjpjchjcbpbgmdnmfmmil',
    name: '有道划词',
    resource: 'style/content.css',
  },
  {
    id: 'cigjjnkjdjhhncooaedjbkiojgelfocc',
    name: 'Sales Sort for eBay Advanced Search',
    resource: 'assets/img/home.png',
  },
  {
    id: 'ckkhcgikplgdginlidcaomgjahmddjgb',
    name: 'Brave Detection Block',
    resource: 'block-script.js',
  },
  {
    id: 'clpoilnjjdbfjinifhmcfddhjgneajle',
    name: 'AP',
    resource: 'css/sb.css',
  },
  {
    id: 'cmfmhegpbogfmojekmidappigcfbgbcb',
    name: 'ModeSens',
    resource: 'img/link.png',
  },
  {
    id: 'cnlnnpnjccjcmecojdhgpknalcahkhio',
    name: 'Salesforce.com Enhanced Formula Editor',
    resource: 'regexp.js',
  },
  {
    id: 'cplhlgabfijoiabgkigdafklbhhdkahj',
    name: 'Vidnoz Flex',
    resource: '3rd/lib/base.js',
  },
  {
    id: 'cpliknnmgllhifnomnldjhcambhpdino',
    name: 'Netflix Party',
    resource: 'content/index.js',
  },
  {
    id: 'cpndclgiioidaongmkcammhiffagogpi',
    name: 'mdpi_home',
    resource: 'extra/bg/blue.png',
  },
  {
    id: 'dboboillnhldihjigadainihehfoackd',
    name: 'PM-Chrome',
    resource: 'pdf/pdf.js',
  },
  {
    id: 'dfbpjijneaihingmldgpgcodglkoamoe',
    name: 'Google Calendar',
    resource: 'icons/wp1.png',
  },
  {
    id: 'dffcfjmmliepbognbgkmbhiodoapgmno',
    name: 'Whale CoCreator',
    resource: 'page.html',
  },
  {
    id: 'dgibbaokhfpninakmmnpmgedoabcmnpd',
    name: 'TCMB Döviz Kurları Excel',
    resource: 'lib/jquery.min.js',
  },
  {
    id: 'dgijgfdodcankfloblhnngmlkdaahbco',
    name: 'Google Transcribe & Summarize Live',
    resource: 'meet_helper.js',
  },
  {
    id: 'dhgffppaghichiohafmjjikabhkdeodk',
    name: 'MyEasy86',
    resource: 'image/icon.png',
  },
  {
    id: 'dhkbjdnlhahnffncheehbnoaecncdpdk',
    name: 'Criminal IP',
    resource: 'data/only_hashed_100K.csv',
  },
  {
    id: 'djldgekfnmbecjgdfnbnilgoojfihfli',
    name: 'AsoSpy for Google Play Store ASO',
    resource: 'popup.html',
  },
  {
    id: 'dknfgdeknchipilffmnpinhocfegkmmh',
    name: 'Superpower Google',
    resource: 'img/clover.svg',
  },
  {
    id: 'dlbfelpcjcildnjoiehdkpgbjbbmachb',
    name: 'PUBG 맵 뷰어',
    resource: 'map-viewer.js',
  },
  {
    id: 'dmpmnkbjbdpimnfjfaioomceonmjfdbo',
    name: 'MossVox Subtitle',
    resource: 'setting.html',
  },
  {
    id: 'doedeaghekakhljnkpgpgcgpmecdomhh',
    name: 'Mojo',
    resource: 'css/popup.css',
  },
  {
    id: 'dpindoafffjhbnhbdgjibhdoklelcfdn',
    name: 'DocHero AI',
    resource: 'copy.svg',
  },
  {
    id: 'eagmgpbjpedchliifpgfgogdknnmkaej',
    name: 'IDmelon WebLogin',
    resource: 'ui/pin/index.html',
  },
  {
    id: 'ebgihidhndognkpkhbclgflembljmpjp',
    name: '불사자',
    resource: 'assets/icon.png',
  },
  {
    id: 'ebjhengpaamjfjpmmdldganmhmcbhohg',
    name: 'Informatica QuickLook',
    resource: 'scripts/ca.js',
  },
  {
    id: 'eblnlelbhacfliafbpolhdeogpolchoi',
    name: 'Dark Mode for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'ecbeanbjdpjfmckloplgmfmlpcakbmjo',
    name: 'Editorify',
    resource: 'libs/icons/edit.png',
  },
  {
    id: 'ecpkkfgllianigfeoonafccgbfeglmgb',
    name: 'Focus',
    resource: 'html/menu.html',
  },
  {
    id: 'edkmbojkflfanganifkkajmldejmhlec',
    name: 'GoCashBack',
    resource: 'styles/serp.css',
  },
  {
    id: 'egbncdggdomnmpkngingeacgmlbcneif',
    name: 'Zopi',
    resource: 'images/cj.png',
  },
  {
    id: 'eggeglpgocmdjooigdckjjkbaflgjbbp',
    name: 'SellerSpace',
    resource: 'img/logo.png',
  },
  {
    id: 'ehfgnibbcikohadnbkbdollhbphgeoki',
    name: 'Invenias',
    resource: 'index.html',
  },
  {
    id: 'eijfgedfkehblhdaiommcibimdgfgbop',
    name: 'Winning Hunter',
    resource: 'static/js/main.js',
  },
  {
    id: 'ejhkkbilnpifailgngpkgmiofhioacjd',
    name: 'eesel AI',
    resource: '119.bundle.js',
  },
  {
    id: 'ejkpocbmomaefkinmkfbfnpjjfbinegb',
    name: 'Xiangji Image Translator',
    resource: 'icon16.plasmo.6c567d50.png',
  },
  {
    id: 'ekeajhgcfbclgdnmfjdnpdfmaficebka',
    name: 'EasyPrint',
    resource: 'pages/reader/index.html',
  },
  {
    id: 'emaamodndfmmmcjepfigalbjjjemadom',
    name: 'MediaPlus',
    resource: 'core/images/ok.png',
  },
  {
    id: 'emcpjechgmpcnjphefjekmdlaljbiegp',
    name: 'The Optimiser',
    resource: 'selector.json',
  },
  {
    id: 'emeakbgdecgmdjgegnejpppcnkcnoaen',
    name: 'SiteData',
    resource: 'trends.html',
  },
  {
    id: 'endljcppflpjdhdpjidgelopcmmbbdbh',
    name: 'Geolocation Spoofing',
    resource: 'feedback_system.js',
  },
  {
    id: 'eocobhdapiaeehkkeondnhbppmbeeoic',
    name: 'MeasuringU-IQ survey',
    resource: 'assets/muiq-16.png',
  },
  {
    id: 'epechikapdipcpfihonkhmnknbjmnlmi',
    name: 'Olymp Robot',
    resource: 'content.js',
  },
  {
    id: 'epmomlhdjfgdobefcpocockpjihaabdp',
    name: 'Testsigma',
    resource: 'img/icon.png',
  },
  {
    id: 'faeamafkmcffkmkodkbjdnkfagnoknmm',
    name: 'TeachShare Copilot',
    resource: 'icon48.png',
  },
  {
    id: 'fagjmplkfdopalfkkajedcgmhnlfdjjc',
    name: 'Obelisk VPN',
    resource: 'sdk-bundle.js',
  },
  {
    id: 'fcdibhhcebjndgimaclicpbjhnpmmonc',
    name: 'ALM Coupon Codes Finder',
    resource: 'assets/imgs/logo.svg',
  },
  {
    id: 'fdnbhgmdmneheakaoicpfephhfcpgele',
    name: 'vpn-rice',
    resource: 'index.html',
  },
  {
    id: 'felcheipcdolkjejhodkggkgjljkipfe',
    name: 'Netflix party with video chat',
    resource: 'videoScript.js',
  },
  {
    id: 'femogemiolfjofilbccdokahgohlokha',
    name: 'Voice Changer',
    resource: 'icon-34.png',
  },
  {
    id: 'ffpdmmhnnfbfahdofjfpijncocihhcle',
    name: 'FlyForm',
    resource: 'ExtPay.js',
  },
  {
    id: 'fgajhklfilekicmafnliflbpjejefdpp',
    name: 'Free VPN Proxy',
    resource: 'icons/icon-48.png',
  },
  {
    id: 'fgcpkofcgicoihkkpfmbjgllkgkbpkpe',
    name: 'Fiidom',
    resource: 'static/js/custom-script.js',
  },
  {
    id: 'fgpmefnkfcomnfcbfopligpnfgcajbln',
    name: 'Quick Grammar Corrector',
    resource: 'assets/chunk-6a985a70.js',
  },
  {
    id: 'fhhhgkkoemddgkeooalbffcmcknlombc',
    name: 'Free VPN',
    resource: 'scripts/popup.js',
  },
  {
    id: 'filjhgipogkkmalceianiopidelcacam',
    name: 'Tetri. Classic Brick Game',
    resource: 'bg.png',
  },
  {
    id: 'fjbegfkmkcjknjkkcebnejcpdchpadpc',
    name: '一字幕',
    resource: 'injectPanku.904e05e8.js',
  },
  {
    id: 'fmnhijmajiagcpknfmmncahjbphjmbif',
    name: 'BinoBot',
    resource: 'content.js',
  },
  {
    id: 'fndolnghdocnehakldlpmmgjonibehel',
    name: 'Money Rain',
    resource: 'js-ui.js',
  },
  {
    id: 'fnfipngolkdmolfocahlgjoipplhbmha',
    name: 'Song Lyrics',
    resource: 'pages/popup.html',
  },
  {
    id: 'fngpibmhccdaokelgaccddiehlggihlo',
    name: 'BitBit',
    resource: 'inpage.js',
  },
  {
    id: 'fogcpfhkppaffphabnmapoopakjbfnbb',
    name: 'PixelPal',
    resource: 'embed.js',
  },
  {
    id: 'fondjoepdngpdimiojnpikbajiakobhb',
    name: 'Visual Enhancements for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'gakkobdjiifadnllomenhnpojjdaoaad',
    name: 'Mega-Debrid',
    resource: 'assets/icon.png',
  },
  {
    id: 'gbnebpdekafhpcipejfhabfghccgfnbh',
    name: 'ReClipped',
    resource: 'help/index.js',
  },
  {
    id: 'gcfofolonkmploncafjcocnncjcobefk',
    name: 'SelectTranslate',
    resource: 'content.css',
  },
  {
    id: 'gcjikeldobhnaglcoaejmdlmbienoocg',
    name: 'SpanTree',
    resource: 'icons/icon16.png',
  },
  {
    id: 'gfgacgecfchldicemecobpoafkoimpbp',
    name: 'Escape Goose',
    resource: 'door.gif',
  },
  {
    id: 'gfmbbcakoflhbbamcfcfgclgjibaodgc',
    name: 'Teleparty-pro',
    resource: '128.png',
  },
  {
    id: 'gfnemhnpjahoinogkdcmocmaahjakehi',
    name: 'Price tracker',
    resource: 'src/icons/48.png',
  },
  {
    id: 'gglcalnjbighdaklagfdkclchfildlal',
    name: 'Chat and Meet for Google',
    resource: 'img/icon.ico',
  },
  {
    id: 'ggngddfdaahilohaenpbmogmlokbdifb',
    name: 'Content Filter',
    resource: 'html/block.html',
  },
  {
    id: 'ghbflkcnhdpkmbbdoflmemnifphjehec',
    name: 'Arcify',
    resource: 'sidebar.js',
  },
  {
    id: 'ghlpdbkhlenlfiglgphledhfhchjfjfk',
    name: 'Inssman',
    resource: 'options/options.html',
  },
  {
    id: 'giidlnpcdhcldhfccdhkaicefhpokghc',
    name: 'FlyMSG',
    resource: 'css/fms.css',
  },
  {
    id: 'gilfchnfojjoaehejepdgnceoeldhkga',
    name: 'GDON',
    resource: 'assets/helpers-Bu-r7iPt.js',
  },
  {
    id: 'gipgngmeehfjmholacajopgiicmjlddc',
    name: 'HP Featured Offers',
    resource: 'auth.html',
  },
  {
    id: 'gnbafbeabkbkecmbedfgebgboicpnkpp',
    name: 'Pixelay for Figma',
    resource: 'css/content.css',
  },
  {
    id: 'gpbcbbajoagdgnokieocaplbhkiidmmb',
    name: 'Anki Adder',
    resource: 'popup.html',
  },
  {
    id: 'gpeoanngekmaamggfdklbbhakcohppll',
    name: 'AliExpressNewUserPriceDisplay',
    resource: 'img/qr.jpg',
  },
  {
    id: 'hafhjepjihcimcljkdphpinannbdmnhf',
    name: 'JobLander',
    resource: 'content.styles.css',
  },
  {
    id: 'heaibpimgfhcajocbhbbdofcocdcnali',
    name: 'TicNote Cloud',
    resource: 'src/assets/main.css',
  },
  {
    id: 'heajkapboekajadhibjilcdbpkindhpa',
    name: 'Hreflang Checker',
    resource: 'popup.js',
  },
  {
    id: 'heojonaoafggmjonoicpcknmamoepjha',
    name: 'Arc XP',
    resource: 'inject.js',
  },
  {
    id: 'hfhfhmjmahcmfnpoheijkhhlicgjabmk',
    name: 'AI SEO AEO Optimizer',
    resource: 'content.js',
  },
  {
    id: 'hgdpdmomcjheafojdkbpnpbbhpcidnci',
    name: 'Notes Online',
    resource: 'assets/chunk-DPTnAQ2v.js',
  },
  {
    id: 'hhcfeikmmkngnnaogpodbggmcjcebfba',
    name: 'Briefy',
    resource: 'fonts.css',
  },
  {
    id: 'hhejbopdnpbjgomhpmegemnjogflenga',
    name: 'OWallet',
    resource: 'assets/icon-128.png',
  },
  {
    id: 'hhoblekomblecenhpocenhkmhjioehig',
    name: 'PRDKDP',
    resource: 'assets/audio.js',
  },
  {
    id: 'hkbhjllliedcceblibllaodamehmbfgm',
    name: 'Prism',
    resource: 'inject.js',
  },
  {
    id: 'hkccefhopobjcapedjbobimahkpcppnc',
    name: 'Toggl Plan',
    resource: 'jira.css',
  },
  {
    id: 'hnffjpappohfnmhdimbpeljbnokjagdd',
    name: 'Click-to-call для MANGO OFFICE',
    resource: 'images/call.svg',
  },
  {
    id: 'hnojgennkffohepmhlkcacohoehakdic',
    name: 'Picture-in-Picture Anything',
    resource: 'fonts/Inter.ttf',
  },
  {
    id: 'hobgigdbbobngdogaleppndendfpnnpa',
    name: 'Sur.ly Surfguard',
    resource: 'popup.html',
  },
  {
    id: 'holiffefjdehbfhliggafhhlecphpdof',
    name: 'Add Remote Torrent',
    resource: 'js/theme.js',
  },
  {
    id: 'hpglfhgfnhbgpjdenjgmdgoeiappafln',
    name: 'Guarda Crypto Wallet',
    resource: 'src/provider.js',
  },
  {
    id: 'hpibfnhnogcgalnademehbgcpllmgdil',
    name: 'Scrollshot',
    resource: 'img/preparation.png',
  },
  {
    id: 'hpjimioijmfpedllbemdjdjjhkaoifaj',
    name: 'Netflix Game Remover',
    resource: 'ngr-main.css',
  },
  {
    id: 'ibniinmoafhgbifjojidlagmggecmpgf',
    name: 'Meteor DevTools Evolved',
    resource: 'dist/inject.js',
  },
  {
    id: 'idgchoknbblfldifahagmnpdldknnheh',
    name: 'Browsershield',
    resource: 'assets/icon.png',
  },
  {
    id: 'ifclboecfhkjbpmhgehodcjpciihhmif',
    name: 'Klever Wallet',
    resource: 'public/bridge/inject.js',
  },
  {
    id: 'igjbikakmdaeecjpgcdpihkbciggnjpo',
    name: 'Pronoto',
    resource: 'popup.html',
  },
  {
    id: 'iikcddhdncngibeinfpancdokfmnpegk',
    name: 'QuickRec',
    resource: 'stop.svg',
  },
  {
    id: 'ijlpmpplkkhpkhgpingckadmlohkgddg',
    name: 'OnceHub for Gmail',
    resource: 'index.html',
  },
  {
    id: 'imoljjojcgjocfglobcbbhfbghpdjlfn',
    name: 'FollowFox',
    resource: 'assets/icn-vip.png',
  },
  {
    id: 'innpfpppbpcjdgidokoodlgdmbbbohpa',
    name: 'Einsia',
    resource: 'icons/logo.svg',
  },
  {
    id: 'iogidfihemjcepgbcaccmickojidjhlf',
    name: 'GMB Audit',
    resource: 'assets/style.css',
  },
  {
    id: 'ipfpipdgeogfdloffmjmbllbanelachb',
    name: '2FA Live',
    resource: 'pages/popup.html',
  },
  {
    id: 'jaehimmlecjmebpekkipmpmbpfhdacom',
    name: 'ScriptCat Beta',
    resource: 'src/install.html',
  },
  {
    id: 'jaeoaaennpljipamineocgopmncgfnpj',
    name: 'Dark Mode for YouTube',
    resource: 'js/rate.js',
  },
  {
    id: 'jenlhondkkckfmehobgliecmdngfdkbo',
    name: 'React Scan Toggle',
    resource: 'react-scan.js',
  },
  {
    id: 'jgbmahcekagncippgbmfipnjkonnhbkd',
    name: 'SpellCheckerGE',
    resource: 'popup.js',
  },
  {
    id: 'jhhafkobmfjlcfppjenldjalejnfhcfk',
    name: 'Secure Kit',
    resource: 'img/eye.svg',
  },
  {
    id: 'jiikabmboknibiohmgaapgbmdopklnmn',
    name: 'X-Alpha',
    resource: 'assets/x_new.png',
  },
  {
    id: 'jikahkldllpmocjlfcmjkpecjjipbfmj',
    name: 'N8N Master',
    resource: 'welcome.js',
  },
  {
    id: 'jikanmlokejbknkfemnbhaebmmibgmmb',
    name: 'Sidebar Bookmarks',
    resource: 'sidepanel.html',
  },
  {
    id: 'jpejneelbjckppjapemgfeheifljmaib',
    name: 'TabMark',
    resource: 'images/link.png',
  },
  {
    id: 'jpodanhbbpcdfgpafdjhkojjbagbcmno',
    name: 'Usetiful',
    resource: 'edit.svg',
  },
  {
    id: 'kapoabaoamgiilmlanmfejgfomlnccph',
    name: 'GPT Sidebar',
    resource: 'icons/tag.png',
  },
  {
    id: 'kcbkloeogbimjlofcbhehlakjmmnlhhn',
    name: 'OptimHire Job Auto-Applier',
    resource: 'assets/sad.png',
  },
  {
    id: 'kcjjkkabmjiplbbbnggdfjjdoedbhjip',
    name: 'pixiv smart downloader',
    resource: 'download.html',
  },
  {
    id: 'kenonclglhedldnloaodkjajhlfkmofc',
    name: 'VOD Loader',
    resource: 'src/injected.js',
  },
  {
    id: 'kfnejlcapblanfejlgcpiakicmfkhmhe',
    name: 'Word Counter',
    resource: 'src/icons/48.png',
  },
  {
    id: 'kgbmammdmhpmpjhlnelelcdmomlbidkd',
    name: 'Give Freely',
    resource: 'shoppay.js',
  },
  {
    id: 'kgnnlaamhmjmhkeegiaimkfojcagjcml',
    name: 'Accops NativeClient',
    resource: 'manifest.json',
  },
  {
    id: 'khppfbnjbaampmeeiocjhcodkklkcfjf',
    name: 'MIDI Player',
    resource: 'inject.js',
  },
  {
    id: 'kihnnjkmbhhockopicpjhalcbchpmkkh',
    name: 'AdBlocker Lite',
    resource: 'data/content_script/inject_b.css',
  },
  {
    id: 'klohmfhfijipahknljjelpfgjpmandmg',
    name: 'Human Reader',
    resource: 'images/play.svg',
  },
  {
    id: 'kmcfjchnmmaeeagadbhoofajiopoceel',
    name: 'Solid Devtools',
    resource: 'assets/web-pnJ8ILBB.js',
  },
  {
    id: 'kmchiimcbhaaadgpnelddelgiaeahobi',
    name: 'Aloware Click-To-Call',
    resource: 'img/call.png',
  },
  {
    id: 'kmmcaankjjonnggaemhgkofiblbjaakf',
    name: 'Tab Manager',
    resource: 'manifest.json',
  },
  {
    id: 'knlfobadedihfdcamebpjmeocjjhchgm',
    name: 'WA Number Checker',
    resource: 'assets/w.js',
  },
  {
    id: 'kobgllimpgkkbmcfdemjikafafmfpgjo',
    name: 'Maska Method',
    resource: 'maska-popup.js',
  },
  {
    id: 'kohmmjjbkdmalobbokmopcbnhbonifmc',
    name: 'Signitic',
    resource: 'app.css',
  },
  {
    id: 'kpfalnccljfmbogklbbgbhcldihafcpp',
    name: 'Also Boughts Downloader',
    resource: 'ajax-loader.gif',
  },
  {
    id: 'lakehkoheloifeelmimhhbeikghlpjgi',
    name: 'Sovrn Commerce',
    resource: 'public/fonts/lineto-circular-bold.woff',
  },
  {
    id: 'lbdojbfpomlnfadfoodgmgmaneeefhei',
    name: 'WA Video Download',
    resource: 'logo/logo_16.png',
  },
  {
    id: 'lbfjbappcgpjejkcdjponeobdcnldlkc',
    name: 'G2T',
    resource: 'inject.js',
  },
  {
    id: 'ldakoiaiecpakeneelfihlfefaabbebh',
    name: 'Track Your Order',
    resource: 'manifest.json',
  },
  {
    id: 'leahaijgocdnkbclikipeddaafahlpme',
    name: 'Contact Saver',
    resource: 'resource/img/down.png',
  },
  {
    id: 'ledcljjhlgnpecmppjmganlmoppekkff',
    name: 'Bitcashback',
    resource: 'images/star.svg',
  },
  {
    id: 'lejiahlknapicagjldmkeoccbgmimkgo',
    name: 'AIS Visa Portal',
    resource: 'popup.html',
  },
  {
    id: 'lfopjgadjgdlkjldhekplmeggobolnej',
    name: 'WPPME',
    resource: 'ts/a/qt.js',
  },
  {
    id: 'lghclmmgbfppenladibnkmamnichaplp',
    name: 'Simple Screen Recorder',
    resource: 'assets/content.css',
  },
  {
    id: 'lhbojnmdenknginchionjabhdiphnemp',
    name: 'Web for WhatsApp',
    resource: 'icons/logo.png',
  },
  {
    id: 'lheehdbcfgapcfcnhncidpmcmdodiidd',
    name: 'Demandbase for Sales',
    resource: 'index.html',
  },
  {
    id: 'ljmncfcjgfjogaelciimcgnogdbpbkoh',
    name: 'NeetoRecord',
    resource: 'chunks/utils-CXV4siSA.js',
  },
  {
    id: 'lkjldebnppchfbcgbeelhpjplklnjfbk',
    name: 'Listelf - formerly Crosslist Magic',
    resource: 'web_accessible_resources/images/copy.png',
  },
  {
    id: 'llgcejoamphenmjaoiipcipcohjpmjof',
    name: 'Salesforce Revamp',
    resource: 'code/testclass.js',
  },
  {
    id: 'lmldakdjelendidnmaieidggbffljlle',
    name: 'Senja',
    resource: 'assets/storage-JVAJO15L.js',
  },
  {
    id: 'lpnnhhkdbmobjiheokoonjlmaffljcng',
    name: 'RemNote Clipper',
    resource: 'assets/icons/X.svg',
  },
  {
    id: 'madglblnbddpkecoihhnkohnofachcgn',
    name: 'XPath Helper',
    resource: 'res/icons/ui/drag.png',
  },
  {
    id: 'madmnbedogbppkndfjkhmkklikhoimdo',
    name: '玄奘百宝箱',
    resource: 'insert.js',
  },
  {
    id: 'mbclkgocofhagldefeogoionalbpckoo',
    name: 'Publer',
    resource: 'dashboard.html',
  },
  {
    id: 'mbmlkjlaognpikjodedmallbdngnpbbn',
    name: 'WA Bulk Sender',
    resource: 'assets/w.js',
  },
  {
    id: 'mbnakgcjfddknegppggflmbjmahndkjf',
    name: 'Random wallpaper',
    resource: 'newtab.js',
  },
  {
    id: 'mcalfpchdglalmmjkgohhcadlfigoglo',
    name: 'UpCat',
    resource: 'assets/logo.svg',
  },
  {
    id: 'mcbhalpamcihagflkpllacdcfmmnjemn',
    name: 'markClipper',
    resource: 'scripts/func-script.js',
  },
  {
    id: 'mdboomfjonbgmphcfjnbmhdlenecbkkh',
    name: 'Password Boss WebApp',
    resource: 'ui/index.html',
  },
  {
    id: 'mdhaadeocjnpjkpecinmaokfmbcgocgn',
    name: 'Ringostat click-to-call',
    resource: 'favicon.ico',
  },
  {
    id: 'mgceiehcajpibpoeiddepnnmfkgiipdd',
    name: 'Convert JPG to PDF',
    resource: 'assets/css/Index.chunk.css',
  },
  {
    id: 'mgffkfbidihjpoaomajlbgchddlicgpn',
    name: 'pali',
    resource: 'js/pali.bundle.js',
  },
  {
    id: 'mgliikamgjonfkmdljhkpbcfjnndoojh',
    name: 'Photo Zoom Plus',
    resource: 'icon-34.png',
  },
  {
    id: 'mhfodjdadffkgglbjdlnfakpohhemdga',
    name: 'Eye Saver',
    resource: 'src/util.js',
  },
  {
    id: 'mhgiefelomcdfcdbknkkohpibdpbdhmo',
    name: 'Tab Notes',
    resource: 'common/notesStorage.js',
  },
  {
    id: 'mhgineegmgpjljjpmocmnlaonmegjkdg',
    name: 'VR Dashboard I.T.Y.C.',
    resource: 'img/foil.png',
  },
  {
    id: 'mhhcggkelljdbflokkmbnfaoeilnngll',
    name: 'fontSwap',
    resource: 'scripts/apply-font/apply-fontrule.js',
  },
  {
    id: 'mjfahldkpjhcnfbbmdhpjolcjpcfhcpj',
    name: 'Toolbox',
    resource: 'popup.html',
  },
  {
    id: 'mlaaofkinooaabkchhidlhhjoiaomcmf',
    name: 'Mail Seen',
    resource: 'intro.js',
  },
  {
    id: 'mlakcjhcfmdpimbmpjjmdemfcjpeghgm',
    name: 'CompanyCam',
    resource: 'images/logo.png',
  },
  {
    id: 'mleflnbfifngdmiknggikhfmjjmioofi',
    name: 'LookGood Live',
    resource: 'iframe.html',
  },
  {
    id: 'mmmhadpnjmokjbmgamifipkjddhlfkhi',
    name: 'Present',
    resource: 'src/quote/index.html',
  },
  {
    id: 'mnkpjcgdlhenamhcbempiogjamdkbbgi',
    name: 'Tagbird',
    resource: 'inpage.js',
  },
  {
    id: 'mnmmbiifajmgbpnbknbhnjclafhijgbn',
    name: 'Power Mouse X',
    resource: 'mute.svg',
  },
  {
    id: 'mohjajgdccdncohjeglnacfdchccegcg',
    name: 'UpAlerts',
    resource: 'Assets/bootstrap.css',
  },
  {
    id: 'mpjlflflalhkkdifhejdphepjlbfjjdm',
    name: 'ShotApp',
    resource: 'index.html',
  },
  {
    id: 'nahdggilmmpnphekajnpckogaeibnfci',
    name: '1688Japan（旧タオタロウ） Order Assistant',
    resource: 'src/assets/logo.png',
  },
  {
    id: 'najpnfmjndlimkajheonmcdhheppahmn',
    name: 'Closefox',
    resource: 'assets/icn-vip.png',
  },
  {
    id: 'nfnjemoofkhppjhjcehbddolbalmibkg',
    name: 'Auto Cleaner',
    resource: 'img/info.svg',
  },
  {
    id: 'ngbebejjbijmijmhbbpkllcnjpgkjikl',
    name: 'Depth Translator',
    resource: 'Deepl40.png',
  },
  {
    id: 'ngmlmeaknfjiomiklcdjmoajhdompmii',
    name: 'POS & Label Printer Manager',
    resource: 'tabs/index.html',
  },
  {
    id: 'nhhfoaoafpdjengjbndbdojlnfjlafpc',
    name: 'Recruitee Talent Sourcing',
    resource: 'images/add.svg',
  },
  {
    id: 'niaagjifaifoebkdkkndbhdoamicolmj',
    name: 'Universal Keyword Planner box',
    resource: 'content/index.js',
  },
  {
    id: 'niicpkfpebcmikhdmmjnlamoljlabkni',
    name: 'Claude Exporter',
    resource: 'browse.html',
  },
  {
    id: 'nikjkfpkdchpheoilbeekhbimcofegkl',
    name: 'Cashbe',
    resource: 'content/styles.css',
  },
  {
    id: 'njnaggoebacjnbklkcccmbnpfmeagcmp',
    name: 'Web Color Filter',
    resource: 'filters.xml',
  },
  {
    id: 'nkjiffgankhjcemjlikehngfajkdgfgd',
    name: 'Trustifi',
    resource: '735.js',
  },
  {
    id: 'nlmoemlbohbcjdobfebkmjpkkdbgnbki',
    name: 'Ecommerce Product Price Tracker',
    resource: 'images/people.png',
  },
  {
    id: 'nnpdpbjoioeijoaplmdmnnfeenkacfon',
    name: 'WeChat Web Open SideBar',
    resource: 'iframe_page.html',
  },
  {
    id: 'nnplkdokacnobmlbeolphcbloomcodpe',
    name: 'Store Detector',
    resource: 'apps.js',
  },
  {
    id: 'nogokoemmdgggiojcpalgneggpijacea',
    name: 'XML Formatter',
    resource: 'img/dark.png',
  },
  {
    id: 'nolmmmfbcjgjejnoajfkikdikaelamcg',
    name: 'Tab Rename Wiz',
    resource: 'icons/icon16.png',
  },
  {
    id: 'nopflpjffmdlioccdjkhkdgbgfmkcpbd',
    name: 'TradeWiz',
    resource: 'src/lib/injected.js',
  },
  {
    id: 'npofhepaljhejbmhheffcjgcafdcnaac',
    name: 'Case Status',
    resource: 'cs-frame.css',
  },
  {
    id: 'npojienggkmiiemiolplijhfdmppacik',
    name: 'WA Audio & Voice Message to Text',
    resource: 'logo/logo_16.png',
  },
  {
    id: 'ocibfjgeibhjhjpkdidnjmegkddihdok',
    name: 'S.コンテキストガジェット＆ウェブメニュー',
    resource: 'images/Logo.gif',
  },
  {
    id: 'oepplnnfceidfaaacjpdpobnjkcpgcpo',
    name: 'RecipeSage',
    resource: 'inject/clip.js',
  },
  {
    id: 'ofaccdedcjcdbkjgjepbnacoekoeoepf',
    name: 'EyeCare Assistant',
    resource: 'sounds/README.md',
  },
  {
    id: 'ogepjnnfghfpkpjjieenkcppifhmmcdg',
    name: 'LoadHunter',
    resource: 'icons/16.png',
  },
  {
    id: 'oidniehfklehibjbdlcmkploiojjpbkb',
    name: 'Translator for Discord Web',
    resource: 'assets/index.534cdb2c.js',
  },
  {
    id: 'oihpodnimjebpjcdfhipjfmpmcbmedoe',
    name: 'Jarvis',
    resource: 'images/icon-16.png',
  },
  {
    id: 'okdbbjbbccdhhfaefmcmekalmmdjjide',
    name: 'Draw.io MCP',
    resource: 'main_world.js',
  },
  {
    id: 'omblejblkjafdgejjnjmhkjcakhglmke',
    name: 'TechLink',
    resource: 'store.js',
  },
  {
    id: 'onoiombdhkjneegnlbgodhopdnadfknm',
    name: 'Offer.love',
    resource: 'icons/gear.svg',
  },
  {
    id: 'oonmbnfejhgollkgadbgpinlhldcmboe',
    name: 'ANNEXX SEO ID',
    resource: 'icons/arrow.png',
  },
  {
    id: 'opaohckmjkaakaaacfamchijckiagnbi',
    name: 'Better Flight Finder',
    resource: 'interceptor.js',
  },
  {
    id: 'opkclndfcbafdaecbbaklefnaadopcln',
    name: 'AntiDebug Breaker',
    resource: 'scripts/hook_log.js',
  },
  {
    id: 'oppacfhojhdjcgkjeeonghmolpjhgcec',
    name: 'Ntro.io',
    resource: 'styles/font.css',
  },
  {
    id: 'pahfpfcfakjnfjgknppagnmajidhakea',
    name: 'darkmode',
    resource: 'css/noty.css',
  },
  {
    id: 'pakmpbenpabdjjgpieichnpkmedcnpne',
    name: 'BestStore Printer Launcher',
    resource: 'ping.js',
  },
  {
    id: 'pcmopeooniljomkngcpdnijhdkimldpo',
    name: 'GladMail',
    resource: 'sdk.js',
  },
  {
    id: 'pepdpaiacpcgjoapmhehgmjcicninpgf',
    name: 'Bulk WA Number Checker & Validator & Search & lookup',
    resource: 'logo/logo_16.png',
  },
  {
    id: 'pfcacfgohgdodgmahbjkbndbdkmfknlo',
    name: "IT'S TIME TO STOP!",
    resource: 'assets/1.webm',
  },
  {
    id: 'pgmffgofnnjppcongjleophechoafipl',
    name: 'AmzTrends',
    resource: 'config.json',
  },
  {
    id: 'pjcoeodfcijljpnpimnohlcbhpedgpoe',
    name: 'Identity Guard',
    resource: 'images/logo-24.svg',
  },
  {
    id: 'pjhdflpjemjalkidecigcjcamkbllhoj',
    name: 'ChatGPT for Google',
    resource: 'one.svg',
  },
  {
    id: 'pkckbkheblnpnlnmkldeikhkfddhnkah',
    name: 'OUI9 HLS PLAYER M3U8',
    resource: 'hls.js',
  },
  {
    id: 'pmcgedeeklmholbbcohkffpghigplibj',
    name: '店鲸灵',
    resource: 'icon/16.png',
  },
  {
    id: 'aabfpcmijdbilcmhnakjmoebdnmkoiii',
    name: 'Face Swap',
    resource: 'img/logo.png',
  },
  {
    id: 'aafjjocpcjgbdkcfblcaejddeemlfjej',
    name: 'Satsback.com',
    resource: 'banner.html',
  },
  {
    id: 'aanpkkmackhljjnbcopdoidpdjngfooc',
    name: 'Elevar GTM Event Builder',
    resource: 'InterVariable.woff2',
  },
  {
    id: 'adhgifgmkblkmejdgiplocmdjbbibkip',
    name: 'AI Translation',
    resource: 'js/ui-panel.js',
  },
  {
    id: 'adiafdcdgijidhafcchahkbaaidcohda',
    name: 'Airbnb for Digital Nomads',
    resource: 'api.js',
  },
  {
    id: 'adodeopedjkoofdbblibackjdklbnepe',
    name: 'Oald',
    resource: 'icon.gif',
  },
  {
    id: 'aeoilchhomapofiopejjlecddfldpeom',
    name: 'Module Federation',
    resource: 'static/js/post-message.js',
  },
  {
    id: 'aheodpkhmemjhjboebkkaiihfchljepc',
    name: 'AgreeSafe',
    resource: 'assets/icons/icon_128.png',
  },
  {
    id: 'ahjjidbbielmekkaklabocljkljbmnlm',
    name: 'Reddit Scraper',
    resource: 'html/history-viewer.html',
  },
  {
    id: 'ahkidgegbmbnggcnmejhobepkaphkfhl',
    name: 'GIF Blocker',
    resource: 'data/block.svg',
  },
  {
    id: 'ahnaknhjlbcofkaiapoldfkpacjegnme',
    name: 'MindYourPass',
    resource: 'assets/securelogin2/signin.html',
  },
  {
    id: 'ajenepebkdbgemdaiijnfpdfiglijpag',
    name: 'Yaka Sinhala English Dictionary',
    resource: 'assets/icon.svg',
  },
  {
    id: 'akaghbppajebgbeaikhobgbifkcigami',
    name: '比一比',
    resource: 'js/main.js',
  },
  {
    id: 'akkmagafhjjjjclaejjomkeccmjhdkpa',
    name: 'Nintondo Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'akobgmenldnlbglcoaekkiolkjkfhmam',
    name: 'Máquina de Leads',
    resource: 'js/aes.js',
  },
  {
    id: 'allkflnjjojcebeclfejonalicefpiph',
    name: 'Chatly',
    resource: 'content-scripts/article-widget.css',
  },
  {
    id: 'ambbpgjiiielnmnnihfndemhlbancppp',
    name: '智云台',
    resource: 'render.js',
  },
  {
    id: 'amkahembcklobdkoaaepgfpmdnobmdkh',
    name: 'Search with DuckDuckGo',
    resource: 'src/search_popup/popup.html',
  },
  {
    id: 'ammlkccachoinkdojonhojkdojgniaki',
    name: 'css scanner',
    resource: 'img/copy.svg',
  },
  {
    id: 'anfgglggipbhpklbnbolpbgnpjampiaf',
    name: 'Knovel',
    resource: 'assets/images/on.svg',
  },
  {
    id: 'annoaihhfdegphdkkkbahheignkgigpd',
    name: 'FollowUp.cc for Gmail',
    resource: 'images/icon16.png',
  },
  {
    id: 'aodleelklmlppabmpdecbogjogklhlgi',
    name: 'Similar Inc',
    resource: 'images/key.png',
  },
  {
    id: 'aofgbbaefoieceocnahfnebmglfcjkfh',
    name: 'TG Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'aohfenpemkefcdchmonkodnkdnkejegd',
    name: 'Screen recorder',
    resource: 'setup.html',
  },
  {
    id: 'aonflkdebcjkiimklgpgkclmjohclbbf',
    name: 'Shift Click',
    resource: 'lib/url.js',
  },
  {
    id: 'aoommnddcomiepijigekgidcapgamkmo',
    name: 'HotSave',
    resource: 'images/16.png',
  },
  {
    id: 'apobfogcnacaeoaakikjmiolohhknjkd',
    name: 'Oneko Neko',
    resource: 'assets/oneko.png',
  },
  {
    id: 'bammnammeldigbbkooilpcmigfejfhko',
    name: 'HTML To Elementor',
    resource: 'icon-256.png',
  },
  {
    id: 'banenbandgkedafhamkionjblbbiblmf',
    name: 'Snipe Sensei',
    resource: 'icons/64.png',
  },
  {
    id: 'bbiljflfafkaejgdebbnmcohpidgkejj',
    name: 'Add Sense',
    resource: 'injected.js',
  },
  {
    id: 'bcddfclcghmjpkihmjdlnejflhccdjgg',
    name: 'whatsgw',
    resource: 'client.js',
  },
  {
    id: 'bclpaijcplngobfnfobipmjdallopgep',
    name: 'Sound Equalizer',
    resource: 'popup.js',
  },
  {
    id: 'bcppghiggoobhkjlkfpmonlcigffpime',
    name: 'Score App',
    resource: 'main.css',
  },
  {
    id: 'bddhabjbedlkklcpkbgpiidbmdinjkbm',
    name: 'PageSaver',
    resource: 'turndown.js',
  },
  {
    id: 'bdgbhdnmgjkbpedemhmphgfjabmoagbk',
    name: 'Vocal Remover, Music Separator',
    resource: 'content.js',
  },
  {
    id: 'bebloogeelkcpmflbhdhdkppjjbifiih',
    name: 'Image Metadata Viewer',
    resource: 'json5.js',
  },
  {
    id: 'behnabjcooikinkcebobgcdcpbmkoldm',
    name: 'Better Pronote',
    resource: 'assets/name.png',
  },
  {
    id: 'bfafhgjcljndbkjgnfdmdeeidhmpmenk',
    name: 'Temu Seller Assistant',
    resource: 'icon/16.png',
  },
  {
    id: 'bfmkncnednfdodcollgepkgmjkpgdlcm',
    name: 'Fatkun Image Downloader',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'bgadbfbglghghbbiaifneokpapebncmk',
    name: 'EasyJobs',
    resource: 'style.css',
  },
  {
    id: 'bhegpnjcnbmflfpllknknngbpndjmogn',
    name: 'Mira for Chrome',
    resource: 'sidepanel/proxy-page.html',
  },
  {
    id: 'bhlokigpgcdidlakfodbghhgbdpgaobb',
    name: 'Transposer',
    resource: 'pitch-processor.js',
  },
  {
    id: 'biamdbghcfnhfomoeoofijhgbaconohn',
    name: 'Voice control for chatGPT',
    resource: 'logo.png',
  },
  {
    id: 'bifgfhokfobhebifcogneljkpaaloonp',
    name: 'Cesturefy',
    resource: 'fonts/icons.woff',
  },
  {
    id: 'bjfjkjhibpmaimoapdkgcflpjlbbmind',
    name: 'RoboProfit',
    resource: 'img/ca.webp',
  },
  {
    id: 'bjmgcelbpkgmofiogkmleblcmecflldk',
    name: 'Briefly',
    resource: 'src/deps/sentry.js',
  },
  {
    id: 'bknaiihbekigjeginplhehfiekeeodme',
    name: 'Activity Map v3',
    resource: 'sate.js',
  },
  {
    id: 'bkokmlhcdmoeobdcabifliikflimplol',
    name: 'Vepaar',
    resource: 'assets/icons/48.png',
  },
  {
    id: 'blcaacmeglnfblclocdgaomhopnfobof',
    name: 'TAP Wallet',
    resource: 'assets/tap-script.js',
  },
  {
    id: 'blfabmcjenebgankcigjloaibmpcoopn',
    name: 'Auto Full Screen for Google Meet',
    resource: 'styles/body.css',
  },
  {
    id: 'bmcnakllnfgdjlalfffanmfhampcoalm',
    name: 'Jive Anywhere',
    resource: 'Extension/options.html',
  },
  {
    id: 'bmheaicmcnedjkbkidcfegibipknddga',
    name: 'BrowserCopilot AI',
    resource: 'src/assets/logo.png',
  },
  {
    id: 'bnblmfafhphijgdplnefciaffabgmboo',
    name: 'Zoho PageSense',
    resource: 'injected-scripts/script-loader.js',
  },
  {
    id: 'bpbbdkcbhmgmkhbneldocmlndddhkpec',
    name: 'Competition Meter',
    resource: 'icons/16.png',
  },
  {
    id: 'cabldpgmkejdhjbgmeooocablkljdbcg',
    name: 'SocialPilot',
    resource: 'icon/16.png',
  },
  {
    id: 'cahanjnhpgjbnhjemgfohkgfjkbhpbdc',
    name: 'UI Replicator',
    resource: 'icon.png',
  },
  {
    id: 'cbdgkflbadceflcbbogjkldbnjddnhbl',
    name: 'KAERU',
    resource: 'src/assets/images/16.png',
  },
  {
    id: 'cbfllaanijkpjgnolhfhephemiccnacj',
    name: 'Bublup',
    resource: 'data/js/lib/q.js',
  },
  {
    id: 'cbjgpemimjmpbldgimfocbanmmkoefbi',
    name: 'Click-to-Call',
    resource: 'js/fsm.js',
  },
  {
    id: 'cbmhmapejkobbbmhdlpjmiljbfgnfknc',
    name: 'Ye Scraper',
    resource: 'help.html',
  },
  {
    id: 'ccecbaojlioecmnfloeoiehhaiddailm',
    name: 'Spy Wolf',
    resource: 'inject.js',
  },
  {
    id: 'cdafelflmnppkmabioccepjnelidmgkn',
    name: 'SIPOUT',
    resource: 'img/answer.svg',
  },
  {
    id: 'cellkdckoofbjfpelacpagofdpijhblh',
    name: 'Page Marker Extension',
    resource: 'main.css',
  },
  {
    id: 'ceondjobkkcjpcmkcggnpoenhhimmkln',
    name: 'Enhanced Vue.js devtools',
    resource: 'devtools.html',
  },
  {
    id: 'cgenfommofedogdmkmjdndijcilplkmg',
    name: 'GetVM',
    resource: 'sidepanel.html',
  },
  {
    id: 'cgganjhojpaejcnglgnpganbafoloofa',
    name: 'Easy Exporter',
    resource: 'icon/icon.png',
  },
  {
    id: 'cgpcmjlbbminbhmmhodnhihbabgnbaji',
    name: 'GenTech',
    resource: 'logo.png',
  },
  {
    id: 'cgpljmpgijchejkjecmnpkgajklfdnak',
    name: 'miniOrange SSO',
    resource: 'html/widget.html',
  },
  {
    id: 'cibedeeoecmjnbldmojlibkhlahndedf',
    name: 'Dark Mode for AliExpress & Alibaba',
    resource: 'img/on.png',
  },
  {
    id: 'cjabmkimbcmhhepelfhjhbhonnapiipj',
    name: 'simple-virtual-keyboard',
    resource: 'content_scripts/contentScript.3a8356c2.css',
  },
  {
    id: 'ckekikbobbnplbgbogmiebdmjclgajgp',
    name: 'PDF Filler',
    resource: 'icons/16x16.png',
  },
  {
    id: 'clhmnbpdboilpogpmojknkopklkfggpa',
    name: 'LeadRocks for LinkedIn',
    resource: 'icons/copy.svg',
  },
  {
    id: 'cmdooepdomcdmmdjgjohkkeajegcngfb',
    name: 'PDF Viewer Pro',
    resource: 'content/web/pdf-viewer-pro-intro.pdf',
  },
  {
    id: 'cniohcjecdcdhgmlofniddfoeokbpbpb',
    name: 'EME Logger',
    resource: 'trace-anything.js',
  },
  {
    id: 'cpfchfkodgnkhfmndmmkecbihmdahpia',
    name: 'Workspace Tab Manager',
    resource: 'import.html',
  },
  {
    id: 'cpjinncdhahoifeafejhlfohlomhkmkf',
    name: 'AIPrompter',
    resource: 'resources/images/tip.png',
  },
  {
    id: 'daajafhilgdopgffhkoalglfpghbenai',
    name: 'Henry Luxe Rewards',
    resource: 'browser.fa05fdaf.js',
  },
  {
    id: 'damdgpjmjphpbefjenbpmmknijkiiemo',
    name: 'Pixcall',
    resource: 'extension.html',
  },
  {
    id: 'dbhedbldemmlecbgjnbolcbcgaelciea',
    name: 'Taobao',
    resource: 'js/test.js',
  },
  {
    id: 'dbkmhaamlapkjabaieclhlofhnaoccmb',
    name: 'Read Time Estimator',
    resource: 'manifest.json',
  },
  {
    id: 'dcfmgfgnkhcehmdgpoekllfmnbpbgkha',
    name: 'MU² Web Unicode Converter',
    resource: 'YoeYar-One.ttf',
  },
  {
    id: 'dchjcpaccnemnmhnnmkcpapjieaknljk',
    name: 'Prayer Times',
    resource: 'donate.js',
  },
  {
    id: 'ddaigcnbmdcdkfocmgkpbbnhmfekglkp',
    name: 'DingTalk AI',
    resource: 'views/popup.html',
  },
  {
    id: 'dejblhmebonldngnmeidliaifgiagcjj',
    name: 'Quick Find',
    resource: 'images/sprites/close.png',
  },
  {
    id: 'dejmgcinmidgfjbnfkeeopfmfmcggdhj',
    name: 'Studylib New Tab',
    resource: 'assets/img/star.png',
  },
  {
    id: 'dfkedikhakpapbfcnbpmfhpklndgiaog',
    name: 'PaperDbg',
    resource: 'images/locator.png',
  },
  {
    id: 'dfljickgkbfaoiifheibjpejloipegcb',
    name: 'Track & Trace Tools',
    resource: 'img/google.svg',
  },
  {
    id: 'dfncaoemjmmnbcfldoochfgkhenhegjl',
    name: 'Chrome Lock',
    resource: 'services/queue/marks/icon_lg.png',
  },
  {
    id: 'dfnhlnnmcjnmlihpjbkdefpnfdpgedbn',
    name: 'Full Picture',
    resource: 'popup/index.html',
  },
  {
    id: 'dhnfhejepmiknkfdmfhmogfelijlfdma',
    name: 'NMO Quiz Wrapper',
    resource: 'css/style.css',
  },
  {
    id: 'didjghlckjhcmaehijhnndpmagpakkkm',
    name: 'Found',
    resource: 'icons/over.svg',
  },
  {
    id: 'diggedafpdocbgcamamledcjfmckeaeh',
    name: 'Magic Assistant Workspace',
    resource: 'assets/icon.png',
  },
  {
    id: 'djdfdgpbbieoekodflodcagmnjnineji',
    name: 'Vận chuyển Việt Trung',
    resource: 'style.css',
  },
  {
    id: 'djdnajgjcbjhhbdblkegbcgodlkkfhcl',
    name: 'Sporran',
    resource: 'js/injectedScript.js',
  },
  {
    id: 'djlifjbljbhnhkplahimejgmjmnandjk',
    name: 'Auto Dialer for Twilio Platform',
    resource: 'chin-up.mp3',
  },
  {
    id: 'djmienebkjmfcelnfkcnlbdomapjbgfh',
    name: 'OKKI助手',
    resource: 'assets/img/mk.png',
  },
  {
    id: 'dkcgdknimgiffognmpiheegpfkkmcapk',
    name: 'Sundial',
    resource: 'cities.json',
  },
  {
    id: 'dkdkgolbbhndgncnaogbdgdnldopcggj',
    name: 'Mention Network',
    resource: 'assets/images/loading.gif',
  },
  {
    id: 'dlbiigchkpmpijahmlofleeemiomaneo',
    name: 'Dokobot',
    resource: 'sandbox.html',
  },
  {
    id: 'dljchadmceknaijmdmnaaodjkkidhakh',
    name: 'Comfortable Sakai',
    resource: 'img/logo.png',
  },
  {
    id: 'dmlmenebejdemdbmgldkpckfbmijlchh',
    name: 'Zillow Redfin Realtor',
    resource: 'lib/jquery.js',
  },
  {
    id: 'dnojajbhnmlckbikniacaidonnbamfpf',
    name: 'Mailscan',
    resource: 'xhrOverrideScript.js',
  },
  {
    id: 'dogbmklcnehaooiadgndpdklmcmoddpe',
    name: 'R Discovery',
    resource: 'assets/icon.png',
  },
  {
    id: 'dpfkgaedamhcmkkgeiajeggihmfjhhlj',
    name: 'Simple Chat Hub',
    resource: 'assets/chunk-06acad6c.js',
  },
  {
    id: 'dpkbdbpmahebenenkkjenihgfophknbm',
    name: 'Overloop',
    resource: 'lib/dist/domain.js',
  },
  {
    id: 'dpleccoifgoflihlgpjlkeigjemckbgn',
    name: 'Simple Posher',
    resource: 'bell.mp3',
  },
  {
    id: 'eaffganlcmlddhikdkbaghmkgfpjhphl',
    name: 'Taobao search by image',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ealmaonflbncbmofgpniamdfgobliffm',
    name: 'Ascendara Download Handler',
    resource: 'cookie-popup.html',
  },
  {
    id: 'ebjidplbhbakkfpkofpmfhhdgpdajffh',
    name: 'Ultimate 432 Player',
    resource: 'popup.html',
  },
  {
    id: 'efbhkecfjhcpmepgbpogiiaidkmjhojl',
    name: 'ManabiDojo',
    resource: 'up_/wordbook/wordbook.html',
  },
  {
    id: 'efcbfjjkfckbphmcjpacbgpjknkbebgg',
    name: 'Paywall Porter for NotebookLM',
    resource: 'locales/af.json',
  },
  {
    id: 'efeikkcpimdfpdlmlbjdecnmkknjcfcp',
    name: 'Ads Library Downloader & Ad Finder & Adspy Tool',
    resource: 'icons/logo_128.png',
  },
  {
    id: 'ehekffhhobjogdcdafcfhkfpcpaeagnd',
    name: 'GPTOnline',
    resource: 'README.md',
  },
  {
    id: 'eiflpppdaikieggdeojonknijogibjhh',
    name: '랭플릭스',
    resource: 'content.css',
  },
  {
    id: 'ejcciljmcobakbcljagiadhbholnahja',
    name: 'VipIP.ru',
    resource: 'assets/img/logo.png',
  },
  {
    id: 'ekfkopmgnijagfmjgcjkbffcnmggekec',
    name: 'SafeToOpen',
    resource: 'js/enc.js',
  },
  {
    id: 'emchgjmefmdpapndjafcahblejlmfmlh',
    name: 'PallyCon LicenseCipher',
    resource: 'tables.bin',
  },
  {
    id: 'emfegmjcadbmdcmdecepfkmhnenpnfip',
    name: 'Discord Voice Messages',
    resource: 'static/css/main.61ef816e.css',
  },
  {
    id: 'emgfmfgandmhbgleikkoaebngboghfpe',
    name: 'Readapt',
    resource: 'fonts/Luciole-Bold.ttf',
  },
  {
    id: 'enbnpdbkfjdnhlepfeaaahegcggljhdh',
    name: 'Bitway Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'engdhlnghkdaoccckbbglafcanmpohob',
    name: 'Export WhatsApp Surveys',
    resource: 'script.js',
  },
  {
    id: 'enhjjhkhjenjnanplmdkahkbkoeeljjp',
    name: 'FuseBase Clarity',
    resource: 'assets/flex.css',
  },
  {
    id: 'eninbjdhgaccikhclpomppfcclammnoc',
    name: 'Frejun',
    resource: 'mic.js',
  },
  {
    id: 'enmeegingoekbnecjoaogdebdpcmfnff',
    name: 'YouTube Uninterrupted',
    resource: 'js/mainCS.js',
  },
  {
    id: 'ennfiiedhgpkgfknpaggcammgfohgfap',
    name: 'Shopee Image Downloader',
    resource: 'js/contentScript.js',
  },
  {
    id: 'eopgniffanmbfaeadkhigcmonfdljldn',
    name: 'Faypay',
    resource: 'js/injectScript.js',
  },
  {
    id: 'eopjnahefjhnhfanplcjpbbdkpbagikk',
    name: 'Epublifier',
    resource: 'js/829.js',
  },
  {
    id: 'epbjhopaefahnekpoieicafdbhbgokoc',
    name: 'Search New Tab',
    resource: 'index.html',
  },
  {
    id: 'eppedlbobmdflmhleafebmahnbphgipb',
    name: 'Locus',
    resource: 'assets/icons/icon-16.png',
  },
  {
    id: 'fbplokigmiekbdgkpfngbgpkhepnkace',
    name: 'MathPad',
    resource: 'icons/icon-16.png',
  },
  {
    id: 'fejbaoplibjdpbdlebomlhpncffgcchc',
    name: 'Mooon',
    resource: 'index.html',
  },
  {
    id: 'fepohihpoobnpbgnnndppkbmloaohhco',
    name: 'MiCloud Connect',
    resource: 'images/icons/icon12.png',
  },
  {
    id: 'fflfneomfmjmcmfbegldeflcakinffef',
    name: 'Custom Cursor World',
    resource: 'content.js',
  },
  {
    id: 'fgoilnlnleemcedbmhoalpmhkefdppbm',
    name: 'Geniuslink',
    resource: 'js/frame.js',
  },
  {
    id: 'fhkelfkhcaokghlkckfgjoejhanelped',
    name: 'Shopify App Detector',
    resource: 'icons/icon16.png',
  },
  {
    id: 'fikmdgdekfjikohjnjabmmefbkmkahgj',
    name: 'Chatgot',
    resource: 'content.js',
  },
  {
    id: 'fmeenkjnbikclpgbonadanhnipgmofhn',
    name: 'gloCOM Call',
    resource: 'detectAjax.js',
  },
  {
    id: 'fmjgfjanmcbhpmlemahbnfehjoboopce',
    name: 'TweetsMash',
    resource: 'icon.png',
  },
  {
    id: 'fomgcolbgdjbmnabgijnbmmmoimhlidi',
    name: 'Workable',
    resource: 'images/logo.png',
  },
  {
    id: 'fpggfghfmngphoamhjllcdkfdpjpnbko',
    name: 'Pronounce Words',
    resource: 'img/logo-16.png',
  },
  { id: 'gacfacdpfimbkgcnlegknnmcccjgcbnp', name: 'CWS', resource: 'fen.png' },
  {
    id: 'gaibhhiogjpncmcehohlmcikfgbcacbl',
    name: 'Phone On Web',
    resource: 'assets/index.js',
  },
  {
    id: 'gbnadjkeegkhbcoeaeaoedpojlcknnhp',
    name: 'JSON Formatter Pro',
    resource: 'assets/icons/icon-16.png',
  },
  {
    id: 'gcaiimgaiohlnlflkjjmcohobkpbbnfi',
    name: 'AdsPower Assistant',
    resource: 'dist/security/index.html',
  },
  {
    id: 'gclnfffacbjpclfenjgefpfnafmjghhk',
    name: 'AvailableReads',
    resource: 'icons/icon25.png',
  },
  {
    id: 'gdaboelanpkjafmhbggldmofabiblcbm',
    name: 'Read Aloud',
    resource: 'pdf.png',
  },
  {
    id: 'gedoaajonjaiigaefeaanpfmhnadkgkm',
    name: 'Breeze',
    resource: 'images/close.png',
  },
  {
    id: 'geopmmjhgiigoelgcgnpcfmblameojce',
    name: 'Silver',
    resource: 'assets/Images/svg.svg',
  },
  {
    id: 'gfakplbimkgohgmoaoapfckkccbompod',
    name: 'Twitter Video Downloader',
    resource: 'injected.js',
  },
  {
    id: 'gffkeecoolocldhomifoigdefjcplaim',
    name: 'UA Price Tracker',
    resource: 'images/logo_96.png',
  },
  {
    id: 'gfjkkccgjogpdhmhdinjngakpajljhba',
    name: 'Dynu Dynamic DNS Client',
    resource: 'icon48.png',
  },
  {
    id: 'gflobokeglbgdhdelipppigfncpnfgbh',
    name: 'Dyslexic Browser',
    resource: 'img/play.svg',
  },
  {
    id: 'gfpilfgnkbfegagnmbkgagcecckfbaga',
    name: 'Wa2in',
    resource: 'sdk/adapter/hook.js',
  },
  {
    id: 'ghnnkkhikjclkpldkbdopbpcocpchhoi',
    name: 'Shein Images Downloader',
    resource: 'injected.js',
  },
  {
    id: 'gicodedokficeedibakcjaopopjbgojk',
    name: 'ByNoGame Auto Trader',
    resource: 'sounds/info.mp3',
  },
  {
    id: 'gijnkelbkbmaekkkgoalpimggbmoahol',
    name: 'Audio SpeechScribe',
    resource: 'icon-48.png',
  },
  {
    id: 'gjogacgmdajpnhnilhpidkjdehnhcdpp',
    name: 'Finder',
    resource: 'img/logo.svg',
  },
  {
    id: 'gkblidmkgpdljmiaapdlnmogmhfcidee',
    name: '치지직 클립 다운로더',
    resource: 'ts2mp4/LICENSE',
  },
  {
    id: 'glhpeoijpjagckhmieidipcekdmmhofn',
    name: 'FatfoxTab',
    resource: 'fox.jpg',
  },
  {
    id: 'gllmkcahdekdbapmdfnffclacbpnicaj',
    name: 'MSA',
    resource: 'images/logo.png',
  },
  {
    id: 'gmkblbmghnolinkhfmkidocbojcfiejm',
    name: 'Jump To Recipe',
    resource: 'popup.html',
  },
  {
    id: 'gmkgbihnjmflaahgkhlmenngplbinkji',
    name: 'Phone-C',
    resource: 'img/x.png',
  },
  {
    id: 'gndcbndejfodldbldgjlbceailbadmni',
    name: 'TasteWP',
    resource: 'images/logo.svg',
  },
  {
    id: 'gnemaookpcekfeidmgocagofgijpoced',
    name: 'OrderPro Exporter',
    resource: 'html/budget-short.html',
  },
  {
    id: 'gnkeincopncoghpfiepmdnlonocbfgah',
    name: 'Active Junky',
    resource: 'icon-34.png',
  },
  {
    id: 'gnkoofidpbkdoejdloidmbdefjpgpjdi',
    name: 'Walution',
    resource: 'app/pwmClient.js',
  },
  {
    id: 'gnmokfnnmiogbienadgnimmgpjgollen',
    name: '易用侧边栏 Pro',
    resource: 'rules.json',
  },
  {
    id: 'gnogdcplfkjnmnapmdheajijmmoooion',
    name: 'Bonk Leagues Client',
    resource: 'client/js/injector.js',
  },
  {
    id: 'haddgijkelkjimhdhgaopfcjhnoipimj',
    name: 'typedesk Canned Responses',
    resource: 'logo_icon.svg',
  },
  {
    id: 'haigaafonckooggfpmjplfpbkafelcfe',
    name: 'dmitlichess',
    resource: 'ogg/completed',
  },
  {
    id: 'haikmmmjkcejaalkjbfobneapigfmldp',
    name: 'CMeter',
    resource: 'addonParams.js',
  },
  {
    id: 'haminfolhoibklkkjmkjmmgnmbkgmehe',
    name: 'Change Google Calendar Background',
    resource: 'assets/js/utils.js',
  },
  {
    id: 'hbihkmdifofjofeoaoppajjpcjcpgndk',
    name: '股票基金管家',
    resource: 'options/options.html',
  },
  {
    id: 'hbnbcapieoandchfgacedlkjpdbbejgb',
    name: 'NoCaptcha AI',
    resource: 'temp.js',
  },
  {
    id: 'hcgejekffjilpgbommjoklpneekbkajb',
    name: 'Kibisis',
    resource: 'client.js',
  },
  {
    id: 'hdlfamnpialfmlkddnmijnimciflhbjo',
    name: 'Shade Calendar',
    resource: 'assets/images/wave.png',
  },
  {
    id: 'hekemgbiebopgohbhcheiibcpelbbfon',
    name: 'CAD SCOUT 3Dfindit',
    resource: 'images/bim.svg',
  },
  {
    id: 'hgejhpdhgknnbiiabjjamepdojgldbhn',
    name: 'AdCrunch',
    resource: 'strictblock.9888d31fc4b7dcbe.html',
  },
  {
    id: 'hhiapgaiakcmflgmeabfdjmbkljocgce',
    name: 'Grackle Check',
    resource: 'icons/icon16.png',
  },
  {
    id: 'hhmmfngefldoedchbmpanmnjakgfacih',
    name: 'Optimize Next',
    resource: 'logo.png',
  },
  {
    id: 'hieogbibhnhplofpndgbfficihlgahfa',
    name: 'The Read Time',
    resource: 'main.js',
  },
  {
    id: 'hinnghaoldgikiknkglnepdhjlcljbjl',
    name: 'Donut@Home for ZLT S10',
    resource: 'resources/images/bmc_qr.png',
  },
  {
    id: 'hjcdffalgapcchmopkbnkljenlglloln',
    name: 'ENO-M',
    resource: 'dist/contentScripts/style.css',
  },
  {
    id: 'hjknhpdppgbbademebbiagbnohjgbbin',
    name: 'EMB Tools',
    resource: 'bootstrap/bootstrap.bundle.min.js',
  },
  {
    id: 'hloeehlfligalbcbajlkjjdfngienilp',
    name: 'Steps Recorder',
    resource: 'Images/Like.svg',
  },
  {
    id: 'hloekinecmafifaghekdjepphlabepkl',
    name: 'Arweave.app',
    resource: 'wrapper.js',
  },
  {
    id: 'hmckjkoaomjipiplhjmihgdjgkjedfjg',
    name: 'Merch Dominator For Merch',
    resource: 'img/logo.png',
  },
  {
    id: 'hmpfdofadldbdljibacoicljekdmbpog',
    name: 'CTD',
    resource: 'ctd_logo.svg',
  },
  {
    id: 'hnphkpnkdaddihgjkcjaphgednckknbc',
    name: 'S@PHIR',
    resource: 'main.js',
  },
  {
    id: 'ianmkfjhfmjjlchjceijknakecemeope',
    name: 'TransorAI',
    resource: 'i18n.js',
  },
  {
    id: 'ibkcolodejfkapecfacofdibcaoldbjf',
    name: 'OneVnet',
    resource: 'js/popup.js',
  },
  {
    id: 'iccjbccjppdhlmnicgjkabhapcmilpog',
    name: 'BP Assistant',
    resource: 'ga/analytics.js',
  },
  {
    id: 'icpikagpkkbldbfjlbefnmmmcohbjije',
    name: 'Z3US',
    resource: 'assets/types-c157500c.js',
  },
  {
    id: 'ieoljnibpcpfkljlmamklclnbinngide',
    name: 'Easy Shop',
    resource: 'app.js',
  },
  {
    id: 'iiamdhkongjbodlgiofmclneebnocnki',
    name: 'Jiminny Sidekick',
    resource: 'icons/sms.svg',
  },
  {
    id: 'ijdelikbohnbiacoipaclicioknnihni',
    name: 'JP English Dictionary',
    resource: 'opencvHandler.html',
  },
  {
    id: 'ijpjifeopinhiiofbbblkfgcdcfcmncd',
    name: 'MagicHow',
    resource: 'tabs/save.html',
  },
  {
    id: 'ikddeecpbbbnfmnkldhnhjlljddnjbon',
    name: 'UpSignOn by Septeo',
    resource: 'u-icon.png',
  },
  {
    id: 'ikmpcihcohdjammgkopfgohojdelmfoi',
    name: 'Lichess enhancement',
    resource: 'ressources/js/arrive.js',
  },
  {
    id: 'ikphihiljfhlmpokjbmkhliphckfpcph',
    name: 'Amazon Review Export New V3',
    resource: 'config.json',
  },
  {
    id: 'ilbkkhmnmnehcicempfpekgcpneeekao',
    name: 'Mockiato',
    resource: 'mockiato.js',
  },
  {
    id: 'ileggkkibledcbjfampjhcghkkinenjd',
    name: 'Tab Revolver',
    resource: 'icons/tab.svg',
  },
  {
    id: 'ilhaljfiglknggcoegeknjghdgampffk',
    name: 'Beam Web Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'ilkdmekogmmllhlakbcmfpbagepbdbgj',
    name: '划词翻译',
    resource: 'assets/main.js',
  },
  {
    id: 'ilocfjnmkngcmoonmlpmdiigiddlloea',
    name: 'РешуОГЭ/ЕГЭ+',
    resource: 'script.js',
  },
  {
    id: 'inpjhnjfkjaibkkpcdhibhiccnndljnf',
    name: 'Devyce Softphone',
    resource: 'assets/js/links.js',
  },
  {
    id: 'ioamghgbfkachnkafmlfjgddjljidcbi',
    name: 'Peek',
    resource: 'icons/Logo.svg',
  },
  {
    id: 'ipgahklhmkcajgelkfombkolodahigco',
    name: 'Cordial',
    resource: 'resources/Welcome.js',
  },
  {
    id: 'ipifgcppajjnnkbhndgdlbnmkmcfokid',
    name: 'Knowmax',
    resource: 'assets/api-65b3401b.js',
  },
  {
    id: 'ipkhkglhpmngdkgclngmlpkekkpplbgm',
    name: 'Prayer Times',
    resource: 'solemn.mp3',
  },
  {
    id: 'jakjgacnfiechbpinegcjkomhfhnbhhe',
    name: 'Cache Clear',
    resource: 'popup.html',
  },
  {
    id: 'jbddomeagbjjdoaehkdffdhifdhnmfic',
    name: 'HoverTranslate',
    resource: 'manifest.json',
  },
  {
    id: 'jbnlcgeengmijcghameodeaenefieedm',
    name: 'Snowplow Debugger',
    resource: 'config.json',
  },
  {
    id: 'jcmgaoihheikehfhnhjdedbnbaipdpkf',
    name: 'Ambition',
    resource: 'dist/contentScripts/style.css',
  },
  {
    id: 'jdfkagmmfcpkkapheeidelffnligiekb',
    name: 'RightClick',
    resource: 'popup.html',
  },
  {
    id: 'jeiknhbgbecfmponmblcpaimhhdoleca',
    name: 'Masterschool',
    resource: 'static/css/main.e5ab261a.css',
  },
  {
    id: 'jfippgilnpggpddhmfjaaecadnfhcopa',
    name: 'Python Playground',
    resource: 'pyodide/ffi.d.ts',
  },
  {
    id: 'jflbdgpbnmffamamiimbdgpfggddhcpc',
    name: 'CrypSearch',
    resource: 'icon-128.png',
  },
  {
    id: 'jgobnmpfeomiffhbedhfgbhelcnnelkd',
    name: 'Odoo Toolbox',
    resource: 'odoo-websites.js',
  },
  {
    id: 'jifommjndpnefcfplgnbhabocomgdjjg',
    name: 'ScrollMaps',
    resource: 'images/permission_icon.png',
  },
  {
    id: 'jjdlecgjgcejnobmljdmjolnadeplapb',
    name: 'UK Visa Sponsorship Checker',
    resource: 'assets/pic1.jpg',
  },
  {
    id: 'jkhkimeccaklhnefcjdjfgblaohadjlf',
    name: 'Search Online',
    resource: 'manifest.json',
  },
  {
    id: 'jkjfhnkojkogodcfloiloeakkjieiijo',
    name: 'ZumaPiano',
    resource: 'index.html',
  },
  {
    id: 'jkncjfiaifpdoemifnelilkikhbjfbhd',
    name: 'n8n Copilot',
    resource: 'assets/icon48.png',
  },
  {
    id: 'jmlaohefegdedjnmgpedcoococlpdida',
    name: 'Zoho Expense',
    resource: 'loader.html',
  },
  {
    id: 'jmohbogdcndleclcgnmjnfmghegbdfma',
    name: 'Our Mouse Gesture',
    resource: 'js/content.js',
  },
  {
    id: 'jnfhbofpfodjehahbofdnaliphmjngnf',
    name: 'Vajehyab',
    resource: 'src/images/x.svg',
  },
  {
    id: 'jnhibbjmekoijdjaopflcjbjieamifhh',
    name: 'vREST',
    resource: 'options.html',
  },
  {
    id: 'joioghagfpnpmdfdjijibfbfeolkddlf',
    name: 'Fabrie Web Clipper',
    resource: 'assets/js/index.js',
  },
  {
    id: 'jojgobnbjjpgehmhmogiacnbffahefnl',
    name: 'SAVRZ',
    resource: 'icons/icon16.png',
  },
  {
    id: 'kaebmfgmehefgiphckeahegicpfddhan',
    name: 'Furigana Plus',
    resource: 'dict/cc.dat.gz',
  },
  {
    id: 'kahnhlonadjlllgnilndafpajaiepdag',
    name: 'Sonatype Platform',
    resource: 'css/content.css',
  },
  {
    id: 'kbgffjjeekfafdbjlghgcgchkiocfokn',
    name: 'Авито аналитика',
    resource: 'lib/jszip.min.js',
  },
  {
    id: 'kbhghidlilegihmipoohlboebekiigli',
    name: 'SEO Pilot',
    resource: 'main.js',
  },
  {
    id: 'kcgmbngghfpnddnfccnabnioiidenipc',
    name: 'Beep for Gmail',
    resource: 'assets/icon48.png',
  },
  {
    id: 'kcoefldjifkfeclbjicapcenpknedhnf',
    name: 'Payscore',
    resource: 'Images/download.svg',
  },
  {
    id: 'kddlnbejbpknoedebeojobofnbdfhpnm',
    name: 'RideShare Trip Stats',
    resource: 'assets/_commonjsHelpers-CUmg6egw.js',
  },
  {
    id: 'kekchpijkaijdcppfehiplaghiokpcld',
    name: 'Waldo',
    resource: 'manifest.json',
  },
  {
    id: 'kfmcnbhcjcmfmjmnefhhmcjifakidfnp',
    name: 'OnePageCRM Lead Clipper',
    resource: 'dMJR8LiqACcaEg2F.html',
  },
  {
    id: 'kfngooidkiiljlbpaafgcfjddkgnhjkl',
    name: 'xLaw',
    resource: 'img/rk.png',
  },
  {
    id: 'kgjaddbcmpmacilgaekjfelhdebfjgib',
    name: 'Dropdown Search',
    resource: 'select2.full.js',
  },
  {
    id: 'kgnigbfnfjgpfaiaafcbgdkpalapiinb',
    name: 'Tab Snooze',
    resource: 'offscreen.html',
  },
  {
    id: 'kkaohflldandkklonkginlamccaknkok',
    name: '샵플링 플러그인',
    resource: 'config.json',
  },
  {
    id: 'kkgmmlflilcfcogmfpnhakfamdkdcbpl',
    name: 'AutoScroll 2.0',
    resource: 'data/images/origin/both.svg',
  },
  {
    id: 'kknghfgohminjbcadngbfnhjojeaoakj',
    name: 'Strong Password Generator',
    resource: 'icon32.png',
  },
  {
    id: 'kkpllbgjhchghjapjbinnoddmciocphm',
    name: 'Ninji Wallet',
    resource: 'inpage.be9fe2f5.js',
  },
  {
    id: 'klddneocmcmoacnnemmelgeilnedcpjj',
    name: 'BPM Changer',
    resource: 'mainContentScript.bundle.js',
  },
  {
    id: 'kmhjedddeligclkfcfbghcgngkhokdee',
    name: 'THunt image search',
    resource: 'icon/icon16.png',
  },
  {
    id: 'kmmefoagengbhadldokpjbkppebklema',
    name: 'iKorektor',
    resource: 'img/bolt.svg',
  },
  {
    id: 'kmnajldildkckmfgfbcfbfimdibebnjl',
    name: 'AutoHan',
    resource: 'han19.png',
  },
  {
    id: 'kmnlmigcmphnjgkmojgakabcidolhmbi',
    name: 'GoTo',
    resource: 'popover.html',
  },
  {
    id: 'knpbmoflfeeokanhpkiofaoaohpgfbjh',
    name: 'Comment Exporter',
    resource: 'main-world.js',
  },
  {
    id: 'knpfogmkplfinkdfehonaelmgjganbia',
    name: 'WorthEPenny',
    resource: 'scripts/w-4-0.js',
  },
  {
    id: 'koccpomgiggapkmlccpahgiickhacdch',
    name: 'Image to Prompt By Robi Technology',
    resource: 'style.css',
  },
  {
    id: 'kocnjkachacifcgiboaphjkmohggmpmh',
    name: 'Shopify Custom Fields',
    resource: 'icon.png',
  },
  {
    id: 'kofahhnmgobkidipanhejacffiigppcd',
    name: 'LT Debug',
    resource: 'index.html',
  },
  {
    id: 'kolhjbddamlepljhchmgmlabaanmpegk',
    name: 'Librezam',
    resource: 'content/content.js',
  },
  {
    id: 'kpflbjbcnmdmcahhdjhgbjfaclgefdbd',
    name: 'waboxapp MV3',
    resource: 'client.js',
  },
  {
    id: 'kpgalhfobkofgfhoiegcfbjclnlghjek',
    name: 'Google Rank Checker, Keyword SERP Ranking Extractor',
    resource: 'images/google.png',
  },
  {
    id: 'kphegobalneikdjnboeiheiklpbbhncm',
    name: 'Ajax Interceptor Tools',
    resource: 'pageScripts/index.js',
  },
  {
    id: 'lammobjjkafhagncabkhpplgnobhgnim',
    name: 'Shield AdBlocker',
    resource: 'icons/icon16.png',
  },
  {
    id: 'lbllhjepggobipdmalfamjplndhfcclh',
    name: 'ResumeUp.AI',
    resource: 'assets/logo.svg',
  },
  {
    id: 'lcgdcmgblmaamnegeblfjljkabjnpaod',
    name: 'iGenflow',
    resource: 'popup.js',
  },
  {
    id: 'ldadolhckmdcpiodmjjgilbbmiakbhgp',
    name: 'Marter',
    resource: 'bootstrap.css',
  },
  {
    id: 'ldolgfmfhlgpgnmplmblipcdmojfhbld',
    name: 'Smart TV Emulator',
    resource: 'images/x.png',
  },
  {
    id: 'lfaifjhjdolnpnlgeohohaalbeidhlpj',
    name: 'Commanders Act Assistant',
    resource: 'icons/48.png',
  },
  {
    id: 'lfeanemcbooflodhblonkcpjgmdkoepf',
    name: 'Translator for Messenger Web',
    resource: 'assets/index.2e493a08.js',
  },
  {
    id: 'lgbaopmimcnpphepmfphadncdofnojnd',
    name: 'GScholarLENS',
    resource: 'libs/chart.js',
  },
  {
    id: 'lgkipoadghdedmdaheacnjcfabmheeck',
    name: 'H1B Sponsor Checker',
    resource: 'index.html',
  },
  {
    id: 'lhhocifdmhogpekeppdjamkelohahbop',
    name: 'Downloads',
    resource: 'img/icons/icon-48x48.png',
  },
  {
    id: 'lhnmlndglclegompodlkifbmkhedoing',
    name: 'eNewie Cloud AI Subtitle',
    resource: 'images/icon48.png',
  },
  {
    id: 'liijobbiponnejejcfpbbmkanlnhhkoo',
    name: 'CS2 Case Stats',
    resource: 'templates/pulled-item.html',
  },
  {
    id: 'lklcifanokbdbllonclebeohlgkdpflb',
    name: 'Font of Web',
    resource: 'assets/root.ts-BLbAoeFl.js',
  },
  {
    id: 'lmebfikckidfjlkdajghlcmcmkefdkah',
    name: 'Executive Road Warrior Web Defender',
    resource: 'icons/icon128.png',
  },
  {
    id: 'lmgopblphifhibefhjehacdnngaohdoe',
    name: 'CI',
    resource: 'img/icon64.png',
  },
  {
    id: 'lmmbbhmbabdipogenjcndkkjjphkacpo',
    name: 'myparcels.app',
    resource: 'img/no.png',
  },
  {
    id: 'lmmgcpmnkfiocjngaibffkipfnogmojf',
    name: 'GW Sistemas',
    resource: 'manifest.json',
  },
  {
    id: 'lnmbffkdpinhcccidngekokeidglicic',
    name: 'Responsive LookUp',
    resource: 'frame.html',
  },
  {
    id: 'lobgnfjoknmnlljiedjgfffpcbaliomk',
    name: 'WA Number Checker',
    resource: 'assets/wa.js',
  },
  {
    id: 'loipjegagmfjcbofhmigjemdfcahcggm',
    name: 'Arabic Dictionary',
    resource: 'tooltip.js',
  },
  {
    id: 'lophahkofjipnddpmanfboohncfcjcoc',
    name: 'אתרים במייל',
    resource: 'onboarding.js',
  },
  {
    id: 'lpbacicclbdjgbcnbgfhdoliimkicfhd',
    name: 'ZoomSelling',
    resource: 'locales/cn.json',
  },
  {
    id: 'lpcohdfbomkgepfladogodgeoppclakd',
    name: 'AI Chat Organizer',
    resource: 'assets/icon.png',
  },
  {
    id: 'lpfpajiaohmafbnaidbfiolibpnclhei',
    name: 'Anki Tool',
    resource: 'pages/sidepanel.html',
  },
  {
    id: 'lpggagjnphkfelodjnhbhkkpbgmkpiop',
    name: 'Quick Call by Callyzer',
    resource: 'options.js',
  },
  {
    id: 'lpnjjifdoogdofcndompgiffigklmagb',
    name: 'Tailwind Turbo',
    resource: 'fonts/StudioFeixenSans-Bold.woff',
  },
  {
    id: 'makmhllelncgkglnpaipelogkekggpio',
    name: 'Litmus',
    resource: 'inject.js',
  },
  {
    id: 'mbgcfldceiogelfphfjdlbhbofcobcco',
    name: '전화번호안심로그인',
    resource: 'web/alert.html',
  },
  {
    id: 'mckfenhgbmiiomplialpmjjgclicdina',
    name: 'Bluelight Blocker',
    resource: 'img/bootstrap-icons/eye.svg',
  },
  {
    id: 'mdmenpppkndcjiojaclnlceegloooeip',
    name: 'NotebookLM Source Helper',
    resource: 'images/icon.html',
  },
  {
    id: 'meeeiblldcmbdhhaibnbpdiiknkoaakl',
    name: '패스트컷AI',
    resource: 'images/x.png',
  },
  {
    id: 'mfhpdapldnbmejcanhlbbmjlojncicfj',
    name: 'Numeo Spot',
    resource: 'get.js',
  },
  {
    id: 'mfjlolbldcokknaeaaphebndgeicolfm',
    name: 'WEBM to MP4 converter',
    resource: 'libs/utils.js',
  },
  {
    id: 'mgchaojnijgpemdfhpnbeejnppigfllj',
    name: 'NativeMind',
    resource: 'main-world-injected.js',
  },
  {
    id: 'mgijkcklpcaokmpejjcmchocpmkjdged',
    name: 'Classology AI',
    resource: 'assets/logo.svg',
  },
  {
    id: 'mgkmnfklffoiklgfeelhkppchpbmmneg',
    name: 'Best ChatGPT Prompts & AI Image Generator',
    resource: 'content.js',
  },
  {
    id: 'mhballnbcieehgglecpjocnbggoogbge',
    name: 'Kimchi Reader',
    resource: 'static/data/words.json',
  },
  {
    id: 'mhjpeloaogkjmpgcngiflachhggknlph',
    name: 'Speech to Text Converter',
    resource: 'icons/logo.svg',
  },
  {
    id: 'mjkojjodijpaneehkgmeckeljgkimnmd',
    name: 'Drizzle Studio',
    resource: 'unsupported.js',
  },
  {
    id: 'mjmjgaclkoadgkgpaaclfajeffcoochp',
    name: 'CiJiang-AMZ massive keyword operation',
    resource: 'icon.png',
  },
  {
    id: 'mjpagpldmjhnpheaecnfknepgcibknjm',
    name: 'StepHow',
    resource: 'assets/app.js',
  },
  {
    id: 'mkahfeefmklmbhemabnabepheopkljgp',
    name: 'PasswordPocket',
    resource: 'credential_box.html',
  },
  {
    id: 'mkjfooclbdgjdclepjeepbmmjaclipod',
    name: 'SLyrics',
    resource: 'gem.js',
  },
  {
    id: 'mlnpdkdakoffgljkmaddmhflcgaddnnb',
    name: 'Sokrates Browser Proctoring',
    resource: 'utils/webcam.js',
  },
  {
    id: 'mmdclkcghbikhhjcbjlnhgnnkeaolhek',
    name: 'SteamAuth',
    resource: 'cash.mp3',
  },
  {
    id: 'mnbjmbehipoccafkfbblidgpgkolojfo',
    name: 'WA Contacts Extractor & Group Number Download',
    resource: 'contacts/gh/h/pro.png',
  },
  {
    id: 'mohdgdcdkibdljkppnmnihdacpbpllmj',
    name: 'Font Detector',
    resource: 'assets/icons/font-detector-logo-38.png',
  },
  {
    id: 'mokbddmlkhplhijmdgbdmhengkodhojl',
    name: 'Uphint',
    resource: 'logoUPHINT_16X16.png',
  },
  {
    id: 'mpcdemfgjeeojcjknijpgigdkdokjfdk',
    name: 'TrackFox',
    resource: 'assets/icn-vip.png',
  },
  {
    id: 'mpcimhkpmbilcgnafkkdanemdmjpipjc',
    name: 'Premium Sender Pro',
    resource: 'logo/cc.png',
  },
  {
    id: 'mpnhboifpcngcoilgolajnnlfeoafefa',
    name: 'Epryx',
    resource: 'icon.png',
  },
  {
    id: 'nbbinpgfldgjgbmfnjlhglpaihlhmdho',
    name: 'Proxy SwitchyOmega Pro',
    resource: 'icons/16x16.png',
  },
  {
    id: 'nbeghbnelcdncbbgniiokocdinabgofp',
    name: 'SubKun',
    resource: 'assets/icon.png',
  },
  {
    id: 'nblkbiljcjfemkfjnhoobnojjgjdmknf',
    name: 'PronounDB',
    resource: 'assets/index-CkWL3tij.js',
  },
  {
    id: 'nbmibeplmlgngdlophigpneidnekoceo',
    name: 'WallySmarter',
    resource: 'login.html',
  },
  {
    id: 'nbmmhcmajjdfjobnmgnkbdhfpnbhpkef',
    name: 'LinkedIn Finder Email',
    resource: 'images/Logo/logo16.png',
  },
  {
    id: 'ncaklohihnpojbahjcfpikcnfnmpfgmb',
    name: 'Opus Recorder 2.0',
    resource: 'index.html',
  },
  {
    id: 'ncokhechhpjgjonhjnlaneglmdkfkcbj',
    name: 'Habit Tracker',
    resource: 'content-scripts/wgt.css',
  },
  {
    id: 'ndabodbljahojbefpjklnmkghopppccg',
    name: 'Lazy Felix',
    resource: 'assets/imgs/paw.svg',
  },
  {
    id: 'ndbfannaibelbknpfdikeochfnlhjmpb',
    name: '大作采集器',
    resource: 'js/pinall.js',
  },
  {
    id: 'ndcehhfhbobpfbnkigpomgbaomabgcoa',
    name: 'Apollo Scraper',
    resource: 'photos/vv.png',
  },
  {
    id: 'ndgknbhllloeanmdgalcnmlhmkogngca',
    name: 'HTML to Markdown Converter',
    resource: 'assets/index.ts-CpwyaNyi.js',
  },
  {
    id: 'ndnijdpeemcjongapibpkoclhleoajnd',
    name: 'JobJump',
    resource: 'assets/img/logo-16.png',
  },
  {
    id: 'ndnlnhpinbkaofpploddaiklccjlaghb',
    name: '夸克搜题',
    resource: 'assets/chunk-ed1b1de9.js',
  },
  {
    id: 'nenhidhfpjbccpbikiceenfnchkhljmd',
    name: 'Discord Translator',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'nepeemhbchedjbebdekhpkhknljppmif',
    name: 'Modelpress Image Downloader',
    resource: 'images/gear.svg',
  },
  {
    id: 'nfciaicdjmilipnlpkdmpplabgomgfmk',
    name: 'Abit',
    resource: 'abpage.html',
  },
  {
    id: 'nfjplhbfoplapnmjnlakfehkefjlmiii',
    name: 'Virtual Mouse Jiggler',
    resource: 'logo.png',
  },
  {
    id: 'nfkcmgnppifcbibieibjdimmkbcadckl',
    name: 'JokeTab',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'ngahbogbmipbekfhhofglbknheobldbm',
    name: 'Awesome New Tab',
    resource: 'assets/main-KSKi99GN.js',
  },
  {
    id: 'ngpbabbfpbihacogfnbgobceeadfidcb',
    name: 'Easy Builder',
    resource: 'images/logo.svg',
  },
  {
    id: 'nhomcdhhlpjelhmjppkcdhoejehbkodd',
    name: 'meetXcc',
    resource: 'meet_helper.js',
  },
  {
    id: 'niebmpjbnghbfnjbbeajlndkjpgpamhi',
    name: 'Grok Media Downloader',
    resource: 'lib/ffmpeg/ffmpeg.min.js',
  },
  {
    id: 'ninkobkbpfmfemolepdagihmfmbpbino',
    name: 'UXM',
    resource: 'js/uxm_web_agent.debug.js',
  },
  {
    id: 'njcnagohlmamfijimejlnelenhahnoce',
    name: 'Piwik PRO',
    resource: 'js/app.css',
  },
  {
    id: 'njobcapbbjdidmjdodjeipekdbknacin',
    name: 'Chrome Reader Mode',
    resource: 'images/cross.svg',
  },
  {
    id: 'nkkdeadncmkfpmoafagdoanfkipoogkl',
    name: 'Data Scraper',
    resource: 'images/csv.svg',
  },
  {
    id: 'nlhaepbakkedjfnddhmacjfgcpndoejn',
    name: 'GoldFynch',
    resource: 'html/goldenflynch.html',
  },
  {
    id: 'nljfdifffnfijpidnjfbibbdeipnnlln',
    name: 'Guidejar',
    resource: 'fonts.css',
  },
  {
    id: 'nmdenlkgkkgncmibclhckkhclilpfjap',
    name: 'Beamery',
    resource: 'index.html',
  },
  {
    id: 'nnhplomobinijgpongnbofokpibpbioa',
    name: 'BlitzCapture',
    resource: 'js/bg.js',
  },
  {
    id: 'noeifmogdcakcepkkgpgpfmfjkpjembc',
    name: 'Tóm Tắt Văn Bản',
    resource: 'css/sct.css',
  },
  {
    id: 'oagkbgolfdnkknkjomnggnhmnlfmgdod',
    name: 'Dadan',
    resource: 'assets/icon.png',
  },
  {
    id: 'oaodbbeaklbdmjcghbkcfgmioafnjbfe',
    name: 'grateful-grabber',
    resource: 'stealie-128.png',
  },
  {
    id: 'obkgcgojdmdlbdgamjpjceojkpbnkkmn',
    name: 'Pinterest Video Bulk Downloader',
    resource: 'side.js',
  },
  {
    id: 'ocelmccppkcibiflhhepafdjjomimddf',
    name: 'EasySubs',
    resource: 'icon-34.png',
  },
  {
    id: 'odjijkianjealigfahgcmccgmdepende',
    name: 'WAIncognito',
    resource: 'ts/a/qt.js',
  },
  {
    id: 'oecglhldbofcklanmhckefiflhfhabdd',
    name: 'やっぱり Noto Sans',
    resource: 'css/replacefont-extension-bold.css',
  },
  {
    id: 'oefjnfpageadahlgfklncpebmanopcoj',
    name: 'ELMessenger Pro',
    resource: 'images/elm.png',
  },
  {
    id: 'ofeanjpmjdifbpdcjakglfiphhdibokg',
    name: 'DeftGPT',
    resource: 'static/453.js',
  },
  {
    id: 'ofgfpnpgheacjcoijlfcjmdjjjhhcfac',
    name: 'TakeScreenshot',
    resource: 'toolbar.css',
  },
  {
    id: 'ogcopdaeipjphchggpacpamopkdehdgg',
    name: 'EBSCOhost Passport',
    resource: 'static/Institution.png',
  },
  {
    id: 'ohgdgoglcbcfofphmmnkkdbpffklhjgh',
    name: 'Select box filter',
    resource: 'icons/icon16.png',
  },
  {
    id: 'ojifjnngghhagndjdfeemiccjppainil',
    name: 'SalesHood',
    resource: 'assets/auth-e3d99b97.js',
  },
  {
    id: 'okcecoaebgilbpfffgmgnbmegkibegcm',
    name: 'ByToken',
    resource: 'ui/modal.html',
  },
  {
    id: 'olmlgedphnhncbcchpglfmcjgibaleah',
    name: 'Hotmail',
    resource: 'release.bat',
  },
  {
    id: 'olmmaccabblmaegeofmeidedoahadlkp',
    name: 'Wordeep',
    resource: 'wordeep.css',
  },
  {
    id: 'olmndgcpdonjljapfdcgfhlilmdhgdil',
    name: 'resize images',
    resource: 'ui/index.html',
  },
  {
    id: 'omgfpihdadclmbmmdjlopimfjlndicna',
    name: 'Currency converter app',
    resource: 'currency_config.json',
  },
  {
    id: 'omnbdiakakjaieidemehlfmcpmbgdfga',
    name: 'Turbo Email Extractor',
    resource: 'images/video.svg',
  },
  {
    id: 'onadkmijcmnbepodmehedcnocmfniopg',
    name: '京东购物助手',
    resource: 'libs/wl.js',
  },
  {
    id: 'ongmhdpacmehecbiabpknpdfkjolbpbk',
    name: 'Облачный парсер',
    resource: 'styles/ico_48.png',
  },
  {
    id: 'oniajgpocamknkleaaflnhgddjlbkidc',
    name: 'Real Madrid wallpaper',
    resource: 'js/main.js',
  },
  {
    id: 'opefegokalblljhkomgkkbkdpemnccpl',
    name: 'Auto Text Replacer',
    resource: 'assets/chunk-DfzJWNpy.js',
  },
  {
    id: 'opihcipckemolhojbblphpfegfbimhgo',
    name: 'Simply Best Coupons',
    resource: 'content/styles.css',
  },
  {
    id: 'opljadcmhagcipiljmcppgekfffjimkc',
    name: 'Grata',
    resource: 'options.html',
  },
  {
    id: 'pbbiianacjodglafeohjdipcjnmbbhbd',
    name: 'Page Camera',
    resource: 'tabs.js',
  },
  {
    id: 'pbhldkcipcaeniadfnhhdaealdfjgbpj',
    name: 'Jurism Connector',
    resource: 'itemSaver.js',
  },
  {
    id: 'pbnfhkmfddkhbenbjbajgonmbdaclbak',
    name: 'Blaawk',
    resource: 'blaawk.jpg',
  },
  {
    id: 'pbomhlnclnkljppaaaioedckboaeggih',
    name: 'Nametag',
    resource: 'assets/img/eth.png',
  },
  {
    id: 'penegkenfmliefdbmnfkidlgjfjcidia',
    name: 'Tabee',
    resource: 'assets/icon_32.png',
  },
  {
    id: 'pfccjkejcgoppjnllalolplgogenfojk',
    name: 'Tomo Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'pfcikkcgjmkajmladjaalbcheeakeiap',
    name: 'SEO Broken Link Checker',
    resource: 'main.js',
  },
  {
    id: 'phnnhecgcpifhhoadkgkcfdijlnffcgp',
    name: 'Batch Link Downloader',
    resource: 'help.html',
  },
  {
    id: 'piioidjoaoeddcllookbidcghjmjdcha',
    name: 'Typing Through Voice by Spokenly',
    resource: 'welcome.html',
  },
  {
    id: 'pinjkilghdfhnkibhcangnpmcpdpmehk',
    name: '微博图床',
    resource: 'scripts/env.js',
  },
  {
    id: 'pjhgdolnnlcjdngllidooanllmcagopf',
    name: 'history & web cache cleaner',
    resource: 'img/info.svg',
  },
  {
    id: 'pkggifhhgmciginnjehljefknnpkadjm',
    name: 'Thunder Download Support Pro',
    resource: 'assets/tick.png',
  },
  {
    id: 'pkkcbddohfehjhknimeckglogkcdonff',
    name: '股票行情助手',
    resource: 'js/catcher.js',
  },
  {
    id: 'pkkmgcildaegadhngpjkklnbfbmhpdng',
    name: 'ChatSearch',
    resource: 'pay.html',
  },
  {
    id: 'plkaaldfeolmpbeahghnndlphopbpcfm',
    name: 'Whale CoPilot',
    resource: '305.js',
  },
  {
    id: 'plnpanokbgeabagnmbcamehkcninjbac',
    name: 'Ad collector',
    resource: 'icon.png',
  },
  {
    id: 'plplcdpfeknmlciiohlgpjoonjmadlbc',
    name: 'MyLogin',
    resource: 'brand.svg',
  },
  {
    id: 'pnbllofomdnncapklolkeplmhflalhei',
    name: 'TwFollowExporter',
    resource: 'inject.js',
  },
  {
    id: 'pnnmjhghimefjdmdilmlhnojccjgpgeh',
    name: '2FA Authenticator',
    resource: 'icon-34.png',
  },
  {
    id: 'ppchhgfhijijbmaafmgafgnkimhidmaf',
    name: 'Junify',
    resource: 'html/popup.html',
  },
  {
    id: 'aaanccbgcapmhkemhjlkmladllalcmie',
    name: 'Sellify',
    resource: 'popup/cart.png',
  },
  {
    id: 'aacicbnabpgaphlbbaccgbdecgiephck',
    name: 'Titan',
    resource: 'img/x.png',
  },
  {
    id: 'aaidmnmkldkdnogoaapbgcecmhbejmph',
    name: 'TorpedoRead',
    resource: 'fonts.css',
  },
  {
    id: 'abdgglboblncdngedhnggfgjlnobingo',
    name: 'Yodeck Record',
    resource: 'recordTool.css',
  },
  {
    id: 'acfhjnfdooiblbcflkalpnemgibffnab',
    name: 'Areviews',
    resource: 'images/loading.gif',
  },
  {
    id: 'acmdbomkcpamfjlnbefdomoldfdibekp',
    name: 'Tele on GPM Login',
    resource: 'js/replacement.js',
  },
  {
    id: 'acnogbaldkeemneolhfnmcghconcmjna',
    name: 'RevenueHero',
    resource: 'external.css',
  },
  {
    id: 'aechfppapbojcbgfiipkdocfiegkchmb',
    name: 'BT Cloud Work for Google',
    resource: 'client.html',
  },
  {
    id: 'aefebdiljiacpomdendfdnapkmjmfkji',
    name: 'Tellus AI',
    resource: 'style.css',
  },
  {
    id: 'aegihabihhhoihnomlekgheekcdcifpk',
    name: 'JSON Alexander',
    resource: 'content.css',
  },
  {
    id: 'aekapeghhlcblpdcahndmoggepeccmok',
    name: 'X Unfollower',
    resource: 'options.html',
  },
  {
    id: 'afkfmjjhfnefebkoadnbfpfcpcpmneeo',
    name: 'ClicSpy',
    resource: 'tippy.js',
  },
  {
    id: 'ahigdeeepecbhcmdcnlhiojdggilpkog',
    name: 'Stocks',
    resource: 'img/logo.png',
  },
  {
    id: 'ahkgfeaondknnomofelaogdefndmapak',
    name: 'In Private Mode',
    resource: 'listener.js',
  },
  {
    id: 'aijkbfcgfacnbgaladlemlbonnddphdf',
    name: 'WorkGPT',
    resource: 'utils/copy.png',
  },
  {
    id: 'ailkhjklbmefaidepjigcalcjdachpfp',
    name: 'Alibaba Image Downloader',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'ajceemkmbgjolpocnkfccjmplcbbppel',
    name: 'Springboard JobTracker',
    resource: 'index.html',
  },
  {
    id: 'ajiejgobfcifcikbahpijopolfjoodgf',
    name: 'Xget Now',
    resource: 'icons/icon16.png',
  },
  {
    id: 'ajmcpdllaaklaocodbnllhkaflncmlog',
    name: 'doqment',
    resource: 'pdfjs/web/viewer.html',
  },
  {
    id: 'ajppjggkpcpiignpmdinfacapgffemhd',
    name: 'Mizfa Tools SEO',
    resource: 'html/popup.html',
  },
  {
    id: 'akmgkiagajiaaopnealbkppagompbegg',
    name: 'Twitter Unfollow Assistant',
    resource: '_locales/ja/messages.json',
  },
  {
    id: 'akmlgdbkdgmgjoobidmmkknmlblhjomj',
    name: 'WebOutLoud',
    resource: 'images/wol.svg',
  },
  {
    id: 'albfhllpljifkmplbcmmfppfcfdlpdcf',
    name: 'Futrich',
    resource: 'Logo.png',
  },
  {
    id: 'anjikclblkfdigpmbjckiampdojgjecn',
    name: 'Icon Changer',
    resource: 'utils.js',
  },
  {
    id: 'apoddhkbbnbfkhpjhpfdjachfifbedbk',
    name: 'SponsorBlock',
    resource: 'popup.css',
  },
  {
    id: 'appgbhabfeejggifkkbfdbkfckheiojk',
    name: 'Sprout SEO',
    resource: 'popup.html',
  },
  {
    id: 'baciplbchhojjmlgfpenindejajmldpg',
    name: 'CONTADU NeuronWriter',
    resource: 'contadu_ext.css',
  },
  {
    id: 'bbfnidnhpngjjbmmlakaogggmdnnjbnm',
    name: 'Linnk AI',
    resource: 'logo.png',
  },
  {
    id: 'bbnemobkpbncbpklloncaljndkagjfeh',
    name: 'Grips',
    resource: 'icon-128.png',
  },
  {
    id: 'bcbfalkgcdnejkdjacfpgcoanadljgoe',
    name: 'Vocal Remover',
    resource: 'mainContentScript.bundle.js',
  },
  {
    id: 'bcbpabgcmmmofaddaliomhdpnbpnkhid',
    name: 'InsComment',
    resource: 'assets/icon-16.png',
  },
  {
    id: 'bciapecjfmaegmfpofmbfigkoagdknpj',
    name: 'SOS Ticket',
    resource: 'assets/favicon.png',
  },
  {
    id: 'bckkboajpcaejmbajljhebicnflhdajc',
    name: 'Layerpath',
    resource: 'assets/icon.png',
  },
  {
    id: 'bcogakegjkeopbkokbkkaopnclmhhfmp',
    name: 'YouTube Default Playback Speed',
    resource: 'html/time_ui.html',
  },
  {
    id: 'bdeapcnahigpibeoehandgaiijljkdnl',
    name: 'Ringover VoIP Phone for Odoo',
    resource: 'missing_cookies_alert/missing_cookies_alert.html',
  },
  {
    id: 'bdljmpplpbibfkejhafjkngnhkenpnoi',
    name: 'ModernLoop',
    resource: 'panel.html',
  },
  {
    id: 'bdlmjfkblpjnkienagkgljcodcgjjjml',
    name: 'SuperSmashBrowser',
    resource: 'images/wand2.png',
  },
  {
    id: 'bdplgemfnbaefommicdebhboajognnhj',
    name: '电梓播放器',
    resource: 'assets/index.ts-a2b7a288.js',
  },
  {
    id: 'bfaijiabgmdblmhbnangkgiboefomdfj',
    name: 'AI Search Impact Analysis',
    resource: 'update.js',
  },
  {
    id: 'bfcoofacbpockpcfeeckliogafkkjkpk',
    name: 'ChromeGPT',
    resource: 'css/menu.css',
  },
  {
    id: 'bfdoopgbjcacghflbbdikollnphobemo',
    name: 'RSS Reader',
    resource: 'umi.js',
  },
  {
    id: 'bffjahjlgaigjnfhgjplbcimebbighni',
    name: 'Clico',
    resource: 'icon.png',
  },
  {
    id: 'bfjihladgnccpchokgeeicpjcakdmkbe',
    name: 'OhBridge',
    resource: 'popup.js',
  },
  {
    id: 'bgimchkiihedllcfmdgjlnndkeaeaoml',
    name: 'Volte for Randstad Foundation',
    resource: 'assets/images/1.png',
  },
  {
    id: 'bgjogpoidejdemgoochpnkmdjpocgkha',
    name: 'Ecto Wallet',
    resource: 'js/inpage.js',
  },
  {
    id: 'bgocaiandcncfnmoajmhpbdjfojblilh',
    name: 'Video Ads Collection Tool',
    resource: 'collect.html',
  },
  {
    id: 'bgopmpphpeghjpififijeoaojmmaiibh',
    name: 'Twitch Chat for Full Screen',
    resource: 'js/overlay.js',
  },
  {
    id: 'bhdnlmmgiplmbcdmkkdfplenecpegfno',
    name: 'CloudWatch Synthetics Recorder',
    resource: 'images/product-icon-16.png',
  },
  {
    id: 'bhfhdidbcclahddgkikdccfidjbcmibi',
    name: 'Jumpshare',
    resource: 'js/popup.js',
  },
  {
    id: 'bhkmchipjcnljhlablgoommejanegoif',
    name: 'Atomseo Broken and Redirect Links Checker',
    resource: 'img/on.png',
  },
  {
    id: 'bhkobcgijlfcgnkamhbndpdiiigefoph',
    name: 'Dehelper',
    resource: 'content/assets/i18n/en.json',
  },
  {
    id: 'bhljhndlimiafopmmhjlgfpnnchjjbhd',
    name: 'Backbone Debugger',
    resource: 'js/lib/text.js',
  },
  {
    id: 'bjilalbcjkmilhhkfagmblkoekicmcnf',
    name: 'AI for Math',
    resource: 'icon/16.png',
  },
  {
    id: 'bmabahhenimmnfijaiccmonalfhpcndh',
    name: 'Relation ONE',
    resource: 'web/index.js',
  },
  {
    id: 'bmdlblkcnngnjahdbgiehfddgppkhdep',
    name: 'Auto Form Filler',
    resource: 'icon-128.png',
  },
  {
    id: 'bmgocepbdfedelhdkimnfljkklmbmihi',
    name: 'VModel',
    resource: 'img/logo.png',
  },
  {
    id: 'bmhkdngdngchlneelllmdennfpmepbnc',
    name: 'Hide Comments Everywhere',
    resource: 'js/shared-utils.js',
  },
  {
    id: 'bmmbmlcnghehdpemfobefkmnahgdadbo',
    name: 'Facebook Ad Library Insights',
    resource: 'popup.js',
  },
  { id: 'bmpocemdeedjgacehkbbhjjnjjhdpncd', name: 'CGE', resource: 'cge.js' },
  {
    id: 'bncgplggnepokabcjmnonigedepjcaki',
    name: 'Banglarbhumi Easyprint',
    resource: 'images/icon.png',
  },
  {
    id: 'bndjgcbfkgajohplnleblfkmcfdefjee',
    name: 'Inspect Element',
    resource: 'icons/icon16.png',
  },
  {
    id: 'bohhfnkdmlckklmcojekleinmiimldgg',
    name: 'AliTools',
    resource: 'js/config.js',
  },
  {
    id: 'cacoibopgjlodngfokahhkphgcohakai',
    name: 'gRPC-Web Developer Tools',
    resource: 'inject.js',
  },
  {
    id: 'caeolfomomlibhkmjaoohnglpnpdfjkg',
    name: 'Freevpn',
    resource: 'icons/logo.png',
  },
  {
    id: 'cafffncdbdopajhdpnfpohbneabfmjef',
    name: 'CapBxB Video Editor Pro',
    resource: 'app.html',
  },
  {
    id: 'cajklhanpcgcpkikgpcnogpdndpjdjjn',
    name: 'Lmd bubble',
    resource: 'icons/48.png',
  },
  {
    id: 'calljomlmakockpdlhfjenbphgnngkad',
    name: 'Helpjuice',
    resource: 'style.css',
  },
  {
    id: 'capgbfgnklakdedfbjkacmjpkebanifk',
    name: 'Acedit',
    resource: '_locales/en/messages.json',
  },
  {
    id: 'cbmbcnfemgffnhceiiehgifnabceloeb',
    name: 'arXiv Copilot',
    resource: 'content.js',
  },
  {
    id: 'ccjeccodophadokglbdcinabgkiiakjh',
    name: 'DigitalA11Y Tublets',
    resource: 'data/jquery.js',
  },
  {
    id: 'ccpdpohmhhbjjjaodngpjeblhbnmbhoj',
    name: 'Nocodable',
    resource: 'manifest.json',
  },
  {
    id: 'cflgahhmjlmnjbikhakapcfkpbcmllam',
    name: 'OORT Wallet',
    resource: 'home.html',
  },
  {
    id: 'cgibknllccemdnfhfpmjhffpjfeidjga',
    name: 'Reactime',
    resource: 'bundles/backend.bundle.js',
  },
  {
    id: 'cgiklehnkmjlgfipkapgeieiidcgddab',
    name: 'Xdebug Helper',
    resource: 'dist/options.js',
  },
  {
    id: 'chgiimplfkngbhkgaongceakpeijgdii',
    name: 'Kumo Study',
    resource: 'views/index.html',
  },
  {
    id: 'chkigklfmceaafjchflihcklkjhkallb',
    name: 'Sechify',
    resource: 'assets/images/8.PNG',
  },
  {
    id: 'cifkbafiiegeimphnpgcomajaciffdgb',
    name: 'Emoji Keyboard',
    resource: 'img/icon.ico',
  },
  {
    id: 'cjggdkhenhgccghmgbjclonbdfdpmfje',
    name: 'Textmetrics',
    resource: 'main.js',
  },
  {
    id: 'cjiopambhobomjcdkimcfmdfobmaicgg',
    name: 'Shopdora-Shopee Data',
    resource: 'inject/main.js',
  },
  {
    id: 'ckgimgompljaacjgongnjnnmgflljibg',
    name: 'Atom Appraisal',
    resource: 'icons/icon.svg',
  },
  {
    id: 'ckigbicapkkgfomcfmcbaaplllopgbid',
    name: 'OpenReplay Spot',
    resource: 'injected.js',
  },
  {
    id: 'cknbjddgncdahggojmpllojloapoedao',
    name: 'Prompt Tool',
    resource: 'popup.html',
  },
  {
    id: 'cloifjkbfkkifiakmdbioaagpchmfahg',
    name: 'Color Picker',
    resource: 'canvas.css',
  },
  {
    id: 'cmdphjbmebmejfiaaphlapkldjpccief',
    name: 'Taylor Swift MeaVana',
    resource: '128x128.png',
  },
  {
    id: 'cnailncgolnackgmidhkkifchhegijjf',
    name: 'Lufe.ai',
    resource: 'css/all.css',
  },
  {
    id: 'coemflddgpdgkagckcodafnpfjaclobh',
    name: 'Local Markdown Viewer',
    resource: 'libs/katex.min.css',
  },
  {
    id: 'coonllecklpiahhjkmnjidiaccefopli',
    name: 'Stackable',
    resource: 'index.html',
  },
  {
    id: 'cpakifpbbinhlneabnfmlmmjblkciaej',
    name: 'APKHUB App Downloder',
    resource: 'assets/logo.svg',
  },
  {
    id: 'cpebggobaenfndpoddkdindknnpbjdfc',
    name: 'SCPper',
    resource: 'constants.js',
  },
  {
    id: 'cpgndeiekofpnkdlbcahkfbcnebadgmg',
    name: 'goover',
    resource: 'icon/favicon16.png',
  },
  {
    id: 'cphmhccpbhmoenjpcjmfdiofkhpidpdg',
    name: 'Download audio message Messenger/Instagram/Facebook Plus',
    resource: 'popup.js',
  },
  {
    id: 'cpjikgcdmhfnmaiibplplldlchbjejel',
    name: 'Auto Clicker',
    resource: 'css/_doc.css',
  },
  {
    id: 'dbahdghbinbejobggcklgppgkdkkokbd',
    name: 'DatHangQuangChau.Com',
    resource: 'icon.png',
  },
  {
    id: 'dcahbiceiphnbdneaimbcokoijkmkonf',
    name: 'Xe Currency Converter & Price Switcher',
    resource: 'content.css',
  },
  {
    id: 'dcdjbggikbffllfldmdijljoljjbjomh',
    name: 'Word Counter',
    resource: 'Logofile.png',
  },
  {
    id: 'dceanmchogocclajgodkggichdheonic',
    name: 'СекретарЪ',
    resource: 'macro/macro.html',
  },
  {
    id: 'dcimaoejdbnlgdiimpglcjjafinhdfgj',
    name: 'iFly',
    resource: 'content.css',
  },
  {
    id: 'ddmiifbfkjgacpkjkobphimckkpcempd',
    name: 'Telegram Downloader',
    resource: 'index.html',
  },
  {
    id: 'deepanfkojflalfajnkcnlhiejeomdgk',
    name: 'Examripper',
    resource: 'web_accessible_resources/ixl_quiz_model_inject.script.js',
  },
  {
    id: 'dehljiokopflpeffddpbklhfohffnchh',
    name: 'DatAnswers Chrome Local File Opener',
    resource: 'extension.html',
  },
  {
    id: 'deiohoaklfnegkdjjccbcffohjfjmgne',
    name: 'Document Translator',
    resource: 'icon/2.png',
  },
  {
    id: 'dfakchhpaapjafcpdanclfoeplkdkdek',
    name: 'YouTube Popout Player',
    resource: 'images/rocket.png',
  },
  {
    id: 'dgdfoadgjpimkimgbnjdlcpbbdpdflig',
    name: 'Bleam',
    resource: 'callback.html',
  },
  {
    id: 'dghkonilohohljaaadfgilonemgkoack',
    name: 'Temp Gmail',
    resource: 'assets/html/popup.html',
  },
  {
    id: 'dgocjnalnkkghhpdfgjinkhjigkggjdg',
    name: 'xs',
    resource: 'images/blue_128.png',
  },
  {
    id: 'dhaamkgjpilakclbgpabiacmndmhhnop',
    name: 'Smart Clean',
    resource: 'popup.html',
  },
  {
    id: 'dhaoijcpieaecjobjmpfjnblfhjonnmm',
    name: 'AI QR Code Reader',
    resource: 'sandbox/opencv.js',
  },
  {
    id: 'dhembjhhmbbhhjcmidflhicmeaghgnji',
    name: '오마이집',
    resource: 'popup.html',
  },
  {
    id: 'dhhpjlmenadkmgohjcncccjdicmjgiaj',
    name: 'webphone',
    resource: 'phone.html',
  },
  {
    id: 'dhiabblhplagmkfjfeepopdiidehnmlm',
    name: 'HubSpot',
    resource: 'entry.js',
  },
  {
    id: 'dhildnnjbegaggknfkagdpnballiepfm',
    name: 'rep+',
    resource: 'rules/uri.yaml',
  },
  {
    id: 'dhkaaegmmobodhnlgodgjcblpfpipadp',
    name: 'Porn Blocker',
    resource: 'i18n.js',
  },
  {
    id: 'dicaekdjklcpjdlndghehinafcafmanb',
    name: 'IntraLaunch',
    resource: 'handler.js',
  },
  {
    id: 'dimpmploihiahcbbdoanlmihnmcfjbgf',
    name: 'LINE Chat',
    resource: 'static/js/uts.js',
  },
  {
    id: 'dipffgoiicbpobcagmnebidifhlipncj',
    name: 'Website Unblocker',
    resource: 'popup.js',
  },
  {
    id: 'djnneaagmekpmmbmeicecdkgcnkcnhle',
    name: 'WebTerminal',
    resource: 'css/cmd.css',
  },
  {
    id: 'djokcnedpgplffmnlfgpkamogfgjdbnm',
    name: '知了',
    resource: 'iframe.html',
  },
  {
    id: 'dkgbndlihekhmkfpjaeffcolebphngli',
    name: 'StreamShot',
    resource: 'assets/icons/icon-16.png',
  },
  {
    id: 'dlanhacghegnnloapoliciamiiabbepo',
    name: 'AI Interviewer MIR',
    resource: 'assets/mirwork.png',
  },
  {
    id: 'dmnblpfefmpaflamlfgmimhkmdmhlcda',
    name: 'Vocab Tracker',
    resource: 'chrome-extension/static/js/background.js',
  },
  {
    id: 'dnoelnihdijkhghabgcggckfflgdknfo',
    name: 'MaxRebates',
    resource: 'styles/serp.css',
  },
  {
    id: 'dofbhmhaogckjdfclpalkjblnnbpbbda',
    name: 'Roblox Den',
    resource: 'verify.txt',
  },
  {
    id: 'domjdfjalbobafmoocjppdhmhkombooi',
    name: 'Alfie',
    resource: 'form.html',
  },
  {
    id: 'dpcklmdombjcplafheapiblogdlgjjlb',
    name: 'OrdiFind Wallet',
    resource: 'inject.js',
  },
  {
    id: 'dpeckneljdmfgficgjokjfimkblaegcc',
    name: 'Influencer Marketing Analytics',
    resource: 'src/popup/app/index.html',
  },
  {
    id: 'dpeojhmhickhklcpkpllbjcpobdnjhha',
    name: 'I4Y',
    resource: 'img/icon.png',
  },
  {
    id: 'dpkgpaheppcffpbojkippgddbhkekeai',
    name: 'ScamCheck',
    resource: 'images/veiliginternetten.png',
  },
  {
    id: 'eabahhgkhnfkjnbpfpkicdbmdmjjglao',
    name: 'Agentic Workers',
    resource: 'icon-34.png',
  },
  {
    id: 'eaeaddaoioikiaokcmjfeghddidmmfhc',
    name: 'Kommo',
    resource: 'preset_docs.html',
  },
  {
    id: 'eakmfooeekgbidfkgaljmpojagdlpbgf',
    name: 'InsEmailFinder',
    resource: 'assets/icon-512.png',
  },
  {
    id: 'ealkddoajegofofajnnlfjmeglpflfdl',
    name: 'Shoot Anything',
    resource: 'imgs/lmg.png',
  },
  {
    id: 'eameleifmognlnbmccoaikbbnmcibdop',
    name: 'NEWTYPE DELTA TRACER',
    resource: 'icon.png',
  },
  {
    id: 'eangbddipcghohfjefjmfihcjgjnnemj',
    name: 'FavBox',
    resource: 'ext/browser/index.html',
  },
  {
    id: 'ebgflkobfhjpflbgafeagfghohihmljb',
    name: 'TacticalExpander',
    resource: 'images/icon-16.png',
  },
  {
    id: 'ebhapiodakbafkjhegnfcmohjccfedkm',
    name: 'SourcedCode',
    resource: 'icon-34.png',
  },
  {
    id: 'eckchpcahbgbkngandbmcdpdokeoojbf',
    name: 'DubTab',
    resource: 'imgs/login.png',
  },
  {
    id: 'eckcohdilojamegecdpkdebokgobibmg',
    name: 'Expressfy',
    resource: 'icons/btn.png',
  },
  {
    id: 'ecmgoeapljejplncpocmgnpdemidoffo',
    name: 'NAI Global Privacy Control Signal',
    resource: 'index.html',
  },
  {
    id: 'eehollfmncbbcckmibfgapkmganaeena',
    name: '애드센스팜 황금비서',
    resource: 'popup.html',
  },
  {
    id: 'efgjanhcajpiljllnehiinpmicghbgfm',
    name: 'CrossRequest',
    resource: 'index.js',
  },
  {
    id: 'eghoepajpakgokngemfopchhjadobffk',
    name: 'Find Color Code from Image',
    resource: 'assets/palette',
  },
  {
    id: 'egmilngkgddnnmkpkonkpkjkipiihmkh',
    name: 'Music Storm',
    resource: 'iframe.js',
  },
  {
    id: 'ehedpkhlaonkccedaciehcihdmmglbkl',
    name: '推广助手',
    resource: 'src/assets/js/snArea.js',
  },
  {
    id: 'ehhncnkhbchjllmnbcfebjllhnkgnfpc',
    name: 'Jira Metrics Plugin',
    resource: 'board-selector.js',
  },
  {
    id: 'ehinojkdamkjmikpooempeibejdgalnk',
    name: 'GoodTime Meet',
    resource: 'css/gmail.css',
  },
  {
    id: 'ehppmcooahfnlfhhcflpkcjmonkoindc',
    name: 'DICOM image viewer',
    resource: 'index.html',
  },
  {
    id: 'eicepgnmeaipepaieeecfdmnnkhidlkj',
    name: 'Яндекс Вордстат',
    resource: 'assets/index.css',
  },
  {
    id: 'eijaliiajnchgljfcjdagllhbfkdkmmi',
    name: 'Gener8 Genie',
    resource: 'dist/ui/content.css',
  },
  {
    id: 'einokpbfcmmopbfbpiofaeohhkmcbbcg',
    name: 'AutoConvert',
    resource: 'options.html',
  },
  {
    id: 'ejblanogjchhnpkbplblcmdpgfahhpdi',
    name: 'LearnWithAI',
    resource: 'main.js',
  },
  {
    id: 'ejcmfianlbiiafmcnhmnpndoddnimjki',
    name: 'Stopaganda Plus',
    resource: 'sources/sources.json',
  },
  {
    id: 'ekclgmkkbmncpdmconejbpkbjgpchili',
    name: 'DMfox',
    resource: 'assets/inject.js',
  },
  {
    id: 'ekegjbcgahdlpdhjohalkecfeknpbfke',
    name: 'aRockets',
    resource: 'assets/favicon.ico',
  },
  {
    id: 'ekppadhnhmemajkdbkohalhoncnfhmbm',
    name: 'DESelect Search',
    resource: 'js/popup.js',
  },
  {
    id: 'elclhhlknlgnkbihjkneaolgapklcakh',
    name: 'eCommerce Profit Calculator',
    resource: 'icon/icon.png',
  },
  {
    id: 'elhkfmcodhgaoodhemkeempcihlcbpia',
    name: 'CATS',
    resource: 'sidebar.html',
  },
  {
    id: 'eljhnkoiflafnibcilfgfojbejneefmd',
    name: 'Christmas Decorations',
    resource: 'images/content/frost.png',
  },
  {
    id: 'elnidcpfilmgjnpadcfpihpchjcfdaej',
    name: 'Translate Image',
    resource: 'icon/2.png',
  },
  {
    id: 'emkoflhmeegjlabodebpfbkeicjppebi',
    name: 'TrackWapp Online Monitor',
    resource: 'main.js',
  },
  {
    id: 'emnddjmjlkmgkdcfcpgppmibpekkgifp',
    name: 'HumanTyper',
    resource: 'ExtPay.js',
  },
  {
    id: 'endlgjgkhphjmillpkdoopdchefeghfb',
    name: 'Safeguard Enterprise Password Vault',
    resource: 'index.html',
  },
  {
    id: 'enegojdnkeicfoiknhfjaedhlckeahmf',
    name: 'Remove HTML Elements',
    resource: 'data/content_script/icons/remove.png',
  },
  {
    id: 'eoogbfoalcnbbclpkbofobafmnfdecib',
    name: 'Aanmeldgemak',
    resource: 'icons/icon128.png',
  },
  {
    id: 'epadnmckjchpoedgecdghpmaicnklagd',
    name: 'Bilibili Summary with ChatGPT OpenAI',
    resource: 'logo.png',
  },
  {
    id: 'fabhjblgffknkkihobccaialoijplkei',
    name: 'AI Prompt Reverse',
    resource: 'assets/i18n-DBIG_CsP.js',
  },
  { id: 'fbhlmobhmeicoclioegndhmmifojkcbl', name: 'Loadex', resource: 'l.svg' },
  {
    id: 'fbmfcfkokefgbmfcjahdmomlifclekib',
    name: 'Read Later',
    resource: 'content/pagePosition.js',
  },
  {
    id: 'fcdakleeieippgnbiapagkmjbcefennm',
    name: 'Redbooth for Gmail',
    resource: 'img/sprite.png',
  },
  {
    id: 'fcekgnhgieggcbldnoicmempgknfolbc',
    name: 'Videozen',
    resource: 'html/popup.html',
  },
  {
    id: 'fddmfmckaajmcjcoeeofhkbhbnbhifpg',
    name: 'Ginee Data Scraper',
    resource: 'inject/inject.js',
  },
  {
    id: 'fdgfnideaokaenkdnlmibfffbhiefimb',
    name: 'Hair on Screen',
    resource: 'assets/h1.png',
  },
  {
    id: 'feocfomniclchbgaioedfhccgckmlbed',
    name: 'Panda Video',
    resource: 'js/vimeo.js',
  },
  {
    id: 'ffinlaeadcgbhecidamekinhbfkdhodd',
    name: 'Pocket Prompt',
    resource: 'images/logo.png',
  },
  {
    id: 'fgdkofcdcipbpjedcgpomlifahjlphhc',
    name: 'Подписать документ ПДФ электронной подписью',
    resource: 'content.js',
  },
  {
    id: 'fghcafllghpooedjmgghkflnknnlgbia',
    name: 'AdDragon',
    resource: 'content/clean/clean.js',
  },
  {
    id: 'fhbhfcoaaflofffbnmjffkbcjhpafanb',
    name: 'Spoak',
    resource: 'index.html',
  },
  {
    id: 'fhlfdnhddefmfmmehofnbnkmcbgdlohn',
    name: 'Apollo Scraper',
    resource: 'assets/boot.js',
  },
  {
    id: 'fihdhgobfdmbgggnnlpcokjlflopomji',
    name: 'Advigator',
    resource: 'images/logo.png',
  },
  {
    id: 'fjcpmfaddpkbhganaagemnolpgildlha',
    name: 'VideoSeek',
    resource: 'assets/sign/signVideo.js',
  },
  {
    id: 'fjdnpmenmpfadeojgkhgiogiclmcjgbp',
    name: 'ArqSign Certificado Digital',
    resource: 'popup/bootstrap/jquery.js',
  },
  {
    id: 'fjidjgneljagnakdcijilikbmgoajeln',
    name: 'Windy',
    resource: 'stubs/prefixed.css',
  },
  {
    id: 'fjifkdnhlhndjblobgfjdallikchiape',
    name: 'UUFinds',
    resource: 'icons/qc.jpg',
  },
  {
    id: 'flookmlccbimcdpnbblpdjhpmjlblfgg',
    name: 'RiteBoost',
    resource: 'js/popup.js',
  },
  {
    id: 'fmeihfaddhdkoogipahfcjlicglflkhg',
    name: 'SP Formatter',
    resource: 'dist/popup.js',
  },
  {
    id: 'fmjkhlnfjdeknelfokepacbinhedgbjd',
    name: 'MWA',
    resource: 'css/app.css',
  },
  {
    id: 'fmolkclgdnbgkcgofmgbhgjklmjkhnel',
    name: 'Quick Table for Gmail',
    resource: 'panel.js',
  },
  {
    id: 'fnagkefgadepjfbpdijgiadiohgnjhml',
    name: 'Signspaces',
    resource: 'img/bg.svg',
  },
  {
    id: 'foblnmhpgiilabdcbnfgoheplajhompg',
    name: 'Cute Save Button',
    resource: 'bestgirl.png',
  },
  {
    id: 'fojaboengkcdjplnfcocfnchkjdikfei',
    name: 'Slack Deleter',
    resource: 'js/inject.bundle.js',
  },
  {
    id: 'fpmnfjfoeiobbchodjmhpjgghcmbobki',
    name: 'LeadContact',
    resource: 'index.css',
  },
  {
    id: 'gakfleegiilbiiebpmbihadgcbpjgoha',
    name: 'Color Picker and Palette',
    resource: 'css/injectable.css',
  },
  {
    id: 'gbflgeijihckhgahimeplmbbgnkmaolj',
    name: 'MOCO',
    resource: 'popup.html',
  },
  {
    id: 'gbiddodjfedcfaomleolekbgkidagkci',
    name: 'CallHippo-Virtual Phone System',
    resource: 'callhippo.png',
  },
  {
    id: 'gbihcigegealfmeefgplcpejjdcpenbo',
    name: 'Etsy Images Downloader',
    resource: 'injected.js',
  },
  {
    id: 'gbjajdggloalnhlfbmffjicpfhhoaccc',
    name: '北极象沉浸式翻译',
    resource: 'assets/main.js',
  },
  {
    id: 'gblekkmmmgnmafpdckoapgbcmoiageln',
    name: 'Lisstify',
    resource: 'config.js',
  },
  {
    id: 'gcflfnendjincoakmpkdgkocaoojjnbc',
    name: 'OpenDyslexic Font for Chrome',
    resource: 'fonts/OpenDyslexic-Bold.otf',
  },
  {
    id: 'gcolhagfpagloldpcglmopecbjabeghl',
    name: 'Anti-Porn Blocker Professional',
    resource: 'icons/icon128.png',
  },
  {
    id: 'gdjccbjidgfgoemlndecafmdefbgjcjg',
    name: 'RentScout',
    resource: 'dist/popup.html',
  },
  {
    id: 'gdnncabnclodhioejkjidpddpcclehim',
    name: 'Elwo',
    resource: 'assets/icons/logo.svg',
  },
  {
    id: 'geaeebooindfocegjgdfjkbmkekcpobd',
    name: 'Responsive viewer',
    resource: 'Add.svg',
  },
  {
    id: 'geehhpjaklpibikpekbafencilhodgfi',
    name: 'Custom Video Player for YouTube',
    resource: 'player.js',
  },
  {
    id: 'geiiipddpfifgpmoopnmkkiphionieon',
    name: 'Mydoma Studio NEXT Product Clipper',
    resource: 'clipper/myd-clipper.html',
  },
  {
    id: 'genmfcigpebmanmihmbnfafhheopclek',
    name: 'Drafito',
    resource: 'bridge.html',
  },
  {
    id: 'ggafhcdaplkhmmnlbfjpnnkepdfjaelb',
    name: 'Vultisig',
    resource: 'inpage.js',
  },
  {
    id: 'ghfgcnplehcolnejmpednmiebhjjdige',
    name: 'Botpresso SEO',
    resource: 'css/disable.css',
  },
  {
    id: 'ghijcjpcgppajgljcdpddjkmeoonphcm',
    name: 'I-Play',
    resource: 'constants/donation.jpg',
  },
  {
    id: 'ghkgfdamcfjiflldnfiollnhkdjilmde',
    name: 'MockFlow WireframePro',
    resource: 'js/popup/popup.js',
  },
  {
    id: 'ghlmiigebgipgagnhlanjmmniefbfihl',
    name: 'GoLess',
    resource: 'captcha.bundle.js',
  },
  {
    id: 'giiemjoccofnggceldeendokfcehnobc',
    name: 'ChatGPT Print and Save',
    resource: 'content/content.js.map',
  },
  {
    id: 'gklihgcnchjjfcmihmpgennnemkkpnen',
    name: 'Diccionario RAE en bocadillo',
    resource: 'img/tic.png',
  },
  {
    id: 'gldebcpkoojijledacjeboaehblhfbjg',
    name: 'Ask Steve',
    resource: 'popup.html',
  },
  {
    id: 'glefoejbpalgpdgfbbmemfgegepiamnd',
    name: 'HTML to React',
    resource: 'content/runtime.js',
  },
  {
    id: 'gleocnabcllkbfobbdkibkkghpichebp',
    name: 'DownPictures',
    resource: 'icon/16.png',
  },
  {
    id: 'glkfmfjeafnooojgeobbhdjhdejocoap',
    name: 'Birdie',
    resource: 'js/video.js',
  },
  {
    id: 'gloijbeijaadmokgifafohhfdmmbnbnm',
    name: 'TG Media Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'gmaglilejboehglachimajmepgjckjng',
    name: 'Twitch Translator Pro',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'gmhaghdbihgenofhnmdbglbkbplolain',
    name: 'Open Prompt Manager',
    resource: 'utils.js',
  },
  {
    id: 'gmkdfchigicneikpcdakcoglhiecneak',
    name: 'MySSL',
    resource: 'icon.png',
  },
  {
    id: 'gnjjmhdcbgjopfodapfecjlgedgimebj',
    name: 'JD Data Scrapper Tool',
    resource: 'js/free.js',
  },
  {
    id: 'gnjnihhnaehgadmkhhbcngeihjgcnnpi',
    name: 'Matreshka VPN',
    resource: 'supabase.js',
  },
  {
    id: 'gnlpiibempcekeipifhpeejgfihbjmpo',
    name: 'Gemalto Web Signer',
    resource: 'assets/css/main.css',
  },
  {
    id: 'gnobmiceibhknbpgkacoceabpealjnom',
    name: 'TutorGPT',
    resource: 'assets/log-BnE0iWVC.js',
  },
  {
    id: 'gpklpmejnkejffkogpfpgocfjfedmpbi',
    name: 'Streak Email Sharing for Gmail',
    resource: 'blank.png',
  },
  {
    id: 'hacnbapajkkfohnonhbmegojnddagfnj',
    name: 'Tolgee Tools',
    resource: 'icons/active.png',
  },
  {
    id: 'hagcapmimfcbfdhgmdnabeifnfbicmij',
    name: 'BitTorrent',
    resource: 'icon96.png',
  },
  {
    id: 'hbloagoefkmoeejgiopklnaphpdkninb',
    name: 'AMA Interview AI',
    resource: 'images/icon16.png',
  },
  {
    id: 'hbneiaclpaaglopiogfdhgccebncnjmc',
    name: 'TanglePay IOTA Wallet',
    resource: 'js/inject.js',
  },
  {
    id: 'hbnpcbochkgodkmmicbhfpmmkhbfbhim',
    name: 'Mojito',
    resource: 'mojito.js',
  },
  {
    id: 'hclkdpaahnpfenlibcmjnajjccpkhoak',
    name: 'H-E-B Credit',
    resource: 'auth.html',
  },
  {
    id: 'hdbmiffpbgklodjfljddiliopfniidco',
    name: 'Mymeet.ai',
    resource: 'offscreen.html',
  },
  {
    id: 'heamnjbnflcikcggoiplibfommfbkjpj',
    name: 'Zeal',
    resource: 'zwidget.html',
  },
  {
    id: 'heflipieckodmcppbnembejjmabajjjj',
    name: 'Buttercup',
    resource: 'popup.html',
  },
  {
    id: 'hfmaomlfmjoleedbdemmonkkoleeabec',
    name: 'Map Scraper & Business Email Finder',
    resource: 'icons/16.png',
  },
  {
    id: 'hfmnidllojimehmfjkclnadpebibhgoi',
    name: 'TabTabTab',
    resource: 'js/assets/PopupApp.DSnlJt-t.js',
  },
  {
    id: 'hfmolcaikbnbminafcmeiejglbeelilh',
    name: 'CNL Decryptor',
    resource: 'web_accessible_resources/jdcheck.js',
  },
  {
    id: 'hfpbjnmjofmfpnkcmdnkgndahgpjhpih',
    name: 'Ecosia Dark Mode',
    resource: 'pages/Close.png',
  },
  {
    id: 'hgdnbhdgboglidilhoipggepjlmmmaae',
    name: 'Shopify Product Info',
    resource: 'js/content.js',
  },
  {
    id: 'hglmpnnkhfjpnoheioijdpleijlmfcfb',
    name: 'AutoRemote',
    resource: 'autoremotemedium.png',
  },
  {
    id: 'higncefidfgpbcfojlclpppecnmlnncj',
    name: 'Right Click Enabler',
    resource: 'js/enable.js',
  },
  {
    id: 'hikgnomhpklghakgjgecehpfodfmaanm',
    name: 'TypeOS',
    resource: 'img/ga.png',
  },
  {
    id: 'hiocbajaikpcckgeagcngaeoioncmbim',
    name: 'NexVid',
    resource: 'content.js',
  },
  {
    id: 'hjafaofnkfblcpkppadbneegaepffjfd',
    name: 'Draw on Screen',
    resource: 'pencil.png',
  },
  {
    id: 'hjgllnccfndbjbedlecgdedlikohgbko',
    name: 'URLI',
    resource: 'shr/picker/picker.html',
  },
  {
    id: 'hjhlhpjlfajmkhfangbnooadmnmdpgbi',
    name: 'Extension SEO Chrome',
    resource: 'assets/chunk-a592bc85.js',
  },
  {
    id: 'hjnogdfopgmfniajiofiafhffkpeehjm',
    name: 'Bonjoro',
    resource: 'popup.html',
  },
  {
    id: 'hkidaibpkimofamahhlmadfofjnehoao',
    name: 'Visualizer',
    resource: 'images/256.png',
  },
  {
    id: 'hkkokpigklicphndlikbagklockdabom',
    name: 'Dataso.AI',
    resource: 'src/assets/male.png',
  },
  {
    id: 'hklhhkchffegjfojbofhfkckjidfbjhe',
    name: 'Free VPN',
    resource: 'img/icon16.png',
  },
  {
    id: 'hkoppnnlmjhndhmjpoegdpjfadkjoonn',
    name: 'WhisperAI',
    resource: 'content/content.js',
  },
  {
    id: 'hlaiofkbmjenhgeinjlmkafaipackfjh',
    name: 'Proton Pass (BETA)',
    resource: 'elements.js',
  },
  {
    id: 'hlbgfjkoncdpgmgenfpjbiifagaakddj',
    name: 'Cat wallpaper',
    resource: 'js/main.js',
  },
  {
    id: 'hledcfghfgmmjpnfkklcifpcdogjlgig',
    name: 'Colab Themes',
    resource: 'themes/Amy.json',
  },
  {
    id: 'hoodciagfineodogiihllccfnedacdmk',
    name: 'Hibisco',
    resource: 'native.json',
  },
  {
    id: 'hopgpglmfiggpmklcakbdjfimfbfchck',
    name: 'Nobi Pro',
    resource: 'offscreen.js',
  },
  {
    id: 'hpihikbioohhooknhbnbfmnipjdefhog',
    name: 'Leads2b',
    resource: 'assets/images/add.png',
  },
  {
    id: 'iacpblbgooifgclhbdcaonebhoadpmgj',
    name: 'Device Simulator & Tester',
    resource: 'dist/contentScripts/style.css',
  },
  {
    id: 'iajpkfcbblghbmmnkhjgcpgngklggabo',
    name: 'Gistr',
    resource: 'pages.html',
  },
  {
    id: 'ibhegccigccbgpjjmkofhobdnhpinacb',
    name: 'Webpage Magnifier',
    resource: 'css/evenZoom.css',
  },
  {
    id: 'icaieljbfjoimbchnhejpjnlkpgddmob',
    name: 'Whats the Font',
    resource: 'fonts/workSans.ttf',
  },
  {
    id: 'icfcfdeoejgccmjmiaidaodjoidnoplj',
    name: 'ImportHelper',
    resource: 'icons/noob.png',
  },
  {
    id: 'icfibfjidabjcklhikmodelmopjmghgj',
    name: 'Writing Assistant',
    resource: 'assets/config-036c9d6c.js',
  },
  {
    id: 'icpcaonhnofngeapallehocmhbillkpg',
    name: 'OCR Scanner',
    resource: 'content/content.css',
  },
  {
    id: 'idffaipgnlkhfhibgnodeiogpgojcmfm',
    name: 'Duolingo Solution Viewer',
    resource: 'src/ui.js',
  },
  {
    id: 'idnackiimdohbfkpcpoakocfkbenhpdf',
    name: 'Shopee Images Downloader',
    resource: 'injected.js',
  },
  {
    id: 'idnejmodeepdobpinkkgpkeabkabhhej',
    name: 'AgentQL Debugger',
    resource: 'src/dom_inspector.js',
  },
  {
    id: 'iehnjhgdgfepcjlbfkpngibijmffcmpp',
    name: 'Yoto MYO Magic',
    resource: 'callback.js',
  },
  {
    id: 'iepcfehgcfcoildehjncoefphpdfahhp',
    name: 'Lab Ray Logger',
    resource: 'fail.png',
  },
  {
    id: 'ifdoagofcglampmghhkbngifighmnopj',
    name: 'Quick Text Extraction',
    resource: 'lib/worker-overwrites.js',
  },
  {
    id: 'ifhljpgdgoimmfacomakolapgnamfkbd',
    name: 'NeonLingo',
    resource: 'img/logo.png',
  },
  {
    id: 'ifnlkhhhhklpmjjbdpnpenpgbndniedg',
    name: 'Super Highlighter',
    resource: 'images/16.png',
  },
  {
    id: 'igdenijgigmjhonfjmoaioeagpkgfmfo',
    name: 'Retable',
    resource: 'images/icon-16.png',
  },
  {
    id: 'igeibjcgmjjglmjkehpeepggejgbpjnk',
    name: 'Site24x7 Web Transaction (Browser) Recorder',
    resource: 'content.js',
  },
  {
    id: 'iglbgmakmggfkoidiagnhknlndljlolb',
    name: 'Portkey Wallet',
    resource: 'js/inject.js',
  },
  {
    id: 'ihgncekibldpfkefpchbcdmifodkfhpm',
    name: 'Save Website as PDF',
    resource: 'readability.js',
  },
  {
    id: 'ihhogidnfaalhknbpnoahmopliehocng',
    name: 'Mercado Livre True Sort',
    resource: 'popup.html',
  },
  {
    id: 'iiblfonkagipdojommmomopjldpibdbb',
    name: 'InsL',
    resource: 'assets/crisp.png',
  },
  {
    id: 'iidnmhhnpbahlmclnhhgdpfbpohjiepi',
    name: 'PreVeil for Gmail',
    resource: 'pageWorld.js',
  },
  {
    id: 'iinfjdloicbbgbdliglpofadahlmgjop',
    name: 'Klutch',
    resource: 'img/icon-16.png',
  },
  {
    id: 'ijnffcpmmpapfapajdkajkdegnghgeci',
    name: 'Scales & Modes',
    resource: 'piano/C2.mp3',
  },
  {
    id: 'ikfpolbfdnihjnadfodochmagdagpbik',
    name: 'eBextractor',
    resource: 'fb.png',
  },
  {
    id: 'iklikkgplppchknjhfkmkjnnopomaifc',
    name: 'Humantic AI',
    resource: 'js/fa.js',
  },
  {
    id: 'ikmdmhifkmnmhdgcadinmpocdnjekicg',
    name: 'Office@Hand for Google',
    resource: 'client.html',
  },
  {
    id: 'ikpgaoegbcmlefnjmhampepmflcndimi',
    name: 'Cliarly',
    resource: 'pdfReader.html',
  },
  {
    id: 'iodpjkpedoapnempbhpokpcphopooacg',
    name: 'Gaya',
    resource: 'images/add.png',
  },
  {
    id: 'ipfbhnkkjbafekefiifigffaelgffaed',
    name: 'Subtitle Anything!',
    resource: 'content-ui/index.iife.js',
  },
  {
    id: 'ipiffffgddcefpneolkohhdhgokejclj',
    name: 'Vitamin TSETMC',
    resource: 'files/js1.js',
  },
  {
    id: 'jappgmhllahigjolfpgbjdfhciabdnde',
    name: 'Link Map',
    resource: 'icons/x32.png',
  },
  { id: 'jbialncfijnjojchcmhfmjgjggbbdghb', name: 'SVD', resource: 'js/v.js' },
  {
    id: 'jcejahepddjnppkhomnidalpnnnemomn',
    name: 'RSC Devtools',
    resource: 'assets/fetchPatcherInjector.js',
  },
  {
    id: 'jcfaecpepebjignmaljepmghelcmnbbg',
    name: 'Save Google Books preview as PDF',
    resource: 'lib/jspdf.umd.min.js',
  },
  {
    id: 'jcpbfmlfngbipepbbhadpabogihgiggm',
    name: 'Clipboard Manager Pro',
    resource: 'offscreen.html',
  },
  {
    id: 'jfcbmnpfbhhlhfclmiijpldieboendfo',
    name: 'Segment Inspector (Official)',
    resource: 'broker.js',
  },
  {
    id: 'jfmfcimcjckbdhbbbbdemfaaphhgljgo',
    name: 'Turn Off the Lights',
    resource: 'scripts/video-player-status.js',
  },
  {
    id: 'jgdkgcjfbbfpgfmhihgknpeajkfjcbhb',
    name: 'Digital Contents Library Tool',
    resource: 'images/icon16.png',
  },
  {
    id: 'jgeibpcndpjboeebilehgbpkopkgkjda',
    name: 'Shadertoy Custom Texures',
    resource: 'myscript.js',
  },
  {
    id: 'jgofhdodppnlhijhmefpagmbpdkdfena',
    name: 'TalkaType',
    resource: 'icon-34.png',
  },
  {
    id: 'jhfnhpegkaomkbbnleehfapggppeilnd',
    name: 'SkyDictionary',
    resource: 'popup.js',
  },
  {
    id: 'jhgpcbfjmmkclnkdoplcpinejekdjomp',
    name: 'AdBlock Pro',
    resource: 'js/scripting/picker.js',
  },
  {
    id: 'jhhjbaicgmecddbaobeobkikgmfffaeg',
    name: 'Chat AI',
    resource: 'manifest.json',
  },
  {
    id: 'jhllfdbccclcdiafljibcabipbmkfoem',
    name: 'ChatGPT History Search',
    resource: 'google.svg',
  },
  {
    id: 'jijophmdjdapikfmbckmhhiheghkgoee',
    name: 'AmzGPT',
    resource: 'icon/icon.png',
  },
  {
    id: 'jjdbikbbknmhkknpfnlhgpcikbfjldee',
    name: 'Tabme',
    resource: 'newtab.html',
  },
  {
    id: 'jkeolmadidncndcbnajhaojepbolajag',
    name: 'Lunabot',
    resource: 'index.html',
  },
  {
    id: 'jkimepglppimjfkagodhndbbphijfdme',
    name: 'Full Screen Tabs',
    resource: 'content.css',
  },
  {
    id: 'jkklfgkjlakgkbhhopifahgbpogdkkpm',
    name: 'AutoEDClub',
    resource: 'AutoEDClub/core.js',
  },
  {
    id: 'jlhmjkajbdaelbnigkpegbkcnbpmggab',
    name: 'FRAK',
    resource: 'index.html',
  },
  {
    id: 'jmiljbojpfggbcbjkphaocldmfghdjmp',
    name: 'Mega Ad Blocker',
    resource: 'static/filters_data/data.json',
  },
  {
    id: 'jnjnledlnjnkfgepmadpfdljbmdhcihi',
    name: 'NetMeter Web',
    resource: 'public/icon-34.png',
  },
  {
    id: 'jnljoadncncjcebajpifdkofkoffffcb',
    name: 'X Video Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'jnphifhadlaidikiafjceeogookkpgll',
    name: 'FASHIONGO Style Match+',
    resource: 'img/loading.png',
  },
  {
    id: 'johaackbhmenencefcndbkfpfncjaoaf',
    name: 'Task Monkey',
    resource: 'icon16.plasmo.6c567d50.png',
  },
  {
    id: 'jojgmnkcojhiajdkjjdgehhoemadgmgf',
    name: 'CompareAI',
    resource: 'inject.js',
  },
  {
    id: 'jonplpbnhmanoekkgcepnedhghflblmo',
    name: 'Needle Inspector',
    resource: 'dependencies/editor.js',
  },
  {
    id: 'jpfnanpgediipkfpjlacaadidklielad',
    name: 'Spotless',
    resource: 'muter.js',
  },
  {
    id: 'jphkkablogbfneefecondchaafbdaomc',
    name: 'BrowserAgent',
    resource: 'ba_extension_loader.gif',
  },
  {
    id: 'kaamlhinjaceanpdanmagllfeoelcfhl',
    name: 'Verifee',
    resource: 'sources.txt',
  },
  {
    id: 'kadbegcbiplbenlokcdjkmicjaophmif',
    name: 'AI Site Cloner',
    resource: 'sidepanel-iframe.html',
  },
  {
    id: 'kbkbfefhhabpkibojinapkkgciiacggg',
    name: 'Manga Translator',
    resource: 'static/auto.svg',
  },
  {
    id: 'kdaafcdfdmmkickmajigjaicaclnhbgi',
    name: 'Multi AI Sidebar',
    resource: 'img/icon.ico',
  },
  {
    id: 'kefaeaifbfbgiikgionddpflkecnkgcm',
    name: 'Album Downloader for FB',
    resource: 'ring.svg',
  },
  {
    id: 'kgdbcpllbbnimjgoiomfdebldcofmlbl',
    name: 'Environment Indicator',
    resource: 'background.js',
  },
  {
    id: 'kgihmgkhefmpdcaapjlobbfiblnpjomn',
    name: 'X Video Downloader',
    resource: 'injected.js',
  },
  {
    id: 'kgjmbgpodcgnjnnhfejdabccbdohgbeo',
    name: 'TheCashback',
    resource: 'popup.html',
  },
  {
    id: 'kgmbjoakninmbejgngppphhlbcjelcif',
    name: 'nDocuSoft',
    resource: 'thirdParty/font1.ttf',
  },
  {
    id: 'khdnjjgidjjbjpececegbfglalchffpo',
    name: 'Taostats',
    resource: 'page.js',
  },
  {
    id: 'khggpfckdcbplckilngofklijfifinmj',
    name: 'Codeium Enterprise',
    resource: 'script.js',
  },
  {
    id: 'kihifmacbckmlbcaobdofgjikfgidkmd',
    name: 'mailerplex',
    resource: 'pageWorld.js',
  },
  {
    id: 'kilnpioakcdndlodeeceffgjdpojajlo',
    name: 'Aurox Wallet',
    resource: 'inject_script.js',
  },
  {
    id: 'kjgebebilcoaamgfpogkoehcnjbnncic',
    name: 'Random User Agent',
    resource: 'inject.js',
  },
  {
    id: 'kkafjojibijigkcpgiidnphfnhdnopnf',
    name: 'Telegram Translator Pro',
    resource: '_locales/am/messages.json',
  },
  {
    id: 'kkanflmieobmmjpnmdcickibokkmpdfj',
    name: 'Loom video downloader',
    resource: 'icons/logo.png',
  },
  {
    id: 'kkchefmfekacdingcjkgiaggdafolhen',
    name: 'Minecraft Cursor',
    resource: 'cursors/local.json',
  },
  {
    id: 'kkcmegmneehppekopcpbifkffcmmpbdj',
    name: 'Promp',
    resource: 'saved.js',
  },
  {
    id: 'kkpmmdcehcdjaipdnlgkppolmnkdcnop',
    name: 'S-Net Connect Call',
    resource: 'detectAjax.js',
  },
  {
    id: 'klmgadmgadfhjgomffmpamppmkajdloc',
    name: 'Go European',
    resource: 'html/support.html',
  },
  {
    id: 'kmdljnmicpapnpgdboppapbkmiginfad',
    name: 'Kabinet',
    resource: 'content.html',
  },
  {
    id: 'kmphamhphplpcjcabjdjjklfjmgkmpba',
    name: 'Mock',
    resource: 'scripts/overrideRequest.js',
  },
  {
    id: 'kndnhcfdajkaickocacghchhpieogbjh',
    name: 'Adwizard',
    resource: 'js/content-scripts/injected.js',
  },
  {
    id: 'knegaeodgehajemjpfbhlgjdcloklkal',
    name: 'Myanimelist Redesign',
    resource: 'images/logo.png',
  },
  {
    id: 'kneobeadlbbceenkigmieiobpcmlpcpf',
    name: 'Canvas',
    resource: 'popup.js',
  },
  {
    id: 'kocebhffdnlgdahkbfeopdokcoikipam',
    name: 'The wall',
    resource: 'bg-pattern.2476d6bf.png',
  },
  {
    id: 'kocklgpfjooneciijedkjhbclookilfb',
    name: 'Qalam',
    resource: 'icons/16.png',
  },
  {
    id: 'kojlkoompagohabokhpanhcjannalmbh',
    name: 'Convert Label',
    resource: 'img/icon.png',
  },
  {
    id: 'kolfcecahpbgbilkdkalabnfjjklkkae',
    name: 'XPLA GAMES Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'konbmllgicfccombdckckakhnmejjoei',
    name: 'Workbench',
    resource: 'scripts/app.js',
  },
  {
    id: 'kopfpnjmcapcepinmnbapinfmofpjhof',
    name: 'WINN.AI',
    resource: 'rooney-sans-normal-700.woff2',
  },
  {
    id: 'lalmkfklfomdgoibcpiglaokmmfdbhid',
    name: 'One Piece Wallpaper',
    resource: 'js/main.js',
  },
  {
    id: 'lbelfipebhopddchngmplikbbdibjlmm',
    name: 'NotebookLM YouTube Turbo',
    resource: 'icons/icon16.png',
  },
  {
    id: 'lbjapbcmmceacocpimbpbidpgmlmoaao',
    name: 'Metalet',
    resource: 'content.js',
  },
  {
    id: 'lbmlepiehnodofkkgiamklfhioejnnml',
    name: 'ZeroThreat AI Recorder',
    resource: 'index.html',
  },
  {
    id: 'lckdbjbebjjkogahablhggjbekaepogf',
    name: 'Dream ChatOS chat message sender',
    resource: 'js/tawk.js',
  },
  {
    id: 'lckllohjmijjbkjcmamgbgckcgfjahha',
    name: 'Comic Translator',
    resource: 'images/logo.png',
  },
  {
    id: 'lcpnkclcbpmhekkjnkomhoecoiobbejf',
    name: 'ko-context-hover',
    resource: 'markup/panel.html',
  },
  {
    id: 'ldhjpljmgnggmkpcgaicmocfoefbcojl',
    name: 'Comments Exporter',
    resource: 'injected.js',
  },
  {
    id: 'lgkfjdlfhjdjcmkdgmciobikpjakpgjn',
    name: 'Twos',
    resource: 'content.styles.css',
  },
  {
    id: 'lgmnomldfahgdpkbmlegninjpokgmoob',
    name: 'Discord Batch Deleter',
    resource: 'inject.js',
  },
  {
    id: 'lieifjiddifccacnhgcafeebpahodebe',
    name: 'Kimi Sidebar · 划词翻译 / AI 侧边栏 / 一键导出 Markdown',
    resource: 'icon-34.png',
  },
  {
    id: 'liembfglbhoaacklkmapenocnhckgcdk',
    name: 'CB Insights',
    resource: 'main.js',
  },
  {
    id: 'lijbnhoniejpjjgemoifpjklobhakinb',
    name: 'Mark My Search',
    resource: 'icons/pin.svg',
  },
  {
    id: 'lkliejedgcbfamohhkcpndljomlmfbil',
    name: 'Tabs Rotator',
    resource: 'assets/icons/change-exchange-icon16.png',
  },
  {
    id: 'llcgplklkdgffjmhlidafnajbhbohgen',
    name: 'Comments Exporter',
    resource: 'injected.js',
  },
  {
    id: 'llpedbooglnjaniflkmcohmeffdhhjkd',
    name: 'Jiffy Reader',
    resource: 'assets/icon512.png',
  },
  {
    id: 'lmmpjincoilkndipbbpaojcpamfacbel',
    name: 'Autify Recorder',
    resource: 'static/js/autifyGlobal.js',
  },
  {
    id: 'lmpkfpfpfemkamakbeckaemjfolelifc',
    name: 'Vimego',
    resource: 'src/content.css',
  },
  {
    id: 'loiebadnnjhhmnphkihojemigfiondhf',
    name: 'Video Downloader Pro',
    resource: 'icon-34.png',
  },
  {
    id: 'lpchnognaapglnmmcfbgheomlcnhekfk',
    name: 'Sound Boost Hub',
    resource: 'src/popup/popup.html',
  },
  {
    id: 'lpdfdheclggihiflmodagaccofobklje',
    name: 'TooSlow?',
    resource: 'assets/js/c.js',
  },
  {
    id: 'lplhclpeegjedapdliokcacmphgcnlnd',
    name: 'js_error',
    resource: 'popup.html',
  },
  {
    id: 'madokmnpldgfbohflffkbfdbaojdmeni',
    name: 'MeetAssist',
    resource: 'overlay.css',
  },
  {
    id: 'maegdijinmmpkdclccdnapppabbefmdk',
    name: 'J7Extension',
    resource: 'icons/gmgn.svg',
  },
  {
    id: 'maggaiefhdildaklhjlgnahnfhbmjegk',
    name: 'YouTube Video Ad Downloader & Ad Data Export',
    resource: 'images/#.svg',
  },
  {
    id: 'majhgbekihmliceijipbdccgicepmmei',
    name: 'Instant Preview',
    resource: 'assets/sync-BC5qvjYY.js',
  },
  {
    id: 'mbcpbomfebacllmjjefeifejbbibbope',
    name: 'Capalyze AI',
    resource: 'content.css',
  },
  {
    id: 'mboaiekcfdemibpldhcgejaipihfkjmn',
    name: 'Stella Browser for Biz',
    resource: 'viewer.html',
  },
  {
    id: 'mccegadjoafkdahijbbincjlicfjjibd',
    name: 'Walnut',
    resource: 'vendor/fs.js',
  },
  {
    id: 'mcooieiakpekmoicpgfjheoijfggdhng',
    name: 'YouTube Comment Summary',
    resource: 'logo.png',
  },
  {
    id: 'mcplhmdgjcnoopibapjpbhnjfoainmac',
    name: 'Rayst',
    resource: 'icon-34.png',
  },
  {
    id: 'mdbahoikmdbalfgbblinaiojgmliinbh',
    name: 'WAGrab',
    resource: 'dom.js',
  },
  {
    id: 'mecgnmnjaabkfanlhemgomdocnnfopil',
    name: 'Save to Pinterest',
    resource: 'style.css',
  },
  { id: 'megabacfdcdkoigeenelkfaenmociipc', name: 'Oof!', resource: 'oof.mp3' },
  {
    id: 'meocbidedjibjdlhfjgplpogklmbhbko',
    name: 'sipgate',
    resource: 'wxt.svg',
  },
  {
    id: 'mfalklfpognjpjfbfllclbfjieknodid',
    name: 'Athene Wallet',
    resource: 'keep-alive',
  },
  {
    id: 'mfohnjojhopfcahiddmeljeholnciakl',
    name: 'Mouse Coordinates',
    resource: 'popup.png',
  },
  {
    id: 'mihgbgcojjjcgckpoclhjoneafcmfpng',
    name: 'JoyCode',
    resource: 'token.js',
  },
  {
    id: 'mihpkpgpdkbjjlfhepkjljiiilmbkaeg',
    name: 'Resolver',
    resource: 'tailwind.css',
  },
  {
    id: 'mippleannbnchhhacnchpankapalncke',
    name: 'Frhelper',
    resource: 'content/assets/i18n/en.json',
  },
  {
    id: 'mjecmfhofeojemjhbecidfkfpopikokg',
    name: 'OnPageSEO.ai',
    resource: 'assets/content.js-D_O4zpDi.js',
  },
  {
    id: 'mkfgeifgmfnklgfhdblfeeemhkhgigee',
    name: 'Crypto-Cardholder',
    resource: 'sidebar/style.css',
  },
  {
    id: 'mkflfhejpbpoinpcenpmfpbfgkeldfod',
    name: 'Travelpayouts',
    resource: 'top-bar.html',
  },
  {
    id: 'mkhlnnpfjieohiohgbphcnfdkmniofac',
    name: 'Definitions.net',
    resource: 'popup.html',
  },
  {
    id: 'mkodkaejnhpkbmlgdbnimeaakobcoegn',
    name: 'SAS EuroBonus Finder',
    resource: 'logo.svg',
  },
  {
    id: 'mlhimllheakianplccjmedmiabppmeaj',
    name: 'With A View',
    resource: 'offscreen.html',
  },
  {
    id: 'mlmifkfgafheljfcjlgoiggcfjenjeed',
    name: 'VideoSkip',
    resource: 'go2netflix.js',
  },
  {
    id: 'mlniogmfpplklfllojkdfgfjiiibcmma',
    name: 'Stylar',
    resource: 'assets/img/0001.png',
  },
  {
    id: 'mmbfjiakfgpnpannoknhdbmoammbpdeh',
    name: 'AdTech Ad Inspector',
    resource: 'loader.js',
  },
  {
    id: 'mmlghgaenodejbokcogohcjelnogcckl',
    name: 'HackerRank QuickApply',
    resource: 'main.css',
  },
  {
    id: 'mnnkpffndmickbiakofclnpoiajlegmg',
    name: 'Concordium Wallet',
    resource: 'inject.js',
  },
  {
    id: 'mpcplcmhkechjfdbljgomdeechoppmng',
    name: 'BGU Spark',
    resource: 'images/tosaf.png',
  },
  {
    id: 'mpnmjbcgbfnbfjmljblfngeofmnehdig',
    name: 'Page Grid Ruler',
    resource: 'data/view/index.html',
  },
  {
    id: 'nbefdmllbjackokegljnjidmebhojghn',
    name: 'Google Calendar Dark Mode',
    resource: 'data/content_script/custom/dark.css',
  },
  {
    id: 'ncekbecnpnoiapeghdneaihmeokakpdp',
    name: 'Friend Exporter',
    resource: 'img/pay-secure.jpg',
  },
  {
    id: 'neckdhljenflakkgcbidcnbdjjbpllnk',
    name: 'Page Align Center',
    resource: 'styles/preload.css',
  },
  {
    id: 'necpjbiijgficbgfanibojgkcbbooicg',
    name: 'Flexi',
    resource: 'managers/ModalManager.js',
  },
  {
    id: 'negckdpijkpfbellbeoapmmhbpnmnbef',
    name: 'Gamble Classroom',
    resource: 'images/hex.png',
  },
  {
    id: 'nfgdckhmemppdbmhhhioindkickfknad',
    name: 'Dutycast',
    resource: 'static/assets/bag.svg',
  },
  {
    id: 'nggpkpfmdkbaakpndblpandmldendooa',
    name: 'Jinno',
    resource: 'inject/Jinno.js',
  },
  {
    id: 'nhiegnhgjieegcgdkbneigigmpijbnhe',
    name: 'ふたば',
    resource: 'image/blank.png',
  },
  {
    id: 'nhppolcapbkijdpakbapijalcgnfjbgb',
    name: 'invoicemaker',
    resource: 'js/main.js',
  },
  {
    id: 'niahknneanfdkpapljhmeekakkhmmmpj',
    name: 'Auto-History',
    resource: 'img/loading.gif',
  },
  {
    id: 'niecjcdhljngdjglbehdpiaabhmebkcn',
    name: 'Extract video playback link',
    resource: 'catch-script/i18n.js',
  },
  {
    id: 'nimhpogohihnabaooccdllippcaaloie',
    name: 'WA Quick Group',
    resource: 'assets/wa.js',
  },
  {
    id: 'njboehnbpagnlfpegjnffaehdjfdhiao',
    name: 'Refore',
    resource: 'intermediary.html',
  },
  {
    id: 'njkkmgnoknkknfelokcjldjlnkgnedcm',
    name: 'neuroflash',
    resource: 'lato-latin-400-normal.e64c34d4.woff',
  },
  {
    id: 'njlbigpfmdidjnojdjeadgmeohckdkhi',
    name: 'StarNgage Instagram Profile Analyzer',
    resource: 'images/icon16.png',
  },
  {
    id: 'nkbokoloejkhohjlickhfkjfmbmboaof',
    name: 'Ciphix Mendix dev tools',
    resource: 'bizzoTools.js',
  },
  {
    id: 'nkeddnodkkdijfghdeilhnjodlgjceaj',
    name: 'Get Transit Schedules',
    resource: 'manifest.json',
  },
  {
    id: 'nljldpdlijecbfkakgblhobklpiogmfg',
    name: 'Backstory',
    resource: 'main.js',
  },
  {
    id: 'nmbngkjfkglbmmnlicoejhgaklphedcg',
    name: 'ScreenShot Tool',
    resource: 'preview.html',
  },
  {
    id: 'nmfnikkmipenjmdmlonjahcobmacaoef',
    name: 'ofe',
    resource: 'js/injected.js',
  },
  {
    id: 'noglbipnalamijcpdffjihmepadieajn',
    name: 'Arvin',
    resource: 'tabs/index.html',
  },
  {
    id: 'npgmpehjkfjicciloilfhfkaobhpobgk',
    name: 'Yoko Networks Click to Call',
    resource: 'urls.json',
  },
  {
    id: 'npilhaamcjahflafelbfpmmfcihoiian',
    name: 'Refine',
    resource: 'lib/fonts/lato-bold.woff2',
  },
  {
    id: 'nplkdkbfnfheognggghkckpgngbjkahe',
    name: 'YouTube Subtitle Reader',
    resource: 'content.js',
  },
  {
    id: 'oaceoebbkmkgfjhmngdinoclnionlgoh',
    name: 'Duplicate Tab Helper',
    resource: 'js/ui.js',
  },
  {
    id: 'oacfincmbjdddohpjgjjnhocgljhpeda',
    name: 'Frappe',
    resource: 'icon-16.png',
  },
  {
    id: 'oaenllollgdmpdfhohchhnalkjpogepl',
    name: 'SearchGPT',
    resource: 'js/chat_ai.js',
  },
  {
    id: 'oaknkllfdceggjpbonhiegoaifjdkfjd',
    name: 'Clippy Assistant',
    resource: 'assets/img/clippy.map.png',
  },
  {
    id: 'obegkpmjkhpjfhmdjdojmenmlbepenme',
    name: '1stream Client',
    resource: 'iframePage.html',
  },
  {
    id: 'obfdfohdbngkanenpfmneenfiifgkdio',
    name: 'Video Downloader',
    resource: 'offscreen.js',
  },
  {
    id: 'ocejkjkjbhbkgdidjhodiejdppbiahna',
    name: 'GPTBLOX Content Manager-ChatGPT Download Conversation & web collector',
    resource: 'js/db.js',
  },
  {
    id: 'oddpcajnaolfbinffajkacjhohhahlib',
    name: 'Reveal Deleted FB Messages',
    resource: 'icons/icon16.png',
  },
  {
    id: 'odkdoekijebogaiopbjgkgogkgifjfnk',
    name: 'Angular Inspector',
    resource: 'dist/detector.js',
  },
  {
    id: 'odlncglkkpdcbefpneoelgcopkmgajbh',
    name: 'floik',
    resource: 'icon-34.png',
  },
  {
    id: 'oedpeddiacomhhfieanenlmdghkolgng',
    name: 'ChatGPT & AI Chat Backup',
    resource: 'options.html',
  },
  {
    id: 'oefkggdmcfeondkhehhofnbadaefcdlf',
    name: 'Focus Mode',
    resource: 'help.js',
  },
  {
    id: 'ogbnplgfglcjlbplclgejnmfkccollba',
    name: 'SERP Checker',
    resource: 'data/countries.json',
  },
  {
    id: 'ogcoelhdhiklkfpdnbknmgeaakhghjkg',
    name: 'Night Sun',
    resource: 'themes.js',
  },
  {
    id: 'ogjmohkdfhbogmokhbgphnmkmiilfkce',
    name: 'Thinking Time Tracker',
    resource: 'audio/end.mp3',
  },
  {
    id: 'ohdnokamhlhcobcpebkconbepfomicoa',
    name: 'AI Copy/Paste/Upload Blocker',
    resource: 'inject.js',
  },
  {
    id: 'ohhpijmpbgndokpodomgiclmflhbkihb',
    name: 'Starmarks',
    resource: 'src/extension/newtab/index.ts',
  },
  {
    id: 'ojaclcbknieckfcapcbifaijoocfmpaj',
    name: 'Chrome Color Picker',
    resource: 'dist/contentScripts/style.css',
  },
  {
    id: 'ojgaknagnojclcnmenmickjcnpbijill',
    name: 'AliEHelper',
    resource: 'images/AliHelper_icon.png',
  },
  {
    id: 'ojgbknjkkodmobhncmbeldgmgbfkeida',
    name: 'Flipbook to PDF Downloader',
    resource: 'lib/jspdf.umd.min.js',
  },
  {
    id: 'ojgiocfokgljoliedfipmfmljbijekab',
    name: 'AIRSTEP Play',
    resource: 'scripts/ctx.js',
  },
  {
    id: 'ojihcoimmhapanmaglfhjfddoniigjpg',
    name: 'MlbBaseballTracker',
    resource: 'logos/mlb.png',
  },
  {
    id: 'okchldnojljcfhjhjmeibjpflepmnkaf',
    name: 'Asin Gadget',
    resource: 'icons/128.png',
  },
  {
    id: 'okdfcljlaacbdacenfeaiekllplonlfm',
    name: 'Synclify',
    resource: 'injected.js',
  },
  {
    id: 'okejgpcglnpafnfnmgekpfnddicfhddo',
    name: 'Group Extractor',
    resource: 'img/pay-secure.jpg',
  },
  {
    id: 'okjdkjeiihhiaakknbecdkdakmnhaaem',
    name: 'SessionHub',
    resource: 'wait.html',
  },
  {
    id: 'omdilgkadhcoliihkpbgpkdcpogkbhah',
    name: 'Design Mode',
    resource: 'data/toolbar/index.html',
  },
  {
    id: 'ommalcobdncoghamghedpgepjaaobbbe',
    name: 'Annotate Website',
    resource: 'gear.svg',
  },
  {
    id: 'ooghhnfeahkljnhloggdlnecfbhdkndn',
    name: 'GTA 6 Wallpapers and New Tab',
    resource: 'search.html',
  },
  {
    id: 'ookknocaigciegofgceojalmicafpalj',
    name: '有趣翻译',
    resource: 'scripts/clarity.js',
  },
  {
    id: 'ookpfincecbbcdphphhjobiajhikjbhi',
    name: 'Copy as Markdown for AI',
    resource: 'dist/popup.js',
  },
  {
    id: 'oolobapiojdnnempcokpajdiedgdiecl',
    name: 'User Agent Switcher',
    resource: 'js/inject/changeua.js',
  },
  {
    id: 'oonholcildbjjpikkfiapadhiicmnimb',
    name: 'Interstride Visa Sponsorship Finder - U.S. H-1B & UK Skilled Worker',
    resource: 'lib/chart.min.js',
  },
  {
    id: 'opbinaebpmphpefcimknblieddamhmol',
    name: 'Aleph Zero Signer',
    resource: 'page.js',
  },
  {
    id: 'opekncoplahejgaafgaogmonaianbljm',
    name: 'ADSCleaner',
    resource: 'front/html/block.html',
  },
  {
    id: 'pafkkbjmpnfkdkkhldbbnggnmpbbhkmf',
    name: 'Performance',
    resource: 'icon48.png',
  },
  {
    id: 'paflchebahgbgeambpbhoieeanaddehf',
    name: 'Hand Tool',
    resource: 'openhand.cur',
  },
  {
    id: 'paiilnohppponakpjeamailmlmgdbdll',
    name: 'Kilkaya toolbar',
    resource: 'help.html',
  },
  {
    id: 'pamfkmlimebecnfjoikmacloehbkhhoj',
    name: 'Search by image on Alibaba',
    resource: 'ic.png',
  },
  {
    id: 'pbajmkgfblpcnmbceefnjbhbhkflameh',
    name: 'TwExtract',
    resource: 'js/inject.js',
  },
  {
    id: 'pbdfkndpibcnljjbdlngfobmakglflak',
    name: 'Cisco In Product Support',
    resource: 'src/xdr-onboarding.js',
  },
  {
    id: 'pbkobmcegbmmjnfhholeonfacmfkpcja',
    name: 'Melhores Destinos',
    resource: 'images/icon80.png',
  },
  {
    id: 'pblenjbopecfgkmkmkepboncibolhabk',
    name: 'GroupKit',
    resource: 'images/mail.png',
  },
  {
    id: 'pchacppeelclfhfcoehbbpgbgjhglocc',
    name: 'qr code decoder',
    resource: 'vendor/Jcrop.gif',
  },
  {
    id: 'pcidanpimdgppoffjgbknephlpehfmfb',
    name: 'Zoom Phone For Outreach',
    resource: 'images/logo.png',
  },
  {
    id: 'pdachidppohpjnepdkdheaomgoibolom',
    name: 'LiftmyCV',
    resource: 'assets/dom.js',
  },
  {
    id: 'pdfdjfoigmkblodhcoclpnicpkplbjhf',
    name: 'Elements',
    resource: 'assets/icons/manual.svg',
  },
  {
    id: 'pdihjeafnnlohacikgfmkcmmbelpncif',
    name: 'Safeshop',
    resource: 'app.html',
  },
  {
    id: 'pdnkdpkigplndkpnciommmacnplfjbal',
    name: 'Just Do It',
    resource: 'assets/1.webm',
  },
  {
    id: 'pdobffaogpipbfihagnhgfooejfecald',
    name: 'Indian Visa Autofill Pro',
    resource: 'modal.css',
  },
  {
    id: 'pegemlhekkccgoidiphojbpnabahjmff',
    name: 'Arcify Spotlight',
    resource: 'assets/icon.png',
  },
  {
    id: 'pemlmekccdbjmfeehbmbehbjpcnppcef',
    name: 'Infomon',
    resource: 's.d049c692.png',
  },
  {
    id: 'pfbjijkemboimlmngimalfbnianfcfdd',
    name: 'IDL Helper',
    resource: 'ffmpeg-core.wasm',
  },
  {
    id: 'pfgfbflpcekpehdblfgmffbfnmoljknc',
    name: 'SiteArmor',
    resource: 'warning.html',
  },
  {
    id: 'pfncofjenonlikkhcbbgingooppdddde',
    name: 'Formix',
    resource: 'click.wav',
  },
  {
    id: 'pgaabedmnacicfkgnbfdodgmdmpbcnpk',
    name: 'WZone Import Manifest V3',
    resource: 'js/inject.js',
  },
  {
    id: 'pgenbnkcpmebbcoeeekefkmblmblppbj',
    name: 'Acrolinx',
    resource: 'bowser/es5.js',
  },
  {
    id: 'phjadnllkgbpnckjnihpakjfombonlfd',
    name: 'SymbeePlugin',
    resource: 'css/click2dial.css',
  },
  {
    id: 'phkadhcecbaaijkgbnjbchhgmjnpcnae',
    name: 'AIPal',
    resource: 'locales/ar.json',
  },
  {
    id: 'piaiakpglegnhoenicfmoekbciailcdj',
    name: 'BandLab Music Downloader',
    resource: 'popup.js',
  },
  {
    id: 'picnmejalkhllkgbcmdhhnfnflpcdcej',
    name: 'Broker of Macro Expert',
    resource: 'execute_snippest.js',
  },
  {
    id: 'pjcfmgokdbdffkcldahbehpemeejglhh',
    name: 'Inspecta',
    resource: 'svgs.html',
  },
  {
    id: 'pkacogamhpebcampgohkefmchngbhncf',
    name: 'Goodhue',
    resource: 'assets/content.ts-BPDgDiKT.js',
  },
  {
    id: 'pkjhbflcnjikmfiiojcagjidbjeimkbj',
    name: 'RedditGrab',
    resource: 'ffmpeg/ffmpeg-core.js',
  },
  {
    id: 'pljeedmkegkcfkgdicjnalbllhifnnnj',
    name: 'Edge Translate',
    resource: 'web/dialog.css',
  },
  {
    id: 'pmjagijikomfjjoafjbdeojcinngkcpe',
    name: 'Fast Translation',
    resource: 'assets/main.js',
  },
  {
    id: 'pmmodpeofmnekbdbjojhidofleeacmij',
    name: 'Share-A-Cart for Walmart',
    resource: 'images/sac-16.png',
  },
  {
    id: 'pnenhoomfmddepcbmmkpkbdoplmjohge',
    name: 'FutSniperExtension',
    resource: 'js/2hw43.js',
  },
  {
    id: 'pnlbnejodfpnapdpoiboebofddaejkbg',
    name: 'Zoom For Gov',
    resource: 'images/icon.svg',
  },
  {
    id: 'pnmaepmfepkefgolhjlhhaplimpefaem',
    name: 'PDF Signer',
    resource: 'pdfjs/pdf.js',
  },
  {
    id: 'pnobdlbfobamledoecdignpneeoohhio',
    name: 'DeepAcquire',
    resource: 'icon/16.png',
  },
  {
    id: 'pocmpamlhfofihlehdobhoelfpmkabbi',
    name: 'FullPagePDF',
    resource: 'js/vendor.js',
  },
  {
    id: 'pofheakpngfbdfeidiippmmckgpdceoh',
    name: 'x_Wallet',
    resource: 'logo.png',
  },
  {
    id: 'poiiimgigdekjmhpohdceabjlocjenfl',
    name: 'Power Tools',
    resource: 'assets/logo.png',
  },
  {
    id: 'ppbmlefhgoananjpjenjhoihhaohnmol',
    name: 'Bodyguard',
    resource: 'tabs/block.html',
  },
  {
    id: 'ppijihikpncgdgflhdbfllniclbdmomd',
    name: 'Watch With Me',
    resource: 'join.mp3',
  },
  {
    id: 'ppmhjnpgbdlpeoeboaldplmffgkijjji',
    name: 'Autocorrect Misspelled Words & Text Snippets',
    resource: 'es-100l.txt',
  },
  {
    id: 'ppmokamipefokigaccoiefenhgokncle',
    name: 'DM Saver for Instagram',
    resource: 'buy.html',
  },
  {
    id: 'aaecelcedmmbkgnkcpneohpmanpcbeek',
    name: 'AiNBar',
    resource: 'images/128.png',
  },
  {
    id: 'aalfhpnibomagmpkoljjlblbbkmedcli',
    name: 'Voiceitt',
    resource: 'icons/icon-128.png',
  },
  {
    id: 'acafodflmigcgodaikhfieheibdaepbc',
    name: 'extractor.plus',
    resource: 'img/logo.png',
  },
  {
    id: 'acjicnehenlkmfnfpbjbpfnjegbelbpj',
    name: 'DigitalZen',
    resource: 'dz.html',
  },
  {
    id: 'acjopnffmehbackaohjjnpnnnocfcmnf',
    name: 'Arena Shopify Admin',
    resource: 'resources/arn-main.js',
  },
  {
    id: 'acnbdmcfjdpojblohmiggmenhofldghk',
    name: '达连',
    resource: 'index.css',
  },
  {
    id: 'adjbknblejbhfmcefnhgkdboanoboimj',
    name: 'Downloader for Skool',
    resource: 'indexed-db.js',
  },
  {
    id: 'adkobhmkiigogjoholknnebchngpiboi',
    name: 'Showcase',
    resource: 'ga.js',
  },
  {
    id: 'adoeinlolcjogennbgahohnjeckanaeb',
    name: 'CoinTool',
    resource: 'icon-34.png',
  },
  {
    id: 'aekhkmkjmigbecagogodpaepchpjjcnh',
    name: 'Smart Fiverr',
    resource: 'icon.png',
  },
  {
    id: 'afaenafmlblabamefeeedcmonilklgbk',
    name: 'Themes+ New Tab',
    resource: 'css/base.css',
  },
  {
    id: 'afmnhehfpjmkajjglfakmgmjcclhjane',
    name: 'Coursera Summary',
    resource: 'logo.png',
  },
  {
    id: 'afmodkjhmglpnomeindmmkfofgjandcl',
    name: 'Meetical',
    resource: 'chunks/74.js',
  },
  {
    id: 'afnpaldkfdjklpjphnpaokdafmgpidhn',
    name: 'TrollFaceEverywhere',
    resource: 'trollface.webp',
  },
  {
    id: 'agcepmkdnfaglcenjnfkcabdfcekjfcb',
    name: 'TTS',
    resource: 'settings.html',
  },
  {
    id: 'agdddnmdjmljkjeglnidfpmpenbimmmn',
    name: 'LinkedGPT',
    resource: 'imgs/final.png',
  },
  {
    id: 'aghfgppmefneeefhpmgboigbfkcnmkcd',
    name: 'Eshelper',
    resource: 'content/assets/i18n/en.json',
  },
  {
    id: 'ahlhebeohindihglfenlmpiamkgadnoi',
    name: 'SEO CENTER',
    resource: 'images/icon.PNG',
  },
  {
    id: 'aidgalgknmlipfnekllphkpignegfmid',
    name: 'ExpertBot',
    resource: 'content.js',
  },
  {
    id: 'aidjbcadkohfjgbikjiechlafmiifpfm',
    name: 'KeepChatGPT',
    resource: 'assets/inject.js',
  },
  {
    id: 'aidndodkpjkakjdhhmkkmjgehflbjbae',
    name: 'Temp Mail PW',
    resource: 'qrcode.min.js',
  },
  {
    id: 'aighbajkamplcinockonchknbclndded',
    name: 'Smodin',
    resource: 'domain-checker.service.24da4fb3.js',
  },
  {
    id: 'aioimldmpakibclgckpdfpfkadbflfkn',
    name: 'Source Detector',
    resource: 'popup/index.js',
  },
  {
    id: 'ajepcgeokfoanenjolfjfpfdbcpddooe',
    name: 'FakerFill',
    resource: 'style.css',
  },
  {
    id: 'ajjhglddifjgmjilgjlcgafhjbhapebp',
    name: 'Made in Where',
    resource: 'assets/spinner.gif',
  },
  {
    id: 'ajkgnokoigbiimpgoibiaghdcoiegfgp',
    name: 'Lionel Messi Wallpapers',
    resource: 'js/main.js',
  },
  {
    id: 'akekmdbhpcllngkclondhoffopndiofn',
    name: 'QR Code Scanner',
    resource: 'css/style.css',
  },
  {
    id: 'aklhdocmgpelkhpokopkcepgofimmooc',
    name: 'On Page SEO Checker',
    resource: 'icons/logo.svg',
  },
  {
    id: 'akloompimekeojpneifhfnjgbjemcdeb',
    name: 'Inject JS',
    resource: 'injected-scripts/injector.js',
  },
  {
    id: 'aknpjjjjbhhpbdeboefcnnbafldhckej',
    name: 'Chestr',
    resource: 'content/index.js',
  },
  {
    id: 'alaclngadohenllpjadnmpkplkpdlkni',
    name: 'Images Downloader for Airbnb',
    resource: 'downloader.html',
  },
  {
    id: 'aleoomdhnjddjlmfocibikjdpkdpadko',
    name: 'Breakcold',
    resource: 'assets/index-CkxJ3yCw.js',
  },
  {
    id: 'algbkiepdpcjnhgagoddfcicdeaiimba',
    name: 'hackbar',
    resource: 'icon-34.png',
  },
  {
    id: 'alglchohmdikgdjhafiicilegegieafa',
    name: 'MultiField CopyCat',
    resource: 'content/copycat.png',
  },
  {
    id: 'alngaojhoejljemhkbnhenblnpalgifb',
    name: 'Search by image on Ebay',
    resource: 'ic.png',
  },
  {
    id: 'amhpammgffnhofdboeeihjhlcgchhphg',
    name: '跨境魔方领英助手',
    resource: 'kf.c18a801d.png',
  },
  {
    id: 'amikeononomkhphopbflomhnmdijjpmb',
    name: 'ChatGPT Infinity',
    resource: 'lib/ui.js',
  },
  {
    id: 'amikgkkhclafondlhjpmmhmacibjphnf',
    name: 'Color Wheel Chart',
    resource: 'popup.js',
  },
  {
    id: 'amloklcaibgdommdfkhpjjeopdjmmaoe',
    name: 'Visa Slot Checker',
    resource: 'content.js',
  },
  {
    id: 'anfjigoimfhbhkcpggoomegmafgmnada',
    name: 'NoTab',
    resource: 'popup.js',
  },
  {
    id: 'angccohmaecfihlpglbaedpjklcomddc',
    name: 'FB Videos Downloader',
    resource: 'logo.svg',
  },
  {
    id: 'anhmcblpecaabfbedccbofmjodfdjcdj',
    name: 'WhatsApp Translator',
    resource: 'icons/logo.png',
  },
  {
    id: 'aopnnccplbmphndiljkpkcnnihfdfnpm',
    name: 'Auto Furigana',
    resource: 'kuromoji/dict/cc.dat.gz',
  },
  {
    id: 'aopodabomkfakmjghlkojpknemlileil',
    name: 'EqualWeb Accessibility Crawler',
    resource: 'scripts/content/chart.js',
  },
  {
    id: 'apfohijllfhnblfljmdalceabnebpagn',
    name: 'audioSuite',
    resource: 'platinum.png',
  },
  {
    id: 'apmacgoajagifnflancoaenfcgmjnifc',
    name: 'Autobound',
    resource: 'popup.css',
  },
  {
    id: 'bacpgelchdkdpdhpfejnckhmnodlkfik',
    name: 'PopVerse',
    resource: 'chap.js',
  },
  {
    id: 'bbgoenllpdnfljjapjcababahphohncj',
    name: 'StaticShot',
    resource: 'index.html',
  },
  {
    id: 'bbiokppljpbjgiogcoggjnfffbeiihja',
    name: 'Velatir',
    resource: 'config.js',
  },
  {
    id: 'bbjdllcbfjcaokkmeidgoefbddahbofo',
    name: 'Sparos',
    resource: 'src/assets/images/logo.png',
  },
  {
    id: 'bbnngmmocfegjkekebllkaijmfoelofn',
    name: 'Custom Scrollbar',
    resource: 'popup.js',
  },
  {
    id: 'bcagnbmncmeliaknnhmbkkgackfipoic',
    name: 'ReadLite',
    resource: 'assets/icon-16.png',
  },
  {
    id: 'bchkeljpaneffcdpbglmgdhlemdcpdhb',
    name: 'Simpsons cursor',
    resource: 'cur/0.cur',
  },
  {
    id: 'bdehmbdbcnaodfmjjgkgkcekomeijdoh',
    name: 'Favourites.io',
    resource: 'public/templates/popup.html',
  },
  {
    id: 'bdgjkkdfafbckdafophnhkhldcdbijfp',
    name: 'Kopy',
    resource: 'assets/client-Dxn_vZUZ.js',
  },
  {
    id: 'bdiohckpogchppdldbckcdjlklanhkfc',
    name: 'Nighthawk',
    resource: 'static/media/qr-code.181c8eeb065bb04f416d.png',
  },
  {
    id: 'bdngfgjiioghlobpnibipeeaejhgipnd',
    name: 'Lead Talk CRM',
    resource: 'icon16.png',
  },
  {
    id: 'behnnpfjjmnpcmclpbcgfmidjmmpffhh',
    name: 'QuickCreator',
    resource: 'sidepanel.html',
  },
  {
    id: 'bekjlhfdjnggolmglphobmeigmcajnfe',
    name: 'Gmail.com Login',
    resource: 'config.js',
  },
  {
    id: 'belclhbabjnajafdinionmjhpnedbobi',
    name: 'Orange Pass',
    resource: 'icon-34.png',
  },
  {
    id: 'benpolaabjjganjkmhbdppijcfimlgdb',
    name: 'Abbreviations.com',
    resource: 'popup.html',
  },
  {
    id: 'bfaoaaogfcgomkjfbmfepbiijmciinjl',
    name: 'Ollama Client',
    resource: 'assets/sql-wasm.wasm',
  },
  {
    id: 'bfaomcmkpeapcnglnhfdcngpcicmbaog',
    name: 'Juicy Coupon',
    resource: 'popup.js',
  },
  {
    id: 'bfcegiickjkkfnfkaahogfaacjhkfphi',
    name: '360 Ribbon',
    resource: 'cancelnew.png',
  },
  {
    id: 'bfheaockklhhdaohopnlkbohdadlfdjo',
    name: 'Colleague AI',
    resource: 'click.mp3',
  },
  {
    id: 'bfkiphdpanhdnjbekkjigbjjmllhndch',
    name: 'Sugar Connect',
    resource: 'main.js',
  },
  {
    id: 'bfpogemllmpcpclnadighnpeeaegigjk',
    name: 'Peek',
    resource: 'img/gear.svg',
  },
  {
    id: 'bgeejdmhoicoclcgdbcoggbigdlpfahl',
    name: 'Lightfunnels Domain Connector',
    resource: 'popup.html',
  },
  {
    id: 'bhnojmjkeoofbgecpijmpnepjdonaoak',
    name: 'Extensions Syncer',
    resource: 'postcss.config.js',
  },
  {
    id: 'bidcnmfhffpamjhgkemdmjdmnchjnmdf',
    name: 'RussianGram',
    resource: 'js/popup.js',
  },
  {
    id: 'bieekfeiaebohcjnfemcklfjkejndijd',
    name: 'Humble AI',
    resource: 'options.html',
  },
  {
    id: 'bigfgeehfoenaimkoohnokeeideaomnd',
    name: 'MockMan',
    resource: 'app/bundle.js',
  },
  {
    id: 'binamioddebkgapafhckcomlljmagkcp',
    name: 'Cursor Space',
    resource: 'assets/reload.svg',
  },
  {
    id: 'biohbbbijnpljcdhobbjakhgpkelmjpg',
    name: 'Vocus.io',
    resource: 'css/app.css',
  },
  {
    id: 'bipdhagncpgaccgdbddmbpcabgjikfkn',
    name: 'Clown Wallet',
    resource: 'js/injectScript.js',
  },
  {
    id: 'bmcjeckemmdkoapcmpmffabkelgknlme',
    name: 'Cashclub',
    resource: 'content.css',
  },
  {
    id: 'bmkakpenjmcpfhhjadflneinmhboecjf',
    name: 'WELLDONE Wallet for multichain',
    resource: 'inject.js',
  },
  {
    id: 'bmkimnpopagbkknhfpjfbgmhimofmmkm',
    name: 'Browser Recorder',
    resource: 'player.html',
  },
  {
    id: 'bmninhlkpnllbioeiflnedibkeifpmkm',
    name: 'Drawboard PDF',
    resource: 'loader.js',
  },
  {
    id: 'bnaofpgjajbimmicdiipemhmheafhgkb',
    name: 'ServiceNow Web Automation',
    resource: 'lib/water-flow.js',
  },
  {
    id: 'bneepngbmdnjodaceeffcodionfphgcb',
    name: 'Ebsta for Bullhorn',
    resource: 'js/bar.js',
  },
  {
    id: 'bneijclffbjaigpohjfnfmjpnaadchdd',
    name: 'Indeed Scraper',
    resource: 'injected.js',
  },
  {
    id: 'bnhhfjmfcfmdhkgdcflpcgjkbnmcnenp',
    name: 'Simple Volume Booster',
    resource: 'ads.json',
  },
  {
    id: 'bniifnajcfhipaemdbbodnegpdhegkik',
    name: 'VibeGrade',
    resource: 'img/ga.png',
  },
  {
    id: 'bnlanfoeolmminabanfaomlpacadfkie',
    name: '云神价-购物点点',
    resource: 'js/area.js',
  },
  {
    id: 'bnpjledobdcjaahppbiiooamdlclgfen',
    name: 'Chess Free Online',
    resource: 'config.js',
  },
  {
    id: 'boaldbonhjahlifomlfompdicecodccc',
    name: 'StyleGuard Pro',
    resource: 'js/common.js',
  },
  {
    id: 'bpbgeempipgeepdhjcmoacgllolnmabi',
    name: 'NexSoft AI Autofill',
    resource: 'editor.js',
  },
  {
    id: 'bpcliekjnopcagpekljnkpicfdpjfbkc',
    name: 'Chinese Learning',
    resource: 'copy.png',
  },
  {
    id: 'bphiihopjpbcbahfpngldhoafegggeab',
    name: 'Marsello',
    resource: 'jquery.min.js',
  },
  {
    id: 'cadnjdgggbmgmiokgmbngklhlldabhom',
    name: 'Telegram Translator',
    resource: '_locales/ar/messages.json',
  },
  {
    id: 'capganbaogpgmmlkboomnkdaoghepcng',
    name: 'Skuowner',
    resource: 'images/icon16.png',
  },
  {
    id: 'cblecgnkfldiipmmfpiolmfhfphhfngo',
    name: 'Quetta Video Downloader',
    resource: 'icon-128.png',
  },
  {
    id: 'cbngnnhgfljncoliddifmkgklphlojnf',
    name: 'Polygraf AI Content Detector',
    resource: 'icon-32.png',
  },
  {
    id: 'cdkbepknpekpkhhpdnmmaogojkmoieig',
    name: 'quicksnap',
    resource: 'camera.mp3',
  },
  {
    id: 'celhojiplcoiojnmgjoenklfgghifncp',
    name: 'Scroll To Top',
    resource: 'css/popup.css',
  },
  {
    id: 'cfebdnpaooilklaiemggkhnbakafohel',
    name: 'AntiTestportal GPT',
    resource: 'assets/anti-anti-tamper.js',
  },
  {
    id: 'cfegfckldnmbdnimjgfamhjnmjpcmgnf',
    name: 'AI Memory',
    resource: 'icons/add.png',
  },
  {
    id: 'cffpojocacfloplffkpecnmhfldddegd',
    name: 'Screen Capture Recorder 4K',
    resource: 'editor.html',
  },
  {
    id: 'cfgmcamlcehdcoegmngjofiafnglhkgo',
    name: 'Clean Reader',
    resource: 'js/reader.js',
  },
  {
    id: 'cgdjipjplklipnlfbglgkjlnhfkpihfd',
    name: 'Tarss',
    resource: 'framework/dotnet.js',
  },
  {
    id: 'cgkclfedooedmjpcfjefjdoflddknopo',
    name: 'Ad Library Helper',
    resource: 'images/#.svg',
  },
  {
    id: 'cgmllohkcppmnkfpijpngkplpdbikhlf',
    name: 'Safe Surf',
    resource: 'img/atf.svg',
  },
  {
    id: 'cgphfnglahpambfhocchajalljaeegef',
    name: 'JSONView',
    resource: 'css/jsonview.css',
  },
  {
    id: 'chccpjfkgkgogeaaekpgoocmcekajgjk',
    name: 'Is Generated',
    resource: 'assets/x.svg',
  },
  {
    id: 'chdjnoopbpficpjmhekoolcinknhkagn',
    name: 'amberSearch',
    resource: 'index.js',
  },
  {
    id: 'chdpdcmianoeafncndadkpmklicedlkl',
    name: 'HolyTrick',
    resource: 'content-scripts/ui.css',
  },
  {
    id: 'chkihcfmnokicddjbagimapohpgbdlhj',
    name: 'CodeFlicker',
    resource: 'preview-injector.mjs',
  },
  {
    id: 'chnggbbijedpjecbpkadjfdgiapgdadp',
    name: 'NotebookLM Source Manager',
    resource: 'filter.js',
  },
  {
    id: 'cianjgodoefcpaifdgbhkbnnpelkakaf',
    name: 'Split Screen Pro',
    resource: 'styles.css',
  },
  {
    id: 'ciholhjpbfhkdgbjhdefoaiibpmkhonk',
    name: 'Chirpyest',
    resource: 'images/bird-dark.svg',
  },
  {
    id: 'cinalcbancbfnkeajghjljhmaanjekgl',
    name: 'sendencrypted',
    resource: 'dist/extension.js',
  },
  {
    id: 'cipnpfcceoapeahdgomheoecidglopld',
    name: 'Virtual Json Viewer',
    resource: 'assets/jq.wasm',
  },
  {
    id: 'ckgeffpapoiemciaenjgbelealaekgic',
    name: 'Zeus',
    resource: 'darkmode.css',
  },
  {
    id: 'ckhdepimeomofedoiebgmklphncjnfhe',
    name: 'Warehouse Job Scheduler',
    resource: 'alert.wav',
  },
  {
    id: 'ckjjfpcdnccfjnkpnlfndpmlbdlohgcm',
    name: 'Toolset for Google Calendar',
    resource: 'web_accessible_resources/xhook.min.js',
  },
  {
    id: 'cklfipcjofdnmdolnfngpmokdaejidim',
    name: '不背单词查词',
    resource: 'lookup.html',
  },
  {
    id: 'ckllkdbaocdendijohldneangieacpci',
    name: 'WA Master',
    resource: 'popup.html',
  },
  {
    id: 'clalpejhefalfblnijneiplagklnifee',
    name: 'SHEINImage',
    resource: 'icon-48.png',
  },
  {
    id: 'clidjbmbkfhbhjenclljiclfpjbglmeo',
    name: 'Pinterest Board Bulk Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'clmkmffdbohhicjlhkcdghlgflpoabfj',
    name: '边写边搜',
    resource: 'icons/del.svg',
  },
  {
    id: 'clncechdmbedjkkfmpmjlbbfkgkhmemk',
    name: 'Travtus Gateway',
    resource: 'images/icons/icon-64.png',
  },
  {
    id: 'cmbihlcgenpbmdkipolfghkplheignfe',
    name: 'ABlock',
    resource: 'js/injected.js',
  },
  {
    id: 'cmbnmnfclolmdoienholojjecenpofhk',
    name: 'WASendly',
    resource: 'content/store-init.js',
  },
  {
    id: 'cmibdnmeihbjkdgnohgjeelkofcnfhid',
    name: 'File Explorer',
    resource: 'pages/main.html',
  },
  {
    id: 'cmncoolckhinjbfghfbiionapeanngep',
    name: 'Pinterest extra',
    resource: 'icon-34.png',
  },
  {
    id: 'cmnjpgpkkdmkkmpliipnmhbelgbiefpa',
    name: 'justTLDR',
    resource: 'assets/icons/logo.png',
  },
  {
    id: 'cmoakldedjfnjofgbbfenefcagmedlga',
    name: 'Nest Wallet',
    resource: 'injected.js',
  },
  {
    id: 'cmpjcbhhaneoeekleibpfoejfieblekk',
    name: 'easy-web-macro-extension',
    resource: 'assets/storage-B9T1X6OE.js',
  },
  {
    id: 'cndnkfinbmlobbgjgbhoiaikajocejgo',
    name: 'Alibaba, AliExpress & 1688 Search by Image',
    resource: 'loader-icon.svg',
  },
  {
    id: 'cnephjboabhkldgfpdokefccdofncdjh',
    name: 'HackMD-it',
    resource: 'popup.js',
  },
  {
    id: 'cnkodomhnmnbmiehakpmaabjjbjifhel',
    name: 'Ellisphere',
    resource: 'script.js',
  },
  {
    id: 'coajjoaadmkcapmoikohngmljgddnbkj',
    name: 'Probook AI',
    resource: 'assets/footer.png',
  },
  {
    id: 'coknkdplmddfgoggddpienehfhdgegna',
    name: 'Newmoney.AI',
    resource: 'src/content/injector.js',
  },
  {
    id: 'cpcnmjjlfdpicppncnambopmefpienej',
    name: 'XPath Tool',
    resource: 'styles.css',
  },
  {
    id: 'cpgnbnkicmfhkglagioeamammaefejeg',
    name: 'Free Shopify Product Scraper & Exporter',
    resource: 'popup/popup.js',
  },
  {
    id: 'cphdjiacoelggmgfopmgmljdnhmlhici',
    name: 'Artab',
    resource: 'icon16.png',
  },
  {
    id: 'cpjedmmeadohcjionoanpigjbldckpog',
    name: 'Neuron (formerly Prospect)',
    resource: 'css/global.css',
  },
  {
    id: 'daeejbkgpkoagacncliemiienmlnclmj',
    name: 'ChatBrawl',
    resource: 'config.js',
  },
  {
    id: 'dafimblndlbfdhmdnefmmnjdpbbnflgd',
    name: 'Ad Observer',
    resource: 'webpage/bundle.js',
  },
  {
    id: 'dahgndeklkpppijkgeejmflpiachffig',
    name: 'Omegle Alternatives',
    resource: 'config.js',
  },
  {
    id: 'damonelhcfhpjhgnikakjpjinakfejhe',
    name: 'Impact Factor Finder',
    resource: 'data/journal_impact_2024.csv',
  },
  {
    id: 'daniknejbbnjhfmcgolfpaedkpcfkaop',
    name: 'Mutable',
    resource: 'images/kittens/8.jpg',
  },
  {
    id: 'dbdemkocknedkigkocjlackhcmlfhjih',
    name: 'X情报查询助手',
    resource: 'images/pin.png',
  },
  {
    id: 'dbdodecalholckdneehnejnipbgalami',
    name: 'Weda Helper',
    resource: 'README.md',
  },
  {
    id: 'dbgmdhljlomlbiapjfikffgdmdmpjgdk',
    name: 'NetSuite Better Export',
    resource: 'images/BE.svg',
  },
  {
    id: 'dcbebomificokapbopjhihlhjobeincb',
    name: 'In-Page Piano Analytics',
    resource: 'assets/font/Graphik-Light-Web.woff',
  },
  {
    id: 'dcddjkhomebafjbaleonddmfdbdagojb',
    name: 'Couponuts',
    resource: 'images/logo.png',
  },
  {
    id: 'dclfbcpopdggpbinijdfionpoljgbaep',
    name: 'eCaresConnect',
    resource: 'apiUrls.js',
  },
  {
    id: 'dcpjobjmablklmjigkcdjfjnmhgjpmkj',
    name: 'SMTP',
    resource: 'images/logo/smtp_16.png',
  },
  {
    id: 'ddbcpkedjbeclghgffkbdjingpdbodfl',
    name: 'Ruliweb',
    resource: 'chunks/download.js',
  },
  {
    id: 'deachoodakeofjlfikfkohihnpcgiaim',
    name: 'Font Tester',
    resource: 'content.js',
  },
  {
    id: 'dedaccjfjdboopgpoafnimpppmbhplof',
    name: 'Div Capture',
    resource: 'Images/Copy.svg',
  },
  {
    id: 'dediaclnfcimkehebcpkblokfgikfddg',
    name: 'Zoho Bookings',
    resource: 'index.html',
  },
  {
    id: 'deekoplmjnhcnbkpojidakdbllmdhekh',
    name: 'TurboVPB',
    resource: 'content-scripts/content.css',
  },
  {
    id: 'dehmghpdcahlffompjagejmgbcfahndp',
    name: 'Todoist Keys',
    resource: 'mousetrap.js',
  },
  {
    id: 'delinpnhfdkcjeifmapikhinioghdeia',
    name: 'AverPoint',
    resource: 'icons/rw-wizard/1.png',
  },
  {
    id: 'dfjnghanlijbolkebkkljiodhamhcong',
    name: 'Tiktok选品助手',
    resource: 'popup.css',
  },
  {
    id: 'dgcjdgkiclbfekoepomcjmifmgejhdga',
    name: 'minerBlock',
    resource: 'js/minerkill.js',
  },
  {
    id: 'dgfnbmfhjioifionnlcklnpfkkjjglbj',
    name: 'GPA Calculator',
    resource: 'GPACalc.js',
  },
  {
    id: 'dglhlgljkmbceajpnbkkaangdkjfkdbb',
    name: 'Theater Mode',
    resource: 'data/content_script/page_context/theater_1.css',
  },
  {
    id: 'dhgdeehgkaefgjgbaildeljkiplpepon',
    name: 'Attentional',
    resource: 'index.html',
  },
  {
    id: 'dhpeeacgmigfhhnakifhdmecfbmnbobl',
    name: 'Tranzly',
    resource: '404.html',
  },
  {
    id: 'diinamlcdbbpfebknmhajjaijpflnaoe',
    name: 'LeetTest',
    resource: 'scripts/companies.json',
  },
  {
    id: 'dinoljglaimamjigddfnffgmfbkigkkl',
    name: 'New York City MeaVana',
    resource: '128x128.png',
  },
  {
    id: 'djjliapmlicjimjjlbendpibnhlbebfj',
    name: 'Double Click Image Downloader',
    resource: 'icons/icon16.png',
  },
  {
    id: 'djmbdbpbdodhaoinnbokkmjndpkbgbhc',
    name: 'Rank Up Content',
    resource: 'icons/48.png',
  },
  {
    id: 'dkfmadebibibgfogainfmieipbgffomp',
    name: 'Reepl AI',
    resource: 'icons/tab.svg',
  },
  {
    id: 'dkgmjefaaffbdcjlfelfjgfnddckcokf',
    name: 'Tiktok Voice Generator',
    resource: 'src/images/icon128.png',
  },
  {
    id: 'dkhpgbbhlnmjbkihoeniojpkggkabbbl',
    name: 'AI Compare',
    resource: 'icons/up.svg',
  },
  {
    id: 'dkibpfneinleinbaakbaolmhkgfckjcn',
    name: 'Простые звонки',
    resource: 'img/card.png',
  },
  {
    id: 'dklmcgbmpnmkndhapabinagmmdmjhjgl',
    name: '小红书MCP助手',
    resource: 'inject-scripts/noop.js',
  },
  {
    id: 'dldfdpfndbfoehaimcjagficojlofclc',
    name: 'Net Info EAD',
    resource: 'i/ico16.png',
  },
  {
    id: 'dleflnkkioeajpjokhniiaieonpacano',
    name: 'Spotlight Lingo',
    resource: 'src/index.js',
  },
  {
    id: 'dlomoooljpceboafkelgjgnlpjaignhe',
    name: '던템',
    resource: 'content.css',
  },
  {
    id: 'dlplljmhphnabhmlhjplfgpakefmfhho',
    name: 'WhatsApp Contact Exporter',
    resource: 'csv.svg',
  },
  {
    id: 'dmajilfknankpppoomabobggpnpdlbnl',
    name: 'markerNote',
    resource: 'icon.png',
  },
  {
    id: 'dmcddloohffhmjngiieikfifpfneadcc',
    name: 'ContentStudio',
    resource: 'js/content.js',
  },
  {
    id: 'dmhgdnbkjkejeddddlklojinngaideac',
    name: 'Nudge',
    resource: 'hider-menu.css',
  },
  {
    id: 'dmmildkgnkpdfiabjoddfdoodneaklhm',
    name: 'CAIPA POC 2.0',
    resource: 'about.html',
  },
  {
    id: 'dnaodehopbbgbddbaojmfahnhlacjegi',
    name: 'oneClipper',
    resource: 'scripts/screenshot/crop-box.js',
  },
  {
    id: 'dncmnmelaadhdoihlcbegdjfgkpaianf',
    name: 'PlayMax',
    resource: 'js/e_f.js',
  },
  {
    id: 'dngcajjmbmmghjlhakccphaikekoieig',
    name: 'YouTube Video Dubbing',
    resource: 'src/assets/128.png',
  },
  {
    id: 'dnhfbehomlbkmimmmoejcmcondhmebia',
    name: 'Kirby Cursor',
    resource: 'cursors/local.json',
  },
  {
    id: 'dnidbhhpcjgffjophhebfelbcnonoclh',
    name: 'dimmer',
    resource: 'assets/chunk-f012184a.js',
  },
  {
    id: 'dnofffnpfhkjcnicnbikofkmgckebdpm',
    name: 'Meet Assistant',
    resource: 'scripts/swal.min.js',
  },
  {
    id: 'dnomhejcghecjcjckenhjpidfeiibgnp',
    name: 'Virat Kohli MeaVana',
    resource: '128x128.png',
  },
  {
    id: 'doecfodblgfnjmmphbedjgllipnbgbld',
    name: 'Ruttl',
    resource: 'poetry.js',
  },
  {
    id: 'doklnekkemmhclakfekoccilofpdcncb',
    name: 'Codatta Clip',
    resource: 'signin.js',
  },
  {
    id: 'doobkkcnlfiglhoafllloikhabjgblae',
    name: 'Google AI Citation Analysis',
    resource: 'images/copy.png',
  },
  {
    id: 'eaandldnbchhjimdfnaagaaidgebplgj',
    name: 'Citavi Picker (Beta)',
    resource: 'shared.js',
  },
  {
    id: 'eabpolgjfkpchgffbkiedgfemcgbnbde',
    name: 'SF Explorer',
    resource: 'panel.html',
  },
  {
    id: 'eadhganlkcdpcmecaijndbnjjbaofeic',
    name: 'LeanData BookIt',
    resource: 'README.md',
  },
  {
    id: 'eadjllodfjkbljlihgiflhapafcigoee',
    name: 'Hero Wallet',
    resource: 'inpage.js',
  },
  {
    id: 'eagdjobngjgfcnkejhopjggjbpjfljao',
    name: 'Screen Shade',
    resource: 'images/icon.png',
  },
  {
    id: 'ebagjefpiapkaedjbgkjmjcgjdnbhdnp',
    name: 'Voice Master',
    resource: 'panel.js',
  },
  {
    id: 'ecfilieagpfognifbnjagkcfpmffeelh',
    name: 'miniwebtool',
    resource: 'data/tools-en.json',
  },
  {
    id: 'ecnknpjoomhilbhjipoipllgdgaldhll',
    name: 'ChatSider AI Copilot',
    resource: 'pay.html',
  },
  {
    id: 'edakgbfdfagmejpllgkdfbabldbbkfle',
    name: 'Meetingtor',
    resource: 'fw.min.css',
  },
  {
    id: 'edcebjbpihembjfeogmjamkphfhldnln',
    name: 'BLUF',
    resource: 'content.css',
  },
  {
    id: 'edeaffpifpnlcemnfjieocmhbcffchhh',
    name: 'Strava Enhanced Maps',
    resource: 'style.css',
  },
  {
    id: 'edecegdhgepeakgbiilnkeemmgppcnnm',
    name: 'Скачать Музыку ВКонтакте',
    resource: 'download.png',
  },
  {
    id: 'eeadaochfaalhdgkgejdfalcpdddcpea',
    name: 'Quden',
    resource: 'tabs/embed-view.html',
  },
  {
    id: 'eeibjfehheofgblbiloinpeckmfkenpc',
    name: 'Kakao Pixel Helper',
    resource: 'assets/index.ts-BTOj1JXx.js',
  },
  {
    id: 'eemdohkhbaifiocagjlhibfbhamlbeej',
    name: 'prompts.chat',
    resource: 'icon/16.png',
  },
  {
    id: 'efaeagjhmbmadgklpdaplpmcedmdgfmi',
    name: 'Web Page Converter',
    resource: 'html-docx.js',
  },
  {
    id: 'efcnkaeocmkpckkenjinmdgkbjhajoca',
    name: 'X Word Replacer',
    resource: 'assets/types-BzRs3UaO.js',
  },
  {
    id: 'egcllnngclmpejnnfdneoilfcbkfimdp',
    name: '友鹰数据',
    resource: 'index.html',
  },
  {
    id: 'egjonoicjpecjmnegjogdpnagopdkdej',
    name: 'Crawl date checker for Google',
    resource: 'assets/logo_16.png',
  },
  {
    id: 'ehaflkmcdefjghkmpfhgjemioeblndke',
    name: 'WAPI FREE',
    resource: 'logo/cc.png',
  },
  {
    id: 'eheamandfbjkahaicdglmjpkmkipkoig',
    name: 'WiFi Toggle Blocker',
    resource: 'blocked.html',
  },
  {
    id: 'ehjjfmgnkkkhaeeocejeimgjgepajkeh',
    name: 'Nepeto',
    resource: 'bootstrap.css',
  },
  {
    id: 'ehjlfojolienejbcmcepemcphlmoidkf',
    name: 'Price Tracker',
    resource: 'sounds/ding.wav',
  },
  {
    id: 'eidehbdehdaggoophgjhkplcbjhelfkc',
    name: 'Muses Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'eikknpnckalfaafkjkkjbikfbkbkdnfc',
    name: 'Zelix',
    resource: 'content.css',
  },
  {
    id: 'eiodncfpgnjmbdfgfimggoondoiaabca',
    name: 'Taobao',
    resource: 'logo-small.png',
  },
  {
    id: 'ejklmdggogcbjpehmmjnebehjafnkiaj',
    name: 'Conversion.com Optimizely',
    resource: 'options.html',
  },
  {
    id: 'ekaikenfcpochobnfnjiidbaopmofegp',
    name: 'Award Travel Finder',
    resource: 'welcome.js',
  },
  {
    id: 'eknkbhblmchgnbemajfjkhibbobamdod',
    name: 'Cinnamoroll Cursor',
    resource: 'cursors/local.json',
  },
  {
    id: 'elajeappnnlkfmffkincmhkmomnjgjpj',
    name: 'Voice to Text',
    resource: 'sidepanel.html',
  },
  {
    id: 'elfdoindoanbfgpjkmgfenelmhlpjhci',
    name: 'PicHound',
    resource: 'resources/iqdb.ico',
  },
  {
    id: 'elfmpgajdjmknldbbicgpdiaalbkkioc',
    name: 'ChatGPT context companion',
    resource: 'images/icon16.png',
  },
  {
    id: 'elnjagingppccbpccnldbhmlgmomeaml',
    name: 'Notion Font Changer',
    resource: 'icon-34.png',
  },
  {
    id: 'emblehfcjcbcmnnhclikihlbikobocmk',
    name: 'Recorder',
    resource: 'images/BNSK-57x57.png',
  },
  {
    id: 'emhjndcjncnpgdlogdkeichobfnenebi',
    name: 'Snap for Merch on Demand',
    resource: 'assets/clear.svg',
  },
  {
    id: 'emlejidncokahfahckdjdofakebjfagm',
    name: 'KeyGuard',
    resource: 'index.html',
  },
  {
    id: 'enafhefnjpdnhbmccghnphjjlflohpkg',
    name: 'ImageXtract',
    resource: 'engine/index.js',
  },
  {
    id: 'enblfhocndnkhhpnmmonjlncmndfmhcd',
    name: '跨境旺财',
    resource: 'index.js',
  },
  {
    id: 'endmmacdmacjnonhdkkbgkhofmhigamg',
    name: 'Whatsapp Plus',
    resource: 'script.js',
  },
  {
    id: 'enelhcfnkabehgjjcfliejjnmlnnmnei',
    name: 'Suitelook',
    resource: 'js/netscript.js',
  },
  {
    id: 'enhcifgjnffebdckpjiohlcelmobbicb',
    name: 'MP4 to GIF converter',
    resource: 'assets/js/index.98d5cbb1.js',
  },
  {
    id: 'eojfohkjmcigemmccnbkkpmpnomdagbf',
    name: 'Whatsapp Bulk Message',
    resource: 'images/icon16.png',
  },
  {
    id: 'eopapfppdnbiabhoaedoebkficbmdbpk',
    name: 'Delete Google Photos',
    resource: '_locales/en/messages.json',
  },
  {
    id: 'epellgielojfhbjhdnplcnmndnifbien',
    name: '青葉のカメラ',
    resource: 'logic/MyMenu.html',
  },
  {
    id: 'ephoilihbddhdekcpnpkokighhcdmljb',
    name: 'ProfitGo for Amazon',
    resource: 'proxy.js',
  },
  {
    id: 'epnkcojifofdcdmmlflmoejfaennhjbm',
    name: 'Fluently',
    resource: 'options.html',
  },
  {
    id: 'eppgaaffepbibmnbaoodmilbhnmphchp',
    name: 'PBX',
    resource: 'inject.js',
  },
  {
    id: 'faafihopigjlmphlldphfgdgagioejmk',
    name: 'LetPlant GreenFocus Pomodoro Timer',
    resource: 'images/qr.png',
  },
  {
    id: 'faaknmkjnigkoehjkgeenmafoacngiif',
    name: 'ZingProxy',
    resource: 'flags/hn.svg',
  },
  {
    id: 'fadefoaoccmlhenbfcjkeipniieoioja',
    name: 'dSender',
    resource: 'assets/inject.js',
  },
  {
    id: 'fbholmgghhfhbbigpcolkfmegpojfpei',
    name: 'Магічний телепорт',
    resource: 'css/main.css',
  },
  {
    id: 'fbpjhnpcopgbnkomjdkmhlfhdenaooko',
    name: 'Vibe n8n',
    resource: 'offscreen.js',
  },
  {
    id: 'fchghbfimckdiapkacfaljimmkojgfhi',
    name: 'Extract Links from PDF',
    resource: 'help.html',
  },
  { id: 'fcjjdbmegeocgffpjihgaodhglknopag', name: 'WARP', resource: 'app.js' },
  {
    id: 'fckmlnagohleefboaleepppikpdkckjn',
    name: 'YDD',
    resource: 'assets/socials/x.png',
  },
  {
    id: 'fdchconolfmpkjnjnmmhfklfanlnaohp',
    name: 'Picture-in-Picture Everywhere',
    resource: 'icons/icon16.png',
  },
  {
    id: 'fdcmomajekgiigcalflcbjbkemogcbaf',
    name: '纳米AI助手',
    resource: 'icon48.png',
  },
  {
    id: 'fdjminldlpednddoeokglgpjiibncfpe',
    name: 'Selling.com',
    resource: 'images/logo.png',
  },
  {
    id: 'fdnbeafickafiocjpfpioapepifdfkhj',
    name: 'Trending Products',
    resource: 'ali.png',
  },
  {
    id: 'fecibmlbfjpemepjjdenacplfohleoaf',
    name: '智能销售-客户雷达',
    resource: 'inject.js',
  },
  {
    id: 'fefcliabdkllgfbhmfhjmpphjhbcjjal',
    name: '聚贝中控-直播提效工具',
    resource: 'inject.js',
  },
  {
    id: 'fekaahebjicdpoofanbhmjmhomelpifi',
    name: 'PointOne',
    resource: 'xhrUpdate.js',
  },
  {
    id: 'ffeplcclnhichbeocjmighhccebmdicn',
    name: 'WA Group Sender & Group Link Scraper',
    resource: 'assets/wa.js',
  },
  {
    id: 'ffjbejplhhgfbhckieoklhaoibhckbed',
    name: 'Clifl',
    resource: 'content_scripts/task.js',
  },
  {
    id: 'ffjncjpkoanpjjmcdonkhfammlhfapll',
    name: 'Quantcast',
    resource: 'consent-check.js',
  },
  {
    id: 'ffpmdofklpmnbkgiocdcofknfjckhbjl',
    name: 'Video DL',
    resource: 'content/modal.html',
  },
  {
    id: 'fgmknallmmochhfngjmmmcpobelihfhe',
    name: '划词搜索',
    resource: 'js/setup.js',
  },
  {
    id: 'fgpnklngaiahpcpjennhbcmkiahjohdk',
    name: 'Shake',
    resource: 'libs/main.css',
  },
  {
    id: 'fhbangijpbodiabepaedlofigolecong',
    name: 'Image Downloader Pro',
    resource: 'views/exportcsv.js',
  },
  {
    id: 'fhbkphgopfnhbbldhjgcncllngmkcndi',
    name: 'Noa Notes by Docplanner',
    resource: 'content-scripts/content.js',
  },
  {
    id: 'fhdhabioobmdidfhaldhdbleeeigkadn',
    name: 'BlueConic',
    resource: 'copyright.txt',
  },
  {
    id: 'fhfmioonhaaojhlicfalhidddcpcdogf',
    name: 'PumpPill',
    resource: 'notification.mp3',
  },
  {
    id: 'fhmgmglbnkddnkkcglfahocfahmjplbj',
    name: 'AI Fox',
    resource: 'popup.html',
  },
  {
    id: 'fifbgboiihlbnmgcjpdbeeaaemnlgnoh',
    name: 'studyfoc.us',
    resource: 'logo-500.png',
  },
  {
    id: 'fihbdpohplcdnhllhliaeapefmmpcdjo',
    name: 'TrashMail',
    resource: 'api.js',
  },
  {
    id: 'fiogakiegoacaiplkdnjildblhfhchfi',
    name: 'TabAI',
    resource: 'icons/favicon.svg',
  },
  {
    id: 'fkekkoekkbdfhkifdadejlofdilbcdel',
    name: 'Web2PDF',
    resource: 'templates/hintLimitAlert.html',
  },
  {
    id: 'fldjmbbjgmffpdjckmhalgadjnnjipfj',
    name: 'Lookup',
    resource: 'popup/popup.css',
  },
  {
    id: 'fleifcognemdgekfknmnbelghpgbpkek',
    name: 'hangve.com',
    resource: 'site.js',
  },
  {
    id: 'flghhnkgbpmbliapbejejdepagkebcgn',
    name: 'WA Group Scraper',
    resource: 'pics/pic16.png',
  },
  {
    id: 'flhoijlhfhcgcglcgacnebnpmjiglcgf',
    name: 'ClockAssist',
    resource: 'icon128.png',
  },
  {
    id: 'flhpobcpjeilaheadnpdkkinakogbdhb',
    name: 'HashPass Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'fmjogafcialngfcopflagalflkcnlebk',
    name: 'AutoLatex',
    resource: 'katex/katex.js',
  },
  {
    id: 'fnlodpokkmdkbfdpndggldifechbglbf',
    name: 'AiPrice(AliPrice) Search by image for Shein',
    resource: 'assets/js/popup.js',
  },
  {
    id: 'fnnjdcbkpadiklnhgeeamibhncnindhl',
    name: 'Video to Text',
    resource: 'assets/16x16.png',
  },
  {
    id: 'fnpagnmajaopjagdhmdplmojfolmfkaf',
    name: 'PassWatch',
    resource: 'src/images/icons/blank.png',
  },
  {
    id: 'fofjdonkemjmfkaapekcfakjocelcejk',
    name: 'VKnow',
    resource: 'dtree.js',
  },
  {
    id: 'foknhhcbfhdhocmbapkphabgjbikofeb',
    name: 'PubSpy.io',
    resource: 'popup.css',
  },
  {
    id: 'fpaofkicpfiiifjpmkcadjpedlohpgep',
    name: 'Cursor Traveler',
    resource: 'assets/content.ts-BaToihlY.js',
  },
  {
    id: 'fpbbmgkekkdgipkngmlgcfgadhnapdle',
    name: 'One Click Add Parcel',
    resource: 'injected.min.js',
  },
  {
    id: 'fpbdkgbdodcinnndaigolincodkjkkjp',
    name: 'CamDesk CamDesktop Floating Webcam',
    resource: 'icon-512.png',
  },
  {
    id: 'fpbjfdjepolhfoddohnbonljioemgggk',
    name: 'SSFeatures',
    resource: 'css/core/menu.css',
  },
  {
    id: 'fpieolagnlkejcpejlbjgbdpaglffacj',
    name: 'Salesforce Dependent Picklist Matrix Export/Import',
    resource: 'js/clickjs.js',
  },
  {
    id: 'fpiffaomkpnhmldgjbcinoikplpjnpca',
    name: 'dSaver',
    resource: 'assets/icn-vip.png',
  },
  {
    id: 'gaaeokfljnaahnemphknpchoimmbmhjj',
    name: 'Elevate by GrowthX',
    resource: 'assets/index.js',
  },
  {
    id: 'gadbifgblmedliakbceidegloehmffic',
    name: 'Paragon',
    resource: 'pageProvider.js',
  },
  {
    id: 'gagmnmenidmghmppkbadhgmhnjeaglan',
    name: 'Bulk image background remover',
    resource: 'tabs/home.tsx',
  },
  {
    id: 'gaimofgglbackoimfjopicmbmnlccfoe',
    name: 'Caramel',
    resource: 'index.html',
  },
  {
    id: 'gakjlgabbpdkoilkncmlolaampjadjbj',
    name: 'CTiContRol',
    resource: 'config.json',
  },
  {
    id: 'gapmocmoommgabdpknjkelccgkeekgom',
    name: 'BlockSite Block Websites & WebSilence',
    resource: 'blocked.html',
  },
  {
    id: 'gbagnebpngfakhnlgkcfcchdhaijgdig',
    name: 'TTExporter',
    resource: 'icon-48.png',
  },
  {
    id: 'gbakppfkjgpeingibhfgkeddlahonikc',
    name: 'Pricing',
    resource: 'Icon.woff',
  },
  {
    id: 'gbgnhpjhopjdoocmdofdlogbjdnlkkka',
    name: 'AITab',
    resource: 'content-scripts/image.css',
  },
  {
    id: 'gbhnalmnijncecapleoengindkloelki',
    name: 'CheckFlow Browser Relay',
    resource: 'help.html',
  },
  {
    id: 'gbjocelfmcapnmcocncmheabfhdhmadl',
    name: 'Allow copy',
    resource: 'enable.js',
  },
  {
    id: 'gchllbbiiaaofhgjpnbnmfpiflahnghl',
    name: 'TwiPlay',
    resource: 'js/popup.js',
  },
  {
    id: 'gckiocdfdaofgabchobljcdimjieookl',
    name: 'OmniBox',
    resource: 'icon-34.png',
  },
  {
    id: 'gdbekefhpfaglcbndddhkejemcddjfpj',
    name: 'Popup Blocker',
    resource: 'pageBridge.js',
  },
  {
    id: 'gdbemlfgncdmmljmkkcemfedbbfgghcp',
    name: 'Pulsedive',
    resource: 'options.html',
  },
  {
    id: 'gdcmnnclkneggcgjookihlggijjkdhli',
    name: 'Sticky Notes Plus',
    resource: 'assets/book.svg',
  },
  {
    id: 'gdpfgejmikpgbnbhbhjegjfglhodfloa',
    name: 'Easy! Show Title Plus',
    resource: 'options.html',
  },
  {
    id: 'gedldgbbikhdlaeleapcnlhnilajfmff',
    name: 'StockGlow by Upstox',
    resource: 'upstox-wordmark.svg',
  },
  {
    id: 'gfhoehljpmelihfdcpeiklgdapbakhhc',
    name: 'Bulk Whatsapp Sender',
    resource: 'images/rocket.png',
  },
  {
    id: 'gfkndgikhlecndckncfohdpblncbgffa',
    name: 'WAMP (BETA)',
    resource: 'sidepanel.html',
  },
  {
    id: 'gflankmgolakfdeiponkgmbhbhpdmjlg',
    name: 'Bad Connection Simulator',
    resource: 'scripts/inject.js',
  },
  {
    id: 'ggbadcghmcpofonkoeepddbabdkfbbia',
    name: 'Map Overlays',
    resource: 'scripts/page.js',
  },
  {
    id: 'ghbmpbdefklbjbnebdcpbjflekgmalpb',
    name: 'Salvage Auction Research Tool',
    resource: 'loader.html',
  },
  {
    id: 'ghgojagblcngfmngghgndhcogdceogoi',
    name: 'Script Injector',
    resource: 'popup.js',
  },
  {
    id: 'ghmbpcmonklliphfbkdbedkdkilfbngm',
    name: 'Anomali Copilot',
    resource: 'tab.css',
  },
  {
    id: 'ghmjdagapadakjaffiimogiecdnjdaac',
    name: 'Webutler.AI',
    resource: 'static/README.md',
  },
  {
    id: 'gidpkdpdnngpfohekcfkfjbkieeihekj',
    name: 'BTC Ticker',
    resource: 'assets/images/icon-48.png',
  },
  {
    id: 'ginchbkmljhldofnbjabmeophlhdldgp',
    name: 'PolkaGate',
    resource: 'page.js',
  },
  {
    id: 'gipdjalmbiackhnmpjlpafmiaciejfdf',
    name: 'Volley',
    resource: 'mic.js',
  },
  {
    id: 'gjddlbmkbmjhhdhkhldpkdelbefkilkk',
    name: 'Grandstream Wave',
    resource: 'content.js',
  },
  {
    id: 'gjdpaicenfffjkgofmcjikilokigkonj',
    name: 'Funlingo',
    resource: 'logo.png',
  },
  {
    id: 'gjgpkaoddmagbljkjfcefhpdnkhknijb',
    name: 'Text To Anime',
    resource: 'page.html',
  },
  {
    id: 'gjpiagbfbbkapibdiifonjbpiieapkad',
    name: 'AI Trading Simulator by simul8or',
    resource: 'alert.mp3',
  },
  {
    id: 'glgcbdbnacmlgjaabjliokbnklbpdlno',
    name: 'Easyamz',
    resource: 'img/icons/img16.png',
  },
  {
    id: 'glieaboaghdnlglpkekghloldikefofo',
    name: 'Fuskr',
    resource: 'assets/images/1x1.png',
  },
  {
    id: 'gljimdoibfdibckkdmcciihdkbmdjmbc',
    name: 'Slowed',
    resource: 'tapeHiss.mp3',
  },
  {
    id: 'gmdepndgcafcpjaiflfdijnblnmloebj',
    name: 'Talqeen',
    resource: 'oauth-callback.html',
  },
  {
    id: 'gmfpkimhlpfknllbhfbcjbghmkhhgdbc',
    name: 'Domain Age Checker',
    resource: 'icon.png',
  },
  {
    id: 'gmgmmjabnmigondjggpcjmhicekiognh',
    name: 'Steam Plus',
    resource: 'bridge.bundle.js',
  },
  {
    id: 'gmjbokljijbegndgfhbmobaniejnaali',
    name: 'Smart Paste',
    resource: 'app.js',
  },
  {
    id: 'gnhhoabiokmfnfklhlplkmkdcfoabbnc',
    name: 'OfficeRnD',
    resource: 'login_return.html',
  },
  {
    id: 'gnkbgepgknkbhnnbaihklcfkjhbclajk',
    name: 'Anon Wallet',
    resource: 'pageProvider.js',
  },
  {
    id: 'gnpppldhfbbagiaalkddddajadhlgofm',
    name: 'Timestamped YouTube Comments',
    resource: 'ding.wav',
  },
  {
    id: 'gohemgflodfhnlmbimcgefjnnmjmgnka',
    name: 'Profitario',
    resource: 'util/jquery.js',
  },
  {
    id: 'gpaoonmjikbnoedbnnmihhichnjlojji',
    name: 'PitchMeAI',
    resource: 'drawer-iframe.html',
  },
  {
    id: 'gpgalkgegfekkmaknocegonkakahkhbc',
    name: 'DirPlayer',
    resource: 'ruffle/README.md',
  },
  {
    id: 'gpmhbgdppjngmgeinbgkoglkdhnajdjm',
    name: 'Mr Mute',
    resource: 'mrmute-common.js',
  },
  {
    id: 'haepcjhchonagnpkeaijnbfeldaikjjm',
    name: 'Quick Search for YouTube',
    resource: 'icon-play-34.png',
  },
  {
    id: 'hbfbfmnfkingjgomkgopabedgfpgobkg',
    name: 'Crosshair Plus',
    resource: 'images/icon-48.png',
  },
  {
    id: 'hbpcekiibgkgchcanlpagfjkbpdpkogk',
    name: 'Full Screen Video',
    resource: 'content.css',
  },
  {
    id: 'hbpgkphoidndelcmmiihlmjnnogcnigi',
    name: 'DocuViz',
    resource: 'css/global.css',
  },
  {
    id: 'hcajefpkmimmoiljokpnjoaeoapebohe',
    name: 'Garmin Connect Web Missing LoadFocus Fixer',
    resource: 'fix-garmin.js',
  },
  {
    id: 'hchhikbldhimjcbgmedilgbnbigpokpf',
    name: 'SurfKeeper',
    resource: 'blocked.js',
  },
  {
    id: 'hcmjeljnhadbmagohaliefekhgaidijn',
    name: 'WeLoop.ai',
    resource: 'resources/weloopai.js',
  },
  {
    id: 'hcnffmpopoelpggikahccdfenoobjigj',
    name: 'Quiver Web Clipper',
    resource: 'overlay/index.js',
  },
  {
    id: 'hdaniddaeomoofbnoagkncfofebaablc',
    name: 'PeekLink',
    resource: 'icons/icon16.png',
  },
  {
    id: 'hdoplfhlfoagdghmfamhnakmjjffeila',
    name: 'close_tab(s)',
    resource: 'img/edit.png',
  },
  {
    id: 'hehieakgdbakdajfpekgmfckplcjmgcf',
    name: 'Prompt Catalyst',
    resource: 'icons/logo.png',
  },
  {
    id: 'heikifnngkibnhgdnhbpggbmefnagjgp',
    name: 'Email Extractor',
    resource: 'assets/utils.js',
  },
  {
    id: 'hekbjgfncacdinlajhgiakpaieajpfph',
    name: 'Cobalt',
    resource: 'content/horizen.js',
  },
  {
    id: 'helpjbehgodflkpbifaolbjmkjffmeop',
    name: 'Crossbeam Copilot',
    resource: 'icon-34.png',
  },
  {
    id: 'henbmcahfhbfpecpglpbkgclbbfodfgd',
    name: 'Funny Gru',
    resource: 'funny.mp3',
  },
  {
    id: 'hfhdhfpapgcjpljpmaiddoicoapghaci',
    name: 'Zoom Phone For Bullhorn',
    resource: 'images/logo.png',
  },
  {
    id: 'hfhghglengghapddjhheegmmpahpnkpo',
    name: 'WooCommerce Dropshipping',
    resource: 'html/popup_in.html',
  },
  {
    id: 'hfpokjeoalngkknelljbenaobinichjf',
    name: 'Guides',
    resource: 'images/hruler.png',
  },
  {
    id: 'hghepaogndoaijlgelomneagnjlhaled',
    name: 'Readio Pro',
    resource: 'placeholder.js',
  },
  {
    id: 'hgmoaheomcjnaheggkfafnjilfcefbmo',
    name: 'Rabet',
    resource: 'dist/popup.js',
  },
  {
    id: 'hhcfhpgkpmlbmncciaeanehopjhnbdoi',
    name: 'HEIC to PDF',
    resource: 'assets/css/Index.chunk.css',
  },
  {
    id: 'hhdmnjenemjjibploldnadhffkgkpcpo',
    name: 'Edit website',
    resource: 'icons/logo.png',
  },
  {
    id: 'hhfchlbmcogpndocbfcffpdllgfkjbme',
    name: 'Reddit Video Downloader',
    resource: 'csv.svg',
  },
  {
    id: 'hhfpmfhdaokfgnecalgnogganpjiehkb',
    name: 'SherpaDesk',
    resource: 'icon-48.png',
  },
  {
    id: 'hhhlicedeodnigigfpfheggdpknpljfj',
    name: 'SubDub',
    resource: 'inject-script.js',
  },
  {
    id: 'hhodeijkemcdbelkfdhglgmgpmgkfekk',
    name: 'Gramatika',
    resource: 'popup.html',
  },
  {
    id: 'hhodnpljldlmcdgielblijcfppncjogf',
    name: 'Forecastfox',
    resource: 'skin/popup.css',
  },
  {
    id: 'higfkiojenkggbdbiilfidjfcgdjpijp',
    name: 'Shopify Checker and Detector',
    resource: 'styles.css',
  },
  {
    id: 'hiljfagagekagnennhceimgkgbbacgip',
    name: 'Print feedbacks for Google Forms',
    resource: 'images/icon-colors.svg',
  },
  {
    id: 'hipjlflbbjaojdoecdgbelgofbfckpai',
    name: 'Enable User Select',
    resource: 'popup.js',
  },
  {
    id: 'hjapegicpojdkoinhhdpjmpkomkjccaa',
    name: 'Image Zoom',
    resource: 'injection.css',
  },
  {
    id: 'hjdcnhcldlclkloongmklmonejnaohek',
    name: 'TravelMonkey',
    resource: 'js/newtab.js',
  },
  {
    id: 'hjkhpfdoiikleoogpcjmbgajeeknfbed',
    name: 'Lead411',
    resource: 'images/48.png',
  },
  {
    id: 'hjpbnkkeihnknafkdbglklgmblkgdkki',
    name: 'Basket',
    resource: 'images/e27644152954c9989f01f1a5061d7fa0-save.svg',
  },
  {
    id: 'hkckiflbaedpdigcjoeiacmfnlncpeoj',
    name: 'M.I.T. Consulting Token signing',
    resource: 'page.js',
  },
  {
    id: 'hkfgnnpbnglaeejogkfacndfcobllped',
    name: '타오바오 이미지 검색',
    resource: 'aww.css',
  },
  {
    id: 'hkibdedfdlapbjemojfddcldcfkhmldd',
    name: 'SEO station by Carlos Estevez',
    resource: 'scscript.js',
  },
  {
    id: 'hkiecfigipbfbmkbpjhmejjhiffdgmok',
    name: 'HTML Validator',
    resource: 'readme.txt',
  },
  {
    id: 'hlhfnpbjlanadonkeggjnccpnjcfkncp',
    name: 'YouTube Speeder',
    resource: 'assets/times-solid.svg',
  },
  {
    id: 'hllggpdokhihmkgmbmogepokoelmicji',
    name: 'Font Recognition',
    resource: 'popup.css',
  },
  {
    id: 'hlnhhamckimoaiekbglafiebkfimhapb',
    name: 'SnapThePrice',
    resource: 'content-scripts/button.css',
  },
  {
    id: 'hlnlgomflnboogkaampmdhiaifjkfcgc',
    name: 'Delete X Tweets - Remove Twitter Posts',
    resource: 'csv.svg',
  },
  {
    id: 'hmegdmljjhbohphjhfogpgbhcfjkifbh',
    name: 'TXT to SRT',
    resource: 'css/tailwind.min.css',
  },
  {
    id: 'hnjepanannlajhppemgdmcjjpimlhkgm',
    name: 'Callvoip C2D',
    resource: 'i18n/en/en.json',
  },
  {
    id: 'hnjmbhjbnjccalkgfgicfigopnnchpam',
    name: 'AI Manga Translator',
    resource: 'dist/contentScripts/style.css',
  },
  {
    id: 'hnjndehnpihbookgefodeoochoimkojd',
    name: 'PYTools',
    resource: 'py/common.js',
  },
  {
    id: 'hnlonillhoifflkeblghhphdonfgbhdi',
    name: 'trufflepiggy',
    resource: 'js/reqwest.js',
  },
  {
    id: 'hnmhchbaimjlmckjphofeilojekjihcc',
    name: 'Banner Dimensions',
    resource: 'dimensions.js',
  },
  {
    id: 'hohljodjndmmaiedadcdmnelgdfnbfgp',
    name: 'Cloudhood',
    resource: 'img/main-icon-48.jpg',
  },
  {
    id: 'hopnjiadheaagfhpipecoamoegijhnij',
    name: 'Overseerr Assistant',
    resource: 'css/style.css',
  },
  {
    id: 'hpbebebpjajeiadiakgckpahmhkbkpoa',
    name: 'Stay',
    resource: 'source/content.js',
  },
  {
    id: 'hpiljnaahbpfebfinmobpchoenlphghg',
    name: 'TacticalBucket.com One-Click Installer',
    resource: 'images/icon-16.png',
  },
  {
    id: 'hpinghefcjjgfegpbpcigbgcdmboadjc',
    name: 'Covideo',
    resource: 'options.js',
  },
  {
    id: 'hpjilhicpmofjnjehgnojaldkaoalmpg',
    name: 'notionClipper',
    resource: 'scripts/clip-site/clip-article.js',
  },
  {
    id: 'hpmbccepehpoanjpjkamfdpdkbmfmhek',
    name: 'Anime4K',
    resource: '269.js',
  },
  {
    id: 'hpmolahefgjbmidmoifolgpjkmhdmalf',
    name: 'Close Tab',
    resource: 'js/share.js',
  },
  {
    id: 'ialfjajikhdldpgcfglgndennidgkhik',
    name: 'Ctrl+Tab MRU',
    resource: 'content.js',
  },
  {
    id: 'ibbjcpcbjnjlpfjinbeeefbldldcinjg',
    name: 'Shein Scraper',
    resource: 'libs/style.scss',
  },
  {
    id: 'ibcnlnjajdjfjdcogphnhombiegpcnbj',
    name: 'Infinex',
    resource: 'inpage.js',
  },
  {
    id: 'ibenkaeanlddcgpbfokocbhgbpfhieoc',
    name: 'Scribenote PIMSPal',
    resource: 'icon.png',
  },
  {
    id: 'icbnjddomcacgkbfikejkkcbjpfdbkcg',
    name: 'Pinterest Search',
    resource: 'img/icons/64x64.png',
  },
  {
    id: 'icekdmlfmjngcpakbdjpjiikhofmenia',
    name: 'snapAddy Helper',
    resource: 'scripts/page-scripts/shared/proxy.js',
  },
  {
    id: 'icgjkfebljaiiccoeeihocdmjnojmeal',
    name: 'Mano',
    resource: 'src/fonts/avenir-light.woff',
  },
  {
    id: 'idiaamllmenbecdfkjggnoeliaajecea',
    name: 'JPG to WebP',
    resource: 'jszip.min.js',
  },
  {
    id: 'idpbkjelfafclebibpchnammadmdlipe',
    name: '購有錢',
    resource: 'img/close.png',
  },
  {
    id: 'iecgdccnjbljdabegnogafjkkjlcpcgh',
    name: 'Dashworks',
    resource: 'dashworks.css',
  },
  {
    id: 'iehkgjmhdpofilpcgfkelniplfckagbo',
    name: 'Zoho Invoice Timer',
    resource: 'js/mainmenu.js',
  },
  {
    id: 'ifcljmkcponiminmkdhpfiidbijpnljb',
    name: 'ChatSilo',
    resource: 'assets/icons/32.png',
  },
  {
    id: 'ifihdndmhcceaghgjfdnbmikeabbcbpf',
    name: 'Screen Recorder',
    resource: 'assets/icon.png',
  },
  {
    id: 'ifnbicdjdgfcnlanmepehagilpdelamo',
    name: 'Agency Dashboard',
    resource: 'js/mobileView.js',
  },
  {
    id: 'igdgmhjmiicjgechaninpciapoofnoia',
    name: 'Eclipse PDF',
    resource: 'onboarding.js',
  },
  {
    id: 'igfcoofpmcdpcocfofdobneaileiogmo',
    name: 'Send web articles to Kindle',
    resource: 'icon-48.png',
  },
  {
    id: 'iglhjjaalhoebkpbceimidnjjbcigdhn',
    name: 'videostep',
    resource: 'contents.js',
  },
  {
    id: 'iglkpadagfelcpmiidndgjgafpdifnke',
    name: 'AIPex',
    resource: 'assets/icon.png',
  },
  {
    id: 'ihkdflhmhcaldfmliekcmbbfhfeeemie',
    name: 'Facebook Groups',
    resource: 'i18n.js',
  },
  {
    id: 'ihoengccmhdfpgeajdljjnalhdjncbbp',
    name: 'IDX Privacy',
    resource: 'src/ab.js',
  },
  {
    id: 'iiabgfkclnahbclmddagjnkjhloepclb',
    name: 'Cursor Pet',
    resource: 'chibi_paimon_cautious.png',
  },
  {
    id: 'iignnndcdkoehloecaaeemlkpcfnhbme',
    name: 'ITONICS Web Clipper Enterprise',
    resource: 'icons/plus.png',
  },
];
const expectedExtensionId = 'ghbmnnjooekpmoecnnnilnnbdlolhkhi';
const targetById = new Map(
  extensionTargets.map((target) => [target.id, target] as const),
);

async function detect(target: ExtensionTarget): Promise<boolean> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 2500);
  try {
    await fetch(`chrome-extension://${target.id}/${target.resource}`, {
      cache: 'no-store',
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timeout);
  }
}

async function collect(): Promise<RawData> {
  const detected = new Array<boolean>(extensionTargets.length).fill(false);
  let nextIndex = 0;
  const worker = async (): Promise<void> => {
    while (nextIndex < extensionTargets.length) {
      const index = nextIndex;
      nextIndex += 1;
      const target = extensionTargets[index];
      if (!target) {
        continue;
      }
      detected[index] = await detect(target);
    }
  };
  await Promise.all(Array.from({ length: 20 }, worker));
  return {
    extensions: extensionTargets.filter((_target, index) => detected[index]),
  };
}

function validateExtensions(rawData: RawData): ValidationResult {
  const reasons: string[] = [];
  const extensions = Array.isArray(rawData.extensions)
    ? rawData.extensions
    : [];
  const ids = new Set<string>();
  for (const extension of extensions) {
    if (!isRecord(extension)) {
      reasons.push('Found extension has an invalid shape');
      continue;
    }
    const id = String(extension.id ?? '');
    const target = targetById.get(id);
    if (!/^[a-p]{32}$/.test(id)) {
      reasons.push('Found extension has an invalid ID');
    } else if (!target) {
      reasons.push(`Found extension ${id} is absent from the probe list`);
    }
    if (
      target &&
      (extension.name != target.name || extension.resource != target.resource)
    ) {
      reasons.push(`Found extension ${target.name} has invalid metadata`);
    }
    if (ids.has(id)) {
      reasons.push(`Found extension ${id} is duplicated`);
    }
    ids.add(id);
  }
  const onlyExtension =
    extensions.length == 1 && isRecord(extensions[0]) ? extensions[0] : null;
  if (onlyExtension?.id != expectedExtensionId) {
    reasons.push('Only Google Docs Offline must be detected');
  }
  return validation(reasons);
}

function format(rawData: RawData): string {
  const error = formatError(rawData);
  if (error) {
    return error;
  }
  const extensions = Array.isArray(rawData.extensions)
    ? rawData.extensions.filter(isRecord)
    : [];
  return extensions.length == 1 && extensions[0]?.id == expectedExtensionId
    ? 'Google Docs Offline'
    : `${extensions.length} extensions`;
}

async function run(): Promise<TestResult> {
  let rawData: RawData;
  try {
    rawData = await collect();
  } catch (error) {
    rawData = { error: errorText(error) };
  }
  return result(rawData, format);
}

function validate(rawData: RawData): ValidationResult {
  const error = validationError(rawData);
  if (error) {
    return error;
  }
  return validateExtensions(rawData);
}

export const extensionsTest: TestDefinition = {
  id: 'extensions',
  title: 'Extensions',
  category: 'shared',
  format,
  run,
  validate,
};
